/* global globalThis */
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Slider,
  Stack,
  Typography,
  useMediaQuery,
  Paper,
  MenuItem,
  MenuList,
  Drawer,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Picker from "react-mobile-picker"; 
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalContext } from "../context/GlobalContext";
import axios from "axios";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { ReactComponent as UndoIcon } from "../Assets/undo.svg";
import EditRedIcon from "../Assets/Edit-red.svg";
import { ReactComponent as MagicIcon } from "../Assets/Magic.svg";
import { alpha, useTheme } from "@mui/material/styles";
import { ReactComponent as RedoIcon } from "../Assets/redo.svg";
import { ReactComponent as ExitIcon } from "../Assets/exit.svg";
import { ReactComponent as RotateIcon } from "../Assets/rotate1.svg";
import { ReactComponent as FlipHorizonolIcon } from "../Assets/flip-horizontol1.svg";
import { ReactComponent as FlipVericalIcon } from "../Assets/flip-vertical1.svg";
import { ReactComponent as DeleteIcon } from "../Assets/delete.svg";
import { ReactComponent as FilterIcon } from "../Assets/Filter.svg";
import { ReactComponent as ShowZonesIcon } from "../Assets/show-zones.svg";
import { ReactComponent as HideZonesIcon } from "../Assets/hide-zones.svg";
import { getTenantConfig } from "../utils/tenantConfig";
import BrandedExportModal from "../Components/BrandedExport/BrandedExportModal";
import { BRANDED_EXPORT_ENABLED } from "../constants/brandedExport";
import { ReactComponent as ActionIcon } from "../Assets/actions.svg";
import { ReactComponent as ShuffleIcon } from "../Assets/shuffle1.svg";
import { ReactComponent as ExitFooterIcon } from "../Assets/exit.svg";
import IosShareIcon from "@mui/icons-material/IosShare";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import EditIcon from "@mui/icons-material/Edit";
import {
  useGetAllItemsBySupplementaryQuery,
  useGetItemsBySupplementaryQuery,
  useGetItemsByZoneQuery,
} from "../Slices/roomNateConstantApis";
import { useGetPartnerZonesQuery } from "../Slices/roomNateApis";
import { useUserProfileSelector } from "../hooks/useUserProfile";
import { useGlobalAuthContext } from "../context/AuthContext";
import Cookies from "js-cookie";
import { baseUrl, apiUrl } from "../utils/baseUrl";
import { ErrorAlert, SuccessAlert } from "../utils/Alerts";
import {
  adjustDoorPositionAndOrientation,
  adjustVertices,
  calculateFilteredAverage,
  calculateNewScaleFactor,
  calculateScaleFactor,
  convertLengthToFeetAndInches,
  doorsFindRoom,
  filterBoxesInRoom,
  findRoom,
  getDoorsWithLineIndex,
  scaleDoors,
  scalePoints,
  scaleObstacles,
  scaleEdgeSegments,
  transformWalls,
} from "../utils/convertFloorToVertices";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { decodeAllImages, rasterizeNode } from "../utils/captureNode";
import { useGetSavedLayoutByIdQuery } from "../Slices/roomNateApis";
import DeleteDialog from "../Components/DeleteDilogue";
import ManuallyItems from "./ManuallyItems";
import LayoutOptionMenu from "../Components/LayoutOptionMenu";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import { debounce, cloneDeep } from "lodash";
import NewFolderDialog from "../Components/NewFolder";

import copy from "copy-to-clipboard";
import { useWindowWidth } from "../Components/Vibes/useWindow";
import ShoppingContent from "../Components/ShoppingContent";
import AuthModal from "../Components/AuthModal";
import CustomSwitch from "../Components/GlobalStyles/CustomSwitch";
import {
  getEditorPanelSurfaceSx,
} from "../Components/StandardDialog";
import { getActionMenuToggleRowSx } from "../utils/actionMenuStyles";
import {
  findClosestLineToDimension,
  getBoxesInsideWalls,
  getClosestWalls,
  getMaxWidthBox,
  isValidNumber,
  normalizeVerticesForMeasurementLine,
} from "../utils/compareTwoVertices";
import { fallBackManualItemZones, getMakeMagicZones } from "../utils/fallBackData";
import useUptimeTracker from "../hooks/useUptimeTracker";
import { useTrackEngagementMutation } from "../Slices/roomNateApis";
import layoutCacheStore from "../utils/Cache";
import { setPendingEditorBlob, CAPTURE_SKIPPED, setLastDoneEntry } from "../utils/pendingEditorBlobs";
import { shouldArmPickModeOnOpen, consumePendingShuffleIntent } from "../utils/pendingShuffleIntent";
import {
  SHUFFLE_FAB_ACTION,
  isPrimaryFabSolo,
  primaryFabSoloShiftPercent,
  resolveShuffleFabAction,
} from "../utils/editorShuffleFab";
import { resolveFurnitureRetransform } from "../utils/editorFurnitureTransform";
import { normalizeTextBoxes } from "../utils/normalizeTextBoxes";
import {
  getCoverFill,
  shouldCoverPlanLabelsForRoom,
} from "../utils/planLabelOverlays";
import {
  fingerprintEditorDomCapture,
  fingerprintGuestForkDomDeep,
  fingerprintGuestLayoutState,
  mfGalleryDebugEnabled,
  mfLogGalleryCaptureDiag,
  mfLogGuestGalleryAuth,
} from "../utils/galleryStaleTransitionDebug";
import { useDispatch } from "react-redux";
import { apiRoomNate } from "../Slices/roomNateApis";
import { useAnalytics } from '../utils/eventLogAnalytics';
import GalleryUploaderContactModal from "../Components/GalleryUploaderContactModal";
import GalleryInquireModal from "../Components/GalleryInquireModal";
import GalleryInterestToast from "../Components/GalleryInterestToast";
import { useGalleryInquiry } from "../hooks/useGalleryInquiry";
import { useGalleryUploaderContact } from "../hooks/useGalleryUploaderContact";
import { normalizeEmail } from "../utils/sessionAudience";
import {
  BUYER_CONTACT_MENU_LABEL,
  dismissContactBanner,
  inquiriesAvailableForLayout,
  canConfigureGalleryInquiries,
  isGuestLayoutOwner,
  layoutCopiedFromId,
  resolveGuestAuthPrefillEmail,
  shouldDisplayUploaderContactModal,
  shouldShowGuestContactBanner,
  shouldShowEditorInquireFab,
  shouldShowViewerInquire,
} from "../utils/galleryInquiryUx";
import {
  editorBottomFadeGradient,
  getFabCircleGlassSx,
  getSpatialFilterChipSx,
  ink,
} from "../theme/spatial";
import { getMFPrimaryButtonSx } from "../utils/dialogStyles";

const bedSize = ["Twin", "Full", "Queen", "King"];

/** Persisted so the editor tap-room hint does not return after dismiss or first room tap. */
const TAP_ROOM_HINT_DISMISSED_KEY = "mf_tap_room_hint_dismissed";
/**
 * How long an editor auto-armed into room-pick mode by the gallery "Shuffle it"
 * handoff waits for its plan's rooms before falling back to the default editor.
 * Only reached when the plan's payload never arrives, so it is a backstop rather
 * than part of the normal path — long enough to clear a slow fetch, short enough
 * that a user staring at an empty canvas is not left there.
 */
const ARMED_PICK_MODE_ROOMS_TIMEOUT_MS = 4000;
const GO_EDITOR = 1;
const GO_GALLERY = 2;
/**
 * Auth-gate surface for the guest "Save" intent. `requireAuth` keys the
 * pre-auth snapshot retention off this exact value, so the surface must stay
 * shared between the gate and whichever control raises the intent.
 */
const GUEST_SAVE_AUTH_SURFACE = "primarySaveShareFabGuestSave";
// eslint-disable-next-line no-unused-vars
const _console = globalThis.console; // when console is disabled, we can still use this one for specific log
const targetWindowNear = window.opener || (window.parent !== window ? window.parent : null);
const targetWindow =  targetWindowNear && targetWindowNear.parent !== targetWindowNear ? targetWindowNear.parent : targetWindowNear;

const tv = ["Yes", "No"];

/**
 * The combined room type has no entry in `zonesData`; it is synthesised from a
 * room holding both `lounging` and `dining`. Must stay a stable reference: the
 * effect that resolves it runs on every `zonesRoom` change, so a fresh object
 * gave `selectedOption` a new identity each time, which retriggered the
 * seating-capacity effect, which rewrote `zonesRoom` — an endless loop that no
 * other room type entered, every other option being a `zonesData` element.
 */
const LIVING_DINING_OPTION = {
  value: "lounging,dining",
  label: "Living + Dining",
  img: "/livingRoom.svg",
};

// Use canonical baseUrl import only


// =====================================================
// TRIPWIRE CONFIG: Runtime-configurable, staging-only
// =====================================================
// Tripwire blocking is enabled ONLY when:
// 1. Running on staging hostname, AND
// 2. REACT_APP_TRIPWIRE_BLOCK_SAVE env var is 'true'
// OR via query param ?tripwireBlock=1 for testing
// =====================================================
const getTripwireBlockSave = () => {
  // Check query param first (for testing)
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('tripwireBlock') === '1') return true;
    if (urlParams.get('tripwireBlock') === '0') return false;
  }
  // Staging hostname check + env var
  const isStaging = typeof window !== 'undefined' && 
    window.location.hostname.includes('staging');
  const envEnabled = process.env.REACT_APP_TRIPWIRE_BLOCK_SAVE === 'true';
  return isStaging && envEnabled;
};
const TRIPWIRE_BLOCK_SAVE = getTripwireBlockSave();

// =====================================================
// TRIPWIRE HELPER: Compute World Geometry Hash
// =====================================================
// Creates a hash of world geometry (room vertices + furniture exactPosition).
// Used to detect if world geometry is corrupted by camera/view values.
// If hash changes after init, something wrote VIEW data to WORLD coords.
// =====================================================
const computeWorldGeometryHash = (roomsData, modalVertices) => {
  // Need either roomsData or modalVertices to compute hash
  if ((!roomsData || !Array.isArray(roomsData) || roomsData.length === 0) &&
      (!modalVertices || !Array.isArray(modalVertices) || modalVertices.length === 0)) {
    return null;
  }
  
  // Hash modalVertices (floor plan vertices) if available
  // modalVertices is the primary source of world geometry
  let vertexString = '';
  if (modalVertices && Array.isArray(modalVertices) && modalVertices.length > 0) {
    vertexString = modalVertices
      .slice(0, 20) // Limit to first 20 vertices for performance
      .map(v => {
        // Handle { points: [{x, y}, {x, y}] } format (wall segments)
        if (v?.points && Array.isArray(v.points)) {
          return v.points.map(p => `${(p?.x ?? 0).toFixed(2)},${(p?.y ?? 0).toFixed(2)}`).join('|');
        }
        // Handle array of points format
        if (Array.isArray(v)) {
          return v.map(p => `${(p?.x ?? 0).toFixed(2)},${(p?.y ?? 0).toFixed(2)}`).join('|');
        }
        // Handle single point format
        return `${(v?.x ?? 0).toFixed(2)},${(v?.y ?? 0).toFixed(2)}`;
      })
      .join(';');
  }
  
  // Also hash furniture exactPosition from first room's first layout
  // This catches corruption in furniture world coordinates
  let furnitureString = '';
  const firstRoom = roomsData?.[0];
  const firstLayout = firstRoom?.layouts?.[0];
  if (firstLayout?.furniture && Array.isArray(firstLayout.furniture)) {
    furnitureString = firstLayout.furniture
      .slice(0, 10) // Limit to first 10 items for performance
      .map(f => {
        const ex = f?.exactPosition;
        if (ex) {
          return `${(ex.x ?? 0).toFixed(2)},${(ex.y ?? 0).toFixed(2)}`;
        }
        return '';
      })
      .filter(s => s)
      .join('|');
  }
  
  // Need at least vertex or furniture data to create hash
  if (!vertexString && !furnitureString) {
    return null;
  }
  
  const combinedString = `V:${vertexString}|F:${furnitureString}`;
  
  // Simple hash function (djb2)
  let hash = 5381;
  for (let i = 0; i < combinedString.length; i++) {
    hash = ((hash << 5) + hash) + combinedString.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return hash.toString(16);
};

// =====================================================
// 🔧 SCALE DEBUG UTILITY
// Enable with ?debugScale=1 or localStorage.MF_DEBUG_SCALE='1'
// This is OFF by default - no performance impact in production
// 
// WHAT THIS LOGS (when enabled):
// 1. Entry point: scale factors, flow type, room/furniture counts
// 2. Per-room: camera ratios, effective multipliers
// 3. Per-item: transform calculations, internal vs external comparison
// 4. Summary: mutation count, which items affected
// =====================================================
const isScaleDebugEnabled = () => {
  if (typeof window === 'undefined') return false;
  return window.location?.search?.includes('debugScale=1') ||
    localStorage?.getItem('MF_DEBUG_SCALE') === '1';
};

const scaleDebug = {
  enabled: () => isScaleDebugEnabled(),
  log: (...args) => isScaleDebugEnabled() && console.log('[SCALE]', ...args),
  warn: (...args) => isScaleDebugEnabled() && console.warn('[SCALE]', ...args),
  error: (...args) => isScaleDebugEnabled() && console.error('[SCALE]', ...args),
  group: (label) => isScaleDebugEnabled() && console.group('[SCALE] ' + label),
  groupCollapsed: (label) => isScaleDebugEnabled() && console.groupCollapsed('[SCALE] ' + label),
  groupEnd: () => isScaleDebugEnabled() && console.groupEnd(),
  table: (data) => isScaleDebugEnabled() && console.table(data),
  // Always log mutations (even in prod) - but just one line
  mutation: (msg) => console.warn('[SCALE MUTATION]', msg),
  // Helper to format numbers
  fmt: (n, decimals = 4) => typeof n === 'number' ? n.toFixed(decimals) : 'N/A',
};

/**
 * Liquid-glass pill — one per button in the bottom toolbar.
 *
 * Achieves the Apple liquid-glass look without backdrop-filter:
 *   • Near-opaque cool-white fill simulates the frosted backing.
 *   • Multi-layer box-shadow matches editorTopBarMenuIconSx exactly:
 *       outer blue-tinted drop + close diffuse + specular top highlight + bottom edge.
 *   • White semi-transparent border catches the specular rim.
 *   • No backdrop-filter → zero GPU rasterisation cost on mobile Safari.
 */
const EDITOR_BOTTOM_PILL = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: { xs: "4px", sm: "5px" },
  px: { xs: "12px", sm: "14px" },
  py: { xs: "10px", sm: "11px" },
  minHeight: { xs: 54, sm: 52 },
  minWidth: { xs: 52, sm: 56 },
  borderRadius: { xs: "16px", sm: "18px" },
  background: "rgba(252, 252, 255, 0.98)",
  border: "1px solid rgba(255, 255, 255, 0.72)",
  boxShadow: [
    "0 6px 18px rgba(13, 40, 71, 0.10)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.95)",
    "inset 0 -1px 0 rgba(255, 255, 255, 0.20)",
  ].join(", "),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  pointerEvents: "auto",
  // Only transform on press — no background transition avoids a repaint on every tap.
  transition: "transform 0.12s ease",
  "&:active": { transform: "scale(0.96)" },
};


/** Row wrapper for pill buttons — pointer-events none so gaps between pills
 *  are transparent to touch, letting pinch-to-zoom reach the canvas beneath. */
const EDITOR_PILLS_ROW_SX = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "flex-end",
  flexWrap: "nowrap",
  pointerEvents: "none",
};

/**
 * Filter flyout choice chips — matches editor pill language, no backdrop-filter.
 *
 * Style body now lives in src/theme/spatial (getSpatialFilterChipSx). The
 * wrapper keeps the same call signature so the existing chip render sites do
 * not move. The MUI theme argument is intentionally accepted (and ignored)
 * because the spatial chip uses neutral ink rather than the tenant primary
 * the previous implementation pulled from `muiTheme.palette.primary.main`.
 */
const getEditorFilterChipSx = (_muiTheme, selected) =>
  getSpatialFilterChipSx({ selected });

/**
 * Extra offset so fixed editor chrome sits above the "Powered by" strip (+8px).
 * Applied to all editor `bottom` anchors that share the safe-area baseline.
 */
const EDITOR_ABOVE_BRANDING_PX = 8;

/**
 * CSS bottom value for all primary-row fixed elements (FAB, left slot, right slot).
 * Respects iOS safe-area-inset-bottom (home indicator).
 */
const EDITOR_FAB_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * CSS bottom value for the reset-room one-line strip.
 * Sits 12 px above the 52 px-tall 3-FAB row.
 */
// iOS button row: 52px circle + 4px gap + 16px text = 72px. Add 12px clearance above = 84px.
const EDITOR_RESET_STRIP_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + 84px + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * Shared width for the reset-room strip and its flyout panels (zone dropdown +
 * filter panel).  Compact and centred — matches the Make Magic FAB's position.
 */
const EDITOR_RESET_STRIP_WIDTH = "min(310px, calc(100vw - 40px))";

/**
 * CSS bottom value for the furniture actions row (Rotate/Flip/Remove circles).
 * Reuses the room-type strip slot, leaving the primary FAB row available.
 */
const EDITOR_FURNITURE_ACTIONS_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + 84px + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * CSS bottom value for the flip sub-menu pills.
 * Floats above the 52 px-tall furniture-actions row.
 */
const EDITOR_FLIP_MENU_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + 148px + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * CSS bottom value for the zone-type options list and the filter panel that
 * open upward from the reset-room one-line strip.
 * Strip bottom = EDITOR_RESET_STRIP_BOTTOM (64 px), strip height ~44 px,
 * so panels start 8 px above the strip top = 64 + 44 + 8 = 116 px.
 */
// Strip bottom (84px) + strip height ~44px + 8px gap = 136px (+ branding nudge).
const EDITOR_RESET_ZONE_DROPDOWN_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + 136px + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * CSS bottom value for floating toasts (fork toast, helper hints, etc.).
 * Clears the strip (64 px bottom + 44 px height) plus a 12 px gap = 120 px.
 */
const EDITOR_TOAST_BOTTOM = `calc(max(28px, env(safe-area-inset-bottom, 28px)) + 140px + ${EDITOR_ABOVE_BRANDING_PX}px)`;

/**
 * 52 × 52 px glass circle — used for the furniture action buttons
 * (Rotate, Flip/3-dot, Remove).  Matches the liquid-glass language of
 * the pill buttons but is compact and icon-only.
 */
const EDITOR_CIRCLE_BTN_SX = {
  width: 52,
  height: 52,
  flexShrink: 0,
  borderRadius: "50%",
  background: "rgba(252, 252, 255, 0.98)",
  border: "1px solid rgba(255, 255, 255, 0.72)",
  boxShadow: [
    "0 6px 18px rgba(13, 40, 71, 0.10)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.95)",
    "inset 0 -1px 0 rgba(255, 255, 255, 0.20)",
  ].join(", "),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  transition: "transform 0.12s ease",
  "&:active": { transform: "scale(0.93)" },
  pointerEvents: "auto",
};

/** Destructive variant — red tint for the Remove/trash button. */
const EDITOR_CIRCLE_BTN_DESTRUCTIVE_SX = {
  ...EDITOR_CIRCLE_BTN_SX,
  background: "rgba(255, 245, 245, 0.98)",
  border: "1px solid rgba(255, 59, 48, 0.20)",
  boxShadow: [
    "0 6px 18px rgba(255, 59, 48, 0.12)",
    "0 1px 4px rgba(0, 0, 0, 0.05)",
    "inset 0 1.5px 0 rgba(255, 255, 255, 0.95)",
    "inset 0 -1px 0 rgba(255, 59, 48, 0.08)",
  ].join(", "),
};

/** Active/open state for the 3-dot flip button. */
const EDITOR_CIRCLE_BTN_ACTIVE_SX = {
  ...EDITOR_CIRCLE_BTN_SX,
  background: "rgba(235, 240, 255, 0.98)",
  border: "1px solid rgba(100, 130, 255, 0.30)",
};


/** Dark gray (not pure black) — pairs with the light frost capsule. */
const EDITOR_FOOTER_ICON_TONE = "rgba(60, 60, 67, 0.78)";


const EDITOR_FOOTER_LABEL_SX = {
  fontSize: { xs: "10px", sm: "11px" },
  fontWeight: 500,
  letterSpacing: "-0.01em",
  lineHeight: 1.15,
  color: "rgba(60, 60, 67, 0.78)",
  textAlign: "center",
  px: 0.25,
  textShadow: "0 1px 0 rgba(255, 255, 255, 0.55)",
};

/** Same ink as `actions.svg` — Done label + enabled undo/redo (no brand primary). */
const EDITOR_TOP_BAR_ICON_ENABLED = "#202124";
/** Tertiary / disabled undo-redo only */
const EDITOR_TOP_BAR_ICON_DISABLED = "rgba(60, 60, 67, 0.36)";

/**
 * Shared glass surface for floating header: undo, redo, ⋯, and Done pill.
 * Keeps fill + shadow aligned (Done previously used a lighter fill + flat shadow).
 */
const EDITOR_TOP_BAR_SURFACE_SX = {
  border: `1px solid ${alpha("#FFFFFF", 0.72)}`,
  background: "rgba(248, 248, 250, 0.97)",
  boxShadow: [
    `0 6px 18px ${alpha("#0d2847", 0.1)}`,
    `0 1px 4px ${alpha("#000000", 0.05)}`,
    `inset 0 1px 0 ${alpha("#FFFFFF", 0.85)}`,
    `inset 0 -1px 0 ${alpha("#FFFFFF", 0.15)}`,
  ].join(", "),
};

/** System blue (iOS/macOS) — opaque furniture selection frame; avoids soft brand alpha on imagery. */
const EDITOR_FURNITURE_SELECTION_STROKE = "#007AFF";

/** Editor-side stale-gallery trace (native console — UploadFloor shadows `console`). */
const mfStaleGalleryEditorLog = (...args) => {
  if (!mfGalleryDebugEnabled()) return;
  globalThis.console?.log?.("[MF:stale-gallery:editor]", new Date().toISOString(), ...args);
};

// eslint-disable-next-line no-unused-vars
const console = { log() {}, warn() {}, error() {}, debug() {}, info() {}, time() {}, timeEnd() {}, group() {}, trace() {}, groupCollapsed() {}, groupEnd() {}, table() {} };

/**
 * Chains a room's wall segments into an ordered vertex list.
 * Returned array elements are the original wall objects in polygon order.
 */
// Converts wall segments into an ordered polygon vertex list.
// Primary strategy: chain walls head-to-tail, accepting both forward and
// reversed segment directions (walls can be stored either way in the API).
// Fallback: if chaining is incomplete, collect unique endpoints and sort by
// angle from centroid (covers convex rooms regardless of wall order).
function buildRoomPolygon(walls) {
  if (!walls?.length) return [];
  const EPS = 1.0;
  const close = (a, b) => Math.abs(a - b) < EPS;

  // Mutable working copy — each segment tracks whether it has been used
  const segs = walls.map((w) => ({
    sx: parseFloat(w.start.x), sy: parseFloat(w.start.y),
    ex: parseFloat(w.end.x),   ey: parseFloat(w.end.y),
    used: false,
  }));

  segs[0].used = true;
  const pts = [
    { x: segs[0].sx, y: segs[0].sy },
    { x: segs[0].ex, y: segs[0].ey },
  ];

  for (let iter = 1; iter < segs.length; iter++) {
    const { x: cx, y: cy } = pts[pts.length - 1];
    let found = false;
    for (const s of segs) {
      if (s.used) continue;
      if (close(s.sx, cx) && close(s.sy, cy)) {
        pts.push({ x: s.ex, y: s.ey });
        s.used = true; found = true; break;
      }
      if (close(s.ex, cx) && close(s.ey, cy)) {
        pts.push({ x: s.sx, y: s.sy });
        s.used = true; found = true; break;
      }
    }
    if (!found) break;
  }

  // Remove closing vertex if it mirrors the first point (closed polygon)
  if (pts.length > 1) {
    const f = pts[0]; const l = pts[pts.length - 1];
    if (close(f.x, l.x) && close(f.y, l.y)) pts.pop();
  }

  // If chaining produced fewer vertices than walls, fall back to
  // centroid-angle sort over unique endpoints — works for convex rooms.
  if (pts.length < walls.length) {
    const uniq = [];
    const add = (x, y) => {
      if (!uniq.some((p) => close(p.x, x) && close(p.y, y))) uniq.push({ x, y });
    };
    for (const w of walls) {
      add(parseFloat(w.start.x), parseFloat(w.start.y));
      add(parseFloat(w.end.x),   parseFloat(w.end.y));
    }
    if (uniq.length < 3) return uniq;
    const mx = uniq.reduce((s, p) => s + p.x, 0) / uniq.length;
    const my = uniq.reduce((s, p) => s + p.y, 0) / uniq.length;
    uniq.sort((a, b) => Math.atan2(a.y - my, a.x - mx) - Math.atan2(b.y - my, b.x - mx));
    return uniq;
  }

  return pts;
}

const UploadFloor = ({
  layoutId,
  setSketchUploadValue,
  setActiveLayout,
  setStackedLayouts,
  directoryData,
  refetchDirectoryData,
  versionLayout,
  setVersionLayout,
  setProgress,
  setShowVersionLayout,
}) => {
  // =====================================================
  // UPLOADFLOOR RENDER COUNTER - TRACK PARENT RENDERS
  // =====================================================
  // [CODE-VERSION-CHECK] If this appears, latest code is loaded
  if (typeof window !== 'undefined' && !window.__mf_code_version_logged) {
    window.__mf_code_version_logged = true;
    console.error('[CODE-CHECK] UploadFloor loaded with TIMING logs version. Build time:', new Date().toISOString());
  }
  const uploadFloorRenderCountRef = useRef(0);
  const afterAuthSuccessDestinationRef = useRef(GO_EDITOR);
  const uploadFloorMountTimeRef = useRef(Date.now());
  uploadFloorRenderCountRef.current += 1;
  
  const ufRenderCount = uploadFloorRenderCountRef.current;
  const ufTimeSinceMount = Date.now() - uploadFloorMountTimeRef.current;
  
  // [FLASH-DEBUG] Log EVERY render with timestamp for first 20 renders
  if (ufRenderCount <= 20) {
    console.log('[FLASH-DEBUG] RENDER #' + ufRenderCount + ' at t=' + Date.now() + ' (+' + ufTimeSinceMount + 'ms since mount)');
  }
  // Log every 100th render or first 5
  if (ufRenderCount <= 5 || ufRenderCount % 100 === 0) {
    console.log('');
    console.log('╔════════════════════════════════════════════════════════════════════╗');
    console.log('║  [UPLOADFLOOR] 🔄 RENDER #' + ufRenderCount);
    console.log('╠════════════════════════════════════════════════════════════════════╣');
    console.log('║  Time since mount: ' + ufTimeSinceMount + 'ms');
    console.log('║  Renders per second: ' + (ufRenderCount / Math.max(1, ufTimeSinceMount / 1000)).toFixed(2));
    console.log('║  layoutId: ' + layoutId);
    console.log('╚════════════════════════════════════════════════════════════════════╝');
    console.log('');
  }
  
  // Warn about excessive renders
  if (ufRenderCount > 50 && ufTimeSinceMount < 5000) {
    if (ufRenderCount % 200 === 0) {
      console.error('');
      console.error('🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨');
      console.error('🚨 [UPLOADFLOOR] EXCESSIVE RENDERS DETECTED!');
      console.error('🚨 ' + ufRenderCount + ' renders in ' + ufTimeSinceMount + 'ms');
      console.error('🚨 This is likely causing the Share modal flicker!');
      console.error('🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨');
      console.error('');
    }
  }
  
  const {
    uploadImage,
    modalVertices,
    modalData,
    floors,
    setModalData,
    setModalVertices,
    setFloors,
    boxes,
    planLabelBoxes,
    setPlanLabelBoxes,
    forkTransitioning,
    setForkTransitioning,
    setDoneEditing,
    clientRef,
    activeLayout,
  } = useGlobalContext();
  const { eventLog } = useAnalytics(clientRef || 'custom-ref-not-provided');


  const theme = useTheme();
  const dispatch = useDispatch();

  const [minScale, setMinScale] = useState(0.5);
  // Brand color used by discrete affordances inside filter / room-type
  // panels — slider thumb + track, bed-size selected label. These read as
  // tenant accents (not as primary CTAs), so brand is correct here.
  // Primary CTAs (Apply, Make Magic) consume getMFPrimaryButtonSx instead.
  const primaryColor = theme.palette.customPrimary?.main || "#006766";

  const editorTopBarMenuIconSx = useMemo(
    () => ({
      ...EDITOR_TOP_BAR_SURFACE_SX,
      width: 36,
      height: 36,
      minWidth: 36,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    }),
    []
  );

  const sliderRef = useRef(null);

  const DEBOUNCE_DELAY = 0; 
  const layoutCache = layoutCacheStore;

  const params = useParams();
  const { currentUserSessionStorage, partner , partnerPackage} = useGlobalAuthContext();

  // Guest editor mode — derived from auth state
  const isGuest = !currentUserSessionStorage;
  const [isForked, setIsForked] = useState(false);
  const [forkToastOpen, setForkToastOpen] = useState(false);
  useEffect(() => {
    if (!forkToastOpen) return;
    const t = setTimeout(() => setForkToastOpen(false), 4000);
    return () => clearTimeout(t);
  }, [forkToastOpen]);
  const originalLayoutIdRef = useRef(null);
  const forkedLayoutIdRef = useRef(null);   // After fork-save, saves redirect here
  // Room-pick overlay canvas — imperative, avoids React re-renders on pan/zoom
  const overlayCanvasRef = useRef(null);
  const drawOverlayRef = useRef(null);
  const isPickingRoomRef = useRef(false);
  // Animated border canvas — separate from dim canvas so the rAF loop only
  // redraws lightweight strokes; the expensive destination-out dim stays event-driven.
  const borderCanvasRef = useRef(null);
  const borderAnimRef = useRef(null);   // rAF id for cleanup
  const drawBordersStaticRef = useRef(null); // static redraw fn for pan/zoom in normal mode
  const dashOffsetRef = useRef(0);      // current animated dash offset
  // Desktop hover: which room the pointer is currently over (null = none).
  // Read by the border-canvas rAF loop; written by the mousemove useEffect.
  const hoveredRoomRef = useRef(null);
  const forkedLayoutUuidRef = useRef(null);
  // Phase 1 fork-save honesty primitives.
  // forkSaveError: null = saving overlay; string = error overlay with Retry.
  // lastAuthUserIdRef: userId captured at auth success so Retry can refire
  //   saveForkedLayoutAndNavigate without re-prompting the auth modal.
  // forkSaveRetryInFlightRef: guard so a double-tap on Retry can't re-enter.
  // forkTransitioningRef: mirror of forkTransitioning state, read inside
  //   updatedLayoutHelper to block ANY non-strict save during the fork-save
  //   window even if the calling closure was captured before the state flip.
  //   This is the single gate that prevents an autosave timer or any other
  //   pre-auth save call from PUTting to the original layout after login but
  //   before saveForkedLayoutAndNavigate has set forkedLayoutIdRef.
  const [forkSaveError, setForkSaveError] = useState(null);
  const lastAuthUserIdRef = useRef(null);
  const forkSaveRetryInFlightRef = useRef(false);
  const forkTransitioningRef = useRef(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authPrefillEmail, setAuthPrefillEmail] = useState("");
  const guestAuthPrefillEmailRef = useRef("");
  const [inquireModalOpen, setInquireModalOpen] = useState(false);
  const pendingActionRef = useRef(null);
  /** Caller label for guest requireAuth (Save vs Done vs share); cleared in handleAuthSuccess. */
  const pendingGuestAuthIntentRef = useRef(null);
  // Refs to keep latest editor state accessible from stale closures (useCallback)
  const roomsDataRef = useRef(null);
  const roomActiveRef = useRef(null);
  const roomActiveLayoutRef = useRef(null);
  const zonesRoomRef = useRef(null);
  /** Prevents double-firing Back to Gallery (parallel saves / backend overload). */
  const editorBackToGalleryInFlightRef = useRef(false);
  /** Guest Done→gallery: frozen rooms slice captured before auth (live refs may reset after login). */
  const guestForkGallerySaveSnapshotRef = useRef(null);
  /** Guest Done→gallery: DOM capture taken before auth (post-login DOM may refetch stale). */
  const guestForkGalleryCaptureBlobRef = useRef(null);
  /** Latest `downloadLayout` (defined later); used for guest fork → gallery capture only. */
  const downloadLayoutForGalleryCaptureRef = useRef(null);
  /** Editor scale/DOM snapshot for comparing guest fork vs logged-in Done at log time. */
  const guestForkEditorDiagRef = useRef(null);
  /** Correlate forkSave → downloadLayout(type=2); set immediately before capture call. */
  const galleryCaptureDiagSessionRef = useRef(null);
  /** Monotonic id for one guest fork save attempt (forkDiag.* logs). */
  const forkDiagSessionCounterRef = useRef(0);
  /** performance.now() at start of forkDiag session. */
  const forkSaveDiagT0Ref = useRef(0);
  /** Set to true when the seating slider is committed (mouse-up) so the downstream
   *  zonesRoom effect knows to auto-apply a new layout. */

  const [selectedFurniture, setSelectedFurniture] = useState(null);
  const [selectedCopyFurniture, setCopySelectedFurniture] = useState(null);

  const [furniturePositions, setFurniturePositions] = useState({});
  const [isShareLayout, setIsSharelayout] = useState(false);
  const [isResetScale, setIsResetScale] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [layoutDataIdToEdit, setLayoutDataIdToEdit] = useState('');

  const containerShoppingRef = useRef(null);

  const { userProfile: userData, isUserProfileLoaded: isUserDataSuccess } = useUserProfileSelector();

  const [postTrackEngagement] = useTrackEngagementMutation();


  const { data: partnerZones, isLoading: partnerZonesLoading } = useGetPartnerZonesQuery(partner, {
    skip: !partner,
  });

  const zonesData = useMemo(
    () => getMakeMagicZones(partnerZones),
    [partnerZones]
  );
  
  const manualItemsZones = useMemo(() => {
    return (Array.isArray(partnerZones) && partnerZones?.length > 0 
      ? partnerZones 
      : fallBackManualItemZones
    )?.filter(zone => zone.visibleOnManualItem);
  }, [partnerZones]);

  const [resultRoomVerticesState, setResultRoomVerticesState] = useState([]);
  const [backTrackKeepItems, setBackTrackKeepItems] = useState({});
  const [textShow, setTextShow] = useState(false);
  const [optionsMenu, setOptionsMenu] = useState(null);
  // ─── Gallery "Shuffle it" handoff — armed state ──────────────────────────
  // The uuid is reachable three ways depending on which route the editor was
  // opened through (/layout/:id, /floor-plan/:layoutId/version/:version, or the
  // activeLayout handed over by SketchUpload). Check all of them — a key that
  // resolves undefined fails open silently, which is exactly how the first cut
  // of this looked like "nothing happened".
  const shuffleIntentLayoutKey = params.id || params.layoutId || layoutId;
  // Decided once, for the first render, so every piece of pick-mode state can be
  // seeded together. Tapping the Shuffle FAB manually moves five values at once
  // and is only reachable when roomActive is already -1; arming isPickingRoom on
  // its own left the rest at their editor-open defaults, producing a pick-mode
  // state the manual entry point can never reach. peek is side-effect free, so
  // re-evaluating on later renders is harmless — only the initializers below
  // read it, and the intent itself is consumed from the readiness guard.
  const armPickModeOnOpen = shouldArmPickModeOnOpen({
    allowMakeMagic: partnerPackage?.allowMakeMagic,
    layoutKey: shuffleIntentLayoutKey,
  });
  // Manual entry clears this so the "Tap a room" hint reappears on every tap.
  const [tapRoomHintDismissed, setTapRoomHintDismissed] = useState(!armPickModeOnOpen);
  // eslint-disable-next-line no-unused-vars
  const [showHelperMessage, setShowHelperMessage] = useState(armPickModeOnOpen);
  // shufflePickedRoom: room object from modalData that was picked during the shuffle flow.
  // null = no room picked yet. Set when user clicks a room during picking mode; cleared when
  // the overlay is dismissed (no-room click, different room click, or new shuffle started).
  const [shufflePickedRoom, setShufflePickedRoom] = useState(null);
  const shufflePickedRoomRef = useRef(null);

  // true only while waiting for the user to pick a room after tapping "Shuffle Layout"
  //
  // Armed on the FIRST render when the gallery's "Shuffle it" CTA handed off an
  // intent for this layout, so the editor opens already in room-pick mode rather
  // than painting the default editor and transitioning after mount. The editor's
  // existing loading veil covers this window, so there is nothing to see change.
  //
  // peek, never consume, during render: the gallery → editor navigation mounts
  // this component twice. "Shuffle it" fires setActiveLayout at normal priority
  // and navigate inside a transition (v7_startTransition), so SketchUpload
  // swaps the gallery for the editor first, and the route change then replaces
  // that whole subtree — /floor-gallery/:galleryId and /floor-plan/:layoutId/
  // version/:version are separate <Route> entries, each with its own
  // <SketchUpload />. The second mount is the editor the user ends up in, so
  // the intent has to still be there for it. It is consumed later, from the
  // readiness guard, once an armed editor has actually finished loading.
  const [isPickingRoom, setIsPickingRoom] = useState(armPickModeOnOpen);
  // Records that pick mode came from the gallery handoff rather than a user tap,
  // so the readiness guard can stand down without touching the manual flow.
  const autoArmedPickRef = useRef(isPickingRoom);
  // The armed open still owes the user a decision about whether this plan has
  // anything to pick. Separate from autoArmedPickRef because that one is spent
  // claiming the intent, which happens on load, well before the answer is known.
  const armedPickNeedsRoomsRef = useRef(armPickModeOnOpen);
  // Rooms as the plan currently on screen actually defines them, once its saved
  // payload has been applied. null until then — which is the whole point, since
  // "no rooms yet" and "no rooms at all" are otherwise indistinguishable. Tagged
  // with the layout it describes: one mounted editor can move between layouts
  // (version switch, guest fork-save), and the previous plan's answer says
  // nothing about this one.
  const [payloadRoomsForLayout, setPayloadRoomsForLayout] = useState(null);
  // Read from the timeout below, which fires long after its closure went stale.
  const modalDataRef = useRef(modalData);
  useEffect(() => { modalDataRef.current = modalData; }, [modalData]);
  useEffect(() => { isPickingRoomRef.current = isPickingRoom; }, [isPickingRoom]);
  // Invariant: room-pick mode is a Make Magic affordance, and being in it hides
  // the primary FAB row. If the flag resolves to off while pick mode is active
  // there would be no controls and no hint on screen, so stand down.
  useEffect(() => {
    if (isPickingRoom && !partnerPackage?.allowMakeMagic) setIsPickingRoom(false);
  }, [isPickingRoom, partnerPackage]);
  useEffect(() => { shufflePickedRoomRef.current = shufflePickedRoom; }, [shufflePickedRoom]);
  // Close flip sub-menu whenever furniture selection changes.
  useEffect(() => { setShowFlipMenu(false); }, [selectedFurniture]);
  const [tooltipAnimKey, setTooltipAnimKey] = useState(0);
  const dismissTapRoomHint = useCallback(() => {
    try {
      localStorage.setItem(TAP_ROOM_HINT_DISMISSED_KEY, "1");
    } catch (_) {
      /* ignore quota / private mode */
    }
    setTapRoomHintDismissed(true);
    setShowHelperMessage(false);
    setIsPickingRoom(false);
  }, []);
  const [showZonesMenu, setShowZonesMenu] = useState(false);

  const [autoSave, setAutoSave] = useState(false);
  const [, setUpdatedTime] = useState(null);
  const [autoSaveloading, setAutoSaveLoading] = useState(false);
  const [minimizeLoading] = useState(false);
  const [IsNewFolderOpen, setIsNewFolderOpen] = useState(false);
  const autoSaveloadingRef = useRef(autoSaveloading);
  const timeoutRef = useRef(null);
  const [autoSaveDataState, setAutoSaveDataState] = useState({});
  const autoSaveDataRef = useRef({});
  const [shareMenu, setShareMenu] = useState([]);
  const [, setShareModalOpen] = useState(false);
  const [brandedExportOpen, setBrandedExportOpen] = useState(false);
  const [shareLinkCopied] = useState(false);
  const [, setMoveMenu] = useState([]);
  const [viewLayouts, setViewLayouts] = useState(true);

  const [settingsMenu, setSettingsMenu] = useState([]);
  const [uploaderContactModalOpen, setUploaderContactModalOpen] = useState(false);

  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [imagesCountState, setImagesCountState] = useState(0);
  const [, setRerunImagesLoad] = useState(false);
  const [globalUndoFurniture, setGlobalUndoFurniture] = useState([]);

  const [globalRedoFurniture, setGlobalRedoFurniture] = useState([]);

  /** Mirror stack state on every render so handlers see the same stacks the toolbar uses for disabled state. */
  const globalUndoFurnitureRef = useRef([]);
  const globalRedoFurnitureRef = useRef([]);
  globalUndoFurnitureRef.current = globalUndoFurniture;
  globalRedoFurnitureRef.current = globalRedoFurniture;

  const isDraggingFurnitureItem = useRef();

  const isDragDiv = useRef();

  const [loadingLayout, setLoadingLayout] = useState(false);
  /** After a short delay while `loadingLayout` — spinner/label so long waits feel intentional (no API change). */
  const [shuffleLoadingAffordanceVisible, setShuffleLoadingAffordanceVisible] =
    useState(false);
  const shuffleLoadingAffordanceTimerRef = useRef(null);

  const [zoomChecker, setZoomChecker] = useState(true);

  const [scaleXCanvas, setScaleXCanvas] = useState(0);
  const [scaleYCanvas, setScaleYCanvas] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const [offsetXCheck, setOffsetXCheck] = useState(0);
  const [offsetYCheck, setOffsetYCheck] = useState(0);
  
  // RENDER-ONLY scale correction factor
  // This is applied when RENDERING furniture positions, NOT saved to DB
  // It compensates for the difference between backend viewport and user viewport
  // without mutating the canonical exactPosition/origionalPosition values
  const [renderScaleCorrectionX, setRenderScaleCorrectionX] = useState(1);
  const [renderScaleCorrectionY, setRenderScaleCorrectionY] = useState(1);

  const [offsetXCalculateCheck, setOffsetXCalculateCheck] = useState(0);
  const [offsetYCalculateCheck, setOffsetYCalculateCheck] = useState(0);
  const [scaleXCalculateCanvas, setScaleXCalculateCanvas] = useState(0);
  const [scaleYCalculateCanvas, setScaleYCalculateCanvas] = useState(0);
  const [calculateScaleFlag, setCalculateScaleFlag] = useState(false);

  const [scale, setScale] = useState(1);

  const [startPoint, setStartPoint] = useState(null);

  const [loading, setLoading] = useState(null);

  const [vertices, setVertices] = useState({
    index: false,
    roomId: "",
    vertices: [],
  });

  const [items, setItems] = useState([]);

  const [initialScaleFactorX, setInitialScaleFactorX] = useState(false);

  const [calculateInitialScaleFactorX, setCalculateInitialScaleFactorX] =
    useState(false);

  // =====================================================
  // Initialize scale factors to 1 (safe default, prevents Infinity from division)
  // handleUpdate guards block until API sets real values.
  // Furniture rendering is gated on scaleReady to prevent flash.
  // =====================================================
  const [calculateScaleFactorX, setCalculateScaleFactorX] = useState(1);
  const [calculateScaleFactorY, setCalculateScaleFactorY] = useState(1);

  const [scaleFactorX, setScaleFactorX] = useState(1);
  const [scaleFactorY, setScaleFactorY] = useState(1);
  
  // =====================================================
  // PR #89: scaleReady - Gate for auto-save and add-item
  // =====================================================
  // This state tracks when scale initialization is COMPLETE:
  // - Container has non-zero dimensions
  // - scaleFactorX/Y are valid (from API or room data)
  // - handleUpdate has run at least once
  // Until this is true, we should NOT:
  // - Auto-save (would save uninitialized/wrong positions)
  // - Add new items (would use wrong scale for sizing)
  // Using state (not ref) so addItems useEffect can re-trigger when ready
  // =====================================================
  const [scaleReady, setScaleReady] = useState(false);
  
  // =====================================================
  // VIEW TRANSFORM LOCK: Freeze scale/offset after first calculation
  // =====================================================
  // This prevents "mutation" when clicking Customize.
  // Root cause: drawVerticesInDiv fires multiple times, each time
  // potentially recalculating scale/offset → furniture appears to mutate.
  // 
  // Fix: Compute scale/offset ONCE per editor entry, then LOCK it.
  // Unlock only when: new layout loads, or (optionally) window resizes.
  // =====================================================
  const viewTransformLockedRef = useRef(false);
  const viewTransformRef = useRef({ scale: null, offsetX: null, offsetY: null });
  const drawCallCountRef = useRef(0); // For binary validation logging
  
  // =====================================================
  // TRIPWIRE: World Geometry Hash
  // =====================================================
  // Stores a hash of world geometry (room vertices) after initialization.
  // Before auto-save, we compare current hash with initial hash.
  // If different → WORLD coords mutated → block save and log.
  // This catches "transform ownership corruption" where camera/view
  // values accidentally overwrite world coordinates.
  // =====================================================
  const worldGeometryHashRef = useRef(null);
  const worldGeometryInitializedRef = useRef(false);
  // =====================================================
  // TRIPWIRE: Track if user has made intentional edits
  // =====================================================
  // When user drags, shuffles, adds, or removes furniture,
  // world geometry SHOULD change - tripwire must not block.
  // Tripwire only blocks when hasUserEditedRef.current === false
  // (i.e., during gallery→editor transition or refetch with no edits)
  // =====================================================
  const hasUserEditedRef = useRef(false);
  
  // =====================================================
  // SCALE FACTOR INVARIANT: Track if scaleFactorX came from API
  // =====================================================
  // When scaleFactorX is set from API (world calibration from CV),
  // we must NOT overwrite it with the calibration useEffect calculation.
  // The calibration useEffect should only run when user explicitly
  // changes measurements, not on init.
  // =====================================================
  const scaleFactorFromApiRef = useRef(false);
  const pickerOpenScaleRef = useRef(null); // Stores scaleFactorX when picker opens (for relative computation)
  const userAdjustedInchesRef = useRef(null); // Tracks user's last selected inches (for picker re-open display)
  const scaleFactorXRef = useRef(null); // Live ref to scaleFactorX (avoids stale closures in settings menu)
  const initialScaleFactorXRef = useRef(null); // Live ref to initialScaleFactorX
  const initialLengthRef = useRef(null); // Live ref to initialLength
  const handleUpdateKeyRef = useRef(null);
  // Viewport signature of the last handleUpdate pass that re-derived furniture
  // geometry. furnishRoom deliberately clears handleUpdateKeyRef so the next pass
  // recomputes room centers; this ref stays put so that pass leaves the furniture
  // of every room alone. See utils/editorFurnitureTransform.
  const furnitureTransformKeyRef = useRef(null);
  // Tracks which rooms have had their layouts regenerated (first-shuffle triggers PATH A)
  const hasRegeneratedLayoutsRef = useRef({});
  
  const [stateCenterX, setStateCenterX] = useState(1);
  const [stateCenterY, setStateCenterY] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);

  const transformRef = useRef(null);
  const manualAddPlacementIndexRef = useRef(0);
  const manualAddPlacementRoomRef = useRef(null);
  const minScaleRef = useRef(0.5); // kept in sync with minScale state; used inside non-reactive listeners
  // Synchronous flag: set to true in onTouchStart when the room-first guard
  // returns early so that onTouchEnd knows not to select furniture.
  // A ref is used (not state) because onTouchEnd fires in the same render
  // cycle as onTouchStart — a state update would not be visible yet.
  const touchRoomGuardFiredRef = useRef(false);
  // Blocks the browser-synthesized mousedown that follows a touch when the
  // touch caused a room switch.  By the time the synthesized event fires,
  // React state has committed (roomActive === new room), so the stale-closure
  // guard in onMouseDown would no longer block it.  This ref closes that gap.
  const mobileRoomJustSwitchedRef = useRef(false);

  const [doors, setDoors] = useState([]);
  const [windows] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [lineDraw] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [scaleCheck] = useState(false);
  const [shoppingListFlag, setShoppingListFlag] = useState(false);
  const [showFlipMenu, setShowFlipMenu] = useState(false);

  const footerRefShoppingList = useRef(null);
  const footerRefOther = useRef(null);
  const [resize, setResize] = useState(true);
  const [resizeCalculateScaleFlag, setResizeCalculateScaleFlag] =
    useState(true);

  const [lineBoundary, setLineBoundary] = useState(false);
  const [calculate, setCalculate] = useState(false);

  const windowFlag = useWindowWidth();

  const [isLoading, setIsLoading] = useState(false);
  // Only show the saving overlay after a delay so fast saves never flash it.
  const [savingOverlayVisible, setSavingOverlayVisible] = useState(false);
  const savingOverlayTimerRef = useRef(null);
  const isMobile = windowFlag < 601;

  const [layouts, setLayouts] = useState([]);
  const [roomsData, setRoomsData] = useState([]);

  const [roomItemsList, setRoomItemsList] = useState([]);
  const [keepItems, setKeepItems] = useState([]);

  // -1 ("nothing selected") when the gallery handoff armed pick mode, rather than
  // the placeholder 0. Most readers defend against a stale 0 by pairing it with
  // lineBoundary, but the Shuffle FAB branches on roomActive !== -1 alone: with a
  // stale 0 the tap that follows a spotlight pick routes to handleShuffle()
  // against roomsData[0] instead of the picked room's fresh-room path, so the
  // button appears to do nothing. Manual entry into pick mode is only reachable
  // when roomActive is already -1, so seeding it here makes the armed state match
  // the manual one instead of being a state the manual flow can never produce.
  const [roomActive, setRoomActive] = useState(armPickModeOnOpen ? -1 : 0);
  const [roomActiveLayout, setRoomActiveLayout] = useState([]);

  const [seeItAnotherWay, setSeeItAnotherWay] = useState({});

  const isDesktop = useMediaQuery("(min-width:444px)");
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const [isAdding, setIsAdding] = useState(false);
  /** Set when user dismisses Add Items via canvas tap; blocks auto-reopen until room changes. */
  const userDismissedAddItemsRef = useRef(false);
  // true only when isAdding was triggered via the "Something Else" zone
  const [addingFromSomethingElse, setAddingFromSomethingElse] = useState(false);
  // Tracks whether user has manually added an item (via Add Items modal) or
  // shuffled 2+ distinct rooms — determines when Save/Share becomes the primary CTA.
  const [manualItemAdded, setManualItemAdded] = useState(false);
  const [shuffledRoomIds, setShuffledRoomIds] = useState(new Set());
  const [manualToastDismissed, setManualToastDismissed] = useState(false);

  const [divWidth, setDivWidth] = useState(0);
  const [divHeight, setDivHeight] = useState(0);

  const [divDynamicWidth, setDivDynamicWidth] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    if (!loadingLayout) {
      if (shuffleLoadingAffordanceTimerRef.current != null) {
        clearTimeout(shuffleLoadingAffordanceTimerRef.current);
        shuffleLoadingAffordanceTimerRef.current = null;
      }
      setShuffleLoadingAffordanceVisible(false);
      return;
    }
    shuffleLoadingAffordanceTimerRef.current = setTimeout(() => {
      shuffleLoadingAffordanceTimerRef.current = null;
      setShuffleLoadingAffordanceVisible(true);
    }, 400);
    return () => {
      if (shuffleLoadingAffordanceTimerRef.current != null) {
        clearTimeout(shuffleLoadingAffordanceTimerRef.current);
        shuffleLoadingAffordanceTimerRef.current = null;
      }
    };
  }, [loadingLayout]);
  
  // =====================================================
  // LIFECYCLE LOGGING: Track mount/unmount and key changes
  // =====================================================
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('');
      console.log('┌' + '─'.repeat(70) + '┐');
      console.log('│  🚀 [UPLOADFLOOR] COMPONENT MOUNTED at t=' + Date.now() + '           │');
      console.log('├' + '─'.repeat(70) + '┤');
      console.log('│  layoutId:', layoutId);
      console.log('│  versionLayout:', versionLayout);
      console.log('│  timestamp:', new Date().toISOString());
      console.log('│  URL:', window.location.pathname);
      console.log('└' + '─'.repeat(70) + '┘');
    }
    return () => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('');
        console.log('┌' + '─'.repeat(70) + '┐');
        console.log('│  💀 [UPLOADFLOOR] COMPONENT UNMOUNTED at t=' + Date.now() + '         │');
        console.log('├' + '─'.repeat(70) + '┤');
        console.log('│  layoutId was:', layoutId);
        console.log('│  timestamp:', new Date().toISOString());
        console.log('└' + '─'.repeat(70) + '┘');
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // Track when layoutId changes (important for Gallery → Editor flow)
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[UPLOADFLOOR] 📥 layoutId CHANGED:', layoutId);
    }
  }, [layoutId]);
  
  // Track when versionLayout changes
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[UPLOADFLOOR] 📥 versionLayout CHANGED:', versionLayout);
    }
  }, [versionLayout]);

  useEffect(() => {
    if (divRef.current) {
      setDivDynamicWidth(window.innerWidth);

      if (!divWidth && !divHeight) {
        setDivWidth(3000);
        setDivHeight(divRef.current.offsetHeight);
      }
    }
  }, [windowFlag, divWidth, divHeight]);

  const [successAlert] = useState("");
  const [errorAlert] = useState("");
  const [midRangeLineIndexState, setMidRangeLineIndexState] = useState(null)

  const [zonesRoom, setZonesRoom] = useState({});
  const [roomId, setRoomId] = useState();

  const [value, setValue] = useState(1);
  const imagesCount = useRef(0);

  const [errorLayout, setErrorLayout] = useState({});
  const [errorLayoutGlobal, setErrorLayoutGlobal] = useState(false);

  const [vanityIndexByRoom, setVanityIndexByRoom] = useState({});
  const [tvIndexByRoom, setTvIndexByRoom] = useState({});
  const [bedIndexByRoom, setBedIndexByRoom] = useState({});
  const [storageIndexByRoom, setStorageIndexByRoom] = useState({});
  const [updateScale, setUpdateScale] = useState(false);
  const [callFurnish, setCallFurnish] = useState(false);
  const hasInitializedRef = useRef(false); // Track if data has been initialized
  const lockedScalesRef = useRef({}); // Store locked scale values per room

  const [selectedOption, setSelectedOption] = useState(null);

  const [objectsCheck, ] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [added, setAdded] = useState(false);
  const [isScaleDimensionsMarked, setIsScaleDimensionsMarked] = useState("");


  const [supZones, setSupZones] = useState("");

  // Wrap setSupZones to add logging
  const setSupZonesWithLogging = (newZone) => {
    console.log('');
    console.log('🏷️'.repeat(30));
    console.log('[ADD ITEMS ZONES] Zone change requested');
    console.log('[ADD ITEMS ZONES] Previous zone:', supZones);
    console.log('[ADD ITEMS ZONES] New zone:', newZone);
    console.log('[ADD ITEMS ZONES] Available zones:', manualItemsZones?.map(z => z.value));
    console.log('🏷️'.repeat(30));
    console.log('');
    setSupZones(newZone);
  };

  useEffect(()=>{
    if(!partnerZonesLoading && manualItemsZones?.length >=1){
      console.log('[ADD ITEMS ZONES] 🚀 Initial zone set to:', manualItemsZones?.[0]?.value);
      console.log('[ADD ITEMS ZONES] All available zones:', manualItemsZones?.map(z => ({ value: z.value, label: z.label })));
      setSupZones(manualItemsZones?.[0]?.value)
    }
  },[partnerZonesLoading, manualItemsZones])

  // Log when supZones changes
  useEffect(() => {
    console.log('[ADD ITEMS ZONES] 📦 supZones state updated to:', supZones);
    console.log('[ADD ITEMS ZONES] API query will fetch items for zone:', supZones);
  }, [supZones]);
  
  const {
    data: itemsWithSup,
    isLoading: itemsSupLoading,
    isFetching,
    error,
  } = useGetItemsBySupplementaryQuery(supZones, {
    refetchOnMountOrArgChange: true,
    skip: !supZones || supZones.trim() === "",
  });

  // Log when items data changes
  useEffect(() => {
    const timestamp = new Date().toISOString();
    console.log('');
    console.log('📋'.repeat(30));
    console.log('[ADD ITEMS ZONES] Items data updated at', timestamp);
    console.log('[ADD ITEMS ZONES] ─────────────────────────────────');
    console.log('[ADD ITEMS ZONES] Current zone state:', supZones);
    console.log('[ADD ITEMS ZONES] ─────────────────────────────────');
    console.log('[ADD ITEMS ZONES] isFetching:', isFetching);
    console.log('[ADD ITEMS ZONES] isLoading:', itemsSupLoading);
    console.log('[ADD ITEMS ZONES] error:', error);
    console.log('[ADD ITEMS ZONES] ─────────────────────────────────');
    console.log('[ADD ITEMS ZONES] Item count:', itemsWithSup?.items?.length || 0);
    console.log('[ADD ITEMS ZONES] First 5 items:', itemsWithSup?.items?.slice(0, 5)?.map(i => i.name));
    if (isFetching) {
      console.log('[ADD ITEMS ZONES] ⏳ FETCHING IN PROGRESS - waiting for API response...');
    } else if (itemsWithSup?.items?.length > 0) {
      console.log('[ADD ITEMS ZONES] ✅ FETCH COMPLETE - items ready to display');
    }
    console.log('📋'.repeat(30));
    console.log('');
  }, [itemsWithSup, supZones, isFetching, error, itemsSupLoading]);

  const {
    data: rugItems,
  } = useGetItemsBySupplementaryQuery("supplementary-rugs", {
    refetchOnMountOrArgChange: true,
  });

  const rugItemsId = rugItems ? rugItems?.items?.map(item => item._id) : [];

  // Identifies a placed furniture item as a rug.
  // Uses two signals so either alone is sufficient:
  //   1. Catalog ID match (includes, not startsWith, to survive instance-ID prefixes)
  //   2. Item name fallback — guards the window where rugItems hasn't loaded yet
  //      (rugItemsId is empty) and ensures the server save payload is always sorted
  //      correctly regardless of catalog load timing.
  const isRugItem = (item) =>
    rugItemsId.some((id) => item?._id?.includes(id)) ||
    item?.name?.toLowerCase()?.includes("rug");

  const {
    data: allSupplementaryItems,
    isFetching: isFetchingAllSupplementaryItems,
    error: errorAllSupplementaryItems,
  } = useGetAllItemsBySupplementaryQuery(manualItemsZones, {
    skip: !manualItemsZones || manualItemsZones.length === 0
  });

  const allSupplementaryItemsIds = allSupplementaryItems ? allSupplementaryItems?.items?.map(item => item._id) : [];

  const { data: itemsbyZones } = useGetItemsByZoneQuery(zonesRoom[roomId], {
    skip: !zonesRoom[roomId]?.length,
    refetchOnMountOrArgChange: true,
  });

  const {
    data: layoutData,
    isSuccess: isLayoutDataSuccess,
    isFetching: layoutLoading,
    refetch: layoutDataRefetch,
  } = useGetSavedLayoutByIdQuery(
    { id: params.id || layoutId, version: versionLayout },
    {
      skip: !params.id && !layoutId,
      refetchOnMountOrArgChange: true,
    }
  );

  const { data: layoutDataCopy, refetch: layoutDataCopyRefetch } =
    useGetSavedLayoutByIdQuery(
      { id: params.id || layoutId, version: versionLayout },
      {
        skip: !params.id && !layoutId,
        refetchOnMountOrArgChange: true,
      }
    );

  // =====================================================
  // API DATA LOGGING: Log raw API response when received
  // =====================================================
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' && layoutData) {
      console.log('');
      console.log('╔' + '═'.repeat(70) + '╗');
      console.log('║  📡 [API] LAYOUT DATA RECEIVED FROM BACKEND                         ║');
      console.log('╠' + '═'.repeat(70) + '╣');
      console.log('║  layoutId:', layoutData?._id || layoutData?.uuid);
      console.log('║  name:', layoutData?.name);
      console.log('║  payload exists:', !!layoutData?.payload);
      console.log('║  ');
      
      const payload = layoutData?.payload;
      if (payload) {
        console.log('║  PAYLOAD STRUCTURE:');
        console.log('║    scaleXCanvas:', payload.scaleXCanvas);
        console.log('║    scaleYCanvas:', payload.scaleYCanvas);
        console.log('║    scaleFactorX:', payload.scaleFactorX);
        console.log('║    scaleFactorY:', payload.scaleFactorY);
        console.log('║    offsetXCheck:', payload.offsetXCheck);
        console.log('║    offsetYCheck:', payload.offsetYCheck);
        console.log('║    divWidth:', payload.divWidth, '← saved from previous session');
        console.log('║    divHeight:', payload.divHeight);
        console.log('║    roomsData count:', payload.roomsData?.length);
        
        // Log first furniture item's raw coordinates
        const firstFurn = payload.roomsData?.[0]?.layouts?.[0]?.furniture?.[0];
        if (firstFurn) {
          console.log('║  ');
          console.log('║  FIRST FURNITURE (RAW FROM API):');
          console.log('║    name:', firstFurn.name);
          console.log('║    position:', JSON.stringify(firstFurn.position));
          console.log('║    exactPosition:', JSON.stringify(firstFurn.exactPosition));
          console.log('║    width:', firstFurn.width, 'height:', firstFurn.height);
          console.log('║    origionalWidth:', firstFurn.origionalWidth, 'origionalHeight:', firstFurn.origionalHeight);
          
          // CRITICAL: Check if position == exactPosition
          const posEqExact = firstFurn.position?.x === firstFurn.exactPosition?.x;
          console.log('║  ');
          console.log('║  🔍 CRITICAL CHECK: position.x === exactPosition.x?', posEqExact);
          if (posEqExact) {
            console.log('║  ⚠️ WARNING: These are likely ALREADY screen coordinates!');
            console.log('║  ⚠️ Dividing by scaleFactorX will cause BLOW UP!');
          } else {
            console.log('║  ✅ Different values - position may be derived from exactPosition');
          }
        }
      }
      console.log('╚' + '═'.repeat(70) + '╝');
      
      // =====================================================
      // 🔬 BACKEND COORDINATE SPACE DEEP ANALYSIS
      // =====================================================
      console.log('');
      console.log('🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬');
      console.log('[BACKEND ANALYSIS] 🔬 DEEP COORDINATE SPACE ANALYSIS');
      console.log('🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬');
      console.log('');
      
      const backendPayload = layoutData?.payload;
      const sfx = backendPayload?.scaleFactorX || 1;
      const sfy = backendPayload?.scaleFactorY || 1;
      
      console.log('[BACKEND ANALYSIS] 1️⃣  SCALE VALUES FROM BACKEND:');
      console.log('[BACKEND ANALYSIS]    scaleFactorX = ' + sfx + ' (furniture scale)');
      console.log('[BACKEND ANALYSIS]    scaleFactorY = ' + sfy);
      console.log('[BACKEND ANALYSIS]    scaleXCanvas = ' + (backendPayload?.scaleXCanvas || 'N/A') + ' (viewport scale)');
      console.log('[BACKEND ANALYSIS]    1/scaleFactorX = ' + (1/sfx).toFixed(4) + ' (blow-up factor)');
      console.log('');
      
      console.log('[BACKEND ANALYSIS] 2️⃣  VIEWPORT METADATA FROM BACKEND:');
      console.log('[BACKEND ANALYSIS]    divWidth = ' + (backendPayload?.divWidth || 'N/A') + ' px');
      console.log('[BACKEND ANALYSIS]    divHeight = ' + (backendPayload?.divHeight || 'N/A') + ' px');
      console.log('[BACKEND ANALYSIS]    offsetXCheck = ' + (backendPayload?.offsetXCheck || 'N/A'));
      console.log('[BACKEND ANALYSIS]    offsetYCheck = ' + (backendPayload?.offsetYCheck || 'N/A'));
      console.log('');
      
      // Analyze ALL furniture items
      const allFurniture = [];
      backendPayload?.roomsData?.forEach((room, roomIdx) => {
        room?.layouts?.[0]?.furniture?.forEach((furn, furnIdx) => {
          allFurniture.push({
            room: roomIdx,
            index: furnIdx,
            name: furn.name,
            posX: furn.position?.x,
            posY: furn.position?.y,
            exactX: furn.exactPosition?.x,
            exactY: furn.exactPosition?.y,
            origPosX: furn.origionalPosition?.x,
            origPosY: furn.origionalPosition?.y,
            width: furn.width,
            origW: furn.origionalWidth,
            posEqExact: furn.position?.x === furn.exactPosition?.x,
          });
        });
      });
      
      console.log('[BACKEND ANALYSIS] 3️⃣  ALL FURNITURE COORDINATE ANALYSIS:');
      console.log('[BACKEND ANALYSIS]    Total furniture items: ' + allFurniture.length);
      console.log('');
      
      let posEqExactCount = 0;
      let posNeExactCount = 0;
      
      allFurniture.forEach((f) => {
        if (f.posEqExact) posEqExactCount++;
        else posNeExactCount++;
        
        const expectedScreenX = f.exactX / sfx;
        const actualScreenX = f.posX;
        const coordDelta = actualScreenX !== undefined && expectedScreenX !== undefined 
          ? Math.abs(actualScreenX - expectedScreenX) 
          : null;
        const ratio = actualScreenX !== undefined && f.exactX !== undefined && f.exactX !== 0
          ? actualScreenX / f.exactX
          : null;
        
        console.log('[BACKEND ANALYSIS]    [Room ' + f.room + '][' + f.index + '] ' + f.name);
        console.log('[BACKEND ANALYSIS]       exactPosition.x = ' + (f.exactX?.toFixed(2) || 'N/A') + ' (canonical)');
        console.log('[BACKEND ANALYSIS]       position.x = ' + (f.posX?.toFixed(2) || 'N/A') + ' (should be screen)');
        console.log('[BACKEND ANALYSIS]       expected screen = ' + (expectedScreenX?.toFixed(2) || 'N/A') + ' (exactX / sfx)');
        console.log('[BACKEND ANALYSIS]       delta = ' + (coordDelta?.toFixed(2) || 'N/A') + ' px');
        console.log('[BACKEND ANALYSIS]       origionalPosition.x = ' + (f.origPosX?.toFixed(2) || 'N/A'));
        console.log('[BACKEND ANALYSIS]       pos === exact? ' + f.posEqExact);
        if (ratio !== null) {
          console.log('[BACKEND ANALYSIS]       pos/exact ratio = ' + ratio.toFixed(4));
          console.log('[BACKEND ANALYSIS]       expected 1/sfx = ' + (1/sfx).toFixed(4));
          if (Math.abs(ratio - 1) < 0.01) {
            console.log('[BACKEND ANALYSIS]       ⚠️ RATIO ≈ 1 → Backend NOT converting to screen coords!');
          } else if (Math.abs(ratio - (1/sfx)) < 0.1) {
            console.log('[BACKEND ANALYSIS]       ✅ RATIO ≈ 1/sfx → Backend correctly converting');
          }
        }
        console.log('');
      });
      
      console.log('[BACKEND ANALYSIS] 4️⃣  SUMMARY:');
      console.log('[BACKEND ANALYSIS]    Items where position === exactPosition: ' + posEqExactCount);
      console.log('[BACKEND ANALYSIS]    Items where position !== exactPosition: ' + posNeExactCount);
      console.log('');
      
      if (posEqExactCount > 0 && posNeExactCount === 0) {
        console.log('[BACKEND ANALYSIS] 🔴 DIAGNOSIS: ALL items have position === exactPosition');
        console.log('[BACKEND ANALYSIS]    This means backend is NOT converting canonical → screen coords');
        console.log('[BACKEND ANALYSIS]    Frontend will divide by scaleFactorX, causing ' + (1/sfx).toFixed(2) + 'x blow-up');
        console.log('');
        console.log('[BACKEND ANALYSIS] 💡 PETER\'S HYPOTHESIS CHECK:');
        console.log('[BACKEND ANALYSIS]    "Scale problem is upstream in MF-CV" - PARTIALLY TRUE');
        console.log('[BACKEND ANALYSIS]    The REAL issue: Backend stores position = exactPosition');
        console.log('[BACKEND ANALYSIS]    Backend SHOULD compute: position = exactPosition / scaleFactorX');
      } else if (posNeExactCount > 0) {
        console.log('[BACKEND ANALYSIS] ✅ Some items have position !== exactPosition');
        console.log('[BACKEND ANALYSIS]    This suggests backend IS converting for some items');
        console.log('[BACKEND ANALYSIS]    Check which items differ and why');
      }
      
      console.log('');
      console.log('🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬🔬');
      console.log('');
    }
  }, [layoutData]);

  // Ownership check: owner edits original, non-owner/guest gets fork
  const isOwner = useMemo(() => {
    if (isGuest) return false;
    if (!layoutData?.user) {
      // Only the active uploader owns a layout with no assigned user while creating it.
      // Unclaimed guest uploads must not grant ownership to arbitrary signed-in viewers.
      return !layoutData?._id;
    }
    const layoutUserId = typeof layoutData.user === 'object' ? layoutData.user._id : layoutData.user;
    return layoutUserId === userData?._id;
  }, [isGuest, layoutData?.user, layoutData?._id, userData?._id]);

  const {
    saveContact: saveUploaderContact,
    submitting: uploaderContactSubmitting,
    saved: uploaderContactSaved,
    error: uploaderContactError,
    reset: resetUploaderContact,
  } = useGalleryUploaderContact({
    layoutUuid: layoutData?.uuid,
    layoutMongoId: layoutData?._id,
  });

  const rememberGuestAuthPrefillEmail = useCallback((email) => {
    const prefill = normalizeEmail(email);
    if (!prefill) return;
    guestAuthPrefillEmailRef.current = prefill;
    setAuthPrefillEmail(prefill);
  }, []);

  const handleSaveUploaderContact = useCallback(
    async (email, inquiryDisplayName) => {
      const ok = await saveUploaderContact(email, inquiryDisplayName);
      if (ok) {
        rememberGuestAuthPrefillEmail(email);
        layoutDataRefetch?.();
      }
      return ok;
    },
    [saveUploaderContact, layoutDataRefetch, rememberGuestAuthPrefillEmail]
  );

  useEffect(() => {
    const prefill = resolveGuestAuthPrefillEmail({
      layout: {
        _id: layoutData?._id,
        uuid: layoutData?.uuid,
        user: layoutData?.user,
        inquiryContactEmail: layoutData?.inquiryContactEmail,
      },
      cachedEmail: guestAuthPrefillEmailRef.current,
      isGuest,
      userId: userData?._id,
    });
    if (!prefill) return;
    guestAuthPrefillEmailRef.current = prefill;
    setAuthPrefillEmail((current) => current || prefill);
  }, [
    isGuest,
    userData?._id,
    layoutData?._id,
    layoutData?.inquiryContactEmail,
    layoutData?.uuid,
    layoutData?.user,
  ]);

  const guestLayoutOwner = isGuestLayoutOwner(layoutData, isGuest);

  const handleCloseUploaderContactModal = useCallback(() => {
    if (guestLayoutOwner) {
      dismissContactBanner(layoutData?._id);
    }
    setUploaderContactModalOpen(false);
    resetUploaderContact();
  }, [guestLayoutOwner, layoutData?._id, resetUploaderContact]);

  const canConfigureInquiries = canConfigureGalleryInquiries({
    layout: layoutData,
    isGuest,
    userId: userData?._id,
  });
  const inquirySessionLayout = useMemo(() => {
    if (!layoutData) return activeLayout ?? null;
    if (layoutCopiedFromId(layoutData)) return layoutData;
    if (
      activeLayout &&
      layoutData._id &&
      activeLayout._id &&
      String(activeLayout._id) === String(layoutData._id) &&
      layoutCopiedFromId(activeLayout)
    ) {
      return activeLayout;
    }
    return layoutData;
  }, [layoutData, activeLayout]);

  const inquiryViewerLayout = inquirySessionLayout ?? layoutData;

  const layoutInquiriesAvailable = inquiriesAvailableForLayout(inquiryViewerLayout);
  const showLayoutInquire = shouldShowViewerInquire({
    layout: inquiryViewerLayout,
    isGuest,
    userId: userData?._id,
  });

  const {
    submit: submitGalleryInquiry,
    submitting: inquireSubmitting,
    confirmState: inquireConfirmState,
    error: inquireError,
    reset: resetGalleryInquiry,
    guestEmailPrefill: inquireGuestEmailPrefill,
    canOneTap: inquireCanOneTap,
    knownEmail: inquireKnownEmail,
    submitKnown: submitKnownInquiry,
    trackIntent: trackInquiryIntent,
    trackModalOpened: trackInquiryModalOpened,
  } = useGalleryInquiry({
    layout: inquirySessionLayout,
    layoutUuid: layoutData?.uuid,
    layoutMongoId: layoutData?._id,
    customerRef: layoutData?.customer_ref || clientRef || null,
    isGuest,
    userEmail: userData?.email,
    isInternal: Boolean(userData?.is_internal),
    inquiriesAvailable: layoutInquiriesAvailable,
  });

  const inquiryAlreadySent = Boolean(inquireConfirmState);
  const showEditorInquireFab = shouldShowEditorInquireFab({
    showViewerInquire: showLayoutInquire,
    inquiryAlreadySent,
  });
  /** In-flight one-tap submits must not queue a second request behind them. */
  const inquireCtaInert = inquiryAlreadySent || inquireSubmitting;
  const [interestToastOpen, setInterestToastOpen] = useState(false);

  /**
   * One tap when we already hold the viewer's email — the FAB is the submit, and
   * the toast carries both the confirmation and any failure, since no modal is
   * mounted on that path.
   */
  const handleInterestTap = useCallback(async () => {
    trackInquiryIntent("editor");
    if (inquireCanOneTap) {
      const result = await submitKnownInquiry();
      setInterestToastOpen(true);
      return result;
    }
    trackInquiryModalOpened("editor");
    setInquireModalOpen(true);
    return undefined;
  }, [
    trackInquiryIntent,
    inquireCanOneTap,
    submitKnownInquiry,
    trackInquiryModalOpened,
  ]);

  const handleCloseInterestToast = useCallback(() => {
    setInterestToastOpen(false);
    resetGalleryInquiry();
  }, [resetGalleryInquiry]);

  /** `submit` clears the previous error itself, so the toast can stay mounted. */
  const handleRetryInterest = useCallback(async () => {
    await submitKnownInquiry();
    setInterestToastOpen(true);
  }, [submitKnownInquiry]);

  const handleCloseInquireModal = useCallback(() => {
    setInquireModalOpen(false);
    resetGalleryInquiry();
  }, [resetGalleryInquiry]);

  // Guest uploaders: schedule the leads-email prompt after load. Display is
  // gated separately so auth can stay on top without canceling the schedule —
  // otherwise Save/auth within 4s (then signup) permanently skips the prompt.
  // Depend on stable layout fields so refetches do not endlessly reset the timer.
  useEffect(() => {
    if (!shouldShowGuestContactBanner({ layout: layoutData, isGuest })) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setUploaderContactModalOpen(true);
    }, 4000);

    return () => window.clearTimeout(timer);
    // layoutData object identity changes on refetch; only _id / contact email
    // should re-arm the timer.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- stable layout fields only
  }, [isGuest, layoutData?._id, layoutData?.inquiryContactEmail]);

  // Store original layout ID on first load for fork linkage
  useEffect(() => {
    if (layoutData?._id && !originalLayoutIdRef.current) {
      originalLayoutIdRef.current = layoutData._id;
    }
  }, [layoutData?._id]);

  // Fork on first edit — called by every mutation point when user is guest or non-owner
  const forkOnEdit = useCallback(() => {
    if (isForked || isOwner) return;
    console.log('[GUEST-EDITOR] Forking layout on first edit');
    mfLogGuestGalleryAuth("guestFork.forkOnEdit", {
      layoutId: layoutData?._id,
      hadUserEditedFlag: hasUserEditedRef.current,
      liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
    });
    setIsForked(true);
    setForkToastOpen(true);
  }, [isForked, isOwner, layoutData?._id]);

  // Wraps hasUserEditedRef + fork trigger in one call
  const markUserEdited = useCallback(() => {
    hasUserEditedRef.current = true;
    forkOnEdit();
  }, [forkOnEdit]);

  // Gate an action behind auth — shows modal if guest, runs action immediately if logged in
  // intentMeta: optional serializable label for logs (Save vs Done vs duplicate, etc.)
  const requireAuth = useCallback((action, destination = GO_EDITOR, intentMeta = null) => {
    if (!isGuest) {
      action();
      return;
    }
    const keepPreAuthSnapshotForGuestSave =
      destination === GO_EDITOR &&
      intentMeta?.surface === GUEST_SAVE_AUTH_SURFACE;
    if (destination !== GO_GALLERY && !keepPreAuthSnapshotForGuestSave) {
      guestForkGallerySaveSnapshotRef.current = null;
      guestForkGalleryCaptureBlobRef.current = null;
    }
    pendingActionRef.current = action;
    pendingGuestAuthIntentRef.current = intentMeta;
    afterAuthSuccessDestinationRef.current = destination;
    mfLogGuestGalleryAuth("authGate.requireAuth", {
      layoutId: layoutData?._id,
      destination,
      intentMeta,
      isForked,
      isOwner,
      hasUserEdited: hasUserEditedRef.current,
      clearsGallerySnapshot:
        destination !== GO_GALLERY && !keepPreAuthSnapshotForGuestSave,
      hadPreAuthCaptureBlob: !!guestForkGalleryCaptureBlobRef.current,
      autoSaveInFlight: autoSaveloadingRef.current,
      ...fingerprintGuestForkDomDeep(),
    });
    eventLog(targetWindow, 'floor_plan_event', 'auth_wall_triggered', {
      galleryId: layoutData?.uuid || layoutData?._id,
    });
    const prefill = resolveGuestAuthPrefillEmail({
      layout: layoutData,
      cachedEmail: guestAuthPrefillEmailRef.current,
      isGuest,
      userId: userData?._id,
    });
    if (prefill) {
      guestAuthPrefillEmailRef.current = prefill;
      setAuthPrefillEmail(prefill);
    }
    setAuthModalOpen(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGuest, isForked, isOwner, layoutData?._id, layoutData?.inquiryContactEmail]);

  const startX = useRef(0);
  const startY = useRef(0);
  const controllerRef = useRef(null);

  const containerRefZones = useRef(null);

  const [selectedFeet, setSelectedFeet] = useState(0);
  const [selectedResetFeet, setSelectedResetFeet] = useState(0);
  const [selectedResetInches, setSelectedResetInches] = useState(0);

  const [selectedInches, setSelectedInches] = useState(0);
  const [initialLength, setInitialLength] = useState(false);
  const [calculateInitialLength, setCalculateInitialLength] = useState(false);

  // Keep refs in sync with state (for settings menu closure - avoids stale values without causing rebuilds)
  scaleFactorXRef.current = scaleFactorX;
  initialScaleFactorXRef.current = initialScaleFactorX;
  initialLengthRef.current = initialLength;

  const inchOptions = Array.from({ length: 12 }, (_, i) => i);

  const navigate = useNavigate();

  // After auth success: fork layout via server-side copy, then save guest edits
  // to the copy using the existing updatedLayout pipeline (preserves scale
  // correctly). When the just-authenticated user owns the layout (user A logged
  // back in to their own plan), the copy is skipped and we save against the
  // original — owner-returning case must NOT fork.
  const saveForkedLayoutAndNavigate = useCallback(async (authenticatedUserId = null) => {
    let forkDiagSession = 0;
    try {
      const originalId = originalLayoutIdRef.current || layoutData?._id;
      if (!originalId) {
        console.error('[GUEST-EDITOR] No original layout ID to copy');
        guestForkGallerySaveSnapshotRef.current = null;
        guestForkGalleryCaptureBlobRef.current = null;
        editorBackToGalleryInFlightRef.current = false;
        setForkTransitioning(false);
        setAuthModalOpen(false);
        return;
      }

      // Read token from cookie — context may not have re-rendered yet after modal login
      let token = null;
      try {
        const raw = Cookies.get("token");
        token = raw ? JSON.parse(raw) : null;
      } catch { token = Cookies.get("token"); }

      if (!token) {
        console.error('[GUEST-EDITOR] No auth token after login');
        guestForkGallerySaveSnapshotRef.current = null;
        guestForkGalleryCaptureBlobRef.current = null;
        editorBackToGalleryInFlightRef.current = false;
        setForkTransitioning(false);
        setAuthModalOpen(false);
        return;
      }

      const authHeaders = { Authorization: `Bearer ${token}` };

      // Ownership guard — if the just-authenticated user owns this layout
      // (user A logged out, edited as guest, then logged back in), no fork.
      // Saves continue against the original so user A's own plan is updated
      // in place, matching the owner-edit contract everywhere else in the app.
      const rawLayoutOwner = layoutData?.user;
      const layoutOwnerId =
        rawLayoutOwner && typeof rawLayoutOwner === "object"
          ? String(rawLayoutOwner._id || "")
          : rawLayoutOwner
          ? String(rawLayoutOwner)
          : "";
      const authIsOwner =
        !!authenticatedUserId &&
        !!layoutOwnerId &&
        String(authenticatedUserId) === layoutOwnerId;

      // Step 1: Server-side copy when the authenticated user is NOT the owner.
      // Creates a new SavedLayout owned by the authed user with copiedFrom set
      // to the original — that linkage is what the analytics tree builder uses
      // (layoutTreeUtils.buildPartnerLayoutTree) to nest the new layout under
      // its parent once the BE returns cross-partner children.
      let newLayoutId = originalId;
      let newLayoutUuid = layoutData?.uuid;
      // Phase 1: when a previous attempt already created a fork but the save
      // step failed, reuse that copy on Retry instead of creating another
      // orphan. `alreadyForked` is true only when forkedLayoutIdRef holds a
      // distinct id from the original — i.e., a real successful /copy from a
      // prior attempt of this same flow.
      const existingForkId = forkedLayoutIdRef.current;
      const alreadyForked =
        !!existingForkId &&
        String(existingForkId) !== String(originalId);
      if (authIsOwner) {
        console.log('[GUEST-EDITOR] Owner returning — skipping copy, saving to original');
        mfLogGuestGalleryAuth("forkSave.ownerSkippedCopy", {
          diagSession: forkDiagSession,
          layoutId: originalId,
          authenticatedUserId,
          layoutOwnerId,
        });
      } else if (alreadyForked) {
        newLayoutId = String(existingForkId);
        newLayoutUuid = forkedLayoutUuidRef.current
          ? String(forkedLayoutUuidRef.current)
          : layoutData?.uuid;
        console.log('[GUEST-EDITOR] Retry — reusing existing fork', newLayoutUuid);
        mfLogGuestGalleryAuth("forkSave.reusedExistingCopy", {
          diagSession: forkDiagSession,
          newLayoutId,
          newLayoutUuid,
          originalId,
        });
      } else {
        console.log('[GUEST-EDITOR] Step 1: Copying layout', originalId);
        const copyResponse = await axios.post(
          `${baseUrl}/savedLayout/copy/${originalId}`,
          {
            parent: null,
            // Only the uploader's session can see customer_ref. Marking this
            // copy as the listing draft lets a later lookup return the edit
            // without treating a viewer's copy as the listing.
            ...(layoutData?.customer_ref ? { listingDraft: true } : {}),
          },
          { headers: authHeaders }
        );

        const newLayout = copyResponse?.data?.data;
        const newUuid = newLayout?.uuid;
        const newId = newLayout?._id;

        if (!newUuid || !newId) {
          // Bail out without saving — better to lose guest edits than to
          // append them to the original layout under user A's account.
          console.error('[GUEST-EDITOR] Copy response missing uuid/id:', copyResponse?.data);
          mfLogGuestGalleryAuth("forkSave.copyResponseMalformed", {
            diagSession: forkDiagSession,
            layoutId: originalId,
            responseShape: JSON.stringify(copyResponse?.data ?? {}).slice(0, 240),
          });
          setForkTransitioning(false);
          setAuthModalOpen(false);
          return;
        }
        newLayoutId = String(newId);
        newLayoutUuid = String(newUuid);
        console.log('[GUEST-EDITOR] Step 1 done: new layout', newLayoutUuid);
        mfLogGuestGalleryAuth("forkSave.copyDone", {
          diagSession: forkDiagSession,
          originalId,
          newLayoutId,
          newLayoutUuid,
        });
        // Phase 1.5: BE post-copy settle window. Observed in staging that an
        // immediate PUT to a just-created copy can 403 — likely because
        // ownership / version-2 metadata is propagated by an async worker on
        // the BE. A short pause makes the first attempt much more likely to
        // succeed; retries below cover the rare case where it isn't enough.
        await new Promise((r) => setTimeout(r, 500));
      }

      // Step 2: Redirect future saves to the (possibly new) layout id so
      // updatedLayoutHelper writes to the copy instead of the original.
      forkedLayoutIdRef.current = newLayoutId;
      forkedLayoutUuidRef.current = newLayoutUuid;

      // Step 3: Save guest's in-memory edits to the copy using the existing pipeline.
      // Prefer a deep snapshot taken *before* the auth modal (Done→gallery, guest Save)
      // — after login, roomsDataRef can briefly mirror refetched API state while this
      // callback still runs. When no snapshot exists, merge from live refs.
      const goingGallery = afterAuthSuccessDestinationRef.current === GO_GALLERY;
      const snap = guestForkGallerySaveSnapshotRef.current;
      forkDiagSession = ++forkDiagSessionCounterRef.current;
      forkSaveDiagT0Ref.current = performance.now();
      mfLogGuestGalleryAuth("forkSave.start", {
        diagSession: forkDiagSession,
        layoutId: layoutData?._id,
        versionKey: versionLayout || layoutData?.version,
        goingGallery,
        hadPreAuthSnapshot: !!snap,
        liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
        snapshotFingerprint: snap
          ? fingerprintGuestLayoutState(snap.roomsData)
          : null,
        hasUserEdited: hasUserEditedRef.current,
      });
      mfLogGuestGalleryAuth("forkDiag.sessionStart", {
        diagSession: forkDiagSession,
        perfNow: performance.now(),
        hrefTail:
          typeof window !== "undefined"
            ? String(window.location?.href ?? "").slice(-120)
            : null,
        ...fingerprintGuestForkDomDeep(),
        editorPack: guestForkEditorDiagRef.current,
        autoSaveInFlight: autoSaveloadingRef.current,
        editorBackToGalleryInFlight: editorBackToGalleryInFlightRef.current,
        forkedLayoutId: forkedLayoutIdRef.current,
        forkedUuid: forkedLayoutUuidRef.current,
      });
      if (snap) {
        guestForkGallerySaveSnapshotRef.current = null;
        autoSaveDataRef.current = {
          ...autoSaveDataRef.current,
          roomsData: snap.roomsData,
          roomActive: snap.roomActive,
          roomActiveLayout: snap.roomActiveLayout,
          zonesRoom: snap.zonesRoom,
        };
      } else {
        autoSaveDataRef.current = {
          ...autoSaveDataRef.current,
          roomsData: roomsDataRef.current,
          roomActive: roomActiveRef.current,
          roomActiveLayout: roomActiveLayoutRef.current,
          zonesRoom: zonesRoomRef.current,
        };
      }

      // updatedLayoutHelper handles all viewport/scale stripping correctly.
      // generateImage=true → regenerateImage=false → server generates gallery image.
      // Uses updatedLayoutRef to avoid stale closure (scaleReady, etc.)
      mfLogGuestGalleryAuth("forkSave.payloadMerged", {
        diagSession: forkDiagSession,
        layoutId: layoutData?._id,
        payloadSource: snap ? "preAuthSnapshot" : "liveRefs",
        payloadFingerprint: fingerprintGuestLayoutState(
          autoSaveDataRef.current?.roomsData
        ),
        liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
        payloadVsLiveDeepEqual:
          JSON.stringify(
            fingerprintGuestLayoutState(autoSaveDataRef.current?.roomsData)
          ) ===
          JSON.stringify(fingerprintGuestLayoutState(roomsDataRef.current)),
        editorPack: guestForkEditorDiagRef.current,
      });

      console.log('[GUEST-EDITOR] Step 2: Saving guest edits via existing pipeline');
      // Phase 1: retry with bounded backoff. First attempt has zero delay so
      // the happy path's latency is unchanged. 4xx responses skip retry since
      // validation/auth failures will not heal on their own. All attempts run
      // with { strict: true } so the helper's silent skips throw instead of
      // returning success, letting us distinguish a real save from a no-op.
      // We also pass `authToken: token` — the same cookie-sourced JWT used
      // for the /copy call above — so the PUT to the just-forked layout is
      // always authenticated. AuthContext's currentUserSessionStorage has
      // not propagated into handleLayoutSave's closure yet at this point,
      // and an unauthenticated PUT 403s on the BE ownership check.
      const MAX_ATTEMPTS = 3;
      const BACKOFF_MS = [0, 750, 1500];
      let saveSuccess = false;
      let lastSaveError = null;
      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        if (BACKOFF_MS[attempt - 1] > 0) {
          await new Promise((r) => setTimeout(r, BACKOFF_MS[attempt - 1]));
        }
        try {
          saveSuccess = await updatedLayoutRef.current(false, true, {
            strict: true,
            authToken: token,
          });
          if (saveSuccess) break;
        } catch (err) {
          lastSaveError = err;
          const status = err?.response?.status;
          mfLogGuestGalleryAuth("forkSave.saveAttemptFailed", {
            diagSession: forkDiagSession,
            attempt,
            maxAttempts: MAX_ATTEMPTS,
            message: err?.message ?? String(err),
            status: status ?? null,
          });
          // 4xx will not improve on retry — bail to user immediately.
          if (status && status >= 400 && status < 500) break;
        }
      }
      console.log('[GUEST-EDITOR] Step 2 done: save result =', saveSuccess);
      mfLogGuestGalleryAuth("forkSave.saveDone", {
        diagSession: forkDiagSession,
        layoutId: layoutData?._id,
        saveSuccess: !!saveSuccess,
        errorMessage: lastSaveError?.message ?? null,
        errorStatus: lastSaveError?.response?.status ?? null,
        msSinceSessionStart: Math.round(
          performance.now() - forkSaveDiagT0Ref.current
        ),
        autoSaveInFlight: autoSaveloadingRef.current,
      });

      // Phase 1 bail: persist save failed after all retries. Do NOT navigate
      // and do NOT clear forkTransitioning — keeping the overlay up is the
      // single gate that prevents the autosave useEffect from firing against
      // the ORIGINAL layout (which would re-introduce the very forking bug
      // 30fe031e was meant to fix). The user sees a Retry overlay and any
      // subsequent attempt reuses the already-created copy.
      if (!saveSuccess) {
        mfLogGuestGalleryAuth("forkSave.bailed", {
          diagSession: forkDiagSession,
          originalId,
          newLayoutId,
          newLayoutUuid,
          errorMessage: lastSaveError?.message ?? null,
          errorStatus: lastSaveError?.response?.status ?? null,
          attemptsTried: MAX_ATTEMPTS,
        });
        // Restore the snapshot so Retry has the same source-of-truth as the
        // original attempt. The snapshot was nulled out earlier when we
        // merged it into autoSaveDataRef, but autoSaveDataRef still holds
        // the merged copy. Fall back to live refs in the unlikely case any
        // field is missing — both paths preserve the same edits.
        guestForkGallerySaveSnapshotRef.current = {
          roomsData: autoSaveDataRef.current?.roomsData ?? roomsDataRef.current,
          roomActive: autoSaveDataRef.current?.roomActive ?? roomActiveRef.current,
          roomActiveLayout:
            autoSaveDataRef.current?.roomActiveLayout ?? roomActiveLayoutRef.current,
          zonesRoom: autoSaveDataRef.current?.zonesRoom ?? zonesRoomRef.current,
        };
        // Leave forkedLayoutIdRef / forkedLayoutUuidRef set so Retry reuses
        // the existing copy instead of creating another orphan.
        setForkSaveError(
          "We couldn't sync your edits to the new layout. Try again, or dismiss to keep editing — your changes are still here."
        );
        // Important: do NOT emit layout_saved — the save did not succeed.
        // Important: do NOT setForkTransitioning(false) — overlay must stay
        //   up so autosave stays gated.
        // Important: do NOT setAuthModalOpen(false) — modal already stays
        //   hidden behind the overlay and Retry handles the next attempt.
        return;
      }

      // Save succeeded — clear any prior error state from a previous attempt.
      // Always-call is safe; setForkSaveError is a stable setter and a null→null
      // no-op never triggers a re-render in React 18+.
      setForkSaveError(null);

      if (afterAuthSuccessDestinationRef.current === GO_GALLERY) {
        mfLogGuestGalleryAuth("forkDiag.afterSavePreCapture", {
          diagSession: forkDiagSession,
          msSinceSessionStart: Math.round(
            performance.now() - forkSaveDiagT0Ref.current
          ),
          saveSuccess: !!saveSuccess,
          autoSaveInFlight: autoSaveloadingRef.current,
          ...fingerprintGuestForkDomDeep(),
          editorPack: guestForkEditorDiagRef.current,
          payloadFingerprint: fingerprintGuestLayoutState(
            autoSaveDataRef.current?.roomsData
          ),
          liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
        });
      }

      // Emit layout_saved now that the guest's edits are persisted — this is
      // the correct emission site for "Save Layout" button → auth → save flow.
      // Use the new layout's ids so analytics tile clicks land on the copy
      // (or the original, when the owner branch was taken).
      eventLog(targetWindow, 'floor_plan_event', 'layout_saved', {
        galleryId: newLayoutUuid || newLayoutId,
        galleryUrl: newLayoutId ? `${window.location.origin}/floor-gallery/${newLayoutId}` : undefined,
      });

      // Navigate to the (possibly new) layout's editor/gallery. The save above
      // persisted the guest's edits to that layout, so a fresh load shows the
      // correct data. We can't stay in the current editor because auth state
      // changes trigger re-renders that overwrite in-memory state with the
      // original API data.
      if (afterAuthSuccessDestinationRef.current === GO_EDITOR) {
        guestForkGalleryCaptureBlobRef.current = null;
        console.log('[GUEST-EDITOR] Step 3: Navigating to Editor');
        setActiveLayout({ uuid: newLayoutUuid, name: layoutData?.name, _id: newLayoutId });
        setShowVersionLayout(null);
        navigate(`/floor-plan/${newLayoutUuid}/version/2`, { replace: true });
      } else {
        console.log('[GUEST-EDITOR] Step 3: Navigating to Gallery');
        const layoutId = newLayoutId;
        const versionKey = versionLayout || layoutData?.version;
        const preAuthCaptureBlob = guestForkGalleryCaptureBlobRef.current;
        guestForkGalleryCaptureBlobRef.current = null;
        let galleryBlob = null;
        let captureSource = null;

        if (preAuthCaptureBlob && preAuthCaptureBlob.size > 5000) {
          galleryBlob = preAuthCaptureBlob;
          captureSource = "preAuthCapture";
          mfLogGuestGalleryAuth("forkSave.usePreAuthCapture", {
            diagSession: forkDiagSession,
            layoutId,
            versionKey,
            galleryBlobBytes: galleryBlob.size,
            galleryBlobType: galleryBlob.type,
          });
        } else {
          captureSource = "liveCaptureFallback";
          galleryCaptureDiagSessionRef.current = {
            diagSession: forkDiagSession,
            source: "guestForkPostAuth",
            tRequest: performance.now(),
          };
          mfLogGuestGalleryAuth("forkSave.captureStart", {
            diagSession: forkDiagSession,
            msSinceSessionStart: Math.round(
              performance.now() - forkSaveDiagT0Ref.current
            ),
            layoutId,
            versionKey,
            hadPreAuthCaptureBlob: !!preAuthCaptureBlob,
            preAuthBlobBytes: preAuthCaptureBlob?.size ?? null,
            ...fingerprintEditorDomCapture(),
            ...fingerprintGuestForkDomDeep(),
            payloadFingerprint: fingerprintGuestLayoutState(
              autoSaveDataRef.current?.roomsData
            ),
            liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
            editorPack: guestForkEditorDiagRef.current,
          });
          const captureFn = downloadLayoutForGalleryCaptureRef.current;
          galleryBlob = captureFn
            ? await captureFn(2).catch((err) => {
                mfLogGuestGalleryAuth("forkSave.captureRejected", {
                  diagSession: forkDiagSession,
                  message: err?.message ?? String(err),
                });
                return null;
              })
            : null;
        }
        mfLogGuestGalleryAuth("forkSave.captureDone", {
          diagSession: forkDiagSession,
          msSinceSessionStart: Math.round(
            performance.now() - forkSaveDiagT0Ref.current
          ),
          layoutId,
          versionKey,
          captureSource,
          galleryBlobBytes: galleryBlob?.size ?? null,
          galleryBlobType: galleryBlob?.type ?? null,
          ...fingerprintGuestForkDomDeep(),
          editorPack: guestForkEditorDiagRef.current,
        });
        const cacheKey = String(layoutId);
        const oldData = layoutCache.get(cacheKey) || {};
        if (!oldData.versions) oldData.versions = {};
        if (galleryBlob && galleryBlob.size > 5000) {
          const blobUrl = URL.createObjectURL(galleryBlob);
          const cacheEntry = {
            version: versionKey,
            url: blobUrl,
            cachedAt: Date.now(),
          };
          oldData.versions[versionKey] = cacheEntry;
          layoutCache.set(cacheKey, oldData);
          setLastDoneEntry(layoutId, cacheEntry);
          mfLogGuestGalleryAuth("forkSave.cacheWrite", {
            diagSession: forkDiagSession,
            layoutId,
            versionKey,
            blobBytes: galleryBlob.size,
            cachedAt: cacheEntry.cachedAt,
          });
        } else if (oldData.versions[versionKey]) {
          delete oldData.versions[versionKey];
          layoutCache.set(cacheKey, oldData);
          mfLogGuestGalleryAuth("forkSave.cacheSkip", {
            diagSession: forkDiagSession,
            layoutId,
            versionKey,
            reason: !galleryBlob ? "no_blob" : "blob_too_small",
            galleryBlobBytes: galleryBlob?.size ?? null,
          });
        }
        setActiveLayout(null);
        setDoneEditing(true);
        setShowVersionLayout(layoutId);
        navigate(`/floor-gallery/${layoutId}`, {
          state: { editedVersion: versionKey },
        });
        mfLogGuestGalleryAuth("forkSave.navigateGallery", {
          diagSession: forkDiagSession,
          layoutId,
          versionKey,
          editedVersionState: versionKey,
        });
        setTimeout(() => {
          dispatch(apiRoomNate.util.invalidateTags(["savedLayouts"]));
        }, 150);
        editorBackToGalleryInFlightRef.current = false;
      }
    } catch (error) {
      guestForkGallerySaveSnapshotRef.current = null;
      guestForkGalleryCaptureBlobRef.current = null;
      editorBackToGalleryInFlightRef.current = false;
      mfLogGuestGalleryAuth("forkSave.error", {
        diagSession: forkDiagSession,
        message: error?.message ?? String(error),
      });
      console.error('[GUEST-EDITOR] Failed to fork layout:', error);
      setForkTransitioning(false);
      setAuthModalOpen(false);
    }
  }, [
    dispatch,
    eventLog,
    layoutCache,
    layoutData,
    navigate,
    setActiveLayout,
    setDoneEditing,
    setForkTransitioning,
    setShowVersionLayout,
    versionLayout,
  ]);

  // Called after successful login via the auth modal.
  // `isNewAccount` is true only for signups; false for existing-user logins.
  // `userId` is the just-authenticated user's _id, forwarded into the fork
  // routine so the ownership guard can skip the copy when user A logs back
  // into their own plan.
  const handleAuthSuccess = useCallback(({ isNewAccount, userId } = {}) => {
    const action = pendingActionRef.current;
    pendingActionRef.current = null;
    const authIntentMeta = pendingGuestAuthIntentRef.current;
    pendingGuestAuthIntentRef.current = null;
    // account_created is emitted server-side by /user/signup
    // (createAccountCreatedEvent) as the single source of truth. AuthModal now
    // sends guestSessionId + signup_source="editor" on the signup request, so
    // the server event carries the session join + editor origin. Emitting it
    // here too would double-count signups/conversion, so it is intentionally
    // not logged from the client.

    mfLogGuestGalleryAuth("authSuccess", {
      layoutId: layoutData?._id,
      isForked,
      isNewAccount: !!isNewAccount,
      destination: afterAuthSuccessDestinationRef.current,
      hadPreAuthSnapshot: !!guestForkGallerySaveSnapshotRef.current,
      authIntentMeta,
      hasUserEdited: hasUserEditedRef.current,
      pendingActionPresent: typeof action === "function",
    });

    // After login, save the forked layout as a new copy first, then run the pending action
    if (isForked) {
      // Phase 1: capture the just-authenticated userId so the Retry button in
      // the error overlay can re-fire saveForkedLayoutAndNavigate without
      // re-prompting auth. Capture lives across the entire post-auth flow
      // until a successful save+navigate remounts this component.
      lastAuthUserIdRef.current = userId ?? null;
      mfLogGuestGalleryAuth("forkDiag.authScheduledForkSave", {
        delayMs: 200,
        destination: afterAuthSuccessDestinationRef.current,
        ...fingerprintGuestForkDomDeep(),
        editorPack: guestForkEditorDiagRef.current,
        autoSaveInFlight: autoSaveloadingRef.current,
      });
      // Show saving screen in modal + overlay (survives route-change remount)
      setForkTransitioning(true);
      // Small delay to let auth state (cookie + context) propagate
      setTimeout(async () => {
        await saveForkedLayoutAndNavigate(userId);
        // Don't close modal here — component remounts on navigate.
        // The overlay (controlled by forkTransitioning) covers the transition.
        // UploadFloor clears forkTransitioning when the new layout data loads.
        if (action) action();
      }, 200);
    } else {
      const lossRisk =
        hasUserEditedRef.current && !isForked
          ? "GUEST_EDITS_NOT_PERSISTED_UNLESS_FORK_SAVE_RAN"
          : "none";
      mfLogGuestGalleryAuth("forkDiag.authNonForkPath", {
        layoutId: layoutData?._id,
        authIntentMeta,
        destination: afterAuthSuccessDestinationRef.current,
        hasUserEdited: hasUserEditedRef.current,
        isForked,
        lossRisk,
        liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
        editorPack: guestForkEditorDiagRef.current,
        autoSaveInFlight: autoSaveloadingRef.current,
        pendingActionPresent: typeof action === "function",
      });
      setAuthModalOpen(false);
      // Done → gallery for a guest who did NOT edit (non-fork). The fork path
      // navigates to the gallery inside saveForkedLayoutAndNavigate, but the
      // non-fork path historically ran an empty pending action and never
      // navigated — leaving a view-only guest (e.g. someone who inquired then
      // opened the editor) stranded in the editor with the in-flight latch
      // stuck, so Done appeared dead. Mirror the logged-in runBackToGallery
      // navigation here so Done → gallery completes on the first authenticated
      // tap. Scoped to GO_GALLERY so Save/Share (GO_EDITOR) is unaffected.
      if (afterAuthSuccessDestinationRef.current === GO_GALLERY) {
        const layoutId = layoutData?._id;
        const versionKey = versionLayout || layoutData?.version;
        setActiveLayout(null);
        setDoneEditing(true);
        setShowVersionLayout(layoutId);
        editorBackToGalleryInFlightRef.current = false;
        if (layoutId) {
          navigate(`/floor-gallery/${layoutId}`, {
            state: { editedVersion: versionKey },
          });
          setTimeout(() => {
            dispatch(apiRoomNate.util.invalidateTags(["savedLayouts"]));
          }, 150);
        }
      } else if (action) {
        setTimeout(() => action(), 200);
      }
      const lid = layoutData?._id;
      setTimeout(() => {
        mfLogGuestGalleryAuth("forkDiag.postAuthNonForkTick280ms", {
          layoutId: lid,
          authIntentMeta,
          liveRefFingerprint: fingerprintGuestLayoutState(roomsDataRef.current),
          editorPack: guestForkEditorDiagRef.current,
          autoSaveInFlight: autoSaveloadingRef.current,
          ...fingerprintGuestForkDomDeep(),
        });
      }, 280);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isForked, saveForkedLayoutAndNavigate, setForkTransitioning]);

  // Phase 1.5 fork-save dismiss handler. After a bail the user picks Dismiss
  // to walk away from the failed save and keep editing. We clear the error
  // state and the fork-transition gate so:
  //   - the AuthModal closes (open is driven by authModalOpen || forkTransitioning),
  //   - autosave can resume (the forkTransitioningRef gate releases),
  //   - the user's edits stay in memory exactly as they are,
  //   - subsequent saves go to forkedLayoutIdRef (the existing fork) because
  //     that ref is intentionally NOT cleared — keeps the user pointed at
  //     their own copy rather than re-overwriting the original.
  const handleForkSaveDismiss = useCallback(() => {
    mfLogGuestGalleryAuth("forkSave.dismissedByUser", {
      forkedLayoutId: forkedLayoutIdRef.current,
      forkedLayoutUuid: forkedLayoutUuidRef.current,
    });
    setForkSaveError(null);
    setForkTransitioning(false);
    setAuthModalOpen(false);
    forkSaveRetryInFlightRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setForkTransitioning]);

  // Phase 1 fork-save retry handler: re-runs the same fork-save pipeline,
  // reusing the existing forkedLayoutIdRef so we do NOT create another copy.
  // Guarded against double-fire by forkSaveRetryInFlightRef. Clears
  // forkSaveError up front so the overlay swaps back to the saving spinner.
  const handleForkSaveRetry = useCallback(() => {
    if (forkSaveRetryInFlightRef.current) return;
    forkSaveRetryInFlightRef.current = true;
    setForkSaveError(null);
    mfLogGuestGalleryAuth("forkSave.retryStart", {
      forkedLayoutId: forkedLayoutIdRef.current,
      forkedLayoutUuid: forkedLayoutUuidRef.current,
      hasAuthedUserId: !!lastAuthUserIdRef.current,
    });
    // Defer one tick so React commits the setForkSaveError(null) before the
    // save starts (overlay flips back to spinner immediately).
    setTimeout(async () => {
      try {
        await saveForkedLayoutAndNavigate(lastAuthUserIdRef.current);
      } catch (err) {
        // saveForkedLayoutAndNavigate has its own try/catch that handles errors
        // via setForkSaveError; this catch is purely a guard against unexpected
        // throws (e.g. import-time issues) so the in-flight ref always clears.
        mfLogGuestGalleryAuth("forkSave.retryUnexpectedThrow", {
          message: err?.message ?? String(err),
        });
      } finally {
        forkSaveRetryInFlightRef.current = false;
      }
    }, 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveForkedLayoutAndNavigate]);

  // Track whether this UploadFloor instance mounted with forkTransitioning already
  // active (i.e., the NEW instance after navigate). The OLD instance sets the flag
  // mid-lifecycle, so its data is already loaded and the clearing effect would fire
  // immediately — which is wrong. Only the NEW instance should clear the overlay.
  const mountedDuringForkTransition = useRef(false);
  useEffect(() => {
    if (forkTransitioning) {
      mountedDuringForkTransition.current = true;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- intentionally mount-only

  // Mirror forkTransitioning into a ref so save helpers can read the *latest*
  // value even from stale closures (e.g. an autosave setTimeout captured
  // before the state flip). Without this mirror the autosave timer that was
  // scheduled while isGuest was true can fire post-auth, see a stale
  // `forkTransitioning=false`, and PUT to the original layout.
  useEffect(() => {
    forkTransitioningRef.current = forkTransitioning;
  }, [forkTransitioning]);

  // Clear the fork transition overlay once the new layout data has loaded.
  // Only fires on the NEW UploadFloor instance (mountedDuringForkTransition=true).
  useEffect(() => {
    if (forkTransitioning && mountedDuringForkTransition.current && isLayoutDataSuccess && !layoutLoading) {
      setForkTransitioning(false);
    }
  }, [forkTransitioning, isLayoutDataSuccess, layoutLoading, setForkTransitioning]);

  // eslint-disable-next-line no-unused-vars
  const [isActive, setIsActive] = useState(true);
  const [imageDimensions, setImageDimensions] = useState({
    width: "",
    height: "",
    orgWidth: "",
    orgHeight: "",
  });

  useEffect(() => {
    guestForkEditorDiagRef.current = {
      waveTs: Date.now(),
      scaleReady,
      isGuest,
      roomActive,
      roomActiveLayoutSlot: roomActiveLayout?.[roomActive] ?? null,
      imageDimensions: {
        orgWidth: imageDimensions.orgWidth,
        orgHeight: imageDimensions.orgHeight,
        width: imageDimensions.width,
        height: imageDimensions.height,
      },
      scaleFactorX,
      scaleFactorY,
      calculateScaleFactorX,
      calculateScaleFactorY,
      scaleXCanvas,
      scaleYCanvas,
      offsetXCheck,
      offsetYCheck,
      divWidth,
      divHeight,
    };
  }, [
    scaleReady,
    isGuest,
    roomActive,
    roomActiveLayout,
    imageDimensions.orgWidth,
    imageDimensions.orgHeight,
    imageDimensions.width,
    imageDimensions.height,
    scaleFactorX,
    scaleFactorY,
    calculateScaleFactorX,
    calculateScaleFactorY,
    scaleXCanvas,
    scaleYCanvas,
    offsetXCheck,
    offsetYCheck,
    divWidth,
    divHeight,
  ]);

  const autoSaveCount = useRef(0);
  const { startTracking } = useUptimeTracker();  

  // Forward declaration to avoid initialization order issues
  const furnishRoomRef = useRef();

  const deleteFurnitureObject = useCallback((deletedObj) => {
    const undoLayouts = JSON.stringify(
      roomsData?.[roomActive]?.layouts?.map((layout) => ({
        furniture: layout.furniture.map((furniture) => ({ ...furniture })),
      }))
    );

    const updatedLayouts = roomsData.map((room, roomIndex) => ({
      ...room,
      layouts: room.layouts.map((layout) => ({
        ...layout,
        furniture: layout.furniture.map((furniture) => ({ ...furniture })),
      })),
    }));

    updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture =
      updatedLayouts[roomActive].layouts[
        roomActiveLayout[roomActive]
      ].furniture.filter((furniture) => furniture._id !== deletedObj._id);

    setRoomsData(updatedLayouts);

    const updatedRoomItemsList = JSON.parse(JSON.stringify(roomItemsList));

    updatedRoomItemsList[roomActive][roomActiveLayout[roomActive]] =
      updatedRoomItemsList[roomActive][roomActiveLayout[roomActive]].filter(
        (item) => item._id !== deletedObj._id
      );

    setRoomItemsList(updatedRoomItemsList);

    setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
      ...prevGlobalUndoFurniture,
      {
        roomId: roomActive,
        type: "change",
        layouts: undoLayouts,
        redoLayouts: JSON.stringify(
          updatedLayouts?.[roomActive]?.layouts?.map((layout) => ({
            furniture: layout.furniture.map((furniture) => ({ ...furniture })),
          }))
        ),
      },
    ]);
  }, [roomsData, roomActive, roomActiveLayout, roomItemsList, setRoomsData, setRoomItemsList, setGlobalUndoFurniture]);

  const handleDelete = useCallback(() => {
    if (selectedFurniture) {
      // TRIPWIRE: Mark as user-edited (intentional world change)
      markUserEdited();
      console.log('[TRIPWIRE] User edit detected: DELETE furniture');
      
      deleteFurnitureObject(selectedFurniture);
      setSelectedFurniture(null);
      setCopySelectedFurniture(null);
      setSelectedItem(null);

      if (roomId === "custom-room") {
        setLineBoundary(false);
        return setRoomActive(-1);
      }

      const itemExists1 = keepItems?.[roomActive]?.[
        roomActiveLayout?.[roomActive]
      ]?.some((item) => item._id === selectedFurniture._id);

      if (itemExists1) {
        const updatedKeepItems = JSON.parse(JSON.stringify(keepItems));

        updatedKeepItems[roomActive][roomActiveLayout[roomActive]] =
          updatedKeepItems[roomActive][roomActiveLayout[roomActive]].filter(
            (item) => item._id !== selectedFurniture._id
          );

        setKeepItems(updatedKeepItems);
      }

      const itemExistsInBackTrack = backTrackKeepItems?.[roomId]?.some(
        (item) => item._id === selectedFurniture._id
      );

      if (itemExistsInBackTrack) {
        furnishRoomRef.current?.();
      }
    }
  }, [selectedFurniture, deleteFurnitureObject, markUserEdited, roomId, setLineBoundary, setRoomActive, keepItems, roomActive, roomActiveLayout, setKeepItems, backTrackKeepItems]);

  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Delete") {
        if (selectedFurniture) handleDelete(selectedFurniture);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedFurniture, handleDelete]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRefZones.current &&
        !containerRefZones.current.contains(event.target)
      ) {
        setShowZonesMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangeScale = (name, value) => {
    console.log('[SCALE-ADJUST] handleChangeScale called:', value, '=', value === 'feet' ? name.feet : name.inches,
      '| current: selectedFeet=' + selectedFeet + ' selectedInches=' + selectedInches,
      '| scaleFactorX=' + scaleFactorX, '| apiRef=' + scaleFactorFromApiRef.current,
      '| roomsData.length=' + roomsData?.length);
    if (roomsData?.length >= 1) {
     console.log('[SCALE-ADJUST] ⚠️ ERASING rooms (roomsData had', roomsData.length, 'rooms)');
     setRoomsData([])
     setRoomActiveLayout([]);
     resetLayouts();
     resetRoom();
      // }
      setIsResetScale(false);
      setOptionsMenu(null);
    }

    if(!partnerPackage?.allowMakeMagic){
      setRoomsData((prevRoomsData) => {
        const existingRoomIndex = prevRoomsData.findIndex(
          (room) => room.roomId === "custom-room"
        );

        if (existingRoomIndex !== -1) {
          setRoomActiveLayout((prevActiveLayout) => {
            if (prevActiveLayout[existingRoomIndex] !== undefined) {
              return prevActiveLayout;
            }

            const newLayout = [...prevActiveLayout];
            newLayout[existingRoomIndex] = 0;
            return newLayout;
          });

          return prevRoomsData;
        } else {
          setRoomItemsList((prevRoomItemsList) => {
            const initializedItemsArray = Array.from({ length: 1 }, () =>
              Array.from({ length: 1 }, () => [])
            );

            const combinedArray = [
              ...prevRoomItemsList,
              ...initializedItemsArray,
            ];
            return combinedArray;
          });

          const newCustomRoom = {
            layouts: [
              {
                room: {
                  width: 124,
                  height: 214,
                  shape: "box-shape",
                  zone: [
                    {
                      value: "workingvanity",
                      capacity: 1,
                    },
                  ],
                  position: {
                    x: 0,
                    y: 0,
                    z: 0,
                  },
                },
                doors: [],
                windows: [],
                furniture: [],
                vertices: [],
                prompt: "",
              },
            ],
            payloadVertices: [],
            doors: [],
            windows: [],
            scaleX: scaleFactorX,
            scaleY: scaleFactorY,
            centerX: 1500,
            centerY: divHeight / 2,
            roomId: "custom-room",
            orignalPayloadVertices: [],
            scaleXCanvas: scaleXCanvas,
            scaleYCanvas: scaleYCanvas,
            offsetX: offsetXCheck,
            offsetY: offsetYCheck,
            zones: [{ value: "custom", label: "Custom Room" }],
            resultRoomVerticesState: {},
          };

          const newIndex = prevRoomsData.length;

          setRoomActiveLayout((prevActiveLayout) => {
            const newLayout = [...prevActiveLayout];
            newLayout[newIndex] = 0;
            return newLayout;
          });

          return [...prevRoomsData, newCustomRoom];
        }
      });
    }

    if (value === "feet") {
      // Don't unlock recalibration here -- scale should NOT change until "Done" is clicked.
      // scaleFactorFromApiRef stays true, so the calibration useEffect skips recalculation.
      // The "Done" handler will unlock and apply the new scale.
      setSelectedFeet(name.feet);
    } else if (value === "inches") {
      setSelectedInches(name.inches);
    }
  };

  useEffect(() => {
    console.log('[SCALE-RESET-UE] isScaleDimensionsMarked=' + isScaleDimensionsMarked,
      '| selectedResetFeet=' + selectedResetFeet, 'selectedResetInches=' + selectedResetInches,
      '| selectedFeet=' + selectedFeet, 'selectedInches=' + selectedInches);
    if (isScaleDimensionsMarked === true) {
      console.log('[SCALE-RESET-UE] ⚠️ Resetting picker to reset values: ' + selectedResetFeet + "'" + selectedResetInches + '"');
      setSelectedFeet(selectedResetFeet);
      setSelectedInches(selectedResetInches);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScaleDimensionsMarked, selectedResetFeet, selectedResetInches]);

  const handleRotateAntiClockwise = () => {
    if (selectedFurniture) {
      // TRIPWIRE: Mark as user-edited (intentional world change)
      markUserEdited();
      console.log('[TRIPWIRE] User edit detected: ROTATE furniture');
      
      updateFurniturePositionRotation(
        selectedFurniture,
        selectedFurniture.angle + 90
      );
    }
  };


  const getManualAddViewportCenter = (scaleX, scaleY) => {
    const { transformState, wrapperComponent } =
      transformRef?.current?.instance;

    if (
      !transformState ||
      !wrapperComponent ||
      !scaleX ||
      !scaleY ||
      !divWidth ||
      !divHeight
    ) {
      return { x: 0, y: 0 };
    }

    const { scale, positionX, positionY } = transformState;
    const viewWidth = wrapperComponent.offsetWidth;
    const viewHeight = wrapperComponent.offsetHeight;

    // Map the live wrapper viewport center into content-local coordinates,
    // then express as a newlyAdded position offset (anchor = divWidth/2, divHeight/2).
    const localCenterX = (viewWidth / 2 - positionX) / scale;
    const localCenterY = (viewHeight / 2 - positionY) / scale;

    return {
      x: (localCenterX - divWidth / 2) / scaleX,
      y: (divHeight / 2 - localCenterY) / scaleY,
    };
  };

  const MANUAL_ADD_STAGGER_PX = 24;

  const getManualAddItemBaseId = (itemId) => {
    const parts = String(itemId).split("-");
    parts.pop();
    return parts.join("-");
  };

  const getManualAddItemQuantity = (itemId) => {
    const quantity = parseInt(String(itemId).split("-").pop(), 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const getManualAddSourceItemId = (itemId) => {
    const quantity = getManualAddItemQuantity(itemId);
    if (quantity <= 1) return null;
    return `${getManualAddItemBaseId(itemId)}-${quantity - 1}`;
  };

  const getFurniturePlacementPosition = (roomKey, furnitureItem) => {
    const livePosition = furniturePositions[roomKey]?.[furnitureItem._id];
    if (
      livePosition?.x != null &&
      livePosition?.y != null &&
      Number.isFinite(livePosition.x) &&
      Number.isFinite(livePosition.y)
    ) {
      return livePosition;
    }
    return furnitureItem?.position;
  };

  const findDuplicateSourceFurniture = (
    furnitureList,
    itemId,
    activeRoomKey,
    duplicateSourceId
  ) => {
    if (duplicateSourceId) {
      const explicitMatch = furnitureList.find(
        (f) => f._id === duplicateSourceId
      );
      if (explicitMatch) return explicitMatch;
    }

    const quantity = getManualAddItemQuantity(itemId);
    if (quantity <= 1) return null;

    const itemBase = getManualAddItemBaseId(itemId);
    const selected = selectedFurniture;

    if (
      selected?._id &&
      Number(selected.roomId) === Number(activeRoomKey) &&
      getManualAddItemBaseId(selected._id) === itemBase &&
      quantity === getManualAddItemQuantity(selected._id) + 1
    ) {
      const selectedMatch = furnitureList.find((f) => f._id === selected._id);
      if (selectedMatch) return selectedMatch;
    }

    const sourceId = getManualAddSourceItemId(itemId);
    return sourceId
      ? furnitureList.find((f) => f._id === sourceId) || null
      : null;
  };

  const applyManualAddStagger = (center, staggerIndex, scaleX, scaleY) => {
    if (!staggerIndex || staggerIndex <= 0 || !center) {
      return center;
    }

    const sx = scaleX || 1;
    const sy = scaleY || 1;

    return {
      x: center.x + (staggerIndex * MANUAL_ADD_STAGGER_PX) / sx,
      y: center.y - (staggerIndex * MANUAL_ADD_STAGGER_PX) / sy,
    };
  };

  const addItems = () => {
    const activeRoom = roomActive;
    const activeLayout = roomActiveLayout?.[activeRoom];
    const roomItems = roomItemsList?.[activeRoom]?.[activeLayout] || [];

    // PETER'S DIAGNOSTIC: Log entry conditions
    console.log('');
    console.log('╔' + '═'.repeat(90) + '╗');
    console.log('║  📦 [ADD ITEMS] FUNCTION ENTRY - COMPREHENSIVE STATE DUMP                                ║');
    console.log('╠' + '═'.repeat(90) + '╣');
    console.log('║  ENTRY CONDITIONS:');
    console.log('║    roomActive:', roomActive);
    console.log('║    roomActiveLayout:', JSON.stringify(roomActiveLayout));
    console.log('║    activeLayout (derived):', activeLayout);
    console.log('║    roomItemsList exists?', !!roomItemsList);
    console.log('║    roomItems count:', roomItems?.length);
    console.log('║    roomItems[0]?.name:', roomItems?.[0]?.name);
    console.log('║  ');
    console.log('║  ROOMSDATA STRUCTURE:');
    console.log('║    roomsData exists?', !!roomsData);
    console.log('║    roomsData length:', roomsData?.length);
    console.log('║    roomsData[activeRoom] exists?', !!roomsData?.[activeRoom]);
    console.log('║    roomsData[activeRoom].layouts exists?', !!roomsData?.[activeRoom]?.layouts);
    console.log('║    roomsData[activeRoom].layouts length:', roomsData?.[activeRoom]?.layouts?.length);
    console.log('║    roomsData[activeRoom].layouts[activeLayout] exists?', !!roomsData?.[activeRoom]?.layouts?.[activeLayout]);
    console.log('║    Current furniture count:', roomsData?.[activeRoom]?.layouts?.[activeLayout]?.furniture?.length ?? 'N/A');
    console.log('║  ');
    console.log('║  SCALE STATE:');
    console.log('║    scaleReady:', scaleReady);
    console.log('║    scaleFactorX:', scaleFactorX, typeof scaleFactorX);
    console.log('║    scaleFactorY:', scaleFactorY, typeof scaleFactorY);
    console.log('║    roomsData[activeRoom]?.scaleX:', roomsData?.[activeRoom]?.scaleX);
    console.log('║    roomsData[activeRoom]?.scaleY:', roomsData?.[activeRoom]?.scaleY);
    console.log('╚' + '═'.repeat(90) + '╝');
    console.log('');

    if (roomItems?.length > 0 || roomActive !== -1) {
      // =====================================================
      // PR #89: GATE ADD-ITEM UNTIL SCALE IS READY
      // =====================================================
      // If scale isn't ready, handleUpdate hasn't converted positions yet.
      // Adding furniture now would use wrong scale factors and result in
      // HUGE furniture that later "shrinks" after a gallery->editor cycle.
      // =====================================================
      // =====================================================
      // PR #89: COMPREHENSIVE LOGGING FOR ADD ITEMS
      // =====================================================
      console.log('='.repeat(80));
      console.log('[ADD ITEMS] ========== ADD ITEMS TRIGGERED ==========');
      console.log('='.repeat(80));
      console.log('[ADD ITEMS] Current state:', {
        scaleReady: scaleReady,
        activeRoom: activeRoom,
        activeLayout: activeLayout,
        roomItemsCount: roomItems?.length,
        divWidth: divWidth,
        divHeight: divHeight,
        scaleFactorX: scaleFactorX,
        scaleFactorY: scaleFactorY,
      });
      
      if (!scaleReady) {
        console.log('[ADD ITEMS] ⏳ BLOCKED - scaleReady is FALSE');
        console.log('[ADD ITEMS] Current values:', {
          scaleReady: scaleReady,
          divWidth: divWidth,
          divHeight: divHeight,
          scaleFactorX: scaleFactorX,
          scaleFactorY: scaleFactorY,
          roomsDataLength: roomsData?.length,
        });
        console.log('[ADD ITEMS] 💡 scaleReady is set at TOP of handleUpdate useEffect');
        console.log('[ADD ITEMS] 💡 If this keeps blocking, check if useEffect is running');
        console.log('[ADD ITEMS] Will AUTO-RETRY when scaleReady becomes true');
        console.log('='.repeat(80));
        return;
      }
      
      console.log('[ADD ITEMS] ✅ scaleReady=true - proceeding with add');
      
      // PR #89 FIX: Use room.scaleX/Y as primary source, fallback to state, then to 1
      // This fixes "huge furniture on add" bug where scaleFactorX/Y state might be stale
      const roomScaleX = roomsData?.[activeRoom]?.scaleX;
      const roomScaleY = roomsData?.[activeRoom]?.scaleY;
      
      // Priority: room.scaleX > scaleFactorX state > 1 (safe default)
      let effectiveScaleX = scaleFactorX;
      let scaleSourceX = 'scaleFactorX state';
      if (Number.isFinite(roomScaleX) && roomScaleX > 0) {
        effectiveScaleX = roomScaleX;
        scaleSourceX = 'room.scaleX (authoritative)';
      } else if (!Number.isFinite(scaleFactorX) || scaleFactorX <= 0) {
        effectiveScaleX = 1;
        scaleSourceX = 'FALLBACK (1) - WARNING: scale invalid';
      }
      
      let effectiveScaleY = scaleFactorY;
      let scaleSourceY = 'scaleFactorY state';
      if (Number.isFinite(roomScaleY) && roomScaleY > 0) {
        effectiveScaleY = roomScaleY;
        scaleSourceY = 'room.scaleY (authoritative)';
      } else if (!Number.isFinite(scaleFactorY) || scaleFactorY <= 0) {
        effectiveScaleY = 1;
        scaleSourceY = 'FALLBACK (1) - WARNING: scale invalid';
      }
      
      console.log('[ADD ITEMS] Scale factors resolved:', {
        scaleFactorX_state: scaleFactorX,
        scaleFactorY_state: scaleFactorY,
        roomScaleX: roomScaleX,
        roomScaleY: roomScaleY,
        effectiveScaleX: effectiveScaleX,
        effectiveScaleY: effectiveScaleY,
        sourceX: scaleSourceX,
        sourceY: scaleSourceY,
      });
      
      const undoLayouts = JSON.stringify(
        roomsData?.[activeRoom]?.layouts?.map((layout) => ({
          furniture: layout.furniture.map((furniture) => ({ ...furniture })),
        }))
      );

      const updatedLayouts = roomsData.map((room) => ({
        ...room,
        layouts: room.layouts.map((layout) => ({
          ...layout,
          furniture: layout.furniture.map((furniture) => ({ ...furniture })),
        })),
      }));

      const furniture =
        updatedLayouts?.[activeRoom]?.layouts?.[activeLayout]?.furniture || [];

      roomItems?.forEach((item) => {
        const isItemPresent = furniture.some(
          (furnitureItem) => furnitureItem._id === item._id
        );

        if (!isItemPresent) {
          // Placement strategy:
          //   Manual catalog add → room/viewport center (batch stagger for 2nd+ adds in same pass)
          //   Toolbar duplicate  → 24px down/right from the source item (duplicateFromSource only)
          //   Room selected  → center of that room (roomValue.centerX/Y in canvas px)
          //   No room        → center of the visible viewport (getManualAddViewportCenter)
          //
          // The render formula is:
          //   centerLeft = divWidth/2  + position.x * scaleXCanvas
          //   centerTop  = divHeight/2 - position.y * scaleYCanvas
          //
          // Solving for position.x/y so the item lands on the room center:
          //   position.x = (roomCenterX - divWidth/2)  / scaleXCanvas
          //   position.y = (divHeight/2 - roomCenterY) / scaleYCanvas
          const roomCenterX = roomsData?.[activeRoom]?.centerX;
          const roomCenterY = roomsData?.[activeRoom]?.centerY;
          const activeRoomData = roomsData?.[activeRoom];
          const isNoRoomSelected =
            activeRoom === -1 || activeRoomData?.roomId === "custom-room";
          const hasRoomCenter =
            !isNoRoomSelected &&
            roomCenterX != null &&
            roomCenterY != null &&
            Number.isFinite(roomCenterX) &&
            Number.isFinite(roomCenterY) &&
            scaleXCanvas &&
            scaleYCanvas;
          const baseCenter = hasRoomCenter
            ? {
                x: (roomCenterX - divWidth / 2) / scaleXCanvas,
                y: (divHeight / 2 - roomCenterY) / scaleYCanvas,
              }
            : getManualAddViewportCenter(scaleXCanvas, scaleYCanvas);
          const isDuplicateFromSource = item.duplicateFromSource === true;
          let center;

          if (isDuplicateFromSource) {
            const sourceFurniture = findDuplicateSourceFurniture(
              furniture,
              item._id,
              activeRoom,
              item.duplicateSourceId
            );
            const sourcePosition = sourceFurniture
              ? getFurniturePlacementPosition(activeRoom, sourceFurniture)
              : null;

            if (
              sourcePosition?.x != null &&
              sourcePosition?.y != null &&
              Number.isFinite(sourcePosition.x) &&
              Number.isFinite(sourcePosition.y)
            ) {
              center = applyManualAddStagger(
                { x: sourcePosition.x, y: sourcePosition.y },
                1,
                scaleXCanvas,
                scaleYCanvas
              );
            } else {
              center = applyManualAddStagger(
                baseCenter,
                1,
                scaleXCanvas,
                scaleYCanvas
              );
            }
          } else {
            if (manualAddPlacementRoomRef.current !== activeRoom) {
              manualAddPlacementRoomRef.current = activeRoom;
              manualAddPlacementIndexRef.current = 0;
            }
            const staggerIndex = manualAddPlacementIndexRef.current;
            manualAddPlacementIndexRef.current += 1;
            center = applyManualAddStagger(
              baseCenter,
              staggerIndex,
              scaleXCanvas,
              scaleYCanvas
            );
          }
          setShowHelperMessage(false);

          const firstVariant = item?.variants?.[0] || {};
          const _addItemWidth = firstVariant?.width ? +firstVariant.width / effectiveScaleX : item.width;
          console.log('████ [BEDROCK-ADDITEMS] ══════ Adding item:', item.name, '══════');
          console.log('████ [BEDROCK-ADDITEMS] effectiveScaleX:', effectiveScaleX, '(source:', scaleSourceX, ')');
          console.log('████ [BEDROCK-ADDITEMS] center:', JSON.stringify(center), '(source:', hasRoomCenter ? 'room center' : 'viewport center', ')');
          console.log('████ [BEDROCK-ADDITEMS] firstVariant.width:', firstVariant?.width, '(inches)');
          console.log('████ [BEDROCK-ADDITEMS] Computed width:', _addItemWidth?.toFixed(2), 'px');
          console.log('████ [BEDROCK-ADDITEMS] scaleFactorX(state):', scaleFactorX, 'roomScaleX:', roomScaleX);
          console.log('████ [BEDROCK-ADDITEMS] scaleXCanvas:', scaleXCanvas);
          console.log('████ [BEDROCK-ADDITEMS] newlyAddedCenterX would be: divWidth/2 =', divWidth/2);
          console.log('████ [BEDROCK-ADDITEMS] CSS left would be:', (divWidth/2 + (center?.x || 0) - (_addItemWidth || 0) / 2)?.toFixed(2));
          console.log('████ [BEDROCK-ADDITEMS] Room active:', roomActive, 'room centerX:', roomsData?.[roomActive]?.centerX);
          const {
            duplicateFromSource: _placementFlag,
            duplicateSourceId: _duplicateSourceId,
            ...itemForFurniture
          } = item;
          const modifiedItem = {
            ...itemForFurniture,
            newlyAdded: true,
            exactPosition:{
              x: center?.x * effectiveScaleX,
              y: center?.y * effectiveScaleY,
              z: 0,
            },
            position: {
              x: center?.x,
              y: center?.y,
              z: 0,
            },
            rotation: {
              x: 0,
              y: 0,
              z: item?.rotation?.z ? item?.rotation?.z : 0,
            },
            width: !firstVariant?.width
              ? item.width
              : +firstVariant.width / effectiveScaleX || 0,
            height: !firstVariant?.length
              ? item.height
              : +firstVariant.length / effectiveScaleY || 0,
            // PR #89 FIX: origionalPosition MUST be canonical (plan units), NOT screen coords
            // If set to screen coords, later code paths using origionalPosition/scaleFactor
            // will cause furniture to "jump" or resize after recompute
            origionalPosition: { 
              x: center?.x * effectiveScaleX, 
              y: center?.y * effectiveScaleY, 
              z: 0 
            },
            origionalWidth: !firstVariant?.width
              ? item.origionalWidth
              : firstVariant.width,
            origionalHeight: !firstVariant?.length
              ? item.origionalHeight
              : firstVariant.length,
          };

          // =====================================================
          // PETER'S DIAGNOSTIC LOGGING - Find why items don't show
          // =====================================================
          console.log('');
          console.log('╔' + '═'.repeat(90) + '╗');
          console.log('║  🪑 [ADD ITEM] CREATED FURNITURE - COMPREHENSIVE DIAGNOSTIC                              ║');
          console.log('╠' + '═'.repeat(90) + '╣');
          console.log('║  Item Name:', item?.name);
          console.log('║  Item _id:', modifiedItem._id);
          console.log('║  ');
          console.log('║  📍 POSITION FIELDS (Peter\'s checklist):');
          console.log('║    position:', JSON.stringify(modifiedItem.position));
          console.log('║    exactPosition:', JSON.stringify(modifiedItem.exactPosition));
          console.log('║    origionalPosition:', JSON.stringify(modifiedItem.origionalPosition));
          console.log('║  ');
          console.log('║  📐 SIZE FIELDS (Peter\'s checklist):');
          console.log('║    origionalWidth:', modifiedItem.origionalWidth, typeof modifiedItem.origionalWidth);
          console.log('║    origionalHeight:', modifiedItem.origionalHeight, typeof modifiedItem.origionalHeight);
          console.log('║    width (calculated):', modifiedItem.width, typeof modifiedItem.width);
          console.log('║    height (calculated):', modifiedItem.height, typeof modifiedItem.height);
          console.log('║  ');
          console.log('║  🎚️ SCALE VALUES USED:');
          console.log('║    effectiveScaleX:', effectiveScaleX, typeof effectiveScaleX);
          console.log('║    effectiveScaleY:', effectiveScaleY, typeof effectiveScaleY);
          console.log('║    scaleSourceX:', scaleSourceX);
          console.log('║    center.x:', center?.x, 'center.y:', center?.y);
          console.log('║  ');
          console.log('║  📦 RAW INPUT VALUES:');
          console.log('║    firstVariant.width:', firstVariant?.width, typeof firstVariant?.width);
          console.log('║    firstVariant.length:', firstVariant?.length, typeof firstVariant?.length);
          console.log('║    item.width (fallback):', item?.width);
          console.log('║    item.height (fallback):', item?.height);
          console.log('║    item.origionalWidth (fallback):', item?.origionalWidth);
          console.log('║    item.origionalHeight (fallback):', item?.origionalHeight);
          console.log('║  ');
          console.log('║  🔍 FLAGS:');
          console.log('║    calculateWidth:', modifiedItem.calculateWidth);
          console.log('║    newlyAdded:', modifiedItem.newlyAdded);
          console.log('║  ');
          console.log('║  ═══════════════════════════════════════════════════════════════════════════════════════');
          console.log('║  🚨 VALIDATION CHECKS (Peter\'s smoking guns):');
          const posXValid = Number.isFinite(modifiedItem.position?.x);
          const posYValid = Number.isFinite(modifiedItem.position?.y);
          const exactXValid = Number.isFinite(modifiedItem.exactPosition?.x);
          const exactYValid = Number.isFinite(modifiedItem.exactPosition?.y);
          const origWValid = Number.isFinite(modifiedItem.origionalWidth) && modifiedItem.origionalWidth > 0;
          const origHValid = Number.isFinite(modifiedItem.origionalHeight) && modifiedItem.origionalHeight > 0;
          const widthValid = Number.isFinite(modifiedItem.width) && modifiedItem.width > 0;
          const heightValid = Number.isFinite(modifiedItem.height) && modifiedItem.height > 0;
          console.log('║    position.x valid?', posXValid ? '✅' : '❌ NaN/undefined!');
          console.log('║    position.y valid?', posYValid ? '✅' : '❌ NaN/undefined!');
          console.log('║    exactPosition.x valid?', exactXValid ? '✅' : '❌ NaN/undefined! (renderer uses this as rawX)');
          console.log('║    exactPosition.y valid?', exactYValid ? '✅' : '❌ NaN/undefined!');
          console.log('║    origionalWidth valid?', origWValid ? '✅' : '❌ ZERO/NaN/undefined! (causes invisible!)');
          console.log('║    origionalHeight valid?', origHValid ? '✅' : '❌ ZERO/NaN/undefined! (causes invisible!)');
          console.log('║    width (screen) valid?', widthValid ? '✅' : '❌ ZERO/NaN/undefined!');
          console.log('║    height (screen) valid?', heightValid ? '✅' : '❌ ZERO/NaN/undefined!');
          console.log('║  ');
          const allValid = posXValid && posYValid && exactXValid && exactYValid && origWValid && origHValid && widthValid && heightValid;
          if (allValid) {
            console.log('║  ✅ ALL FIELDS VALID - Item should render correctly');
          } else {
            console.log('║  ❌❌❌ INVALID FIELDS DETECTED - THIS IS WHY ITEM DOESN\'T SHOW! ❌❌❌');
          }
          console.log('║  ');
          console.log('║  📊 ROOM/LAYOUT TARGETING:');
          console.log('║    activeRoom:', activeRoom);
          console.log('║    activeLayout:', activeLayout);
          console.log('║    furniture array length BEFORE push:', furniture.length);
          console.log('╚' + '═'.repeat(90) + '╝');
          console.log('');

          furniture.push(modifiedItem);
          
          // Log furniture count AFTER push
          console.log('[ADD ITEM] furniture count AFTER push:', furniture.length);

          const selectionCenterX = hasRoomCenter
            ? roomsData?.[activeRoom]?.centerX
            : divWidth / 2 + (center?.x || 0) * scaleXCanvas;
          const selectionCenterY = hasRoomCenter
            ? roomsData?.[activeRoom]?.centerY
            : divHeight / 2 - (center?.y || 0) * scaleYCanvas;

          setCopySelectedFurniture({
            angle: 0,
            left: selectionCenterX,
            top:
              selectionCenterY -
              firstVariant.length / effectiveScaleY / 2,
            roomId: activeRoom,
            _id: item._id,
            centerTop: selectionCenterY,
          });

        }
      });

      updatedLayouts[activeRoom].layouts[activeLayout].furniture =
        furniture.filter((furnitureItem) => {
          const isInItemsList = roomItems.some(
            (item) => item._id === furnitureItem._id
          );

          if (
            !isInItemsList &&
            furnitureItem?.newlyAdded &&
            (furnitureItem?._id === selectedFurniture?._id ||
              furnitureItem?._id === selectedCopyFurniture?._id)
          ) {
            setSelectedFurniture(null);
            setCopySelectedFurniture(null);
            setSelectedItem(null);
          }

          return isInItemsList || !furnitureItem.newlyAdded;
        });

      // TRIPWIRE: Mark as user-edited (intentional world change)
      markUserEdited();
      console.log('[TRIPWIRE] User edit detected: ADD furniture');
      
      // PETER'S DIAGNOSTIC: Verify targeting before state update
      console.log('');
      console.log('┌' + '─'.repeat(80) + '┐');
      console.log('│  [ADD ITEM] STATE UPDATE - TARGETING VERIFICATION                                │');
      console.log('├' + '─'.repeat(80) + '┤');
      console.log('│  activeRoom:', activeRoom, '  activeLayout:', activeLayout);
      console.log('│  updatedLayouts[activeRoom] exists?', !!updatedLayouts[activeRoom]);
      console.log('│  updatedLayouts[activeRoom].layouts exists?', !!updatedLayouts[activeRoom]?.layouts);
      console.log('│  updatedLayouts[activeRoom].layouts[activeLayout] exists?', !!updatedLayouts[activeRoom]?.layouts?.[activeLayout]);
      const finalFurnitureCount = updatedLayouts[activeRoom]?.layouts?.[activeLayout]?.furniture?.length ?? 0;
      console.log('│  Final furniture count in target layout:', finalFurnitureCount);
      if (finalFurnitureCount > 0) {
        const lastFurn = updatedLayouts[activeRoom]?.layouts?.[activeLayout]?.furniture?.[finalFurnitureCount - 1];
        console.log('│  Last furniture item name:', lastFurn?.name);
        console.log('│  Last furniture item newlyAdded:', lastFurn?.newlyAdded);
      }
      console.log('└' + '─'.repeat(80) + '┘');
      console.log('');
      
      setRoomsData(updatedLayouts);

      const updatedGlobalUndoFurniture = [
        ...globalUndoFurniture,
        {
          roomId: activeRoom,
          type: "change",
          layouts: undoLayouts,
          redoLayouts: JSON.stringify(
            updatedLayouts?.[activeRoom]?.layouts?.map((layout) => ({
              furniture: layout.furniture.map((furniture) => ({
                ...furniture,
              })),
            }))
          ),
        },
      ];

      setGlobalUndoFurniture(updatedGlobalUndoFurniture);
    }
  };

  const feetOptions = useMemo(() => {
    const start = Math.max(0, selectedFeet - 50); 
    return Array.from(
      { length: selectedFeet + 51 - start },
      (_, i) => start + i
    );
  }, [selectedFeet]); 

  // eslint-disable-next-line no-unused-vars
  const handleClick = () => {
    setIsActive((prev) => !prev);
  };

  const drawVerticesInDiv = useCallback((vertices, container) => {
    try {
      // Increment call counter for binary validation
      drawCallCountRef.current += 1;
      const callNumber = drawCallCountRef.current;
      console.log(`[SCALE DEBUG] drawVerticesInDiv CALL #${callNumber} - locked: ${viewTransformLockedRef.current}`);
      
      // =====================================================
      // PATCH 1: Early return if container dimensions are invalid
      // This prevents setting NaN scale values when container isn't ready
      // =====================================================
      if (!divWidth || !divHeight || divWidth === 0 || divHeight === 0) {
        console.log(`[SCALE DEBUG] CALL #${callNumber} - EARLY RETURN: container not ready (divWidth: ${divWidth}, divHeight: ${divHeight})`);
        return;
      }
      
      // Early return if vertices are invalid
      if (!vertices || !Array.isArray(vertices) || vertices.length === 0) {
        console.log(`[SCALE DEBUG] CALL #${callNumber} - EARLY RETURN: vertices not ready (length: ${vertices?.length})`);
        return;
      }
      
      const previousLines = container.querySelectorAll(
        ".line, .line-length-text"
      );
      previousLines.forEach((line) => line.remove());

      const allX = vertices.flatMap((vertex) => [vertex[0].x, vertex[1].x]);
      const allY = vertices.flatMap((vertex) => [vertex[0].y, vertex[1].y]);

      let minX = Math.min(...allX);
      let maxX = Math.max(...allX);
      let minY = Math.min(...allY);
      let maxY = Math.max(...allY);

      minX -= floors?.extraLeft;
      maxX += floors?.extraRight;
      minY -= floors?.extraTop;
      maxY += floors?.extraBottom;

      const shapeWidth = maxX - minX;
      const shapeHeight = maxY - minY;
      
      // PATCH 1 continued: Early return if shape dimensions are invalid
      if (!shapeWidth || !shapeHeight || shapeWidth <= 0 || shapeHeight <= 0 || !isFinite(shapeWidth) || !isFinite(shapeHeight)) {
        console.log('[SCALE DEBUG] drawVerticesInDiv - EARLY RETURN: invalid shape dimensions (shapeWidth:', shapeWidth, 'shapeHeight:', shapeHeight, ')');
        return;
      }

      const containerWidth = divWidth;
      const containerHeight = divHeight;

      // REVERT TO DEV_NEW: Use SHAPE dimensions for scale calculation
      // This is the exact approach used in dev_new which works correctly
      const scaleX = containerWidth / shapeWidth;
      const scaleY = containerHeight / shapeHeight;

      const scale = Math.min(scaleX, scaleY);
      // Critical: minX/minY adjustment accounts for where shape starts in coordinate space
      const offsetX = (containerWidth - shapeWidth * scale) / 2 - minX * scale;
      const offsetY = (containerHeight - shapeHeight * scale) / 2 - minY * scale;
      
      // =====================================================
      // SCALE DEBUG: THE FRONTEND SCALE CALCULATION
      // This is THE formula that should be used everywhere
      // =====================================================
      console.log('');
      console.log('█'.repeat(100));
      console.log('█  [DIAGNOSTIC] drawVerticesInDiv - FRONTEND SCALE CALCULATION                                  █');
      console.log('█'.repeat(100));
      
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  📐 VIEWPORT & SHAPE DIMENSIONS                                                               │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  CONTAINER (current viewport):');
      console.log('│    containerWidth:', containerWidth);
      console.log('│    containerHeight:', containerHeight);
      console.log('│  ');
      console.log('│  RAW VERTEX BOUNDS (from CV/API):');
      console.log('│    X range: [', Math.min(...allX).toFixed(2), 'to', Math.max(...allX).toFixed(2), ']');
      console.log('│    Y range: [', Math.min(...allY).toFixed(2), 'to', Math.max(...allY).toFixed(2), ']');
      console.log('│  ');
      console.log('│  FLOORS PADDING:');
      console.log('│    extraLeft:', floors?.extraLeft, 'extraRight:', floors?.extraRight);
      console.log('│    extraTop:', floors?.extraTop, 'extraBottom:', floors?.extraBottom);
      console.log('│  ');
      console.log('│  ADJUSTED BOUNDS (after padding):');
      console.log('│    minX:', minX.toFixed(2), 'maxX:', maxX.toFixed(2));
      console.log('│    minY:', minY.toFixed(2), 'maxY:', maxY.toFixed(2));
      console.log('│  ');
      console.log('│  SHAPE DIMENSIONS:');
      console.log('│    shapeWidth: maxX - minX =', shapeWidth.toFixed(2));
      console.log('│    shapeHeight: maxY - minY =', shapeHeight.toFixed(2));
      console.log('└' + '─'.repeat(98) + '┘');
      
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  🧮 SCALE CALCULATION (this becomes scaleXCanvas)                                             │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  FORMULA: scale = Math.min(containerWidth/shapeWidth, containerHeight/shapeHeight)');
      console.log('│  ');
      console.log('│  STEP 1: scaleX = containerWidth / shapeWidth');
      console.log('│          scaleX = ' + containerWidth + ' / ' + shapeWidth.toFixed(2) + ' = ' + scaleX.toFixed(6));
      console.log('│  ');
      console.log('│  STEP 2: scaleY = containerHeight / shapeHeight');
      console.log('│          scaleY = ' + containerHeight + ' / ' + shapeHeight.toFixed(2) + ' = ' + scaleY.toFixed(6));
      console.log('│  ');
      console.log('│  STEP 3: scale = Math.min(scaleX, scaleY)');
      console.log('│          scale = Math.min(' + scaleX.toFixed(6) + ', ' + scaleY.toFixed(6) + ') = ' + scale.toFixed(6));
      console.log('│  ');
      console.log('│  🎯 RESULT: scaleXCanvas = ' + scale.toFixed(6));
      console.log('│  ');
      console.log('│  ⚠️  NOTE: This scaleXCanvas is DIFFERENT from scaleFactorX!');
      console.log('│      scaleXCanvas = viewport scale (used for room vertices)');
      console.log('│      scaleFactorX = furniture scale (from API, used for furniture)');
      console.log('└' + '─'.repeat(98) + '┘');
      
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  📍 OFFSET CALCULATION                                                                        │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  FORMULA: offsetX = (containerWidth - shapeWidth * scale) / 2 - minX * scale');
      console.log('│  ');
      console.log('│  offsetX = (' + containerWidth + ' - ' + shapeWidth.toFixed(2) + ' * ' + scale.toFixed(4) + ') / 2 - ' + minX.toFixed(2) + ' * ' + scale.toFixed(4));
      console.log('│  offsetX = ' + offsetX.toFixed(2));
      console.log('│  ');
      console.log('│  offsetY = ' + offsetY.toFixed(2));
      console.log('└' + '─'.repeat(98) + '┘');
      
      console.log('');
      console.log('█'.repeat(100));
      console.log('');
      
      // =====================================================
      // VIEW TRANSFORM LOCK: Prevent mutation on Customize
      // =====================================================
      // If already locked, use the frozen values instead of recalculating.
      // This stops "mutation" caused by multiple drawVerticesInDiv passes.
      // =====================================================
      let effectiveScale = scale;
      let effectiveOffsetX = isValidNumber(offsetX) ? offsetX : 0;
      let effectiveOffsetY = isValidNumber(offsetY) ? offsetY : 0;
      
      if (viewTransformLockedRef.current && viewTransformRef.current.scale !== null) {
        // LOCKED: Use frozen values, don't update state (this is expected behavior after lock)
        console.log(`[SCALE DEBUG] CALL #${callNumber} - 🔒 USING FROZEN VALUES (no state change)`);
        
        effectiveScale = viewTransformRef.current.scale;
        effectiveOffsetX = viewTransformRef.current.offsetX;
        effectiveOffsetY = viewTransformRef.current.offsetY;
        
        // Don't call setState - values are already set and locked
      } else {
        // NOT LOCKED: First calculation - set state and lock
        
        // =====================================================
        // CRITICAL GUARD: Only lock when scale is VALID
        // =====================================================
        // If we lock garbage values, everything stays broken forever.
        // Early guards already checked: divWidth, divHeight, vertices, shapeWidth, shapeHeight
        // This is a final safety check for the calculated scale.
        // =====================================================
        if (!Number.isFinite(scale) || scale <= 0) {
          console.log('[SCALE DEBUG] ⚠️ NOT LOCKING - scale not valid (will retry):', {
            scale,
            isFinite: Number.isFinite(scale),
          });
          // DON'T set state with garbage - just return and wait for next pass
          return;
        }
        
        // =====================================================
        // BINARY VALIDATION: This log should appear EXACTLY ONCE
        // =====================================================
        console.log('='.repeat(80));
        console.log('[SCALE DEBUG] 🎯 SETTING STATE & LOCKING (should appear ONCE):');
        console.log('  scaleXCanvas:', scale);
        console.log('  offsetXCheck:', effectiveOffsetX);
        console.log('  offsetYCheck:', effectiveOffsetY);
        console.log('  divWidth:', divWidth, 'divHeight:', divHeight);
        console.log('='.repeat(80));

        setOffsetXCheck(effectiveOffsetX);
        setOffsetYCheck(effectiveOffsetY);
        setScaleXCanvas(scale);
        setScaleYCanvas(scale);
        
        // LOCK the transform for this layout session
        viewTransformRef.current = {
          scale: scale,
          offsetX: effectiveOffsetX,
          offsetY: effectiveOffsetY,
        };
        viewTransformLockedRef.current = true;
        console.log('[SCALE DEBUG] ✅ View transform LOCKED - all future calls will use frozen values');
      }

      // Draw lines using the EFFECTIVE (possibly frozen) values
      vertices.forEach((vertex, index) => {
        const { x: x1, y: y1 } = vertex[0];
        const { x: x2, y: y2 } = vertex[1];

        const scaledX1 = x1 * effectiveScale + effectiveOffsetX;
        const scaledY1 = y1 * effectiveScale + effectiveOffsetY;
        const scaledX2 = x2 * effectiveScale + effectiveOffsetX;
        const scaledY2 = y2 * effectiveScale + effectiveOffsetY;

        const dx = scaledX2 - scaledX1;
        const dy = scaledY2 - scaledY1;
        const length = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);

        const line = document.createElement("div");
        line.classList.add("line"); 
        line.style.position = "absolute";
        line.style.left = `${scaledX1}px`;
        line.style.top = `${scaledY1}px`;
        line.style.width = `${length}px`;
        line.style.height = "7px"; 
        line.style.backgroundColor = "purple";
        line.style.transformOrigin = "0 0"; 
        line.style.transform = `rotate(${angle}deg)`;

        line.style.visibility = "hidden"; 
       
        container.appendChild(line);
      });
    } catch (error) {
      console.error("Error drawing vertices:", error);
    }
  }, [divWidth, divHeight, floors?.extraLeft, floors?.extraRight, floors?.extraTop, floors?.extraBottom, setOffsetXCheck, setOffsetYCheck, setScaleXCanvas, setScaleYCanvas]);

  const calculateVerticesInDiv = useCallback((vertices, container) => {
    try {
      const previousLines = container.querySelectorAll(
        ".line, .line-length-text"
      );

      previousLines.forEach((line) => line.remove());

      const allX = vertices.flatMap((vertex) => [vertex[0].x, vertex[1].x]);
      const allY = vertices.flatMap((vertex) => [vertex[0].y, vertex[1].y]);

      let minX = Math.min(...allX);
      let maxX = Math.max(...allX);
      let minY = Math.min(...allY);
      let maxY = Math.max(...allY);

      minX -= floors?.extraLeft;
      maxX += floors?.extraRight;
      minY -= floors?.extraTop;
      maxY += floors?.extraBottom;

      const shapeWidth = maxX - minX;
      const shapeHeight = maxY - minY;

      const containerWidth = imageDimensions.orgWidth;
      const containerHeight = imageDimensions.orgHeight;

      const scaleX = containerWidth / shapeWidth;
      const scaleY = containerHeight / shapeHeight;

      const scale = Math.min(scaleX, scaleY);
      const offsetX = (containerWidth - shapeWidth * scale) / 2 - minX * scale;
      const offsetY =
        (containerHeight - shapeHeight * scale) / 2 - minY * scale;

      setOffsetXCalculateCheck(offsetX);
      setOffsetYCalculateCheck(offsetY);
      setScaleXCalculateCanvas(scale);
      setScaleYCalculateCanvas(scale);

      setCalculate((prev) => !prev);
    } catch (error) {
      console.error("Error drawing vertices:", error);
    }
  }, [floors?.extraLeft, floors?.extraRight, floors?.extraTop, floors?.extraBottom, imageDimensions.orgWidth, imageDimensions.orgHeight, setOffsetXCalculateCheck, setOffsetYCalculateCheck, setScaleXCalculateCanvas, setScaleYCalculateCanvas, setCalculate]);

  const measureLineInDiv = useCallback((vertices, container) => {
    if (!scaleXCanvas || !scaleYCanvas) {
      return;
    }

    const previousLines = container.querySelectorAll(".line-measure");
    const previousBoxes = container.querySelectorAll(".measurement-box");
    const previousWhiskerBar = container.querySelectorAll(".whisker-bar");

    const previousMeasureText = container.querySelectorAll(".measurement-text");
    const previousEditIconContainer = container.querySelectorAll(
      ".edit-icon-container"
    );
    const previousEditIcon = container.querySelectorAll(".edit-icon");

    previousBoxes?.forEach((box) => box.remove());
    previousLines?.forEach((line) => line.remove());
    previousWhiskerBar?.forEach((whisker) => whisker.remove());

    previousMeasureText?.forEach((measureText) => measureText.remove());
    previousEditIconContainer?.forEach((container) => container.remove());
    previousEditIcon?.forEach((icon) => icon.remove());

    const resultDoorRoom = doorsFindRoom(modalData);

    const resultRoom = findRoom(modalData);

    const resultRoomdoors = getDoorsWithLineIndex(
      resultRoom?.doors,
      resultRoom?.walls,
      scaleXCanvas,
      scaleYCanvas,
      offsetXCheck,
      offsetYCheck
    );

    const resultRoomvalidDoors = resultRoomdoors.filter(
      (door) => door.lineId !== null
    );

    const resultDoorsRoomDoors = getDoorsWithLineIndex(
      resultDoorRoom?.doors,
      resultDoorRoom?.walls,
      scaleXCanvas,
      scaleYCanvas,
      offsetXCheck,
      offsetYCheck
    );

    const doorsArray = resultRoomdoors?.map((item) => item.width);
    const doorAverageValue = calculateFilteredAverage(doorsArray);

    const doorsArray1 = resultDoorsRoomDoors?.map((item) => item.width);

    const doorDoorAverageValue = calculateFilteredAverage(doorsArray1);

    const resultRoomVertices = transformWalls(resultRoom?.walls);

    const resultRoomAdjustedVertices = adjustVertices(
      resultRoomVertices,
      offsetXCheck,
      offsetYCheck,
      scaleXCanvas,
      scaleYCanvas
    );

    const verticesCheck = transformWalls(resultRoom?.walls);
    const resultDoorsRoomVertices = transformWalls(resultDoorRoom?.walls);

    const resultDoorRoomAdjustedVertices = adjustVertices(
      resultDoorsRoomVertices,
      offsetXCheck,
      offsetYCheck,
      scaleXCanvas,
      scaleYCanvas
    );

    const resultRoomUpdatedDoors = adjustDoorPositionAndOrientation(
      resultRoomvalidDoors,
      resultRoomAdjustedVertices
    );

    const resultDoorsRoomvalidDoors = resultDoorsRoomDoors.filter(
      (door) => door.lineId !== null
    );
    const resultDoorRoomUpdatedDoors = adjustDoorPositionAndOrientation(
      resultDoorsRoomvalidDoors,
      resultDoorRoomAdjustedVertices
    );

    let minCX = Infinity,
      maxCX = -Infinity,
      minCY = Infinity,
      maxCY = -Infinity;

    resultRoomAdjustedVertices.forEach((edge) => {
      edge.points.forEach((point) => {
        minCX = Math.min(minCX, point.x);
        maxCX = Math.max(maxCX, point.x);
        minCY = Math.min(minCY, point.y);
        maxCY = Math.max(maxCY, point.y);
      });
    });

    const shapeCWidth = maxCX - minCX;
    const shapeCHeight = maxCY - minCY;

    let roomWidth = resultRoom?.width;
    let roomHeight = resultRoom?.height;

    if (shapeCWidth > shapeCHeight) {
      if (roomWidth < roomHeight) {
        [roomWidth, roomHeight] = [roomHeight, roomWidth];
      }
    } else {
      if (roomHeight < roomWidth) {
        [roomWidth, roomHeight] = [roomHeight, roomWidth];
      }
    }

    const { scaleX, scaleY } = calculateScaleFactor(
      resultRoomAdjustedVertices,
      roomWidth, 
      roomHeight, 
      parseInt(resultRoomUpdatedDoors?.length > 0 ? doorAverageValue : 32)
    );

    const { scaleX: scaleXDoor, scaleY: scaleYDoor } = calculateScaleFactor(
      resultDoorRoomAdjustedVertices,
      0, 
      0, 
      parseInt(
        resultDoorRoomUpdatedDoors?.length > 0 ? doorDoorAverageValue : 32
      )
    );

    const walls = resultRoom.walls;

    const adjustedVertices = adjustVertices(
      verticesCheck,
      offsetXCheck,
      offsetYCheck,
      scaleXCanvas,
      scaleYCanvas
    );

    const { centerX: centerOriX, centerY: centerOriY } = calculateScaleFactor(
      adjustedVertices,
      0,
      0,
      0
    );

    const insideBoxes = getBoxesInsideWalls(boxes, walls);

    const largestBox = getMaxWidthBox(insideBoxes);
    const closestWalls = transformWalls(
      insideBoxes?.length === 0 ? walls : getClosestWalls(largestBox, walls)
    );

    const closestVertices = adjustVertices(
      closestWalls,
      offsetXCheck,
      offsetYCheck,
      scaleXCanvas,
      scaleYCanvas
    );


    
    const scaledPoints = scalePoints(
      closestVertices,
      scaleXDoor == 1 ? scaleX : ((scaleX + scaleY) / 2 + scaleXDoor) / 2,
      scaleYDoor == 1 ? scaleX : ((scaleX + scaleY) / 2 + scaleXDoor) / 2,
      centerOriX,
      centerOriY
    );
    
    let midRangeLineIndex;

    if(isValidNumber(layoutData?.globalScaling?.activeLineScale)){
      midRangeLineIndex = layoutData?.globalScaling?.activeLineScale
    }else{

      midRangeLineIndex = resultRoom?.width == 0 || resultRoom.height == 0 ? 
      findClosestLineToDimension(closestVertices, resultRoom.width, resultRoom.height)
      :  findClosestLineToDimension(normalizeVerticesForMeasurementLine(scaledPoints , resultRoom.width, resultRoom.height), 1, 1)

      const callApiForGlobalScaling = async () => {
        if (!layoutData?._id) {
          console.warn("Layout ID not available, skipping global scaling update");
          return;
        }

        let updationUrl = `${baseUrl}/savedLayout/edit/${layoutData._id}`;

        try {
          await handleLayoutSave(
            "PUT",
            updationUrl,
            null,
            {
              globalScaling: {
               activeLineScale: midRangeLineIndex,
              },
            }
          );
        } catch (error) {
          console.error("Failed to update layout:", error);
        }
      };

      callApiForGlobalScaling();
    }

    setMidRangeLineIndexState(midRangeLineIndex)

    closestVertices?.forEach((vertex, index) => {
      const { x: x1, y: y1 } = vertex.points[0];
      const { x: x2, y: y2 } = vertex.points[1];

      if (index !== midRangeLineIndex) return;

      const offset = 18;

      const lineLength = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

      const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

      const topBuffer = 0;

      // Use dimension-specific scale when room has valid CV dimensions
      // scaleX = roomWidthInches / roomPixelWidth (exact for horizontal walls)
      // scaleY = roomHeightInches / roomPixelHeight (exact for vertical walls)
      // Only fall back to triple average when CV dimensions are missing
      const hasValidRoomDimensions = resultRoom?.width > 0 && resultRoom?.height > 0;
      const isWallHorizontal = Math.abs(x2 - x1) > Math.abs(y2 - y1);
      const legacyBlend = scaleXDoor == 1 ? scaleX : ((scaleX + scaleY) / 2 + scaleXDoor) / 2;
      const dimensionScale = hasValidRoomDimensions
        ? (isWallHorizontal ? scaleX : scaleY)
        : legacyBlend;

      const firstLineScaled = scalePoints(
        closestVertices,
        dimensionScale,
        dimensionScale,
        centerOriX,
        centerOriY
      )?.[midRangeLineIndex];

      const { x: scaledX1, y: scaledY1 } = firstLineScaled.points[0];
      const { x: scaledX2, y: scaledY2 } = firstLineScaled.points[1];

      const lineLengthScaled = Math.sqrt(
        (scaledX2 - scaledX1) ** 2 + (scaledY2 - scaledY1) ** 2
      );

      let feet = Math.floor(lineLengthScaled / 12);
      let inches = Math.round(lineLengthScaled % 12);
      if (inches >= 12) { feet += 1; inches = 0; }

      // DIAGNOSTIC: Log how the picker initial values are computed
      console.log('[SCALE-INIT-DEBUG] lineLengthScaled=' + lineLengthScaled?.toFixed(2) + ' -> feet=' + feet + ' inches=' + inches);
      console.log('[SCALE-INIT-DEBUG] lineLength (raw px)=' + lineLength?.toFixed(2));
      console.log('[SCALE-INIT-DEBUG] scaleX=' + scaleX?.toFixed(6) + ' scaleY=' + scaleY?.toFixed(6));
      console.log('[SCALE-INIT-DEBUG] hasValidRoomDimensions=' + hasValidRoomDimensions + ' isWallHorizontal=' + isWallHorizontal);
      console.log('[SCALE-INIT-DEBUG] dimensionScale=' + dimensionScale?.toFixed(6) + ' (was legacyBlend=' + legacyBlend?.toFixed(6) + ')');
      console.log('[SCALE-INIT-DEBUG] resultRoom.width=' + resultRoom?.width + '" resultRoom.height=' + resultRoom?.height + '"');

      if (initialLength !== lineLength) {
        setInitialLength(lineLength);
        setInitialScaleFactorX(dimensionScale);

        const callApiForGlobalScaling = async () => {
          if (!layoutData?._id) {
            console.warn("Layout ID not available, skipping global scaling update");
            return;
          }

          let updationUrl = `${baseUrl}/savedLayout/edit/${layoutData._id}`;

          try {
            await handleLayoutSave(
              "PUT",
              updationUrl,
              null,
              {
                globalScaling: {
                  globalSelectedFeet: +feet,
                  globalSelectedInches: +inches,
                  globalResetSelectedFeet: +feet,
                  globalResetSelectedInches: +inches,
                },
              }
            );
          } catch (error) {
            console.error("Failed to update layout:", error);
          }
        };

        if (isScaleDimensionsMarked !== true) {
          setSelectedFeet(+feet);
          setSelectedInches(+inches);
          setSelectedResetFeet(+feet);
          setSelectedResetInches(+inches);
          callApiForGlobalScaling();
        }
      }

      setResize((prev) => !prev);

      if (isScaleDimensionsMarked === true || (roomsData.length >= 1 && partner.allowMakeMagic)) {
        return;
      }

      const lengthText =
        selectedFeet !== false
          ? `${selectedFeet}'-${selectedInches}"`
          : `${feet}'-${inches}"`;

      const lengthDisplay = document.createElement("div");
      lengthDisplay.classList.add("measurement-box");

      const textSpan = document.createElement("span");
      textSpan.innerText = lengthText;
      textSpan.classList.add("measurement-text");

      const iconContainer = document.createElement("div");
      iconContainer.classList.add("edit-icon-container");

      const icon = document.createElement("img");
      icon.src = EditRedIcon;
      icon.classList.add("edit-icon");

      iconContainer.appendChild(icon);

      iconContainer.addEventListener("click", function (event) {
        setIsScaleDimensionsMarked("select");
        setOpenFilters(false);
        resetRoom();
      });

      lengthDisplay.appendChild(textSpan);
      if (isScaleDimensionsMarked !== "select") {
        lengthDisplay.appendChild(iconContainer);
      }

      let adjustedAngle = angle;

      if (angle > 90 || angle < -90) {
        adjustedAngle += 180; 
      }

      if (angle === -90) {
        adjustedAngle = 90;
      }

      lengthDisplay.style.transform = `translate(-50%, -50%) rotate(${adjustedAngle}deg)`;
      lengthDisplay.style.zIndex = `2`;

      const midX = (x1 + x2) / 2;
      const midY = (y1 + y2) / 2 - topBuffer;

      const isVertical = Math.abs(angle) === 90;
      const isHorizontal = Math.abs(angle) === 0 || Math.abs(angle) === 180;

      if (isVertical) {
        lengthDisplay.style.left = `${midX - offset}px`;
        lengthDisplay.style.top = `${midY}px`;
      } else if (isHorizontal) {
        lengthDisplay.style.left = `${midX}px`;
        lengthDisplay.style.top = `${midY - offset}px`;
      } else {
        lengthDisplay.style.left = `${midX}px`;
        lengthDisplay.style.top = `${midY}px`;
      }

      container.appendChild(lengthDisplay);

      const line = document.createElement("div");
      line.classList.add("line-measure");

       if (isVertical) {
        line.style.left = `${midX - offset}px`;
        line.style.top = `${midY}px`;
      } else if (isHorizontal) {
        line.style.left = `${midX}px`;
        line.style.top = `${midY - offset}px`;
      } else {
        line.style.left = `${midX}px`;
        line.style.top = `${midY}px`;
      }

      line.style.width = `${Math.max(
        isHorizontal
          ? lengthDisplay.getBoundingClientRect().width / scale + 20
          : lengthDisplay.getBoundingClientRect().height / scale + 20,
        lineLength
      )}px`;

      line.style.height = "2px";
      line.style.backgroundColor = "#ff5151";
      line.style.position = "absolute";

      line.style.transform = `translate(-50%, -50%) rotate(${angle}deg)`;

      function createWhisker(x, y, angle) {
        const whisker = document.createElement("div");
        whisker.classList.add("whisker-bar");
        whisker.style.width = "10px";
        whisker.style.height = "2px";
        whisker.style.backgroundColor = "#ff5151";
        whisker.style.position = "absolute";
      
        whisker.style.left = `${x}px`;
        whisker.style.top = `${y}px`;
      
        whisker.style.transform = `translate(-50% , -50%) rotate(${angle + 90}deg)`;
        return whisker;
      }

      const lineLen = Math.max(
        isHorizontal
          ? lengthDisplay.getBoundingClientRect().width / scale + 20
          : lengthDisplay.getBoundingClientRect().height / scale + 20,
        lineLength
      );
      
      const halfLen = lineLen / 2;

      const rad = angle * Math.PI / 180;

      const dx = halfLen * Math.cos(rad);
      const dy = halfLen * Math.sin(rad);

      const startX = isVertical ?  midX - offset - dx : midX - dx;
      const startY =  isVertical ? midY - dy : isHorizontal ? midY - offset - dy : midY - dy ;
      const endX   = isVertical ? midX - offset + dx : midX + dx;
      const endY   = isVertical ? midY + dy:isHorizontal ? midY - offset + dy : midY  + dy;

      const whiskerStart = createWhisker(startX, startY, angle);
      const whiskerEnd   = createWhisker(endX,   endY,   angle);


      if (isScaleDimensionsMarked !== true && (roomsData.length === 0 || !partner.allowMakeMagic)) {
        container.appendChild(line);
        container.appendChild(whiskerStart);
        container.appendChild(whiskerEnd);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scaleXCanvas, scaleYCanvas, modalData, offsetXCheck, offsetYCheck, isScaleDimensionsMarked, roomsData, partner, layoutData, boxes, initialLength, scale, selectedFeet, selectedInches]);

  useEffect(() => {
    if (calculateInitialLength === false) {
      return;
    }

    const { feet, inches } = convertLengthToFeetAndInches(
      calculateInitialLength,
      calculateInitialScaleFactorX
    );

    const newScaleFactor = calculateNewScaleFactor(
      calculateInitialLength,
      +feet,
      +inches,
      +selectedFeet,
      +selectedInches
    );

    // Only update if the value actually changed
    let scaleUpdated = false;
    if (prevCalculateScaleRef.current.calculateScaleFactorX !== newScaleFactor) {
      prevCalculateScaleRef.current.calculateScaleFactorX = newScaleFactor;
      setCalculateScaleFactorX(newScaleFactor);
      scaleUpdated = true;
    }
    
    if (prevCalculateScaleRef.current.calculateScaleFactorY !== newScaleFactor) {
      prevCalculateScaleRef.current.calculateScaleFactorY = newScaleFactor;
      setCalculateScaleFactorY(newScaleFactor);
      scaleUpdated = true;
    }

    // Only trigger resize flag if scale factors actually changed
    if (scaleUpdated) {
      setResizeCalculateScaleFlag((prev) => !prev);
    }
  }, [calculateScaleFlag, calculateInitialLength, calculateInitialScaleFactorX, selectedFeet, selectedInches]);

  const prevScaleValuesRef = useRef({ scaleFactorX: false, scaleFactorY: false });
  const prevCalculateScaleRef = useRef({ calculateScaleFactorX: false, calculateScaleFactorY: false });
  
  useEffect(() => {
    if (initialLength === false) {
      return;
    }

    // =====================================================
    // SCALE FACTOR INVARIANT CHECK
    // =====================================================
    // If scaleFactorX was set from API (world calibration from CV),
    // skip the scaleFactorX recalculation but still toggle updateScale
    // to trigger handleUpdate. Production always toggles updateScale here
    // (line 1397 on main branch). Staging previously did an early return
    // which blocked handleUpdate from ever firing via the natural path.
    // =====================================================
    // Also skip when the scale picker is open ("select") or after Done ("true").
    // The Done handler applies the scale via relative computation. The calibration's
    // absolute formula (selectedInches / initialLength) would overwrite it with a wrong value.
    // Only run calibration when isScaleDimensionsMarked is falsy (initial state, no user adjustment).
    const skipCalibration = scaleFactorFromApiRef.current || !!isScaleDimensionsMarked;
    console.log('[CALIBRATION-UE] ▶️ Calibration useEffect fired.',
      '| skipCalibration=' + skipCalibration,
      '| apiRef=' + scaleFactorFromApiRef.current,
      '| pickerOpen=' + (isScaleDimensionsMarked === "select"),
      '| isScaleDimensionsMarked=' + isScaleDimensionsMarked,
      '| initialLength=' + initialLength,
      '| initialScaleFactorX=' + initialScaleFactorX,
      '| selectedFeet=' + selectedFeet,
      '| selectedInches=' + selectedInches,
      '| scaleFactorX=' + scaleFactorX);

    if (!skipCalibration) {
      const { feet, inches } = convertLengthToFeetAndInches(
        initialLength,
        initialScaleFactorX
      );

      const newScaleFactor = calculateNewScaleFactor(
        initialLength,
        +feet,
        +inches,
        +selectedFeet,
        +selectedInches
      );

      console.log('[CALIBRATION-UE] 🔧 Computing new scale:',
        'reference=' + feet + "'" + inches + '"',
        '(from initialLength=' + initialLength + ' × initialScaleFactorX=' + initialScaleFactorX + ')',
        '| user=' + selectedFeet + "'" + selectedInches + '"',
        '| newSF=' + newScaleFactor,
        '| prevSF=' + prevScaleValuesRef.current.scaleFactorX,
        '| changed=' + (prevScaleValuesRef.current.scaleFactorX !== newScaleFactor));

      // Only update if the value actually changed
      if (prevScaleValuesRef.current.scaleFactorX !== newScaleFactor) {
        prevScaleValuesRef.current.scaleFactorX = newScaleFactor;
        console.log('[CALIBRATION-UE] ✅ setScaleFactorX(' + newScaleFactor + ') - was ' + scaleFactorX);
        setScaleFactorX(newScaleFactor);
      }
      
      if (prevScaleValuesRef.current.scaleFactorY !== newScaleFactor) {
        prevScaleValuesRef.current.scaleFactorY = newScaleFactor;
        setScaleFactorY(newScaleFactor);
      }
    }

    // [MATCH-PROD] Always toggle updateScale to trigger handleUpdate
    // Production does this at line 1397. This fires AFTER drawVerticesInDiv
    // has computed scaleXCanvas, so handleUpdate uses correct viewport values.
    setUpdateScale((prev) => !prev);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resize, initialLength, initialScaleFactorX, selectedFeet, selectedInches]);

  useEffect(() => {
    const container = document.getElementById("lineContainer");
    drawVerticesInDiv(modalVertices, container);
  }, [modalVertices, floors, drawVerticesInDiv]);

  useEffect(() => {
    const container = document.getElementById("lineContainer");

    if (imageDimensions.orgWidth && imageDimensions.orgHeight) {
      calculateVerticesInDiv(modalVertices, container);
    }
  }, [modalVertices, imageDimensions, floors, calculateVerticesInDiv]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function calculateLineInDiv(vertices, container) {
    if (
      !scaleXCalculateCanvas ||
      !scaleYCalculateCanvas
    ) {
      return;
    }

    try {
      const resultDoorRoom = doorsFindRoom(modalData);

      const resultRoom = findRoom(modalData);

      const resultRoomdoors = getDoorsWithLineIndex(
        resultRoom?.doors,
        resultRoom?.walls,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas,
        offsetXCalculateCheck,
        offsetYCalculateCheck
      );

      const resultRoomvalidDoors = resultRoomdoors.filter(
        (door) => door.lineId !== null
      );

      const resultDoorsRoomDoors = getDoorsWithLineIndex(
        resultDoorRoom?.doors,
        resultDoorRoom?.walls,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas,
        offsetXCalculateCheck,
        offsetYCalculateCheck
      );

      const doorsArray = resultRoomdoors?.map((item) => item.width);
      const doorAverageValue = calculateFilteredAverage(doorsArray);

      const doorsArray1 = resultDoorsRoomDoors?.map((item) => item.width);

      const doorDoorAverageValue = calculateFilteredAverage(doorsArray1);

      const resultRoomVertices = transformWalls(resultRoom?.walls);

      const resultRoomAdjustedVertices = adjustVertices(
        resultRoomVertices,
        offsetXCalculateCheck,
        offsetYCalculateCheck,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas
      );

      const resultDoorsRoomVertices = transformWalls(resultDoorRoom?.walls);

      const resultDoorRoomAdjustedVertices = adjustVertices(
        resultDoorsRoomVertices,
        offsetXCalculateCheck,
        offsetYCalculateCheck,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas
      );

      const resultRoomUpdatedDoors = adjustDoorPositionAndOrientation(
        resultRoomvalidDoors,
        resultRoomAdjustedVertices
      );

      const resultDoorsRoomvalidDoors = resultDoorsRoomDoors.filter(
        (door) => door.lineId !== null
      );

      const resultDoorRoomUpdatedDoors = adjustDoorPositionAndOrientation(
        resultDoorsRoomvalidDoors,
        resultDoorRoomAdjustedVertices
      );

      let minCX = Infinity,
        maxCX = -Infinity,
        minCY = Infinity,
        maxCY = -Infinity;

      resultRoomAdjustedVertices.forEach((edge) => {
        edge.points.forEach((point) => {
          minCX = Math.min(minCX, point.x);
          maxCX = Math.max(maxCX, point.x);
          minCY = Math.min(minCY, point.y);
          maxCY = Math.max(maxCY, point.y);
        });
      });

      const shapeCWidth = maxCX - minCX;
      const shapeCHeight = maxCY - minCY;

      let roomWidth = resultRoom?.width;
      let roomHeight = resultRoom?.height;

      if (shapeCWidth > shapeCHeight) {
        if (roomWidth < roomHeight) {
          [roomWidth, roomHeight] = [roomHeight, roomWidth];
        }
      } else {
        if (roomHeight < roomWidth) {
          [roomWidth, roomHeight] = [roomHeight, roomWidth];
        }
      }

      const { scaleX, scaleY } = calculateScaleFactor(
        resultRoomAdjustedVertices,
        roomWidth, 
        roomHeight, 
        parseInt(resultRoomUpdatedDoors?.length > 0 ? doorAverageValue : 32)
      );

      const { scaleX: scaleXDoor } = calculateScaleFactor(
        resultDoorRoomAdjustedVertices,
        0, 
        0, 
        parseInt(
          resultDoorRoomUpdatedDoors?.length > 0 ? doorDoorAverageValue : 32
        )
      );

      const walls = resultRoom?.walls;
      const verticesCheck = transformWalls(resultRoom?.walls);

      const insideBoxes = getBoxesInsideWalls(boxes, walls);
      const largestBox = getMaxWidthBox(insideBoxes);

      const closestWalls = transformWalls(
        insideBoxes?.length === 0 ? walls : getClosestWalls(largestBox, walls)
      );
      
      const closestVertices = adjustVertices(
        closestWalls,
        offsetXCalculateCheck,
        offsetYCalculateCheck,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas
      );

      const adjustedVertices = adjustVertices(
        verticesCheck,
        offsetXCalculateCheck,
        offsetYCalculateCheck,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas
      );
  
      calculateScaleFactor(
        adjustedVertices,
        0,
        0,
        0
      );

  
      let midRangeLineIndex;
      if(isValidNumber(layoutData?.globalScaling?.activeLineScale)){
        midRangeLineIndex = layoutData?.globalScaling?.activeLineScale
      }else{
        midRangeLineIndex = midRangeLineIndexState;
      }

      closestVertices?.forEach((vertex, index) => {
        const { x: x1, y: y1 } = vertex.points[0];
        const { x: x2, y: y2 } = vertex.points[1];

        const lineLength = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

        if (index === midRangeLineIndex) {
          let valuesChanged = false;
          if (calculateInitialLength !== lineLength) {
            setCalculateInitialLength(lineLength);
            setCalculateInitialScaleFactorX(
              scaleXDoor == 1
                ? scaleX
                : ((scaleX + scaleY) / 2 + scaleXDoor) / 2
            );
            valuesChanged = true;
          }

          // Only trigger scale flag if values actually changed
          if (valuesChanged) {
            setCalculateScaleFlag((prev) => !prev);
          }
        }
      });

    } catch (error) {
      console.error("Error drawing vertices:", error);
    }
  }

  useEffect(() => {
    if (vertices?.index) {
      const existingIndex = roomsData.findIndex(
        (room) => vertices.roomId === room.roomId
      );

      // [VIEW-DIAG] Log when room selection changes - check if container changes
      const _viewContainer = document.getElementById('lineContainer');
      const _viewRect = _viewContainer?.getBoundingClientRect();
      console.log('[VIEW-DIAG] Room selected: ' + vertices.roomId + ' (index=' + existingIndex + ') | container=' + _viewRect?.width?.toFixed(0) + 'x' + _viewRect?.height?.toFixed(0) + ' | divW=' + divWidth + ' divH=' + divHeight + ' | sxC=' + scaleXCanvas?.toFixed(4));
      // Log again after a delay to see if container changes from UI panels appearing
      setTimeout(() => {
        const _viewRect2 = document.getElementById('lineContainer')?.getBoundingClientRect();
        console.log('[VIEW-DIAG] After 500ms: container=' + _viewRect2?.width?.toFixed(0) + 'x' + _viewRect2?.height?.toFixed(0) + ' | CHANGED=' + (_viewRect?.width !== _viewRect2?.width || _viewRect?.height !== _viewRect2?.height));
      }, 500);

      setRoomActive(existingIndex === -1 ? -1 : existingIndex);

      if (existingIndex !== -1) {
        const hasFurniture = roomsData[existingIndex]?.layouts?.[roomActiveLayout?.[existingIndex]]?.furniture?.length > 0;
        setSeeItAnotherWay((prevState) => ({
          ...prevState,
          [existingIndex]: !hasFurniture,
        }));
      }
    } else {
      const existingIndex = roomsData.findIndex(
        (room) => vertices.roomId === room.roomId
      );
      if (existingIndex != selectedFurniture?.roomId) {
        setSelectedFurniture(null);
        setCopySelectedFurniture(null);

        setSelectedItem(null);
      }
      setRoomActive(existingIndex === -1 ? -1 : existingIndex);

      if (existingIndex !== -1) {
        const hasFurniture = roomsData[existingIndex]?.layouts?.[roomActiveLayout?.[existingIndex]]?.furniture?.length > 0;
        setSeeItAnotherWay((prevState) => ({
          ...prevState,
          [existingIndex]: !hasFurniture,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vertices]);


  function adjustPointToRoom(x, y, offsetXCheck, offsetYCheck) {
    const unscaledX = (x - offsetXCheck) / scaleXCanvas;
    const unscaledY = (y - offsetYCheck) / scaleYCanvas;

    return { adjustedX: unscaledX, adjustedY: unscaledY };
  }

  function isPointInRoomPolygon(x, y, walls) {
    let intersections = 0;
    const n = walls.length;

    for (let i = 0; i < n; i++) {
      const wallStart = walls[i].start;
      const wallEnd = walls[i].end;

      const x1 = parseFloat(wallStart.x);
      const y1 = parseFloat(wallStart.y);
      const x2 = parseFloat(wallEnd.x);
      const y2 = parseFloat(wallEnd.y);

      if (y1 > y !== y2 > y) {
        const xIntersect = ((y - y1) * (x2 - x1)) / (y2 - y1) + x1;
        if (xIntersect > x) {
          intersections++;
        }
      }
    }

    return intersections % 2 === 1;
  }

  function findRoomContainingPoint(rooms, x, y, offsetXCheck, offsetYCheck) {
    const { adjustedX, adjustedY } = adjustPointToRoom(
      x,
      y,
      offsetXCheck,
      offsetYCheck
    );

    for (const room of rooms) {
      if (isPointInRoomPolygon(adjustedX, adjustedY, room.walls)) {
        return room; 
      }
    }
    return null; 
  }

  const appendSelectionFrostLayer = () => {};

  // Move the spotlight to `room` and leave the editor in the state a full room
  // load would leave it in.
  //
  // Every spotlight tap ends up here so that all four values Make Magic reads —
  // roomId, vertices, doors, room centre — describe the same room. They used to
  // be written piecemeal per branch, and the pre-pick branches wrote roomId with
  // an empty wall list, which is worse than writing nothing: roomActive is how
  // this component says "the room is loaded", so the tap marked the room loaded
  // while it held no geometry at all. A room-type change then routes the Shuffle
  // FAB down the re-furnish path, which sends the empty wall list, and no room
  // type can be solved against a room with no walls.
  //
  // Reads the geometry rather than deriving it. handleUpdate owns that
  // derivation: it transforms each room for the current viewport and stores the
  // result on the room, and every other reader — the furniture on screen, the
  // normal furniture tap, the roomsData writes — takes it back from there. A
  // second copy computed here is a copy that can disagree with the one the user
  // is looking at, and furniture is positioned against this exact centre.
  //
  // Returns false when the room has no stored geometry, which means handleUpdate
  // has never processed it. Callers either leave the selection alone or fall
  // through to the full room load, which is where a room that has never been
  // furnished gets its geometry derived.
  const applySpotlightRoomSelection = (room) => {
    const targetRoomId = room?.room_id;
    if (!targetRoomId) return false;

    const stored = roomsData?.find((entry) => entry.roomId === targetRoomId);
    if (!stored?.payloadVertices?.length) return false;

    setShufflePickedRoom(room);
    setVertices({
      index: false,
      vertices: stored.payloadVertices,
      roomId: targetRoomId,
    });
    setDoors(stored.doors || []);
    setStateCenterX(stored.centerX);
    setStateCenterY(stored.centerY);
    setRoomId(targetRoomId);
    setLineBoundary(true);
    return true;
  };

  const drawFloors = (
    x,
    y,
    objFound,
    foundVertices,
    doorsPayload,
    windowsPayload,
    scaleXPayload,
    scaleYPayload,
    centerXPayload,
    centerYPayload,
    roomIdPayload,
    returnData
  ) => {
    

    if (objFound &&  ((roomIdPayload == "custom-room" && !partnerPackage?.allowMakeMagic) || (partnerPackage?.allowMakeMagic) )) {
      // Spotlight protection: while a shuffle spotlight is active, furniture in
      // non-spotlighted rooms switches the spotlight to that room rather than
      // loading its furniture directly. Behaviour mirrors tapping the room region.
      if (shufflePickedRoom != null && roomIdPayload !== shufflePickedRoom?.room_id) {
        const switchRoom = modalData?.find(r => r.room_id === roomIdPayload);
        if (switchRoom) {
          setSelectedFurniture(null);
          setCopySelectedFurniture(null);
          setSelectedItem(null);
          const lcEl = document.getElementById("lineContainer");
          lcEl?.querySelectorAll(".shape").forEach(el => el.remove());
          // Selecting the room, rather than clearing the selection as this used
          // to: the room-type strip and the Shuffle FAB both render off
          // shufflePickedRoom, so leaving roomId empty left the user picking a
          // room type that had nowhere to be stored and a Shuffle that could
          // only send them back to "tap a room".
          applySpotlightRoomSelection(switchRoom);
        }
        return;
      }

      // Pre-pick: furniture tap in any room spotlights that room without
      // entering furniture editing — the next tap does that. The room itself is
      // still selected, so its type can be changed and Make Magic can run on it
      // straight away, which is the whole point of arriving here from "Shuffle
      // it".
      if (isPickingRoom) {
        const pickRoom = modalData?.find(r => r.room_id === roomIdPayload);
        if (pickRoom && applySpotlightRoomSelection(pickRoom)) {
          setIsPickingRoom(false);
          setShowHelperMessage(false);
        }
        return;
      }

      setOpenFilters(false);

      setShowHelperMessage(false);
      setIsPickingRoom(false);

      const lineContainer = document.getElementById("lineContainer");

      const shapeElements = lineContainer.querySelectorAll(".shape");
      shapeElements.forEach((element) => element.remove());

      const existingSvg = document.querySelector(
        `.shape.id_${roomIdPayload}.Line`
      );

      if (existingSvg) {
        existingSvg.remove();
      }

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.classList.add("shape", `id_${roomIdPayload}`, "Line"); 
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      svg.style.position = "absolute";
      svg.style.top = "0";
      svg.style.left = "0";

      const points = foundVertices
        ?.map((vertex) => {
          const { x: x1, y: y1 } = vertex.points[0];
          const { x: x2, y: y2 } = vertex.points[1];
          return `${x1},${y1} ${x2},${y2}`;
        })
        .join(" ");

      appendSelectionFrostLayer(svg, foundVertices, roomIdPayload, divWidth, divHeight);

      // Canvas overlay replaces SVG marching ants when in integration mode.
      if (!partnerPackage?.allowMakeMagic) {
        const polyline = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "polyline"
        );

        polyline.setAttribute("stroke-width", `${1 / scale}`);
        polyline.setAttribute("stroke-dasharray", `${8 / scale},${4 / scale}`);
        polyline.classList.add("marching-ants");
        updateMarchingAntsAnimation(scale);

        polyline.setAttribute("points", points);

        svg.appendChild(polyline);
      }
      lineContainer.appendChild(svg);

      doorsPayload?.forEach((doorPoint, index) => {
        const { position, width, rotation } = doorPoint;

        const door = document.createElement("div");
        door.classList.add("shape", `id_${roomIdPayload}`); 
        door.style.position = "absolute";
        door.style.backgroundColor = "transparent"; 
        door.style.border = "0.1px dashed rgba(255, 255, 0, 0.5)"; 

        door.style.width = `${width}px`; 
        door.style.height = "5px"; 
        door.style.transformOrigin = "center"; 

        const angle = parseFloat(rotation?.z || 0) * (180 / Math.PI); 
        const isVertical = Math.abs(rotation?.z) === Math.PI / 2;
        const adjustedX = isVertical
          ? position.x - width / 2 
          : position.x - (width / 2) * Math.cos(rotation?.z || 0);

        const adjustedY = isVertical
          ? position.y - (width / 2) * Math.cos(rotation?.z || 0)
          : position.y - 5 / 2;

        door.style.transform = `translate(${adjustedX}px, ${adjustedY}px) rotate(${angle}deg)`;

        const lineContainer = document.getElementById("lineContainer");
        if (lineContainer) {
          lineContainer.appendChild(door);

          const doorWidthLabel = document.createElement("div");
          doorWidthLabel.classList.add("shape"); 
          doorWidthLabel.style.position = "absolute";
          doorWidthLabel.style.left = `${position.x}px`;
          doorWidthLabel.style.top = `${position.y}px`;
          doorWidthLabel.style.transform = "translate(-50%, -50%)"; 
          doorWidthLabel.style.color = "green";
          doorWidthLabel.style.fontSize = "5px";
          doorWidthLabel.textContent = `${width.toFixed(0)}in`; 
        } else {
          console.error("Container with ID 'lineContainer' not found");
        }
      });

      setDoors(doorsPayload);

      setStateCenterX(centerXPayload);
      setStateCenterY(centerYPayload);

      setLineBoundary(true);
      setIsAdding(false);
    }

    if (!x || !y) {
      return;
    }

    const room = findRoomContainingPoint(
      modalData,
      x,
      y,
      offsetXCheck,
      offsetYCheck
    );


    if (!room) {
      setIsAdding(false);

      setSelectedFurniture(null);
      setCopySelectedFurniture(null);

      setSelectedItem(null);
      setOpenFilters(false);

      setVertices({ index: false, vertices: [], roomId: "" });
      const lineContainer = document.getElementById("lineContainer");

      const shapeElements = lineContainer.querySelectorAll(".shape");
      shapeElements.forEach((element) => element.remove());
      setLineBoundary(false);
      setRoomId(null);
      // Clicking outside any room exits both pre-pick and post-pick spotlight mode.
      if (isPickingRoom || shufflePickedRoom != null) {
        setIsPickingRoom(false);
        setShufflePickedRoom(null);
        setShowHelperMessage(false);
      } else {
        setShufflePickedRoom(null);
        if (!tapRoomHintDismissed) {
          setShowHelperMessage(true);
        }
      }
    } else if (roomId && room?.room_id !== roomId && shufflePickedRoom == null && !partnerPackage?.allowMakeMagic) {
      // Different room tapped while another is selected (non-magic flow only).
      // In allowMakeMagic mode this branch is skipped so the tap falls directly
      // into the allowMakeMagic handler below, which switches rooms in one tap
      // rather than requiring a deselect first (edge-case 1).
      setIsAdding(false);

      setSelectedFurniture(null);
      setCopySelectedFurniture(null);

      setSelectedItem(null);

      setVertices({ index: false, vertices: [], roomId: "" });
      const lineContainer = document.getElementById("lineContainer");

      const shapeElements = lineContainer.querySelectorAll(".shape");
      shapeElements.forEach((element) => element.remove());
      setLineBoundary(false);
      setRoomId(null);
      setShufflePickedRoom(null);
      if (!tapRoomHintDismissed) {
        setShowHelperMessage(true);
      }

    } else if(partnerPackage?.allowMakeMagic) {
      setOpenFilters(false);

      // Spotlight protection: in post-pick mode, tapping a room that is NOT the
      // currently spotlighted room only switches the spotlight — it does NOT load
      // that room's furniture. The user must tap the spotlighted room a second time
      // to enter full furniture editing. This keeps editing scoped to one room at a time.
      if (shufflePickedRoom != null && room?.room_id !== shufflePickedRoom?.room_id) {
        setSelectedFurniture(null);
        setCopySelectedFurniture(null);
        setSelectedItem(null);
        const lcEl = document.getElementById("lineContainer");
        lcEl?.querySelectorAll(".shape").forEach((el) => el.remove());
        // An earlier pass gave this branch the new room's walls so furnishRoom
        // would stop sending an empty array, but derived them here and left the
        // doors and centre behind, so they kept describing the room being
        // switched away from. Taking all of it from the room's stored geometry
        // keeps the four consistent without deriving a second copy.
        if (applySpotlightRoomSelection(room)) return;
        // Nothing stored means this room has never been furnished, so there is
        // no furniture to keep the user out of and nothing to protect. The full
        // load below is the one place that derives geometry for such a room.
      }

      // Pre-pick mode OR tapping the already-spotlighted room → update spotlight
      // and proceed with full furniture loading for that room.
      // In pre-pick mode also exit picking state so the overlay switches to
      // post-pick spotlight and the room controls (Shuffle Room, etc.) are
      // reachable immediately after the tap (edge-case 2).
      if (isPickingRoom || shufflePickedRoom != null) {
        if (isPickingRoom) setIsPickingRoom(false);
        setShufflePickedRoom(room);
      }

      dismissTapRoomHint();
      const resultDoorRoom = doorsFindRoom(modalData);

      const resultRoom = findRoom(modalData);

      const lineContainer = document.getElementById("lineContainer");

      const shapeElements = lineContainer.querySelectorAll(".shape");
      shapeElements.forEach((element) => element.remove());

      const doors = getDoorsWithLineIndex(
        room?.doors,
        room?.walls,
        scaleXCanvas,
        scaleYCanvas,
        offsetXCheck,
        offsetYCheck
      );

      const validDoors = doors.filter((door) => door.lineId !== null);

      const verticesCheck = transformWalls(room?.walls);

      const resultRoomdoors = getDoorsWithLineIndex(
        resultRoom?.doors,
        resultRoom?.walls,
        scaleXCanvas,
        scaleYCanvas,
        offsetXCheck,
        offsetYCheck
      );

      const resultRoomvalidDoors = resultRoomdoors.filter(
        (door) => door.lineId !== null
      );

      const resultRoomVertices = transformWalls(resultRoom?.walls);

      const resultDoorsRoomDoors = getDoorsWithLineIndex(
        resultDoorRoom?.doors,
        resultDoorRoom?.walls,
        scaleXCanvas,
        scaleYCanvas,
        offsetXCheck,
        offsetYCheck
      );

      const resultDoorsRoomvalidDoors = resultDoorsRoomDoors.filter(
        (door) => door.lineId !== null
      );

      const resultDoorsRoomVertices = transformWalls(resultDoorRoom?.walls);

      const scopeAdjustedVertices = adjustVertices(
        verticesCheck,
        offsetXCheck,
        offsetYCheck,
        scaleXCanvas,
        scaleYCanvas
      );

      const updatedDoors = adjustDoorPositionAndOrientation(
        validDoors,
        scopeAdjustedVertices
      );

      const resultRoomAdjustedVertices = adjustVertices(
        resultRoomVertices,
        offsetXCheck,
        offsetYCheck,
        scaleXCanvas,
        scaleYCanvas
      );

      const resultRoomUpdatedDoors = adjustDoorPositionAndOrientation(
        resultRoomvalidDoors,
        resultRoomAdjustedVertices
      );

      const resultDoorRoomAdjustedVertices = adjustVertices(
        resultDoorsRoomVertices,
        offsetXCheck,
        offsetYCheck,
        scaleXCanvas,
        scaleYCanvas
      );

      const resultDoorRoomUpdatedDoors = adjustDoorPositionAndOrientation(
        resultDoorsRoomvalidDoors,
        resultDoorRoomAdjustedVertices
      );

      const { centerX: centerOriX, centerY: centerOriY } = calculateScaleFactor(
        scopeAdjustedVertices,
        0,
        0,
        0
      );

      const doorsArray = resultRoomdoors?.map((item) => item.width);
      const doorAverageValue = calculateFilteredAverage(doorsArray);
      const doorsArray1 = resultDoorsRoomDoors?.map((item) => item.width);

      const doorDoorAverageValue = calculateFilteredAverage(doorsArray1);

      let minCX = Infinity,
        maxCX = -Infinity,
        minCY = Infinity,
        maxCY = -Infinity;

      resultRoomAdjustedVertices.forEach((edge) => {
        edge.points.forEach((point) => {
          minCX = Math.min(minCX, point.x);
          maxCX = Math.max(maxCX, point.x);
          minCY = Math.min(minCY, point.y);
          maxCY = Math.max(maxCY, point.y);
        });
      });

      const shapeCWidth = maxCX - minCX;
      const shapeCHeight = maxCY - minCY;

      let roomWidth = resultRoom?.width;
      let roomHeight = resultRoom?.height;

      if (shapeCWidth > shapeCHeight) {
        if (roomWidth < roomHeight) {
          [roomWidth, roomHeight] = [roomHeight, roomWidth];
        }
      } else {
        if (roomHeight < roomWidth) {
          [roomWidth, roomHeight] = [roomHeight, roomWidth];
        }
      }

      setResultRoomVerticesState({
        resultRoomVertices,
        resultDoorsRoomVertices,
        roomWidth,
        roomHeight,
        resultRoomUpdatedDoors,
        doorAverageValue,
        resultDoorRoomUpdatedDoors,
        doorDoorAverageValue,
        resultRoomDoors: resultRoom?.doors,
        resultRoomWalls: resultRoom?.walls,
        resultDoorRoomDoors: resultDoorRoom?.doors,
        resultDoorRoomWalls: resultDoorRoom?.walls,
      });

      setStateCenterX(centerOriX);
      setStateCenterY(centerOriY);

      const existingSvg = document.querySelector(
        `.shape.id_${roomIdPayload}.Line`
      );

      if (existingSvg) {
        existingSvg.remove();
      }

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.classList.add("shape", `id_${room.room_id}`, "Line");

      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      svg.style.position = "absolute";
      svg.style.top = "0";
      svg.style.left = "0";

      appendSelectionFrostLayer(
        svg,
        scopeAdjustedVertices,
        room.room_id,
        divWidth,
        divHeight
      );

      // Canvas overlay (dim + white borders) replaces SVG marching ants
      // in allowMakeMagic deployments — no polyline added here.
      lineContainer.appendChild(svg);

      setDoors(updatedDoors);

      updatedDoors?.forEach((doorPoint, index) => {
        const { position, width, rotation } = doorPoint;

        const door = document.createElement("div");
        door.classList.add("shape", `id_${room.room_id}`); 
        door.style.position = "absolute";
        door.style.backgroundColor = "transparent"; 
        door.style.border = "0.1px dashed rgba(255, 255, 0, 0.5)";

        door.style.width = `${width}px`; 
        door.style.height = "5px"; 
        door.style.transformOrigin = "center";

        const angle = parseFloat(rotation?.z || 0) * (180 / Math.PI); 

        const isVertical = Math.abs(rotation?.z) === Math.PI / 2; 

        const adjustedX = isVertical
          ? position.x - width / 2 
          : position.x - (width / 2) * Math.cos(rotation?.z || 0); 

        const adjustedY = isVertical
          ? position.y - (width / 2) * Math.cos(rotation?.z || 0) 
          : position.y - 5 / 2; 

        door.style.transform = `translate(${adjustedX}px, ${adjustedY}px) rotate(${angle}deg)`;

        const lineContainer = document.getElementById("lineContainer"); 
        if (lineContainer) {
          lineContainer.appendChild(door);

          const doorWidthLabel = document.createElement("div");
          doorWidthLabel.classList.add("shape"); 
          doorWidthLabel.style.position = "absolute";
          doorWidthLabel.style.left = `${position.x}px`;
          doorWidthLabel.style.top = `${position.y}px`;
          doorWidthLabel.style.transform = "translate(-50%, -50%)"; 
          doorWidthLabel.style.color = "green";
          doorWidthLabel.style.fontSize = "5px";
          doorWidthLabel.textContent = `${width.toFixed(0)}in`; 

        } else {
          console.error("Container with ID 'lineContainer' not found");
        }
      });

      if (roomId !== room?.room_id) {
      } 

      setSelectedFurniture(null);
      setCopySelectedFurniture(null);

      setSelectedItem(null);

      setIsAdding(false);

      setVertices({
        index: false,
        vertices: scopeAdjustedVertices,
        roomId: room?.room_id,
      });

      setRoomId(room?.room_id);

      setLineBoundary(true);
    }
  };

  const updateFurniturePosition = (
    updatedObj,
    newPosition,
    roomActive,
    _id
  ) => {
    const updatedLayouts = structuredClone(roomsData);

    if (!updatedLayouts[roomActive]?.layouts) return;

    const room = updatedLayouts[roomActive];

    const undoLayouts = JSON.stringify(
      room.layouts?.map((layout) => ({
        furniture: layout.furniture.map((furniture) => ({ ...furniture })),
      }))
    );

    updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture =
      updatedLayouts[roomActive].layouts[
        roomActiveLayout[roomActive]
      ].furniture.map((furniture) =>
        furniture._id === updatedObj._id
          ? {
              ...furniture,
              // CSS renders at position * scaleXCanvas, so divide out scaleXCanvas to store RAW offset
              position: { x: newPosition.x / scaleXCanvas, y: newPosition.y / scaleYCanvas },
              origionalPosition: { x: newPosition.x / scaleXCanvas, y: newPosition.y / scaleYCanvas, z: 0 },
              exactPosition: {
                x: (newPosition.x / scaleXCanvas) * scaleFactorX,
                y: (newPosition.y / scaleYCanvas) * scaleFactorY,
                z: 0,
              },
            }
          : furniture
      );

    setRoomsData(updatedLayouts);

    const redoLayouts = JSON.stringify(
      updatedLayouts[roomActive]?.layouts?.map((layout) => ({
        furniture: layout.furniture.map((furniture) => ({ ...furniture })),
      }))
    );

    setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
      ...prevGlobalUndoFurniture,
      {
        roomId: roomActive,
        type: "change",
        layouts: undoLayouts,
        redoLayouts: redoLayouts,
      },
    ]);

    setFurniturePositions((prevPositions) => {
      const newPositions = { ...prevPositions };
      if (newPositions[roomActive]) {
        delete newPositions[roomActive][_id];
      }
      return newPositions;
    });
  };

  const updateFurniturePositionRotation = (updatedObj, newAngle) => {
    const undoLayouts = JSON.stringify(
      roomsData[roomActive]?.layouts?.map((layout) => ({
        furniture: layout.furniture.map((furniture) => ({ ...furniture })),
      }))
    );

    const updatedLayouts = [...roomsData];

    const updatedFurniture = updatedLayouts[roomActive].layouts[
      roomActiveLayout[roomActive]
    ].furniture.map((furniture) => {
      if (furniture._id === updatedObj._id) {
        let radians = newAngle * (Math.PI / 180);

        const rotatedHeight =
          Math.abs(furniture.width * Math.sin(radians)) +
          Math.abs(furniture.height * Math.cos(radians));

        setCopySelectedFurniture({
          angle: newAngle,
          left: updatedObj.left,
          top: updatedObj.centerTop - rotatedHeight / 2,
          roomId: roomActive,
          _id: updatedObj._id,
          centerTop: updatedObj.centerTop,
        });

        setSelectedFurniture({
          angle: newAngle,
          left: updatedObj.left,
          top: updatedObj.centerTop - rotatedHeight / 2,
          roomId: roomActive,
          _id: updatedObj._id,
          centerTop: updatedObj.centerTop,
        });

        const updatedRotation = {
          x: 0,
          y: 0,
          z: radians,
        };

        return {
          ...furniture,
          rotation: updatedRotation,
        };
      }
      return furniture;
    });

    updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture =
      updatedFurniture;

    setRoomsData(updatedLayouts);

    const updatedRoomItemsList = [...roomItemsList];
    const layoutIndex = roomActiveLayout[roomActive];

    updatedRoomItemsList[roomActive][layoutIndex] = updatedFurniture;

    setRoomItemsList(updatedRoomItemsList);

    setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
      ...prevGlobalUndoFurniture,
      {
        roomId: roomActive,
        type: "change",
        layouts: undoLayouts,
        redoLayouts: JSON.stringify(
          updatedLayouts?.[roomActive]?.layouts?.map((layout) => ({
            furniture: layout.furniture.map((furniture) => ({ ...furniture })),
          }))
        ),
      },
    ]);
  };

  const handleUndoFurniture = () => {
    const undoStack = globalUndoFurnitureRef.current;
    const lastGlobalAction = undoStack?.[undoStack.length - 1];
    if (!lastGlobalAction) {
      return;
    }

    // TRIPWIRE: Mark as user-edited (intentional world change)
    markUserEdited();
    console.log('[TRIPWIRE] User edit detected: UNDO furniture');

    setSelectedFurniture(null);
    setCopySelectedFurniture(null);
    setSelectedItem(null);

    const { roomId, type, layouts } = lastGlobalAction;

    try {
      if (type === "index") {
        setGlobalRedoFurniture((prevGlobalRedoFurniture) => [
          ...prevGlobalRedoFurniture,
          {
            roomId,
            type: "index",
            index: lastGlobalAction.index + 1,
          },
        ]);

        setGlobalUndoFurniture((prevGlobalUndoFurniture) => {
          const updatedGlobalUndoFurniture = [...prevGlobalUndoFurniture];
          updatedGlobalUndoFurniture.pop();
          return updatedGlobalUndoFurniture;
        });

        const updatedRoomActiveLayout = [...roomActiveLayout];
        updatedRoomActiveLayout[roomId] = lastGlobalAction.index;
        setRoomActiveLayout(updatedRoomActiveLayout);
      } else if (type === "change") {
        setGlobalRedoFurniture((prevGlobalRedoFurniture) => [
          ...prevGlobalRedoFurniture,
          lastGlobalAction,
        ]);

        setGlobalUndoFurniture((prevGlobalUndoFurniture) => {
          const updatedGlobalUndoFurniture = [...prevGlobalUndoFurniture];
          updatedGlobalUndoFurniture.pop();
          return updatedGlobalUndoFurniture;
        });

        if (lastGlobalAction.replaceEntireLayouts) {
          const parsedLayouts = JSON.parse(layouts);

          setRoomsData((prev) => {
            const next = [...prev];
            next[roomId] = {
              ...next[roomId],
              layouts: parsedLayouts,
            };
            return next;
          });

          setRoomItemsList((prev) => {
            const next = [...prev];
            next[roomId] = parsedLayouts.map((layout) =>
              (layout?.furniture || []).map((f) => ({ ...f }))
            );
            return next;
          });

          setKeepItems((prev) => {
            const next = [...prev];
            next[roomId] = parsedLayouts.map((layout) =>
              (layout?.furniture || []).map((f) => ({ ...f }))
            );
            return next;
          });

          setRoomActiveLayout((prev) => {
            const next = [...prev];
            next[roomId] =
              lastGlobalAction.priorActiveLayout != null
                ? lastGlobalAction.priorActiveLayout
                : 0;
            return next;
          });
        } else {
          const updatedLayouts = [...roomsData];

          updatedLayouts[roomId].layouts = updatedLayouts[roomId].layouts.map(
            (layout, index) => {
              if (index === roomActiveLayout[roomId]) {
                return {
                  ...layout,
                  furniture: JSON.parse(layouts)[index]?.furniture || [],
                };
              }
              return layout;
            }
          );

          setRoomsData(updatedLayouts);

          const updatedRoomItemsList = JSON.parse(JSON.stringify(roomItemsList));

          const updatedFurniture =
            JSON.parse(layouts)[roomActiveLayout[roomId]]?.furniture || [];

          updatedRoomItemsList[roomId][roomActiveLayout[roomId]] =
            updatedRoomItemsList[roomId][roomActiveLayout[roomId]].filter(
              (item) =>
                updatedFurniture.some((furniture) => furniture._id === item._id)
            );

          setRoomItemsList(updatedRoomItemsList);
        }
      }
    } catch (err) {
      console.error("[UNDO] Failed to apply furniture undo:", err);
    }
  };

  const handleRedoFurniture = () => {
    const redoStack = globalRedoFurnitureRef.current;
    const lastGlobalRedoAction = redoStack?.[redoStack.length - 1];
    if (!lastGlobalRedoAction) {
      return;
    }

    // TRIPWIRE: Mark as user-edited (intentional world change)
    markUserEdited();
    console.log('[TRIPWIRE] User edit detected: REDO furniture');

    setSelectedFurniture(null);
    setCopySelectedFurniture(null);
    setSelectedItem(null);

    const { roomId, type, index, redoLayouts } = lastGlobalRedoAction;

    try {
      if (type === "index") {
        setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
          ...prevGlobalUndoFurniture,
          {
            roomId,
            type: "index",
            index: index - 1,
          },
        ]);

        setGlobalRedoFurniture((prevGlobalRedoFurniture) => {
          const updatedGlobalRedoFurniture = [...prevGlobalRedoFurniture];
          updatedGlobalRedoFurniture.pop();
          return updatedGlobalRedoFurniture;
        });

        const updatedRoomActiveLayout = [...roomActiveLayout];
        updatedRoomActiveLayout[roomId] = index;
        setRoomActiveLayout(updatedRoomActiveLayout);
      } else if (type === "change") {
        setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
          ...prevGlobalUndoFurniture,
          lastGlobalRedoAction,
        ]);

        setGlobalRedoFurniture((prevGlobalRedoFurniture) => {
          const updatedGlobalRedoFurniture = [...prevGlobalRedoFurniture];
          updatedGlobalRedoFurniture.pop();
          return updatedGlobalRedoFurniture;
        });

        if (lastGlobalRedoAction.replaceEntireLayouts) {
          const parsedLayouts = JSON.parse(redoLayouts);

          setRoomsData((prev) => {
            const next = [...prev];
            next[roomId] = {
              ...next[roomId],
              layouts: parsedLayouts,
            };
            return next;
          });

          setRoomItemsList((prev) => {
            const next = [...prev];
            next[roomId] = parsedLayouts.map((layout) =>
              (layout?.furniture || []).map((f) => ({ ...f }))
            );
            return next;
          });

          setKeepItems((prev) => {
            const next = [...prev];
            next[roomId] = parsedLayouts.map((layout) =>
              (layout?.furniture || []).map((f) => ({ ...f }))
            );
            return next;
          });

          setRoomActiveLayout((prev) => {
            const next = [...prev];
            next[roomId] =
              lastGlobalRedoAction.nextActiveLayout != null
                ? lastGlobalRedoAction.nextActiveLayout
                : 0;
            return next;
          });
        } else {
          const updatedLayouts = [...roomsData];

          updatedLayouts[roomId].layouts = updatedLayouts[roomId].layouts.map(
            (layout, idx) => {
              if (idx === roomActiveLayout[roomId]) {
                return {
                  ...layout,
                  furniture: JSON.parse(redoLayouts)[idx]?.furniture || [],
                };
              }
              return layout;
            }
          );

          setRoomsData(updatedLayouts);
          const updatedRoomItemsList = JSON.parse(JSON.stringify(roomItemsList));

          const updatedFurniture =
            JSON.parse(redoLayouts)[roomActiveLayout[roomId]]?.furniture || [];
          const newlyAddedFurniture = updatedFurniture.filter(
            (item) => item.newlyAdded
          );

          updatedRoomItemsList[roomId][roomActiveLayout[roomId]] = [
            ...updatedRoomItemsList[roomId][roomActiveLayout[roomId]],
            ...newlyAddedFurniture.filter(
              (item) =>
                !updatedRoomItemsList[roomId][roomActiveLayout[roomId]].some(
                  (existingItem) => existingItem._id === item._id
                )
            ),
          ];

          setRoomItemsList(updatedRoomItemsList);
        }
      }
    } catch (err) {
      console.error("[REDO] Failed to apply furniture redo:", err);
    }
  };

  useEffect(() => {
    if (
      layouts?.length >= 1 &&
      !loadingLayout &&
      !objectsCheck &&
      zonesRoom[roomId]?.length >= 1 &&
      !openFilters &&
      callFurnish
    ) {
      if (vertices?.vertices?.length >= 1) {
        setCallFurnish(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callFurnish]);



  const addTv = (roomId, idx) => {
    setTvIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: idx, 
    }));

    const existingZones = zonesRoom[roomId] || []; 
    const existingStorageIndex = existingZones.findIndex(
      (zone) => zone.value === "watchingtv"
    );

    if (idx === 0) {
      if (existingStorageIndex === -1) {
        const newStorageZone = {
          value: "watchingtv",
          capacity: 1,
        };

        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: [...existingZones, newStorageZone],
        }));
      }
    } else {
      if (existingStorageIndex !== -1) {
        const updatedZones = existingZones.filter(
          (zone) => zone.value !== "watchingtv"
        );

        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: updatedZones,
        }));
      }
    }
  };



  const addVanity = (roomId, item, idx) => {
    const existingZones = zonesRoom[roomId] || []; 
    const existingStorageIndex = existingZones.findIndex(
      (zone) => zone.value === "gettingready"
    );

    if (idx === 0) {
      if (existingStorageIndex === -1) {
        const newStorageZone = {
          value: "gettingready",
          capacity: 1,
        };

        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: [...existingZones, newStorageZone],
        }));
      }
    } else {
      if (existingStorageIndex !== -1) {
        const updatedZones = existingZones.filter(
          (zone) => zone.value !== "gettingready"
        );

        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: updatedZones,
        }));
      }
    }

    setVanityIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: idx, 
    }));
  };





  const addStorage = (roomId, idx) => {
    const existingZones = zonesRoom[roomId] || []; 
    const existingStorageIndex = existingZones.findIndex(
      (zone) => zone.value === "storagemedia"
    );

    if (idx === 0) {
      if (existingStorageIndex === -1) {
        const newStorageZone = {
          value: "storagemedia",
          capacity: 1,
        };


        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: [...existingZones, newStorageZone],
        }));
      }
    } else {
      if (existingStorageIndex !== -1) {
        const updatedZones = existingZones.filter(
          (zone) => zone.value !== "storagemedia"
        );

        setZonesRoom((prevZones) => ({
          ...prevZones,
          [roomId]: updatedZones,
        }));
      }
    }

    setStorageIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: idx, 
    }));
  };

  const handleItems = (id, itemZ, action, errorFlag, furnitureAdded) => {
    if (errorFlag) {
      setErrorLayoutGlobal(false);
    }
    const updatedItemsList = JSON.parse(JSON.stringify(roomItemsList));

    const currentItems =
      updatedItemsList?.[roomActive]?.[roomActiveLayout?.[roomActive]] || [];

    const similarItems = currentItems.filter(
      (item) => item._id?.split("-")?.[0] === id?.split("-")?.[0]
    );

    if (action === "add") {
      if (similarItems.length > 0) {
        const highestQuantity = similarItems.reduce((max, item) => {
          const quantity = parseInt(item._id.split("-").pop(), 10); 
          return Math.max(max, quantity);
        }, 0);

        updatedItemsList[roomActive][roomActiveLayout[roomActive]].push({
          ...itemZ,
          exactPosition: null,
          _id: `${id?.split("-")?.[0]}-${highestQuantity + 1}`,
          quantity: highestQuantity + 1,
          duplicateFromSource: !!furnitureAdded,
          duplicateSourceId: furnitureAdded ? id : undefined,
        });

        setSelectedItem(
          `${roomActive}-${id?.split("-")?.[0]}-${highestQuantity + 1}`
        );

        const position =
          furniturePositions[roomActive]?.[itemZ._id] || itemZ?.position;

        const { width, height } = itemZ;
        const rotationZ = itemZ?.rotation?.z ?? 0;

        const adjustedWidth = width;
        const adjustedHeight = height;
        const roomValue =
          roomsData?.[roomActive]?.layouts?.[roomActiveLayout[roomActive]];

        const centerLeft = position?.x
          ? roomValue?.centerX
          : roomValue?.centerX + position?.x;
        const centerTop = position?.y
          ? roomValue?.centerY
          : roomValue?.centerY - position?.y;

        const rotationAngle = (rotationZ * 180) / Math.PI;
        const rotationRadians = rotationZ;

        const rotatedHeight =
          Math.abs(adjustedWidth * Math.sin(rotationRadians)) +
          Math.abs(adjustedHeight * Math.cos(rotationRadians));

        if (furnitureAdded) {
          setCopySelectedFurniture({
            left: centerLeft,
            top: centerTop - rotatedHeight / 2,
            angle: rotationAngle,
            centerTop: centerTop,
            roomId: roomActive,
            _id: `${id?.split("-")?.[0]}-${highestQuantity + 1}`,
          });

          setSelectedFurniture({
            left: centerLeft,
            top: centerTop - rotatedHeight / 2,
            angle: rotationAngle,
            centerTop: centerTop,
            roomId: roomActive,
            _id: `${id?.split("-")?.[0]}-${highestQuantity + 1}`,
          });
        }
      } else {
        updatedItemsList[roomActive][roomActiveLayout[roomActive]].push({
          ...itemZ,
          exactPosition: null,
          _id: `${id?.split("-")?.[0]}-1`, 
          quantity: 1, 
        });
        setSelectedItem(`${roomActive}-${id?.split("-")?.[0]}-1`);
      }
    } else if (action === "decrease") {
      if (similarItems.length > 0) {
        const maxQuantityItem = similarItems.reduce((maxItem, currentItem) => {
          const currentQuantity = parseInt(
            currentItem._id.split("-").pop(),
            10
          );
          const maxQuantity = parseInt(maxItem._id.split("-").pop(), 10);
          return currentQuantity > maxQuantity ? currentItem : maxItem;
        });

        const maxItemIndex = currentItems.findIndex(
          (item) => item._id === maxQuantityItem._id
        );
        if (maxItemIndex > -1) {
          currentItems.splice(maxItemIndex, 1);
        }
      }
    }

    updatedItemsList[roomActive][roomActiveLayout[roomActive]] = currentItems;
    setRoomItemsList(updatedItemsList);
    setAdded(!added); 
  };



  useEffect(() => {
    if (!(zonesRoom[roomId]?.length >= 1)) {
      if (openFilters) {
        setOpenFilters(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zonesRoom]);

  useEffect(() => {
    console.log('');
    console.log('🛒'.repeat(40));
    console.log('[ADD ITEMS EFFECT] useEffect triggered');
    console.log('[ADD ITEMS EFFECT] Dependencies:', {
      added: added,
      scale: scale,
      scaleReady: scaleReady,
    });
    console.log('[ADD ITEMS EFFECT] Context:', {
      roomActive: roomActive,
      roomItemsListLength: roomItemsList?.length,
    });
    
    if (scaleReady) {
      console.log('[ADD ITEMS EFFECT] ✅ scaleReady=true - addItems CAN proceed');
    } else {
      console.log('[ADD ITEMS EFFECT] ⏳ scaleReady=false - addItems will be BLOCKED inside the function');
    }
    console.log('🛒'.repeat(40));
    console.log('');
    
    if (roomActive === -1 || roomItemsList?.length === 0) {
      console.log('[ADD ITEMS EFFECT] Early return - no room active or no items');
      return;
    } else {
      console.log('[ADD ITEMS EFFECT] Calling addItems()...');
      addItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [added, scale, scaleReady]); // PR #89: Added scaleReady so pending adds trigger when scale becomes ready

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    return arr1.every((item1) =>
      arr2.some(
        (item2) =>
          item1.value === item2.value && item1.capacity === item2.capacity
      )
    );
  };

  const addZone = (roomId, newZone) => {
    const prevZones = zonesRoom?.[roomId] || [];

    if (!newZone) {
      setZonesRoom((prev) => ({
        ...prev,
        [roomId]: [],
      }));
      return;
    }

    let updatedZones = [];

    if (newZone.value === "lounging,dining") {
      updatedZones = [
        {
          value: "lounging",
          capacity: newZone?.capacity || 1,
        },
        {
          value: "dining",
          capacity: newZone?.capacity || 1,
        },
      ];
    } else {
      updatedZones = [
        {
          value: newZone.value,
          capacity: newZone?.capacity || 1,
        },
      ];
    }

    if (!areArraysEqual(prevZones, updatedZones)) {
      setZonesRoom((prev) => ({
        ...prev,
        [roomId]: updatedZones,
      }));
      if (layouts?.length >= 1 && !loadingLayout) {
        setCallFurnish(true);
      }
    }
  };

  useEffect(() => {
      const roomZones = zonesRoom[roomId] || [];
      const tvIndex = tvIndexByRoom[roomId] ?? [];

      const check = roomZones.some(
        (item) =>
          (item.value === "lounging" && (tvIndex === 0)) ||
          (item.value === "sleeping" && (tvIndex === 0)) ||
          (item.value === "comingandgoing" &&
            (tvIndex === 0))
      );


    if (check && roomId) {
      setStorageIndexByRoom((prevState) => ({
        ...prevState,
        [roomId]: undefined, 
      }));
      setZonesRoom((prevZones) =>
        Object.fromEntries(
          Object.entries(prevZones).map(([roomId, roomZones]) => [
            roomId,
            (Array.isArray(roomZones) ? roomZones : []).filter(
              (zone) => zone.value !== "storagemedia"
            ),
          ])
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tvIndexByRoom[roomId], vanityIndexByRoom[roomId]]);

  const handleChange = (roomId, event, newValue) => {
    // Every zone write is keyed by roomId, and so is furnishRoom's read of it.
    // Without a room there is nowhere to put the choice, and updating
    // selectedOption anyway would show the new room type on the pill while the
    // room kept its old one — the room-type change that appeared to take and
    // then did nothing.
    if (!roomId) return;

    setVanityIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: undefined, 
    }));

    setTvIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: undefined,
    }));

    setBedIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: undefined, 
    }));

    setStorageIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: undefined, 
    }));

    setItems([]);

    setSelectedOption(newValue);
    addZone(roomId, newValue);
  };

  // When the Add Items modal closes and any room now has furniture, mark
  // that the user has manually added an item (triggers Save/Share CTA promotion).
  const prevIsAddingRef = useRef(false);
  useEffect(() => {
    if (!prevIsAddingRef.current && isAdding) {
      manualAddPlacementIndexRef.current = 0;
      manualAddPlacementRoomRef.current = null;
    }
    if (prevIsAddingRef.current && !isAdding && anyRoomHasFurniture) {
      setManualItemAdded(true);
    }
    prevIsAddingRef.current = isAdding;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdding]);

  useEffect(() => {
    const roomZones = zonesRoom?.[roomId];

    if (
      roomZones &&
      roomZones.some((item) => item.value === "lounging") &&
      roomZones.some((item) => item.value === "dining")
    ) {
      setSelectedOption(LIVING_DINING_OPTION);
    } else if (roomZones) {
      const value = zonesData.find((item) =>
        roomZones.some((zone) => zone.value === item.value)
      );

      setSelectedOption(value);
    } else {
      setSelectedOption(null);
    }
    // Include `zonesRoom` so the "See it as a..." pill re-resolves whenever
    // the active room's zone changes — e.g. after picking a zone from the
    // dropdown, after the "Something Else" / Add Items flow writes a custom
    // zone, or when saved-layout zones are loaded asynchronously. Without
    // this, the pill stays stuck on "See it as a..." even after the zone is
    // actually set, and only "wakes up" once the user taps a different room
    // and back. Reproduces in the plan-level Shuffle → tap room flow.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId, roomActive, zonesRoom]);

  // Auto-open Add Items when the user taps a room that has no valid Make Magic
  // zone (e.g. bath, kitchen) so they land directly on the items picker instead
  // of an empty "See it as a..." state.
  //
  // LAUNCH-BLOCKING FIX: `selectedOption === null` is NOT a reliable signal for
  // "this room can't be Make Magic'd". It is also null for any freshly-selected
  // room before the user has picked a room type, and transiently while a saved
  // room's zones resolve asynchronously. Because the "See it as a..." selector
  // (`zonesData`) is always populated for Make Magic partners, this effect was
  // force-opening the manual Add Items panel on first shuffle/room-tap — hiding
  // the room-type selector and making the room look cleared instead of letting
  // the user Make Magic. Only auto-open when there genuinely are NO Make Magic
  // room-type options to show; otherwise leave the shuffle / room-type flow
  // intact.
  useEffect(() => {
    if (!partnerPackage?.allowMakeMagic) return;
    if (!lineBoundary || !roomId || roomActive === -1) return;
    if (isAdding) return;
    if (userDismissedAddItemsRef.current) return;
    if (selectedOption !== null) return;
    // There are room-type options to display → show the selector + shuffle,
    // never the manual Add Items panel.
    if (zonesData?.length > 0) return;
    setIsAdding(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId, selectedOption, lineBoundary]);

  useEffect(() => {
    userDismissedAddItemsRef.current = false;
  }, [roomId]);

  function modifyRoomProperties(data, scaleX, scaleY) {
    // [MATCH-PROD] Divide by scaleX directly (matches production line 2870 AND staging line 3904).
    console.log('[MODIFY-ROOM] scaleX:' + scaleX?.toFixed(4) + ' (prod formula)');
    const clonedData = JSON.parse(JSON.stringify(data));
    let loggedFirst = false;
    const result = clonedData.map((item) => {
      if (item.furniture) {
        let scaleCX = scaleX;
        let scaleCY = scaleY;

        item.furniture = item.furniture.map((furniture) => {
          if (!loggedFirst) {
            console.log('[MODIFY-ROOM] ' + furniture.name + ' | apiW:' + furniture.width + ' → ' + (furniture.width / scaleCX).toFixed(2) + 'px (prod)');
            loggedFirst = true;
          }
          furniture.origionalWidth = furniture.width;
          furniture.origionalHeight = furniture.height;

          furniture.origionalPosition = { ...furniture.position };

          furniture.width = furniture.width / scaleCX;
          furniture.height = furniture.height / scaleCY;

          furniture.position.x = furniture.position.x / scaleCX;
          furniture.position.y = furniture.position.y / scaleCY;

          return furniture;
        });
      }

      return item;
    });

    return result;
  }




  const clearFurniturePositions = (key) => {
    setFurniturePositions((prev) => {
      if (!prev[key]) return prev; 

      return {
        ...prev,
        [key]: {}, 
      };
    });
  };

  const furnishRoom = async (useKeep, manuallyItemsFlag, customZone, fromShuffle = false) => {
    if (!zonesRoom || !roomId || !Array.isArray(zonesRoom[roomId])) {
      return;
    }

    // [DEDUP-FIX] Reset handleUpdate dedup key so that after furnishRoom
    // updates roomsData, handleUpdate will NOT be skipped on next trigger.
    // handleUpdate needs to run to recompute room centers (centerOriX) with
    // the new furniture data. Without this, room centers become stale.
    handleUpdateKeyRef.current = null;
    console.log('[FURNISH ROOM] Called with:', { useKeep, manuallyItemsFlag, customZone, fromShuffle });
    console.log('[DEDUP-FIX] handleUpdateKeyRef reset to null - next handleUpdate will run');

    controllerRef.current = new AbortController();

    setOpenFilters(false);
    setLoadingLayout(true);

    let updatedZones = [...zonesRoom[roomId]];

    if (customZone) {
      updatedZones = [...updatedZones, { label: "Custom", value: "custom" }];
    }

    const hasWatchingTV = updatedZones.some(
      (zone) => zone.value === "watchingtv"
    );

    const hasStorageMedia = updatedZones.some(
      (zone) => zone.value === "storagemedia"
    );

    const hasSleepingOrComing = updatedZones.some(
      (zone) => zone.value === "sleeping" || zone.value === "comingandgoing"
    );

    const hasWorkStation = updatedZones.some(
      (zone) => zone.value === "gettingready"
    );

    const hasLounging = updatedZones.some((zone) => zone.value === "lounging");

    function addUniqueZone(updatedZones, newZone) {
      const exists = updatedZones.some((zone) => zone.value === newZone.value);
      if (!exists) {
        updatedZones.push(newZone);
      }
    }

    if (hasSleepingOrComing) {
      if (hasWatchingTV && hasWorkStation) {
        addUniqueZone(updatedZones, {
          value: "tvworkstation",
          capacity: 1,
        });

        updatedZones = updatedZones.filter(
          (zone) => !["watchingtv", "gettingready"].includes(zone.value)
        );
      }

      if (hasWatchingTV && !hasStorageMedia && !hasWorkStation) {
        addUniqueZone(updatedZones, {
          value: "tvstorage",
          capacity: 1,
        });

        updatedZones = updatedZones.filter(
          (zone) => zone.value !== "watchingtv"
        );
      }

      if (hasWatchingTV && hasStorageMedia && !hasWorkStation) {
        addUniqueZone(updatedZones, {
          value: "tvstorage",
          capacity: 1,
        });

        updatedZones = updatedZones.filter(
          (zone) => !["storagemedia", "watchingtv"].includes(zone.value)
        );
      }

      if (!hasWatchingTV && hasStorageMedia && !hasWorkStation) {
        addUniqueZone(updatedZones, {
          value: "bedroomstorage",
          capacity: 1,
        });

        updatedZones = updatedZones.filter(
          (zone) => zone.value !== "storagemedia"
        );
      }

      if (hasWatchingTV && hasWorkStation && hasStorageMedia) {
        addUniqueZone(updatedZones, {
          value: "tvworkstation",
          capacity: 1,
        });

        updatedZones = updatedZones.filter(
          (zone) =>
            !["watchingtv", "gettingready", "storagemedia"].includes(zone.value)
        );
      }

      if (hasStorageMedia && hasWorkStation) {
        updatedZones = updatedZones.filter(
          (zone) => zone.value !== "storagemedia"
        );
      }
    } else if (hasLounging && hasWatchingTV) {
      // A TV supersedes generic lounging: a living room with a TV asks for the
      // TV-living layouts, and living + dining for those plus dining, never the
      // plain lounging ones. Read off the room's zones rather than the "TV?"
      // toggle index because the zones are what gets sent, and the two can
      // disagree — the index is rebuilt from saved zones on load.
      updatedZones = updatedZones.filter((zone) => zone.value !== "lounging");
    }

    const getAllFurniture = () => {
      const allFurniture =
        keepItems?.[roomActive]?.[roomActiveLayout?.[roomActive]];

      const flattenedFurniture = allFurniture
        ? allFurniture.flat(Infinity) 
        : [];

      return flattenedFurniture;
    };

    let didTimeout = false;


    const mergeFurnitureAndItems = (allFurniture, items) => {
      const safeAllFurniture = Array.isArray(allFurniture) ? allFurniture : [];
      const safeItems = Array.isArray(items) ? items : [];

      const mergedArray = [...safeAllFurniture, ...safeItems];

      return mergedArray;
    };

    const allFurniture = getAllFurniture();

    const mergedResult = mergeFurnitureAndItems(allFurniture, items);

    const itemsPayload = useKeep ? mergedResult : items;

    setBackTrackKeepItems((prevBackTrackKeepItems) => ({
      ...prevBackTrackKeepItems,
      [roomId]: itemsPayload,
    }));

    const timeoutId = setTimeout(() => {
      handleCancelRequest();
      didTimeout = true;
    }, 120000);

    if (manuallyItemsFlag) {
      setLayouts(["No Layout"]);

      setErrorLayout((prevState) => ({
        ...prevState,
        [roomId]: "manually",
      }));
      setErrorLayoutGlobal(true);

      setLoadingLayout(false);

      setSelectedFurniture(null);
      setCopySelectedFurniture(null);
      setSelectedItem(null);

      setRoomsData((prevRoomsData) => {
        const newVertices = vertices?.vertices;

        const existingIndex = prevRoomsData.findIndex(
          (room) => vertices.roomId === room.roomId
        );

        if (existingIndex !== -1) {
          const newInnerArrays = Array.from(
            { length: 1 }, 
            () => []
          );

          setRoomActive(existingIndex);

          const updatedArray = [...roomItemsList];
          updatedArray[existingIndex] = newInnerArrays;

          const updatedlayoutIndex = [...roomActiveLayout];
          updatedlayoutIndex[existingIndex] = 0;
          setRoomActiveLayout(updatedlayoutIndex);

          const updatedKeepItems = [...keepItems];
          updatedKeepItems[existingIndex] = newInnerArrays;

          const updatedGlobalUndoFurniture = globalUndoFurniture.filter(
            (item) => item.roomId != existingIndex
          );
          setGlobalUndoFurniture(updatedGlobalUndoFurniture);

          const updatedGlobalRedoFurniture = globalRedoFurniture.filter(
            (item) => item.roomId != existingIndex
          );
          setGlobalRedoFurniture(updatedGlobalRedoFurniture);

          setRoomItemsList(updatedArray);
          setKeepItems(updatedKeepItems);

          setSeeItAnotherWay((prevState) => ({
            ...prevState,
            [existingIndex]: false, 
          }));

          const updatedRoomsData = prevRoomsData?.map((room, index) => {
            if (index === existingIndex) {
              return {
                ...room,
                layouts: [],
              };
            }
            return room;
          });

          updatedRoomsData[existingIndex].layouts = [{ furniture: [] }];

          updatedRoomsData[existingIndex].doors = doors;
          updatedRoomsData[existingIndex].windows = windows;
          updatedRoomsData[existingIndex].scaleX = scaleFactorX;
          updatedRoomsData[existingIndex].scaleY = scaleFactorY;
          updatedRoomsData[existingIndex].centerY = stateCenterY;
          updatedRoomsData[existingIndex].centerX = stateCenterX;
          updatedRoomsData[existingIndex].payloadVertices = newVertices;
          updatedRoomsData[existingIndex].roomId = vertices.roomId;
          updatedRoomsData[existingIndex].orignalPayloadVertices = newVertices;

          updatedRoomsData[existingIndex].scaleXCanvas = scaleXCanvas;
          updatedRoomsData[existingIndex].scaleYCanvas = scaleYCanvas;

          updatedRoomsData[existingIndex].offsetX = offsetXCheck;
          updatedRoomsData[existingIndex].offsetY = offsetYCheck;
          updatedRoomsData[existingIndex].resultRoomVerticesState =
            resultRoomVerticesState;

          updatedRoomsData[existingIndex].zones = updatedZones;

          return updatedRoomsData;
        } else {
          const initializedItemsArray = Array.from(
            { length: 1 }, 
            () =>
              Array.from(
                { length: 1 }, 
                () => []
              )
          );

          const combinedArray = [...roomItemsList, ...initializedItemsArray];

          setRoomItemsList(combinedArray);
          setRoomActive(roomsData?.length);
          setRoomActiveLayout((prevActiveLayout) => [...prevActiveLayout, 0]);

          return [
            ...prevRoomsData,
            {
              layouts: [{ furniture: [] }],
              payloadVertices: newVertices,
              zones: updatedZones,
              orignalPayloadVertices: newVertices,
              doors: doors,
              windows: windows,
              scaleX: scaleFactorX,
              scaleY: scaleFactorY,
              centerX: stateCenterX,
              roomId: vertices?.roomId,
              centerY: stateCenterY,
              scaleXCanvas: scaleXCanvas,
              scaleYCanvas: scaleYCanvas,
              offsetX: offsetXCheck,
              offsetY: offsetYCheck,
              resultRoomVerticesState: resultRoomVerticesState,
            },
          ];
        }
      });

      setRoomsData((prevRoomsData) => {
        const existingRoomIndex = prevRoomsData.findIndex(
          (room) => room.roomId === "custom-room"
        );

        if (existingRoomIndex !== -1) {
          setRoomActiveLayout((prevActiveLayout) => {
            if (prevActiveLayout[existingRoomIndex] !== undefined) {
              return prevActiveLayout;
            }

            const newLayout = [...prevActiveLayout];
            newLayout[existingRoomIndex] = 0;
            return newLayout;
          });

          return prevRoomsData;
        } else {
          setRoomItemsList((prevRoomItemsList) => {
            const initializedItemsArray = Array.from({ length: 1 }, () =>
              Array.from({ length: 1 }, () => [])
            );

            const combinedArray = [
              ...prevRoomItemsList,
              ...initializedItemsArray,
            ];
            return combinedArray;
          });

          const newCustomRoom = {
            layouts: [
              {
                room: {
                  width: 124,
                  height: 214,
                  shape: "box-shape",
                  zone: [
                    {
                      value: "workingvanity",
                      capacity: 1,
                    },
                  ],
                  position: {
                    x: 0,
                    y: 0,
                    z: 0,
                  },
                },
                doors: [],
                windows: [],
                furniture: [],
                vertices: [],
                prompt: "",
              },
            ],
            payloadVertices: [],
            doors: [],
            windows: [],
            scaleX: scaleFactorX,
            scaleY: scaleFactorY,
            centerX: 1500,
            centerY: divHeight / 2,
            roomId: "custom-room",
            orignalPayloadVertices: [],
            scaleXCanvas: scaleXCanvas,
            scaleYCanvas: scaleYCanvas,
            offsetX: offsetXCheck,
            offsetY: offsetYCheck,
            zones: [{ value: "custom", label: "Custom Room" }],
            resultRoomVerticesState: {},
          };

          const newIndex = prevRoomsData.length;

          setRoomActiveLayout((prevActiveLayout) => {
            const newLayout = [...prevActiveLayout];
            newLayout[newIndex] = 0;
            return newLayout;
          });

          return [...prevRoomsData, newCustomRoom];
        }
      });
      return;
    }


    try {
      // [FIX] Normalize viewport-scaled vertices back to canonical (CV pixel) space
      // before scaling by scaleFactorX. This prevents double-scaling:
      // viewport vertices × sfx creates a distorted grid → beds placed far from walls.
      // canonical vertices × sfx creates a correct inch-space grid → beds against walls.
      // Use GLOBAL scaleXCanvas/offsetXCheck (not room-specific) because
      // payloadVertices are set by handleUpdate's adjustedVertices which uses
      // global viewport values for ALL rooms.
      const vpVerts = vertices?.vertices;
      const canonicalVerts = vpVerts?.map(v => ({
        ...v,
        points: v.points?.map(p => ({
          x: (p.x - offsetXCheck) / scaleXCanvas,
          y: (p.y - offsetYCheck) / scaleYCanvas,
        })),
      }));
      const allCanonX = canonicalVerts?.flatMap(v => [v.points?.[0]?.x, v.points?.[1]?.x].filter(Number.isFinite)) || [];
      const allCanonY = canonicalVerts?.flatMap(v => [v.points?.[0]?.y, v.points?.[1]?.y].filter(Number.isFinite)) || [];
      const canonicalCenterX = allCanonX.length > 0 ? (Math.min(...allCanonX) + Math.max(...allCanonX)) / 2 : stateCenterX;
      const canonicalCenterY = allCanonY.length > 0 ? (Math.min(...allCanonY) + Math.max(...allCanonY)) / 2 : stateCenterY;

      // Convert viewport-scaled doors back to canonical space before scaling by sfx.
      const canonicalDoors = doors?.map(door => ({
        ...door,
        position: {
          x: (door.position.x - offsetXCheck) / scaleXCanvas,
          y: (door.position.y - offsetYCheck) / scaleYCanvas,
        },
        width: door.width / scaleXCanvas,
      }));
      const selectedRoomLayoutData =
        layoutData?.modalData?.find((room) => room?.room_id === roomId) ||
        layoutData?.payload?.modalData?.find((room) => room?.room_id === roomId);

      const response = await axios.post(
        `${baseUrl}/room/getroom-dev`,
        {
          roomId: roomId,
          roomName: selectedRoomLayoutData?.room_name || "unnamed_room",
          width: 224,
          height: 134,
          shape: "box-shape",
          doors: scaleDoors(
            canonicalDoors,
            scaleFactorX,
            scaleFactorY,
            canonicalCenterX,
            canonicalCenterY
          ),
          windows,
          firePlaces: [],
          zone: updatedZones,
          items: itemsPayload,
          vertices: scalePoints(
            canonicalVerts,
            scaleFactorX,
            scaleFactorY,
            canonicalCenterX,
            canonicalCenterY
          ),
          obstacles: scaleObstacles(
            selectedRoomLayoutData?.obstacles ?? [],
            scaleFactorX,
            scaleFactorY,
            canonicalCenterX,
            canonicalCenterY
          ),
          edgeSegments: scaleEdgeSegments(
            selectedRoomLayoutData?.edge_segments ?? [], 
            scaleFactorX, 
            scaleFactorY, 
            canonicalCenterX, 
            canonicalCenterY
          ),
        },
        {
          signal: controllerRef.current.signal,
          headers: {
            Authorization: `Bearer ${currentUserSessionStorage}`,
          },
        }
      );

      if (response.status === 204) {
        if (fromShuffle) {
          // LAUNCH-BLOCKING FIX: a shuffle must NEVER destroy the user's
          // current room or drop them into the manual Add Items panel. When
          // Make Magic returns no new layout (204) for a shuffle, keep the
          // existing furniture exactly as-is and just stop the loader. The
          // destructive "fall back to Add Items + wipe the room" behaviour
          // below is only appropriate for an explicit Make Magic / manual
          // request, not for a shuffle of an already-furnished room.
          setLoadingLayout(false);
          setOpenFilters(false);
          setShowZonesMenu(false);
          setErrorLayoutGlobal(false);
          setErrorLayout((prevState) => ({
            ...prevState,
            [roomId]: undefined,
          }));
          return;
        }

        setLayouts(["No Layout"]);

        // "No Magic Found" → seamlessly fall back to the Add Items modal
        // (same UX as picking "Something Else" from the See it as a... menu).
        // Avoids surfacing a dead-end error banner; the user can populate the
        // room manually instead. errorLayout state stays cleared so the banner
        // never renders for this room.
        setErrorLayout((prevState) => ({
          ...prevState,
          [roomId]: undefined,
        }));
        setErrorLayoutGlobal(false);
        setOpenFilters(false);
        setShowZonesMenu(false);
        userDismissedAddItemsRef.current = false;
        setIsAdding(true);
        setAddingFromSomethingElse(true);
        setManualToastDismissed(false);

        setLoadingLayout(false);

        setSelectedFurniture(null);
        setCopySelectedFurniture(null);
        setSelectedItem(null);

        setRoomsData((prevRoomsData) => {
          const newVertices = vertices?.vertices;

          const existingIndex = prevRoomsData.findIndex(
            (room) => vertices.roomId === room.roomId
          );
          clearFurniturePositions(existingIndex);

          if (existingIndex !== -1) {
            const newInnerArrays = Array.from(
              { length: 1 }, 
              () => []
            );

            setRoomActive(existingIndex);

            const updatedArray = [...roomItemsList];
            updatedArray[existingIndex] = newInnerArrays;

            const updatedlayoutIndex = [...roomActiveLayout];
            updatedlayoutIndex[existingIndex] = 0;
            setRoomActiveLayout(updatedlayoutIndex);

            const updatedKeepItems = [...keepItems];
            updatedKeepItems[existingIndex] = newInnerArrays;

            const updatedGlobalUndoFurniture = globalUndoFurniture.filter(
              (item) => item.roomId != existingIndex
            );
            setGlobalUndoFurniture(updatedGlobalUndoFurniture);

            const updatedGlobalRedoFurniture = globalRedoFurniture.filter(
              (item) => item.roomId != existingIndex
            );
            setGlobalRedoFurniture(updatedGlobalRedoFurniture);

           
            setRoomItemsList(updatedArray);

            setSeeItAnotherWay((prevState) => ({
              ...prevState,
              [existingIndex]: !prevState[existingIndex], 
            }));

            const updatedRoomsData = prevRoomsData?.map((room, index) => {
              if (index === existingIndex) {
                return {
                  ...room,
                  layouts: [],
                };
              }
              return room;
            });

            updatedRoomsData[existingIndex].layouts = [{ furniture: [] }];

            updatedRoomsData[existingIndex].doors = doors;
            updatedRoomsData[existingIndex].windows = windows;
            updatedRoomsData[existingIndex].scaleX = scaleFactorX;
            updatedRoomsData[existingIndex].scaleY = scaleFactorY;
            updatedRoomsData[existingIndex].centerY = stateCenterY;
            updatedRoomsData[existingIndex].centerX = stateCenterX;
            updatedRoomsData[existingIndex].payloadVertices = newVertices;
            updatedRoomsData[existingIndex].roomId = vertices.roomId;
            updatedRoomsData[existingIndex].orignalPayloadVertices =
              newVertices;

            updatedRoomsData[existingIndex].scaleXCanvas = scaleXCanvas;
            updatedRoomsData[existingIndex].scaleYCanvas = scaleYCanvas;

            updatedRoomsData[existingIndex].offsetX = offsetXCheck;
            updatedRoomsData[existingIndex].offsetY = offsetYCheck;
            updatedRoomsData[existingIndex].resultRoomVerticesState =
              resultRoomVerticesState;

            updatedRoomsData[existingIndex].zones = updatedZones;

            return updatedRoomsData;
          } else {
            const initializedItemsArray = Array.from(
              { length: 1 }, 
              () =>
                Array.from(
                  { length: 1 },
                  () => []
                )
            );

            const combinedArray = [...roomItemsList, ...initializedItemsArray];

            const combinedKeepItems = [...keepItems, ...initializedItemsArray];

            setRoomItemsList(combinedArray);
            setKeepItems(combinedKeepItems);
            setRoomActive(roomsData?.length);
            setRoomActiveLayout((prevActiveLayout) => [...prevActiveLayout, 0]);

            return [
              ...prevRoomsData,
              {
                layouts: [{ furniture: [] }],
                payloadVertices: newVertices,
                zones: updatedZones,
                orignalPayloadVertices: newVertices,
                doors: doors,
                windows: windows,
                scaleX: scaleFactorX,
                scaleY: scaleFactorY,
                centerX: stateCenterX,
                roomId: vertices?.roomId,
                centerY: stateCenterY,
                scaleXCanvas: scaleXCanvas,
                scaleYCanvas: scaleYCanvas,
                offsetX: offsetXCheck,
                offsetY: offsetYCheck,
                resultRoomVerticesState: resultRoomVerticesState,
              },
            ];
          }
        });

        return;
      }

      setErrorLayout((prevState) => ({
        ...prevState,
        [roomId]: false,
      }));

      setErrorLayoutGlobal(false);

      setSelectedFurniture(null);
      setCopySelectedFurniture(null);
      setSelectedItem(null);

      setLoadingLayout(false);

      setLayouts(response?.data?.result);

      setRoomsData((prevRoomsData) => {
        const newVertices = vertices?.vertices;

        const existingIndex = prevRoomsData.findIndex(
          (room) => vertices.roomId === room.roomId
        );

        clearFurniturePositions(existingIndex);

        if (existingIndex !== -1) {
          const priorLayoutsForUndo = JSON.parse(
            JSON.stringify(prevRoomsData[existingIndex]?.layouts || [])
          );
          const priorActiveLayoutForUndo = roomActiveLayout[existingIndex];

          const layouts =
            modifyRoomProperties(
              response?.data?.result,
              scaleFactorX,
              scaleFactorY
            ) || [];

          const newInnerArrays = layouts.map((layoutObj) => {
            const furnitureArray = layoutObj.furniture || [];
            return furnitureArray.map((furnitureItem) => ({
              ...furnitureItem,
              _id: `${furnitureItem._id}-1`, 
            }));
          });

          const updatedRoomItemsList = [...roomItemsList];
          updatedRoomItemsList[existingIndex] = newInnerArrays;

          setRoomItemsList(updatedRoomItemsList);

          const updatedlayoutIndex = [...roomActiveLayout];
          // On shuffle: skip index 0 (reserved/hidden) and show index 1 if the
          // API returned more than one layout. Fallback to 0 only if exactly
          // one option came back. The furniture-length guard was removed because
          // it caused mobile to silently fall back to 0 even when index 1 existed.
          const _startIdx = fromShuffle && layouts.length > 1 ? 1 : 0;
          updatedlayoutIndex[existingIndex] = _startIdx;
          setRoomActiveLayout(updatedlayoutIndex);

          const updatedKeepItems = [...keepItems];
          updatedKeepItems[existingIndex] = newInnerArrays;

          const filteredUndo = globalUndoFurniture.filter(
            (item) => item.roomId != existingIndex
          );
          const filteredRedo = globalRedoFurniture.filter(
            (item) => item.roomId != existingIndex
          );

          // Only toggle seeItAnotherWay if NOT called from shuffle
          // When shuffle triggers furnishRoom, we want to stay on the shuffle panel
          if (!fromShuffle) {
            setSeeItAnotherWay((prevState) => ({
              ...prevState,
              [existingIndex]: !prevState[existingIndex], 
            }));
          } else {
            console.log('[FURNISH ROOM] fromShuffle=true - keeping user on shuffle panel (seeItAnotherWay unchanged)');
          }

          const updatedRoomsData = prevRoomsData?.map((room, index) => {
            if (index === existingIndex) {
              return {
                ...room,
                layouts: (
                  modifyRoomProperties(
                    response?.data?.result,
                    scaleFactorX,
                    scaleFactorY
                  ) || []
                ).map((layout) => {
                  const furnitureArray = layout.furniture || [];

                  const updatedFurniture = furnitureArray.map(
                    (furnitureItem) => ({
                      ...furnitureItem,
                      _id: `${furnitureItem._id}-1`, 
                    })
                  );

                  return {
                    ...layout,
                    furniture: updatedFurniture,
                  };
                }),
              };
            }
            return room; 
          });

          updatedRoomsData[existingIndex].doors = doors;
          updatedRoomsData[existingIndex].windows = windows;
          updatedRoomsData[existingIndex].scaleX = scaleFactorX;
          updatedRoomsData[existingIndex].scaleY = scaleFactorY;
          updatedRoomsData[existingIndex].centerY = stateCenterY;
          updatedRoomsData[existingIndex].centerX = stateCenterX;
          updatedRoomsData[existingIndex].payloadVertices = newVertices;
          updatedRoomsData[existingIndex].roomId = vertices.roomId;
          updatedRoomsData[existingIndex].orignalPayloadVertices = newVertices;
          updatedRoomsData[existingIndex].scaleXCanvas = scaleXCanvas;
          updatedRoomsData[existingIndex].scaleYCanvas = scaleYCanvas;
          updatedRoomsData[existingIndex].offsetX = offsetXCheck;
          updatedRoomsData[existingIndex].offsetY = offsetYCheck;

          updatedRoomsData[existingIndex].resultRoomVerticesState =
            resultRoomVerticesState;

          updatedRoomsData[existingIndex].scaleXCanvas = scaleXCanvas;
          updatedRoomsData[existingIndex].scaleYCanvas = scaleYCanvas;

          updatedRoomsData[existingIndex].offsetX = offsetXCheck;
          updatedRoomsData[existingIndex].offsetY = offsetYCheck;

          updatedRoomsData[existingIndex].resultRoomVerticesState =
            resultRoomVerticesState;

          updatedRoomsData[existingIndex].zones = updatedZones;

          // Replacing all layouts (shuffle / Make Magic) used to wipe per-room
          // undo entries without capturing the prior room, so manual adds were
          // lost. Push one snapshot that restores full layouts + active index.
          const nextLayoutsForUndo = JSON.parse(
            JSON.stringify(updatedRoomsData[existingIndex]?.layouts || [])
          );
          setGlobalUndoFurniture([
            ...filteredUndo,
            {
              roomId: existingIndex,
              type: "change",
              replaceEntireLayouts: true,
              layouts: JSON.stringify(priorLayoutsForUndo),
              redoLayouts: JSON.stringify(nextLayoutsForUndo),
              priorActiveLayout: priorActiveLayoutForUndo,
              nextActiveLayout: _startIdx,
            },
          ]);
          setGlobalRedoFurniture(filteredRedo);

          return updatedRoomsData;
        } else {

          const layouts =
            modifyRoomProperties(
              response?.data?.result,
              scaleFactorX,
              scaleFactorY
            ) || [];

          const initializedItemsArray = Array.from({ length: 1 }, () =>
            layouts?.map((layout) =>
              (layout?.furniture || []).map((furnitureItem) => ({
                ...furnitureItem,
                _id: `${furnitureItem._id}-1`, 
              }))
            )
          );

          const combinedArray = [...roomItemsList, ...initializedItemsArray];

          setRoomItemsList(combinedArray);
          setRoomActive(roomsData?.length);
          // On shuffle: skip index 0 (reserved/hidden); fallback to 0 if only one option.
          const _startIdxNew = fromShuffle && layouts.length > 1 ? 1 : 0;
          setRoomActiveLayout((prevActiveLayout) => [...prevActiveLayout, _startIdxNew]);

          return [
            ...prevRoomsData,
            {
              layouts: (
                modifyRoomProperties(
                  response?.data?.result,
                  scaleFactorX,
                  scaleFactorY
                ) || []
              ).map((layout) => {
                const furnitureArray = layout.furniture || [];

                const updatedFurniture = furnitureArray.map(
                  (furnitureItem) => ({
                    ...furnitureItem,
                    _id: `${furnitureItem._id}-1`,
                  })
                );

                return {
                  ...layout,
                  furniture: updatedFurniture,
                };
              }),
              payloadVertices: newVertices,
              doors: doors,
              windows: windows,
              scaleX: scaleFactorX,
              scaleY: scaleFactorY,
              centerX: stateCenterX,
              roomId: vertices?.roomId,
              centerY: stateCenterY,
              orignalPayloadVertices: newVertices,
              scaleXCanvas: scaleXCanvas,
              scaleYCanvas: scaleYCanvas,
              offsetX: offsetXCheck,
              offsetY: offsetYCheck,
              zones: updatedZones,
              resultRoomVerticesState: resultRoomVerticesState,
            },
          ];
        }
      });


    } catch (error) {
      if (fromShuffle) {
        // LAUNCH-BLOCKING FIX: a shuffle must NEVER wipe the room or force the
        // manual Add Items panel. If regeneration fails for any reason, keep
        // the current furniture in place and just stop the loader (mirrors the
        // 204 "no new layout" handling above). The destructive fall-through
        // below is reserved for explicit Make Magic / manual requests.
        setLoadingLayout(false);
        setErrorLayoutGlobal(false);
        setErrorLayout((prevState) => ({
          ...prevState,
          [roomId]: false,
        }));
        return;
      }
      if (error.message === "canceled" && !didTimeout) {
        setLayouts(["No Layout"]);

        setErrorLayout((prevState) => ({
          ...prevState,
          [roomId]: false,
        }));

        setErrorLayoutGlobal(false);

        setLoadingLayout(false);

        setSelectedFurniture(null);
        setCopySelectedFurniture(null);
        setSelectedItem(null);

        return;
      } else {
        setLayouts(["No Layout"]);

        // "No Magic Found" (API failure path) → fall back to Add Items modal
        // rather than showing a dead-end error banner. Mirrors the 204 path
        // above and the "Something Else" zone picker behaviour. Keep the rest
        // of the catch-block bookkeeping (setLayouts / clearing selection /
        // setRoomsData below) so room state stays consistent.
        setErrorLayout((prevState) => ({
          ...prevState,
          [roomId]: undefined,
        }));
        setErrorLayoutGlobal(false);
        setOpenFilters(false);
        setShowZonesMenu(false);
        userDismissedAddItemsRef.current = false;
        setIsAdding(true);
        setAddingFromSomethingElse(true);
        setManualToastDismissed(false);

        setLoadingLayout(false);

        setSelectedFurniture(null);
        setCopySelectedFurniture(null);
        setSelectedItem(null);
      }

      setRoomsData((prevRoomsData) => {
        const newVertices = vertices?.vertices;

        const existingIndex = prevRoomsData.findIndex(
          (room) => vertices.roomId === room.roomId
        );

        clearFurniturePositions(existingIndex);

        if (existingIndex !== -1) {
          const newInnerArrays = Array.from(
            { length: 1 },
            () => []
          );

          setRoomActive(existingIndex);

          const updatedArray = [...roomItemsList];
          updatedArray[existingIndex] = newInnerArrays;

          const updatedlayoutIndex = [...roomActiveLayout];
          updatedlayoutIndex[existingIndex] = 0;
          setRoomActiveLayout(updatedlayoutIndex);

          const updatedKeepItems = [...keepItems];
          updatedKeepItems[existingIndex] = newInnerArrays;

          const updatedGlobalUndoFurniture = globalUndoFurniture.filter(
            (item) => item.roomId != existingIndex
          );
          setGlobalUndoFurniture(updatedGlobalUndoFurniture);

          const updatedGlobalRedoFurniture = globalRedoFurniture.filter(
            (item) => item.roomId != existingIndex
          );

          setGlobalRedoFurniture(updatedGlobalRedoFurniture);

          setRoomItemsList(updatedArray);

          setSeeItAnotherWay((prevState) => ({
            ...prevState,
            [existingIndex]: !prevState[existingIndex],
          }));

          const updatedRoomsData = prevRoomsData?.map((room, index) => {
            if (index === existingIndex) {
              return {
                ...room,
                layouts: [],
              };
            }
            return room; 
          });

          updatedRoomsData[existingIndex].layouts = [{ furniture: [] }];

          updatedRoomsData[existingIndex].doors = doors;
          updatedRoomsData[existingIndex].windows = windows;
          updatedRoomsData[existingIndex].scaleX = scaleFactorX;
          updatedRoomsData[existingIndex].scaleY = scaleFactorY;
          updatedRoomsData[existingIndex].centerY = stateCenterY;
          updatedRoomsData[existingIndex].centerX = stateCenterX;
          updatedRoomsData[existingIndex].payloadVertices = newVertices;
          updatedRoomsData[existingIndex].roomId = vertices.roomId;
          updatedRoomsData[existingIndex].orignalPayloadVertices = newVertices;
          updatedRoomsData[existingIndex].scaleXCanvas = scaleXCanvas;
          updatedRoomsData[existingIndex].scaleYCanvas = scaleYCanvas;
          updatedRoomsData[existingIndex].offsetX = offsetXCheck;
          updatedRoomsData[existingIndex].offsetY = offsetYCheck;
          updatedRoomsData[existingIndex].zones = updatedZones;

          updatedRoomsData[existingIndex].resultRoomVerticesState =
            resultRoomVerticesState;

          return updatedRoomsData;
        } else {
          const initializedItemsArray = Array.from(
            { length: 1 },
            () =>
              Array.from(
                { length: 1 }, 
                () => []
              )
          );
         
          const combinedArray = [...roomItemsList, ...initializedItemsArray];

          setRoomItemsList(combinedArray);
          setRoomActive(roomsData?.length);
          setRoomActiveLayout((prevActiveLayout) => [...prevActiveLayout, 0]);

          return [
            ...prevRoomsData,
            {
              layouts: [{ furniture: [] }],
              payloadVertices: newVertices,
              doors: doors,
              windows: windows,
              scaleX: scaleFactorX,
              scaleY: scaleFactorY,
              centerX: stateCenterX,
              roomId: vertices?.roomId,
              centerY: stateCenterY,
              orignalPayloadVertices: newVertices,
              scaleXCanvas: scaleXCanvas,
              scaleYCanvas: scaleYCanvas,
              offsetX: offsetXCheck,
              offsetY: offsetYCheck,
              zones: updatedZones,
              resultRoomVerticesState: resultRoomVerticesState,
            },
          ];
        }
      });

    } finally {
      setRoomsData((prevRoomsData) => {
        const existingRoomIndex = prevRoomsData.findIndex(
          (room) => room.roomId === "custom-room"
        );

        if (existingRoomIndex !== -1) {
          setRoomActiveLayout((prevActiveLayout) => {
            if (prevActiveLayout[existingRoomIndex] !== undefined) {
              return prevActiveLayout;
            }

            const newLayout = [...prevActiveLayout];
            newLayout[existingRoomIndex] = 0;
            return newLayout;
          });

          return prevRoomsData;
        } else {
          setRoomItemsList((prevRoomItemsList) => {
            const initializedItemsArray = Array.from({ length: 1 }, () =>
              Array.from({ length: 1 }, () => [])
            );

            const combinedArray = [
              ...prevRoomItemsList,
              ...initializedItemsArray,
            ];
            return combinedArray;
          });

          const newCustomRoom = {
            layouts: [
              {
                room: {
                  width: 124,
                  height: 214,
                  shape: "box-shape",
                  zone: [
                    {
                      value: "workingvanity",
                      capacity: 1,
                    },
                  ],
                  position: {
                    x: 0,
                    y: 0,
                    z: 0,
                  },
                },
                doors: [],
                windows: [],
                furniture: [],
                vertices: [],
                prompt: "",
              },
            ],
            payloadVertices: [],
            doors: [],
            windows: [],
            scaleX: scaleFactorX,
            scaleY: scaleFactorY,
            centerX: 1500,
            centerY: divHeight / 2,
            roomId: "custom-room",
            orignalPayloadVertices: [],
            scaleXCanvas: scaleXCanvas,
            scaleYCanvas: scaleYCanvas,
            offsetX: offsetXCheck,
            offsetY: offsetYCheck,
            zones: [{ value: "custom", label: "Custom Room" }],
            resultRoomVerticesState: {},
          };

          const newIndex = prevRoomsData.length;

          setRoomActiveLayout((prevActiveLayout) => {
            const newLayout = [...prevActiveLayout];
            newLayout[newIndex] = 0;
            return newLayout;
          });

          return [...prevRoomsData, newCustomRoom];
        }
      });

      clearTimeout(timeoutId);
      setViewLayouts(true);
    }
  };

  // Assign furnishRoom to ref to avoid initialization order issues
  furnishRoomRef.current = furnishRoom;

  const handleCancelRequest = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null; 
    }
  };

  const getBase64Image = async (url) => {
    try {
      if (!url) {
        console.warn("getBase64Image: No URL provided");
        return null;
      }

      const response = await fetch(url);
      
      if (!response.ok) {
        console.error(`Error fetching image: ${response.status} ${response.statusText} for URL: ${url}`);
        return null;
      }

      const blob = await response.blob();
      
      // Check if the MIME type is correct, or if the URL suggests an image file, or if it's from S3
      const isImageMimeType = blob.type.startsWith('image/');
      const hasImageExtension = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url);
      const isS3Url = url.includes('s3.') || url.includes('amazonaws.com');
      
      // For S3 URLs, be more lenient as they often have incorrect MIME types
      if (!isImageMimeType && !hasImageExtension && !isS3Url) {
        console.error(`Error: Expected image, got ${blob.type} for URL: ${url}`);
        return null;
      }
      
      // Log warnings for debugging but continue processing
      if (!isImageMimeType) {
        if (isS3Url) {
          console.warn(`Warning: S3 returned MIME type ${blob.type} instead of image type for URL: ${url}. Proceeding anyway.`);
        } else if (hasImageExtension) {
          console.warn(`Warning: Incorrect MIME type ${blob.type} for image URL: ${url}. Proceeding anyway.`);
        }
      }

      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => {
          console.error("FileReader error:", error);
          reject(error);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching image:", error, "URL:", url);
      return null;
    }
  };

  const downloadLayout = async (type = 1) => {
    const capDiag =
      type === 2 ? galleryCaptureDiagSessionRef.current : null;
    if (type === 2) {
      galleryCaptureDiagSessionRef.current = null;
    }
    const tDiagEnter = type === 2 ? performance.now() : 0;

    const element = document.querySelector(".image-container");

    if (type === 2) {
      mfLogGalleryCaptureDiag("downloadLayout.enter", {
        capDiag,
        elementFound: !!element,
        ...fingerprintGuestForkDomDeep(),
        editorPack: guestForkEditorDiagRef.current,
        imageDimensionsSnapshot: {
          orgWidth: imageDimensions.orgWidth,
          orgHeight: imageDimensions.orgHeight,
        },
      });
    }

    if (!element) {
      if (type === 2) {
        mfLogGalleryCaptureDiag("downloadLayout.abortedNoElement", { capDiag });
      }
      return;
    }

    // Only log a user-initiated export (type === 1 / default).
    // type === 2 is used internally for blob generation during saves,
    // layout duplication, and gallery image updates — not a real download.
    if (type === 1) {
      eventLog(targetWindow, 'floor_plan_event', 'download_layout', {
        galleryId: layoutData?.uuid || layoutData?._id,
        galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
      });
    }

    const clone = document.createElement("div");

    const imageElement = element.cloneNode(true);

    // Capture geometry. The base plan renders as width:100%/height:100% of a
    // container chain that bottoms out at imageElement's explicit pixel size.
    // If imageDimensions.orgWidth/orgHeight are empty/0/NaN (the initial state,
    // or any flow where they weren't re-derived), that chain collapses to zero
    // and the base plan disappears entirely while the absolutely-positioned
    // furniture still paints — the "only the item I added shows" bug. Derive a
    // reliable size from the live, decoded base-plan image (or the live
    // element's rendered rect) whenever the state dimensions are invalid.
    const liveBasePlan = element.querySelector("img.image-shapes");
    let newWidth = imageDimensions.orgWidth;
    let newHeight = imageDimensions.orgHeight;
    const orgDimsValid =
      Number.isFinite(newWidth) &&
      newWidth > 0 &&
      Number.isFinite(newHeight) &&
      newHeight > 0;
    if (!orgDimsValid) {
      const liveRect = element.getBoundingClientRect();
      newWidth =
        (liveBasePlan && liveBasePlan.naturalWidth) ||
        Math.round(liveRect.width) ||
        0;
      newHeight =
        (liveBasePlan && liveBasePlan.naturalHeight) ||
        Math.round(liveRect.height) ||
        0;
    }

    imageElement.style.width = `${newWidth}px`;
    imageElement.style.height = `${newHeight}px`;

    imageElement.style.transformOrigin = "top left";

    // Belt-and-suspenders: pin the base-plan container AND the base-plan image
    // to explicit pixels so no percentage/flex resolution quirk in the detached
    // clone can collapse them to zero. This guarantees the floor plan is always
    // rasterized at full size regardless of how the clone's layout resolves.
    const cloneBasePlanHost = imageElement.querySelector("#image-container-1");
    if (cloneBasePlanHost) {
      cloneBasePlanHost.style.width = `${newWidth}px`;
      cloneBasePlanHost.style.height = `${newHeight}px`;
    }
    const cloneBasePlanImg = imageElement.querySelector("img.image-shapes");
    if (cloneBasePlanImg) {
      cloneBasePlanImg.style.width = `${newWidth}px`;
      cloneBasePlanImg.style.height = `${newHeight}px`;
      cloneBasePlanImg.style.objectFit = "contain";
    }

    // Strip CSS animations and transitions from every element in the clone.
    // dom-to-image re-renders cloned nodes as fresh DOM, which restarts any
    // CSS animation from its first keyframe (opacity: 0 for furnitureFadeIn).
    // Without this, furniture items captured mid-animation appear translucent
    // in the gallery blob and downloaded image even though the editor looks fine.
    imageElement.querySelectorAll("*").forEach((el) => {
      el.style.animation = "none";
      el.style.animationDuration = "0s";
      el.style.transition = "none";
    });

    clone.style.position = "absolute";
    clone.style.top = "-9999px";

    clone.style.left = "-9999px";
    clone.style.backgroundColor = "white";

    document.body.appendChild(clone);

    const boxes = imageElement.querySelectorAll(".box");
    boxes.forEach((box) => box.remove());
    const shapes = imageElement.querySelectorAll(".shape");
    shapes.forEach((shape) => shape.remove());

    const boundaries = imageElement.querySelectorAll(".boundary");
    boundaries.forEach((boundary) => boundary.remove());

    const rects = imageElement.querySelectorAll(".rect-box rect");

    rects.forEach((rect) => {
      const x = parseFloat(rect.getAttribute("x"));
      const y = parseFloat(rect.getAttribute("y"));
      const width = parseFloat(rect.getAttribute("width"));
      const height = parseFloat(rect.getAttribute("height"));

      const normalizedX = (x - offsetXCheck + 1) / scaleXCanvas;
      const normalizedY = (y - offsetYCheck + 1) / scaleYCanvas;
      const normalizedWidth = (width - 2) / scaleXCanvas;
      const normalizedHeight = (height - 2) / scaleYCanvas;

      const adjustedX =
        normalizedX * scaleXCalculateCanvas + offsetXCalculateCheck;
      const adjustedY =
        normalizedY * scaleYCalculateCanvas + offsetYCalculateCheck;
      const adjustedWidth = normalizedWidth * scaleXCalculateCanvas;
      const adjustedHeight = normalizedHeight * scaleYCalculateCanvas;

      rect.setAttribute("x", adjustedX);
      rect.setAttribute("y", adjustedY);
      rect.setAttribute("width", adjustedWidth);
      rect.setAttribute("height", adjustedHeight);
    });

    const imageBoundaries = imageElement.querySelectorAll(".image-boundary");

    imageBoundaries.forEach((boundary) => {
      boundary.style.outline = "none";
      // FORCE FULL OPACITY
      boundary.style.opacity = "1";
      boundary.style.filter = "none"; // In case a CSS filter is used

      // Parse all values from element ID
      // ID structure: CenterSetX/CenterSetY/roomId/posX/posY/width/height/scaleX/scaleY/exactPosX/exactPosY/newlyAdded/calculateWidth
      const idParts = boundary.getAttribute("id")?.split("/") || [];
      
      // FIX: Read CenterSetX/Y from element ID (indices 0,1) instead of recalculating
      // This ensures thumbnail uses the EXACT same center as the Editor rendering
      const storedCenterX = parseFloat(idParts[0]);
      const storedCenterY = parseFloat(idParts[1]);
      
      const roomId = idParts[2]; 
      const positionX = parseFloat(idParts[3]); 
      const positionY = parseFloat(idParts[4]); 
      const widthValue = parseFloat(idParts[5]); 
      const heightValue = parseFloat(idParts[6]); 
      const roomScaleX = parseFloat(idParts[7]); 
      const roomScaleY = parseFloat(idParts[8]); 

      const exactPositionX = parseFloat(idParts[9]); 
      const exactPositionY = parseFloat(idParts[10]); 

      const idPart = idParts[11];
      
      const calculateWidth = parseFloat(idParts[12]);

      // eslint-disable-next-line no-unused-vars
      const newlyAdded = idPart && idPart !== "false";

      const verticesCheck = transformWalls(
        modalData?.find((item) => item.room_id === roomId)?.walls || []
      );

      // eslint-disable-next-line no-unused-vars
      const adjustedVertices = adjustVertices(
        verticesCheck,
        offsetXCalculateCheck,
        offsetYCalculateCheck,
        scaleXCalculateCanvas,
        scaleYCalculateCanvas
      );

      // Convert viewport room center → canonical (image pixel space).
      // storedCenterX is the editor's VIEWPORT center. The thumbnail renders at
      // native image dimensions where canonical pixels = image pixels.
      // Furniture size/offset from exactPos/sfx is already in canonical pixels.
      // Only the CENTER needs conversion from viewport → canonical.
      const centerOriX = (Number.isFinite(storedCenterX) && storedCenterX > 0 && scaleXCanvas > 0)
        ? (storedCenterX - offsetXCheck) / scaleXCanvas
        : imageDimensions.orgWidth / 2;
      const centerOriY = (Number.isFinite(storedCenterY) && storedCenterY > 0 && scaleYCanvas > 0)
        ? (storedCenterY - offsetYCheck) / scaleYCanvas
        : imageDimensions.orgHeight / 2;

      // Canonical furniture offset from room center (same as production formula)
      // Use scaleFactorX/Y (same as editor's handleUpdate) instead of calculateScaleFactorX/Y
      // calculateScaleFactorY can be stuck at 1.0 (default), causing wrong height
      const thumbSfx = scaleFactorX || calculateScaleFactorX || 1;
      const thumbSfy = scaleFactorY || calculateScaleFactorY || 1;

      const positionLeftX = exactPositionX
        ? exactPositionX / thumbSfx
        : calculateWidth ? positionX / (thumbSfx / roomScaleX) : positionX / thumbSfx;

      const positionTopY = exactPositionY
        ? exactPositionY / thumbSfy
        : calculateWidth ? positionY / (thumbSfy / roomScaleY) : positionY / thumbSfy;

      // Position in canonical/image pixels (no extra scaling needed)
      const newLeft = centerOriX + positionLeftX - widthValue / thumbSfx / 2;
      const newTop = centerOriY - positionTopY - heightValue / thumbSfy / 2;
      const idBoxW = widthValue / thumbSfx;
      const idBoxH = heightValue / thumbSfy;

      // The id-path above re-derives geometry from canonical metadata
      // (exactPosition / origionalPosition / scaleFactor). Freshly-shuffled
      // furniture doesn't have those canonical fields populated until a
      // save+reload normalizes them (e.g. a gallery round-trip), so the math
      // either yields NaN OR a stale-but-finite value that places the item
      // entirely OUTSIDE the captured frame (or collapses it to zero size).
      // Either way the item vanishes from the capture even though it renders
      // correctly in the editor — this is the "some items absent from the
      // preview" bug. When the canonical geometry is missing/unusable OR would
      // drop the item off-frame, fall back to the geometry React ACTUALLY
      // rendered — the cloned boundary's viewport left/top/width/height —
      // converted viewport → canonical exactly like the room center (subtract
      // offset, divide by scale). That is what the user sees, so it is always
      // correct regardless of metadata.
      //
      // PRESENCE-ONLY guard: we intervene solely when the canonical box would
      // make the item disappear (NaN, off-frame, or zero size). Items whose
      // canonical box already lands on the plan keep the exact canonical
      // geometry, so every currently-correct capture — including the gallery's
      // Done capture — is byte-for-byte unchanged. This never nudges a visible
      // item; it only rescues an invisible one.
      const idTrusted =
        Number.isFinite(exactPositionX) &&
        Number.isFinite(exactPositionY) &&
        Number.isFinite(newLeft) &&
        Number.isFinite(newTop) &&
        Number.isFinite(idBoxW) &&
        Number.isFinite(idBoxH);

      // Frame (base-plan) bounds in canonical/image pixels. newWidth/newHeight
      // are the exact size the base plan is rasterized at (see top of
      // downloadLayout), so furniture positioned outside [0..W, 0..H] is off
      // the captured image.
      const frameW =
        Number.isFinite(newWidth) && newWidth > 0
          ? newWidth
          : imageDimensions?.orgWidth;
      const frameH =
        Number.isFinite(newHeight) && newHeight > 0
          ? newHeight
          : imageDimensions?.orgHeight;
      const canonOffFrame =
        !Number.isFinite(frameW) ||
        !Number.isFinite(frameH) ||
        newLeft + idBoxW <= 0 ||
        newTop + idBoxH <= 0 ||
        newLeft >= frameW ||
        newTop >= frameH;
      const canonZeroSize = !(idBoxW >= 1) || !(idBoxH >= 1);

      // Rescue only when the canonical path would drop the item.
      const needsRescue = !idTrusted || canonOffFrame || canonZeroSize;

      let finalLeft = newLeft;
      let finalTop = newTop;
      let finalW = idBoxW;
      let finalH = idBoxH;
      let usedLiveGeometry = false;

      if (needsRescue && scaleXCanvas > 0 && scaleYCanvas > 0) {
        const vpLeft = parseFloat(boundary.style.left);
        const vpTop = parseFloat(boundary.style.top);
        const vpW = parseFloat(boundary.style.width);
        const vpH = parseFloat(boundary.style.height);
        const liveLeft = (vpLeft - offsetXCheck) / scaleXCanvas;
        const liveTop = (vpTop - offsetYCheck) / scaleYCanvas;
        const liveW = vpW / scaleXCanvas;
        const liveH = vpH / scaleYCanvas;
        const liveFinite =
          Number.isFinite(liveLeft) &&
          Number.isFinite(liveTop) &&
          Number.isFinite(liveW) &&
          Number.isFinite(liveH);
        // The rescued box must itself be a real, on-frame box, otherwise we'd
        // trade one invisible position for another. For NaN canonical metadata
        // we keep the original (1502) behavior of adopting any finite live
        // geometry so the freshly-shuffled fix is preserved exactly.
        const liveOnFrame =
          liveFinite &&
          liveW >= 1 &&
          liveH >= 1 &&
          Number.isFinite(frameW) &&
          Number.isFinite(frameH) &&
          liveLeft + liveW > 0 &&
          liveTop + liveH > 0 &&
          liveLeft < frameW &&
          liveTop < frameH;
        const adopt = !idTrusted ? liveFinite : liveOnFrame;
        if (adopt) {
          finalLeft = liveLeft;
          finalTop = liveTop;
          finalW = liveW;
          finalH = liveH;
          usedLiveGeometry = true;
        }
      }

      boundary.style.left = `${finalLeft}px`;
      boundary.style.top = `${finalTop}px`;
      boundary.style.width = `${finalW}px`;
      boundary.style.height = `${finalH}px`;

      // For live-geometry items the box is the exact rendered box scaled to
      // native, so the inner furniture image must simply fill it — the id-keyed
      // svg-image resize below relies on canonical metadata this item lacks.
      // An inline width/height:100% overrides that presentational-attribute
      // resize, so the base64 conversion there still runs harmlessly.
      if (usedLiveGeometry) {
        const innerImg = boundary.querySelector("img.svg-image");
        if (innerImg) {
          innerImg.style.width = "100%";
          innerImg.style.height = "100%";
        }
      }
    });

    const svgImages = imageElement.querySelectorAll("img.svg-image");

    // Resolve logo availability before the conversion loop so the marginTop
    // guard below (which offsets furniture to make room for the header) can
    // also be skipped when there is no logo and therefore no header.
    const tenantConfig = getTenantConfig();
    const hasLogo = (userData?.logo?.length > 0) || !!tenantConfig.logo;

    const conversionPromises = Array.from(svgImages).map(async (img) => {
      img.style.opacity = "1"; // Ensure the image itself isn't translucent
      const base64Data = await convertToBase64(img.src);
      img.src = base64Data;

      const widthValue = parseFloat(img.getAttribute("id")?.split("/")[0]);
      const heightValue = parseFloat(img.getAttribute("id")?.split("/")[1]);

      // Size SVG images to match parent boundary (use scaleFactorX/Y, same as boundary)
      const imgSfx = scaleFactorX || calculateScaleFactorX || 1;
      const imgSfy = scaleFactorY || calculateScaleFactorY || 1;
      img.setAttribute("width", widthValue / imgSfx);
      img.setAttribute("height", heightValue / imgSfy);

      if (isUserDataSuccess && userData && type !== 2 && hasLogo) {
        const parentElement = img.parentElement;
        if (parentElement) parentElement.style.marginTop = "120px";
      }
    });

    await Promise.all(conversionPromises);

    const aspectRatio = newWidth / newHeight;

    const renderedWidth = Math.min(newWidth, newHeight * aspectRatio);

    const headerDiv = document.createElement("div");
    headerDiv.style.width = `100%`;

    headerDiv.style.height = "120px";
    headerDiv.style.display = "flex";
    headerDiv.style.justifyContent = "space-between";
    headerDiv.style.alignItems = "center";
    headerDiv.style.backgroundColor = "#fff";
    headerDiv.style.padding = "0px 10px";
    headerDiv.style.boxSizing = "border-box";

    const leftDiv = document.createElement("div");
    leftDiv.style.display = "flex";
    leftDiv.style.alignItems = "center";

    const logoImage = document.createElement("img");
    logoImage.src = userData?.logo ? (await getBase64Image(userData.logo)) || "/logo.png" : "/logo.png";
    logoImage.style.width = "100px";
    logoImage.style.height = "100px";
    logoImage.style.objectFit = "contain";

    if (userData?.logo?.length == 0 && tenantConfig.logo) {
      logoImage.src = tenantConfig.logo;
    }

    if (hasLogo) {
      leftDiv.appendChild(logoImage);
    }

    const rightText = document.createElement("div");
    rightText.textContent = layoutData?.name || "";
    rightText.style.fontSize = "18px";
    rightText.style.color = "#555";
    rightText.style.fontFamily = "Montserrat, sans-serif";

    if (isUserDataSuccess && userData && type !== 2 && hasLogo) {
      headerDiv.appendChild(leftDiv);
      headerDiv.appendChild(rightText);
      clone.appendChild(headerDiv);
    }

    clone.appendChild(imageElement);
    const footerDiv = document.createElement("div");
    footerDiv.style.width = `${renderedWidth}px`;
    footerDiv.style.height = "fit-content";
    footerDiv.style.display = "flex";
    footerDiv.style.justifyContent = "center";
    footerDiv.style.alignItems = "center";
    footerDiv.style.backgroundColor = "#fff";
    footerDiv.style.fontSize = "14px";
    footerDiv.style.color = "#888";
    footerDiv.style.padding = "0px 10px";
    footerDiv.style.margin = "20px 0px";

    const disclaimerText = document.createElement("div");
    disclaimerText.textContent = userData?.disclaimer || "";

    if (isUserDataSuccess && userData && type !== 2) {
      footerDiv.appendChild(disclaimerText);
      clone.appendChild(footerDiv);
    }

    const scaleFactor = 4;
    const maxSize = 4096; 

    let width = clone.offsetWidth * scaleFactor;
    let height = clone.offsetHeight * scaleFactor;

    console.log('[DOWNLOAD-DEBUG] type:', type);
    console.log('[DOWNLOAD-DEBUG] imageDimensions:', JSON.stringify(imageDimensions));
    console.log('[DOWNLOAD-DEBUG] clone.offsetWidth:', clone.offsetWidth, 'clone.offsetHeight:', clone.offsetHeight);
    console.log('[DOWNLOAD-DEBUG] imageElement size:', imageElement.style.width, 'x', imageElement.style.height);
    console.log('[DOWNLOAD-DEBUG] imageElement children:', imageElement.childElementCount);
    console.log('[DOWNLOAD-DEBUG] .image-boundary count:', imageElement.querySelectorAll('.image-boundary').length);
    console.log('[DOWNLOAD-DEBUG] render width:', width, 'height:', height);

    const ratioW = maxSize / width;
    const ratioH = maxSize / height;
    const safeRatio = Math.min(ratioW, ratioH, 1); 

    width = width * safeRatio;
    height = height * safeRatio;

    if (type === 2) {
      mfLogGalleryCaptureDiag("downloadLayout.cloneMetrics", {
        capDiag,
        cloneOffsetW: clone.offsetWidth,
        cloneOffsetH: clone.offsetHeight,
        imageElBoundaryCount: imageElement.querySelectorAll(".image-boundary")
          .length,
        svgImageCount: imageElement.querySelectorAll("img.svg-image").length,
        renderWidth: width,
        renderHeight: height,
        safeRatio,
        scaleFactorDomtoimage: scaleFactor,
      });
    }


    try {
      const domtoImageOptions = {
        quality: 1,
        width,
        height,
        style: {
          transform: `scale(${safeRatio * scaleFactor})`,
          transformOrigin: "top left",
        },
        skipFonts: true,
        imagePlaceholder: undefined,
        cacheBust: false,
        filter: (node) => {
          // Skip external stylesheets that cause CORS issues
          if (node.nodeName === 'LINK' && node.rel === 'stylesheet') {
            const href = node.href || '';
            if (href.includes('googleapis.com') || href.includes('gstatic.com')) {
              return false;
            }
          }
          // Skip style tags that might have @import rules for external fonts
          if (node.nodeName === 'STYLE' && node.innerHTML) {
            if (node.innerHTML.includes('@import') && 
                (node.innerHTML.includes('googleapis.com') || node.innerHTML.includes('gstatic.com'))) {
              return false;
            }
          }
          return true;
        },
        cssFetch: (url) => {
          // Prevent fetching external CSS that would cause CORS errors
          if (url.includes('googleapis.com') || url.includes('gstatic.com') || url.includes('fonts.')) {
            return Promise.resolve('');
          }
          // For local CSS, use default fetch
          return fetch(url).then(response => response.text()).catch(() => '');
        }
      };

      // ⚠️ DO NOT DELETE THIS toJpeg CALL ⚠️
      //
      // This line LOOKS redundant — its result is discarded — but removing
      // it (commit 6112e3f6, "perf: instant editor-to-gallery transition")
      // is what broke the captured image on staging. Restored here.
      //
      // dom-to-image-more's pipeline (clone → inline CSS → resolve <img>
      // sources → decode → render) runs once per call. The first call
      // synchronously settles the cloned subtree:
      //   * every <img>.src inside the clone resolves and decodes (the
      //     decoded bitmap stays in browser memory);
      //   * every inlined stylesheet rule is applied;
      //   * any pending layout/paint inside the clone is forced.
      // The second call (toBlob below) then runs on a fully-warmed clone
      // and produces a complete JPEG — no half-decoded rugs, no missing
      // late-rendering furniture <img>s, no race with the share modal's
      // MUI fade-in animation.
      //
      // Without this pre-pass, the single toBlob call captures whatever
      // paint state happens to exist at the instant it fires. The 5 KB
      // blank-blob guard in callers does NOT detect partial captures
      // (they routinely exceed 5 KB), so the user silently receives a
      // JPEG missing rugs / furniture / etc. — exactly the regression
      // that hit Done → gallery, Duplicate → gallery, and Share →
      // Download to browser on staging.
      //
      // The doubled DOM-to-image work is bounded (a few hundred ms at
      // worst on a typical layout) and well within tolerance for these
      // user-initiated flows. Correctness over throughput.
      //
      // Capture now runs through the shared rasterizeNode() engine
      // (utils/captureNode) so the editor, gallery, and branded flyer all
      // raster through ONE hardened path. Before capturing we deterministically
      // decode every <img> in the clone (decodeAllImages) instead of trusting
      // the warm-up pass alone to settle late-decoding rasters — the root cause
      // of the "base plan missing / furniture only" partial capture.
      await decodeAllImages(clone);

      // Structural integrity gate: the base floor plan MUST be present and
      // decoded. A partial capture (furniture but no base plan) clears the old
      // byte-size guard easily, so it used to ship silently. Retry the decode
      // once, then fail hard so callers fall back / arm a loader rather than
      // emit a broken image.
      //
      // Deliberately conservative to avoid false negatives: we only treat the
      // base plan as broken when the node is absent, not fully loaded, OR has
      // zero intrinsic size on BOTH axes (i.e. truly unrendered). A valid
      // raster or a vector/SVG plan with any intrinsic dimension passes.
      const basePlanBroken = (n) =>
        !n || !n.complete || (n.naturalWidth === 0 && n.naturalHeight === 0);
      const basePlanNode = imageElement.querySelector("img.image-shapes");
      if (basePlanBroken(basePlanNode)) {
        await decodeAllImages(clone);
      }
      if (basePlanBroken(basePlanNode)) {
        throw new Error(
          "downloadLayout: base plan missing/undecoded — refusing partial capture"
        );
      }

      // One-shot capture diagnostic. If the base plan still comes out blank,
      // these numbers pinpoint the cause (invalid dims → collapsed layout rect,
      // vs. a coordinate/scale problem) without another guess.
      const basePlanRect = basePlanNode.getBoundingClientRect();
      const cloneRect = clone.getBoundingClientRect();
      console.log("[MF-CAPTURE-DIAG]", JSON.stringify({
        type,
        orgDimsValid,
        newWidth,
        newHeight,
        imageDimensions,
        scaleReady,
        scaleXCanvas,
        scaleYCanvas,
        offsetXCheck,
        offsetYCheck,
        scaleFactorX,
        scaleFactorY,
        scaleXCalculateCanvas,
        offsetXCalculateCheck,
        divWidth,
        divHeight,
        basePlanNatural: {
          w: basePlanNode.naturalWidth,
          h: basePlanNode.naturalHeight,
        },
        basePlanLayout: {
          w: Math.round(basePlanRect.width),
          h: Math.round(basePlanRect.height),
        },
        cloneLayout: { w: Math.round(cloneRect.width), h: Math.round(cloneRect.height) },
        boundaryCount: imageElement.querySelectorAll(".image-boundary").length,
        rectMaskCount: imageElement.querySelectorAll(".rect-box rect").length,
      }));

      // Layout-area gate: a decoded base plan that lays out to zero area still
      // produces a base-plan-less capture. Refuse it (fail safe) rather than
      // shipping the partial image the byte-size guard would have passed.
      if (basePlanRect.width < 1 || basePlanRect.height < 1) {
        throw new Error(
          "downloadLayout: base plan collapsed to zero layout area — refusing partial capture"
        );
      }

      const blob = await rasterizeNode(clone, {
        ...domtoImageOptions,
        as: "blob",
      });

      if (type === 2) {
        mfLogGalleryCaptureDiag("downloadLayout.exit", {
          capDiag,
          msInDownloadLayout: Math.round(performance.now() - tDiagEnter),
          msSinceCapTag:
            capDiag?.tRequest != null
              ? Math.round(performance.now() - capDiag.tRequest)
              : null,
          blobBytes: blob?.size ?? null,
          blobType: blob?.type ?? null,
        });
        return blob;
      } else {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${layoutData?.name || "download"}.jpeg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        trackEngagement({ downloads: true });
      }
    } catch (error) {
      console.error("Image export failed:", error);
      if (type === 2) {
        mfLogGalleryCaptureDiag("downloadLayout.catch", {
          capDiag,
          msInDownloadLayout: Math.round(performance.now() - tDiagEnter),
          message: error?.message ?? String(error),
        });
      }
    }
  };

  // (Removed: waitForCaptureReady + computeExpectedBoundaryCount.)
  //
  // These were a speculative pre-flight gate that polled for a populated
  // floor-plan host, a quorum of .image-boundary nodes, and every <img>
  // being .complete && naturalHeight > 0 before allowing downloadLayout
  // to fire. In practice the gate produced false negatives — any single
  // CORS-blocked <img>, any rug that finished decoding one microtask
  // after the 1500 ms timeout, or any expectedBoundaryCount that
  // included a room tab the user hadn't activated — which marked the
  // capture as unsafe even when the actual blob was clean. Downstream
  // cache-write code then skipped the write, the gallery armed its
  // loader, and the durable layoutCache useEffect fell back to a
  // PREVIOUS Done's blob (the 60 s freshness window kept it eligible),
  // pinning a stale image that only a second editor round trip could
  // dislodge.
  //
  // The actual readiness mechanism is dom-to-image's own pipeline. The
  // toJpeg warm-up call inside downloadLayout (see "DO NOT DELETE"
  // comment there) forces every <img> in the cloned subtree to decode
  // before toBlob captures pixels. With that pass restored, the blob
  // size guard is the only signal we need — no speculative polling.

  const duplicateHandleItemsRef = useRef(handleItems);
  const duplicateDownloadLayoutRef = useRef(downloadLayout);
  duplicateHandleItemsRef.current = handleItems;
  duplicateDownloadLayoutRef.current = downloadLayout;
  downloadLayoutForGalleryCaptureRef.current = downloadLayout;

  // Duplicate the currently selected furniture item.  Wired to the
  // ContentCopy icon in the per-item furniture actions toolbar (rotate /
  // ⋯ / remove row) — visible only when an item is selected.  The
  // overflow ⋯ menu no longer routes through this branch; that menu
  // now always duplicates the full version/layout.
  const handleDuplicateItem = useCallback(() => {
    const matches = roomItemsList?.[roomActive]?.[roomActiveLayout?.[roomActive]]?.filter(
      (item) =>
        item?._id?.split("-")?.[0] ===
        selectedItem?.split("-")?.slice(1, -1).join("-")
    );
    if (!matches || matches.length < 1) return;
    const id = selectedItem?.split("-")?.slice(1)?.join("-");
    const selectedItems =
      roomItemsList?.[roomActive]?.[roomActiveLayout?.[roomActive]] || [];
    const item = selectedItems?.find((i) => i._id === id);
    if (!item) return;
    duplicateHandleItemsRef.current(id, item, "add", undefined, true);
  }, [roomItemsList, roomActive, roomActiveLayout, selectedItem]);

  const handleDuplicateVersionOrLayout = useCallback(async () => {
    if (isGuest) {
      requireAuth(() => {}, GO_EDITOR, { surface: "duplicateVersionOrLayout" });
      return;
    }

    if (loading === "duplicating") {
      return;
    }

    if (!layoutData?._id) {
      console.warn("Layout ID not available, skipping duplication");
      return;
    }

    setLoading("duplicating");

    // Quiescence guard: wait for any in-flight autosave to settle and sync the
    // autosave payload from the latest editor refs before sending to the
    // server. Mirrors runBackToGallery so the duplicate uses the same editor
    // state the user sees and so the server image regeneration for the source
    // version uses up-to-date payload data.
    //
    // After the duplicate succeeds, capture a local blob of the editor's
    // current DOM and cache it under the *new* version's key. The editor
    // doesn't re-initialize on a same-_id version change (hasInitializedRef
    // stays true), so the live DOM still represents the source version's
    // content at this moment — and a duplicate is by definition a copy of
    // the source, so that DOM is also a correct preview of the new version.
    // Caching under the *new* key (not the source's) is the difference from
    // the bug fixed in PR #646: prior versions are no longer disturbed.
    //
    // Without this cache write, the gallery falls back to the new version's
    // furnishedImageId — which the server typically hasn't regenerated yet
    // immediately after save-and-duplicate-version — and the slider further
    // falls back to the unfurnished image, which the user perceives as a
    // "blank" gallery thumbnail.
    let newVersion;
    try {
      while (autoSaveloadingRef.current) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      autoSaveDataRef.current = {
        ...autoSaveDataRef.current,
        roomsData: roomsDataRef.current,
        roomActive: roomActiveRef.current,
        roomActiveLayout: roomActiveLayoutRef.current,
        zonesRoom: zonesRoomRef.current,
      };

      // Capture the editor's current DOM BEFORE the POST + invalidateTags
      // pair. Until now this capture ran AFTER the POST returned and AFTER
      // dispatch(invalidateTags(...)) fired, which means it executed while
      // RTK Query was already mid-refetch for this layoutId. Any transient
      // state in that window (a partial paint, an in-flight transform, the
      // scale factors momentarily mismatched against the boundary cache)
      // could produce a wrong-scale or partial blob — and we'd then cache
      // that blob under the new version's slot for the gallery to render.
      // Moving capture to pre-POST closes that race: the live DOM still
      // represents the SOURCE version (no state has flipped yet, no refetch
      // is in flight), and a duplicate is by definition a copy, so the same
      // blob is a correct preview of both source and new versions.
      //
      // We also stash the world-geometry hash here so the cache-write step
      // below can confirm scale didn't drift between capture and write. If
      // it did, the captured blob is suspect and we skip the write entirely
      // (and signal CAPTURE_SKIPPED so PR 2's gallery loader can take over).
      //
      // Read-only: we never write worldGeometryHashRef from this PR — the
      // existing tripwire (see updatedLayoutHelper) is the only writer.
      // Capture readiness used to be gated on a separate
      // waitForCaptureReady() poll (populated #image-container-1, quorum of
      // .image-boundary nodes, every <img>.complete && naturalHeight > 0).
      // That gate produced false negatives — a single CORS-blocked img or a
      // late-decoding rug would mark readiness.timedOut and cause us to
      // skip the capture and write CAPTURE_SKIPPED to the gallery. The
      // duplicate flow's downstream cache-write step then fell through to
      // the else branch and the gallery loader masked a perfectly valid
      // pre-POST DOM. The toJpeg warm-up pass inside downloadLayout (see
      // the "DO NOT DELETE" comment there) is the actual readiness
      // mechanism: it forces every <img> in the cloned subtree to decode
      // before toBlob captures pixels. Trust the blob size guard below.
      const preDuplicateHash = worldGeometryHashRef.current;
      const preDuplicateBlob = await duplicateDownloadLayoutRef
        .current?.(2)
        .catch(() => null);

      // Strip viewport-derived and UI-calibration fields before sending to the
      // server. This mirrors updatedLayoutHelper exactly: the autosave path
      // already strips these because — per the long-standing comments there —
      // persisting them "causes scale drift" / "can corrupt world scale on
      // rehydrate" / was "the root cause of the 'furniture blows up' mutation
      // on re-entry." Until now the duplicate path was sending the raw,
      // unstripped autoSaveDataRef, which let viewport-derived scaleXCanvas/Y,
      // offsetXCheck/Y, divWidth/H and the calculate*/initial* calibration
      // fields land in the persisted payload. That polluted both the new
      // version and (because the server resaves the source row when handling
      // /save-and-duplicate-version) the source version too — manifesting as
      // wrong-scale gallery thumbnails AND wrong-scale editors on re-entry to
      // prior versions. scaleFactorX/Y are intentionally PRESERVED here, same
      // as updatedLayoutHelper, because they are world values (px per foot)
      // and represent the room's calibration.
      const {
        divWidth: _divWidth,
        divHeight: _divHeight,
        offsetXCheck: _offsetXCheck,
        offsetYCheck: _offsetYCheck,
        scaleXCanvas: _scaleXCanvas,
        scaleYCanvas: _scaleYCanvas,
        calculateScaleFactorX: _calculateScaleFactorX,
        calculateScaleFactorY: _calculateScaleFactorY,
        initialScaleFactorX: _initialScaleFactorX,
        initialLength: _initialLength,
        calculateInitialLength: _calculateInitialLength,
        calculateInitialScaleFactorX: _calculateInitialScaleFactorX,
        ...sanitizedDuplicatePayload
      } = autoSaveDataRef.current;

      const updationUrl = `${baseUrl}/savedLayout/save-and-duplicate-version/${layoutData._id}/${layoutData?.version}`;
      const response = await axios.post(
        updationUrl,
        {
          payload: sanitizedDuplicatePayload,
          image: layoutData?.imageId,
          draft: false,
        },
        {
          headers: {
            Authorization: `Bearer ${currentUserSessionStorage}`,
          },
        }
      );

      dispatch(
        apiRoomNate.util.invalidateTags([
          { type: "savedLayouts", id: layoutData._id },
        ])
      );
      newVersion = response?.data?.newLayoutData?.version;

      if (newVersion != null) {
        const sourceVersion = layoutData?.version;
        const hashIntact =
          worldGeometryHashRef.current === preDuplicateHash;
        const blobValid =
          !!preDuplicateBlob && preDuplicateBlob.size > 5000;
        const cacheKey = String(layoutData._id);
        const cacheData = layoutCache.get(cacheKey) || {};
        if (!cacheData.versions) cacheData.versions = {};
        if (blobValid && hashIntact) {
          // Write the pre-POST blob to BOTH the new version slot AND the
          // source version slot. Duplicate is by definition a copy, so the
          // captured DOM is a correct preview of both. Writing to the
          // source slot shadows any wrong-scale server-rendered image the
          // backend may produce when /save-and-duplicate-version resaves
          // the source row — addresses Bug 4 (older versions show mutated
          // scale after Duplicate).
          const blobUrl = URL.createObjectURL(preDuplicateBlob);
          const cachedAt = Date.now();
          cacheData.versions[newVersion] = {
            version: newVersion,
            url: blobUrl,
            cachedAt,
          };
          if (sourceVersion != null) {
            cacheData.versions[sourceVersion] = {
              version: sourceVersion,
              url: blobUrl,
              cachedAt,
            };
          }
          layoutCache.set(cacheKey, cacheData);
        } else {
          // Captured blob failed the size guard, or the world-geometry
          // hash drifted between capture and now. Two things must happen,
          // in this order:
          //
          //   1. INVALIDATE any prior layoutCache entry for the source
          //      version. The duplicate flow always touches the source
          //      row on the server, so the gallery may need to refetch
          //      its image — and any stale blob in this slot would shadow
          //      the new server render. Without this delete, gallery
          //      navigation back to the source after a duplicate could
          //      flash an outdated thumbnail.
          //   2. Signal CAPTURE_SKIPPED for the NEW version so the
          //      gallery arms its loader and waits for server
          //      regeneration rather than flashing a stale image.
          //
          // The new version slot does not need an explicit delete because
          // it does not yet exist in the cache (it is brand new from this
          // POST), but we guard with `if` for safety in case a previous
          // duplicate left an entry there somehow.
          if (sourceVersion != null && cacheData.versions[sourceVersion]) {
            delete cacheData.versions[sourceVersion];
          }
          if (cacheData.versions[newVersion]) {
            delete cacheData.versions[newVersion];
          }
          layoutCache.set(cacheKey, cacheData);
          setPendingEditorBlob(layoutData._id, newVersion, CAPTURE_SKIPPED);
        }
      }

      setVersionLayout(newVersion);
    } catch (error) {
      // Preserve prior swallow-and-clear behavior on failure.
    } finally {
      setLoading(null);
    }
  }, [
    isGuest,
    loading,
    layoutData,
    layoutCache,
    currentUserSessionStorage,
    dispatch,
    requireAuth,
    setLoading,
    setVersionLayout,
  ]);

  const handleLayoutSave = async (method, url, formData, payload = {}, opts = {}) => {
    // TRIPWIRE: Log scale values before save
    console.log('[TRIPWIRE] handleLayoutSave - Before save:', {
      source: 'SAVE_START',
      method,
      url,
      scaleXCanvas,
      scaleYCanvas,
      scaleFactorX,
      scaleFactorY,
      payloadHasScale: !!payload?.scaleXCanvas,
    });

//    eventLog(targetWindow, 'floor_plan_event', 'layout_saved', {
//      galleryId: layoutData?.uuid || layoutData?._id,
//    });

    // Prefer an explicit opts.authToken when the caller has it. The fork-save
    // pipeline runs immediately after AuthContext is told to login but before
    // React has propagated the new currentUserSessionStorage value into this
    // closure, so the live cookie value (read by the caller via Cookies.get)
    // is the only reliable source of the just-issued JWT for that one PUT.
    // All other callers omit opts and keep the historical context-driven
    // behavior unchanged.
    const effectiveAuthToken = opts?.authToken || currentUserSessionStorage;

    let response = null;
    try {
      response = await axios({
        method,
        url,
        data: formData || payload,
        headers: {
          "Content-Type": formData ? "multipart/form-data" : "application/json",
          Authorization: effectiveAuthToken
            ? `Bearer ${effectiveAuthToken}`
            : undefined,
        },
      });

      if (response.status !== 200 && response.status != 201) {
        throw new Error("Request failed");
      }
      
      // TRIPWIRE: Log response to check if it contains scale data
      console.log('[TRIPWIRE] handleLayoutSave - After save response:', {
        source: 'SAVE_RESPONSE',
        responseHasPayload: !!response.data?.payload,
        responseScaleXCanvas: response.data?.payload?.scaleXCanvas,
        responseScaleFactorX: response.data?.payload?.scaleFactorX,
      });
      
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      throw error;
    }
  };

  const shareLayout = async () => {
    const payload = saveStatesToJSON();
    let imageId = "";

    eventLog(targetWindow, 'floor_plan_event', 'share_layout', {
      galleryId: layoutData?.uuid || layoutData?._id,
      galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
    });

    if (!params.id && !layoutId) {
      const formData = new FormData();
      formData.append("file", uploadImage);

      try {
        const uploadUrl = apiUrl("g/fileUpload?generateSizes=true");
        const uploadResponse = await handleLayoutSave(
          "POST",
          uploadUrl,
          formData
        );
        imageId = uploadResponse?.id;
      } catch (error) {
        console.error("Error during image upload:", error);
        return;
      }
    } else imageId = layoutData?.imageId;

    const furnishedformData = new FormData();
    const blob = await downloadLayout(2);
    furnishedformData.append("file", blob, "layout.jpeg");
    let furnishedImageId = "";

    try {
      const furnishedUploadUrl = apiUrl("g/fileUpload?generateSizes=true");
      const furnishedResponse = await handleLayoutSave(
        "POST",
        furnishedUploadUrl,
        furnishedformData
      );
      furnishedImageId = furnishedResponse?.id;
    } catch (error) {
      console.error("Error during layout upload:", error);
      return;
    }

    const data = {
      furnishedImageId: furnishedImageId,
      payload: {
        ...payload,
        type: 2,
      },
    };

    data.image = imageId;

    try {
      const layoutUrlPrefix = currentUserSessionStorage ? "add/" : "add-guest/";
      const layoutResponse = await handleLayoutSave(
        "POST",
        apiUrl(`savedLayout/${layoutUrlPrefix}`),
        null,
        data
      );

      const id = layoutResponse.uniqueId;
      const url = `${window.location.origin}/layout/${id}`;
      await navigator.clipboard.writeText(url);
      refetchDirectoryData();
    } catch (error) {
      console.error("Error saving layout:", error);
    }
  };

  // `opts.strict` opt-in (Phase 1 fork-save honesty): when true, every silent
  // early-return below converts into a thrown error so callers know exactly
  // why a save did not reach the server. Autosave and every other historical
  // caller passes no opts and keeps the current silent-skip semantics.
  const updatedLayoutHelper = async (draft, generateImage, opts = {}) => {
    const strict = !!opts.strict;
    // Phase 1.5 gate: when fork-save is in flight, the ONLY save allowed is
    // the strict one our retry loop runs. Anything else (autosave timer
    // captured before auth, a Done-button parallel save, a Copy-Link save,
    // etc.) is silently skipped — letting it through would PUT the guest's
    // edits to the original layout (user A's plan) and re-introduce the
    // overwrite bug 30fe031e was meant to fix. Read from the ref so even
    // stale closures see the latest forkTransitioning state.
    if (forkTransitioningRef.current && !strict) {
      console.log('[FORK-SAVE-GUARD] Non-strict save blocked: fork-save in flight');
      return;
    }
    if (!layoutData?._id) {
      console.warn("Layout ID not available, skipping layout update");
      if (strict) throw new Error("forkSave: layoutData._id missing");
      return;
    }

    // Use forked layout ID if guest just authenticated and we copied the layout
    const saveTargetId = forkedLayoutIdRef.current || layoutData._id;
    let updationUrl = `${baseUrl}/savedLayout/edit/${saveTargetId}`;

    if (versionLayout) updationUrl += `?version=${versionLayout}`;

    const rawPayload = autoSaveDataRef.current;

    console.log('[GALLERY-DEBUG] updatedLayoutHelper called. draft:', draft, 'generateImage:', generateImage);
    console.log('[GALLERY-DEBUG] rawPayload keys:', Object.keys(rawPayload));
    console.log('[GALLERY-DEBUG] rawPayload has roomsData:', !!rawPayload?.roomsData, 'length:', rawPayload?.roomsData?.length);
    if (rawPayload?.roomsData?.[0]) {
      const _hf = rawPayload.roomsData[0]?.layouts?.[0]?.furniture?.[0];
      console.log('[GALLERY-DEBUG] rawPayload first furniture:', _hf?.name, 'pos:', JSON.stringify(_hf?.position), 'w:', _hf?.width);
    }

    if (Object.keys(rawPayload).length === 0) {
      console.log('[GALLERY-DEBUG] ❌ rawPayload is EMPTY - returning early!');
      if (strict) throw new Error("forkSave: autoSaveDataRef.current is empty");
      return;
    }
    
    // =====================================================
    // PR #89: GATE AUTO-SAVE UNTIL SCALE IS READY
    // =====================================================
    // If scale isn't ready, furniture positions haven't been converted yet.
    // Saving now would persist wrong coords (position === exactPosition).
    // Wait until handleUpdate has completed at least once.
    // =====================================================
    if (!scaleReady) {
      console.log('[AUTO-SAVE] ⏳ BLOCKED - scale not ready yet');
      if (strict) throw new Error("forkSave: scaleReady is false");
      return;
    }
    
    console.log('[AUTO-SAVE] ✅ Scale is ready - proceeding with save');
    
    // =====================================================
    // TRIPWIRE: Check World Geometry Hash
    // =====================================================
    // If world geometry changed since init AND user hasn't made edits,
    // something corrupted WORLD coords. Block save to prevent persisting.
    // 
    // KEY LOGIC (Peter's fix):
    // - If hasUserEditedRef.current === false → block if hash changed (corruption)
    // - If hasUserEditedRef.current === true → world change is EXPECTED (user edit)
    //   → Update baseline hash and allow save
    // =====================================================
    console.log('[TRIPWIRE] Checking world geometry integrity...');
    console.log('[TRIPWIRE] worldGeometryInitializedRef:', worldGeometryInitializedRef.current);
    console.log('[TRIPWIRE] hasUserEditedRef:', hasUserEditedRef.current);
    console.log('[TRIPWIRE] rawPayload.roomsData exists:', !!rawPayload.roomsData);
    console.log('[TRIPWIRE] rawPayload.roomsData length:', rawPayload.roomsData?.length);
    console.log('[TRIPWIRE] rawPayload.modalVertices exists:', !!rawPayload.modalVertices);
    console.log('[TRIPWIRE] rawPayload.modalVertices length:', rawPayload.modalVertices?.length);
    console.log('[TRIPWIRE] TRIPWIRE_BLOCK_SAVE:', TRIPWIRE_BLOCK_SAVE);
    
    if (worldGeometryInitializedRef.current && (rawPayload.roomsData || rawPayload.modalVertices)) {
      const currentHash = computeWorldGeometryHash(rawPayload.roomsData, rawPayload.modalVertices);
      console.log('[TRIPWIRE] Initial hash:', worldGeometryHashRef.current);
      console.log('[TRIPWIRE] Current hash:', currentHash);
      
      if (worldGeometryHashRef.current && currentHash !== worldGeometryHashRef.current) {
        // Hash changed - but is this corruption or legitimate user edit?
        if (hasUserEditedRef.current) {
          // USER HAS EDITED - world change is EXPECTED
          console.log('[TRIPWIRE] ✅ World geometry changed - but user has edited (EXPECTED)');
          console.log('[TRIPWIRE] Updating baseline hash to match new world state');
          worldGeometryHashRef.current = currentHash;
          // Allow save to proceed - this is a legitimate edit
        } else {
          // USER HAS NOT EDITED - this is CORRUPTION
          console.log('='.repeat(80));
          console.log('[TRIPWIRE] ❌ WORLD GEOMETRY CHANGED - CORRUPTION DETECTED');
          console.log('='.repeat(80));
          console.log('[TRIPWIRE] This indicates transform ownership corruption!');
          console.log('[TRIPWIRE] Camera/view values may have overwritten world coords.');
          console.log('[TRIPWIRE] User has NOT edited - world should be invariant!');
          console.log('[TRIPWIRE] Initial hash:', worldGeometryHashRef.current);
          console.log('[TRIPWIRE] Current hash:', currentHash);
          console.log('[TRIPWIRE] First room vertices sample:', JSON.stringify(rawPayload.roomsData[0]?.vertices?.slice(0, 2)));
          console.log('[TRIPWIRE] First furniture exactPosition:', JSON.stringify(rawPayload.roomsData[0]?.layouts?.[0]?.furniture?.[0]?.exactPosition));
          
          if (TRIPWIRE_BLOCK_SAVE) {
            console.log('[TRIPWIRE] ⛔ BLOCKING SAVE - corrupted data will NOT be persisted');
            console.log('[TRIPWIRE] Set TRIPWIRE_BLOCK_SAVE=false or remove ?tripwireBlock=1 to disable');
            console.log('='.repeat(80));
            if (strict) throw new Error("forkSave: tripwire blocked save (world geometry corruption with no user edits)");
            return; // BLOCK THE SAVE
          } else {
            console.log('[TRIPWIRE] ⚠️ NOT blocking save (TRIPWIRE_BLOCK_SAVE=false)');
            console.log('[TRIPWIRE] Corrupted data WILL be persisted - this is a warning only');
          }
          console.log('='.repeat(80));
        }
      } else if (!worldGeometryHashRef.current) {
        console.log('[TRIPWIRE] ⚠️ No initial hash stored - skipping check');
      } else {
        console.log('[TRIPWIRE] ✅ World geometry unchanged - safe to save');
      }
    } else {
      console.log('[TRIPWIRE] ⚠️ Skipping check - not initialized or no roomsData');
    }
    
    // =====================================================
    // STRIP VIEWPORT-DEPENDENT FIELDS FROM AUTO-SAVE
    // =====================================================
    // These fields are calculated from the user's viewport and should NOT be
    // persisted to the database. Saving them causes "scale drift" when the same
    // layout is loaded on different viewports:
    // - Session 1 (laptop): saves scaleXCanvas = 0.704
    // - Session 2 (external): calculates 0.806, auto-save OVERWRITES to 0.806
    // - Session 3 (laptop): API returns 0.806 (wrong!), applies wrong correction
    //
    // By stripping these, the backend's original values are preserved.
    // =====================================================
    const {
      // VIEWPORT-DERIVED FIELDS (never persist - compute at runtime)
      // These change with user's screen size and should be recalculated each load
      divWidth: _divWidth,
      divHeight: _divHeight,
      offsetXCheck: _offsetXCheck,
      offsetYCheck: _offsetYCheck,
      scaleXCanvas: _scaleXCanvas,
      scaleYCanvas: _scaleYCanvas,
      // UI CALIBRATION FIELDS (never persist - can corrupt world scale on rehydrate)
      calculateScaleFactorX: _calculateScaleFactorX,
      calculateScaleFactorY: _calculateScaleFactorY,
      initialScaleFactorX: _initialScaleFactorX,
      initialLength: _initialLength,
      calculateInitialLength: _calculateInitialLength,
      calculateInitialScaleFactorX: _calculateInitialScaleFactorX,
      // NOTE: scaleFactorX/Y are WORLD values (px per foot), NOT viewport-derived!
      // They represent the room's calibration and should be PRESERVED in auto-save.
      // Stripping them caused Plan 2's "major scale inconsistency" bug.
      ...payload
    } = rawPayload;
    
    // =====================================================
    // AUTO-SAVE DIAGNOSTIC LOGGING
    // =====================================================
    console.log('='.repeat(80));
    console.log('[AUTO-SAVE] ========== SAVING LAYOUT ==========');
    console.log('='.repeat(80));
    console.log('[AUTO-SAVE] STRIPPED viewport-dependent fields (NOT saving):');
    console.log('  divWidth:', _divWidth);
    console.log('  divHeight:', _divHeight);
    console.log('  offsetXCheck:', _offsetXCheck?.toFixed?.(2) || _offsetXCheck);
    console.log('  offsetYCheck:', _offsetYCheck?.toFixed?.(2) || _offsetYCheck);
    console.log('  scaleXCanvas:', _scaleXCanvas?.toFixed?.(6) || _scaleXCanvas);
    console.log('  scaleYCanvas:', _scaleYCanvas?.toFixed?.(6) || _scaleYCanvas);
    console.log('[AUTO-SAVE] STRIPPED UI calibration fields (NOT saving):');
    console.log('  calculateScaleFactorX:', _calculateScaleFactorX?.toFixed?.(6) || _calculateScaleFactorX);
    console.log('  calculateScaleFactorY:', _calculateScaleFactorY?.toFixed?.(6) || _calculateScaleFactorY);
    console.log('  initialScaleFactorX:', _initialScaleFactorX?.toFixed?.(6) || _initialScaleFactorX);
    console.log('  initialLength:', _initialLength);
    console.log('  calculateInitialLength:', _calculateInitialLength);
    console.log('  calculateInitialScaleFactorX:', _calculateInitialScaleFactorX?.toFixed?.(6) || _calculateInitialScaleFactorX);
    console.log('[AUTO-SAVE] PRESERVED WORLD values (ARE being saved):');
    console.log('  scaleFactorX:', payload.scaleFactorX?.toFixed?.(6) || payload.scaleFactorX, '(px per foot - room calibration)');
    console.log('  scaleFactorY:', payload.scaleFactorY?.toFixed?.(6) || payload.scaleFactorY, '(px per foot - room calibration)');
    console.log('[AUTO-SAVE] Viewport fields will be RECALCULATED on next load');
    console.log('[AUTO-SAVE] Payload keys being saved:', Object.keys(payload));
    
    // Log first furniture item to verify exactPosition is preserved
    if (payload.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]) {
      const f = payload.roomsData[0].layouts[0].furniture[0];
      console.log('[AUTO-SAVE] First furniture verification:');
      console.log('  name:', f.name);
      console.log('  exactPosition (CANONICAL - preserved):', JSON.stringify(f.exactPosition));
      console.log('  origionalPosition (CANONICAL - preserved):', JSON.stringify(f.origionalPosition));
      console.log('  position (DERIVED - for display only):', JSON.stringify(f.position));
    }
    console.log('='.repeat(80));

    // regenerateImage=false tells the server TO generate the gallery image
    // (backend logic is inverted: false=generate, true=skip)
    // When generateImage=true (gallery click): regenerateImage=false → server generates
    // When generateImage=false (auto-save): regenerateImage=true → server skips
    payload.regenerateImage = !generateImage;

    // Sort rugs to the front of every furniture array before persisting.
    // The server's rendering engine has no knowledge of CSS z-index — it
    // renders furniture in array order (painter's algorithm: first = bottom,
    // last = top). Rugs must sit between the blank floor plan and all other
    // furniture, so they must be first in the array. This is a pure payload
    // transformation: local state (autoSaveDataRef) and the editor's z-index
    // rendering are untouched.
    if (payload.roomsData) {
      payload.roomsData = payload.roomsData.map((room) => ({
        ...room,
        layouts: room.layouts?.map((layout) => {
          if (!layout.furniture?.length) return layout;
          const rugs = layout.furniture.filter((f) => isRugItem(f));
          const rest = layout.furniture.filter((f) => !isRugItem(f));
          return { ...layout, furniture: [...rugs, ...rest] };
        }),
      }));
    }

    try {
      const _putStart = Date.now();
      console.error('[TIMING] PUT request START. regenerateImage:', payload.regenerateImage);
      // Forward opts.authToken so the strict fork-save PUT can attach the
      // just-issued JWT even before AuthContext has rehydrated.
      await handleLayoutSave(
        "PUT",
        updationUrl,
        null,
        {
          payload,
          image: layoutData?.imageId,
          draft: versionLayout ? false : draft,
        },
        { authToken: opts?.authToken }
      );
      console.error('[TIMING] PUT request DONE in ' + (Date.now() - _putStart) + 'ms');
      setAutoSave(true);
      setUpdatedTime(new Date());
      setAutoSaveLoading(false);
    } catch (error) {
      setAutoSaveLoading(false);
      console.error("Error updating layout:", error);
      throw error; // Re-throw so updatedLayout() can detect failure
    }
  };

  // `opts.strict` (Phase 1) passes through to updatedLayoutHelper. When set,
  // helper-side silent skips become throws AND this wrapper re-throws so the
  // fork-save retry loop can distinguish a successful save from a no-op.
  const updatedLayout = async (draft = true, generateImage = true, opts = {}) => {
    try {
      autoSaveCount.current += 1;

      setAutoSaveLoading(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;

      // Save payload to server. When generateImage=true (gallery click),
      // regenerateImage=false tells the server to generate a fresh gallery image.
      // We skip local blob generation (downloadLayout produces blank images)
      // and rely on the server to generate the gallery image.
       await updatedLayoutHelper(draft, generateImage, opts);
       return true; // Save succeeded

    } catch (error) {
      setAutoSaveLoading(false);
      if (opts.strict) throw error;
      return false; // Save failed
    }
  };

  // Refs always point to the latest function (avoids stale closure in useCallback / useEffect deps)
  const updatedLayoutRef = useRef(updatedLayout);
  updatedLayoutRef.current = updatedLayout;
  const trackEngagementRef = useRef(null);

  useEffect(() => {
    // No autosave for guests — edits are in-memory only until they authenticate
    if (isGuest) return;

    // No autosave while a guest-fork transition is in flight. After auth the
    // user becomes non-guest before saveForkedLayoutAndNavigate finishes; an
    // auto-save firing in that window would write to the original layout via
    // forkedLayoutIdRef === null, re-introducing the very overwrite this
    // fork pipeline is meant to prevent.
    if (forkTransitioning) return;

    if ((!params.id && !layoutId) || !layoutData || !isLayoutDataSuccess)
      return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    timeoutRef.current = setTimeout(() => {
      // Only auto-save if user has made edits (prevents flash on reload from saving stale data)
      if (!hasUserEditedRef.current) return;
      updatedLayout(true, false);
    }, 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomsData]);

  useEffect(() => {
    autoSaveloadingRef.current = autoSaveloading;
  }, [autoSaveloading]);

  useEffect(() => {
    const container = document.getElementById("lineContainer");

    if (!layoutLoading) {
      measureLineInDiv(modalVertices, container);
    }
  }, [
    scaleXCanvas,
    scaleYCanvas,
    selectedFeet,
    selectedInches,
    isScaleDimensionsMarked,
    offsetXCheck,
    offsetYCheck,
    divWidth,
    divHeight,
    modalData,
    modalVertices,
    layoutLoading,
    measureLineInDiv,
  ]);

  useEffect(() => {
    const container = document.getElementById("lineContainer");
    calculateLineInDiv(modalVertices, container);
  }, [
    calculate,
    selectedFeet,
    selectedInches,
    isScaleDimensionsMarked,
    scaleXCalculateCanvas,
    scaleYCalculateCanvas,
    offsetXCalculateCheck,
    offsetYCalculateCheck,
    divDynamicWidth,
    divHeight,
    layoutLoading,
    midRangeLineIndexState,
    calculateLineInDiv,
    modalVertices
  ]);

  // Manage locked scales per layout using sessionStorage
  // This ensures scale lock survives navigation (component unmount/remount)
  const previousLayoutIdRef = useRef(null);
  useEffect(() => {
    console.log('[FLASH-DEBUG] layoutData._id useEffect fired at t=' + Date.now() + ' | _id:', layoutData?._id, '| prev:', previousLayoutIdRef.current, '| WILL RESET:', !!(layoutData?._id && layoutData._id !== previousLayoutIdRef.current));
    console.log('[SCALE LOCK] useEffect triggered, layoutData._id:', layoutData?._id, 'previousLayoutIdRef:', previousLayoutIdRef.current);
    if (layoutData?._id && layoutData._id !== previousLayoutIdRef.current) {
      console.log('[SCALE LOCK] Layout ID changed from', previousLayoutIdRef.current, 'to', layoutData._id);
      // Save current layout's locked scales before switching
      if (previousLayoutIdRef.current && Object.keys(lockedScalesRef.current).length > 0) {
        console.log('[SCALE LOCK] Saving locked scales for previous layout:', previousLayoutIdRef.current, lockedScalesRef.current);
        try {
          sessionStorage.setItem(
            `lockedScales_${previousLayoutIdRef.current}`,
            JSON.stringify(lockedScalesRef.current)
          );
        } catch (e) {
          console.error('Failed to save locked scales:', e);
        }
      }
      
      // TRIPWIRE: Log navigation/layout change
      console.log('[TRIPWIRE] Layout ID changed - Navigation detected:', {
        source: 'NAVIGATION',
        previousLayoutId: previousLayoutIdRef.current,
        newLayoutId: layoutData._id,
        currentScaleXCanvas: scaleXCanvas,
        currentScaleFactorX: scaleFactorX,
      });
      
      previousLayoutIdRef.current = layoutData._id;
      hasInitializedRef.current = false; // Reset so new layout can initialize
      handleUpdateKeyRef.current = null; // Force handleUpdate to run fresh on re-entry
      // A different layout's furniture has never been transformed for this
      // viewport, and switching between versions of the same plan leaves every
      // viewport input identical, so the signature alone cannot tell that the
      // data underneath it changed. Clear it or the new layout never gets a pass.
      furnitureTransformKeyRef.current = null;
      setScaleReady(false); // PR #89: Block auto-save/add-item until scale is ready
      
      // =====================================================
      // SCALE FACTOR INVARIANT: Reset for new layout
      // =====================================================
      // Allow API values to be set for the new layout.
      // Will be set to true once we receive scaleFactorX from API.
      // =====================================================
      scaleFactorFromApiRef.current = false;
      console.log('[SCALE INVARIANT] Reset scaleFactorFromApiRef to FALSE for new layout');
      
      // UNLOCK view transform for new layout
      viewTransformLockedRef.current = false;
      viewTransformRef.current = { scale: null, offsetX: null, offsetY: null };
      drawCallCountRef.current = 0; // Reset call counter for binary validation
      console.log('[SCALE DEBUG] 🔓 View transform UNLOCKED for new layout (call counter reset)');
      
      console.log('[SCALE LOCK] Reset hasInitializedRef to false');
      console.log('='.repeat(80));
      console.log('[SCALE READY] ⏳ LAYOUT CHANGED - Scale reset to FALSE');
      console.log('='.repeat(80));
      console.log('[SCALE READY] New layout ID:', layoutData._id);
      console.log('[SCALE READY] Auto-save and add-item are now BLOCKED');
      console.log('[SCALE READY] Waiting for handleUpdate to complete...');
      console.log('='.repeat(80));
      
      // Load locked scales for new layout (if any)
      try {
        const stored = sessionStorage.getItem(`lockedScales_${layoutData._id}`);
        lockedScalesRef.current = stored ? JSON.parse(stored) : {};
        console.log('[SCALE LOCK] Loaded locked scales from sessionStorage:', lockedScalesRef.current);
      } catch {
        lockedScalesRef.current = {};
        console.log('[SCALE LOCK] Failed to load, reset to empty');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutData?._id]); // scaleXCanvas/scaleFactorX intentionally omitted - only used for logging

  useEffect(() => {
    if (!layoutLoading && layoutData?._id) {
      if (layoutData.payload) {
        if (divWidth !== 0 && divHeight !== 0) {
          // Only initialize once per layout to prevent re-loading stored scales
          // which would cause cumulative transformation on navigation
          if (!hasInitializedRef.current) {
            hasInitializedRef.current = true;
            
            // =====================================================
            // SCALE DEBUG: COMPREHENSIVE INITIALIZATION LOGGING
            // =====================================================
            console.log('='.repeat(80));
            console.log('[SCALE DEBUG] ========== INITIALIZATION START ==========');
            console.log('='.repeat(80));
            
            // 1. Viewport/Container dimensions
            console.log('[SCALE DEBUG] 1. VIEWPORT DIMENSIONS:', {
              divWidth,
              divHeight,
              windowWidth: window.innerWidth,
              windowHeight: window.innerHeight,
            });
            
            // 2. Layout metadata
            console.log('[SCALE DEBUG] 2. LAYOUT METADATA:', {
              layoutId: layoutData._id,
              layoutUuid: layoutData.uuid,
              layoutVersion: layoutData.version,
              hasPayload: !!layoutData.payload,
              hasGlobalScaling: !!layoutData.globalScaling,
              imageUrl: layoutData.image?.substring(0, 50) + '...',
            });
            
            // 3. API-provided scale values (from payload)
            console.log('[SCALE DEBUG] 3. API SCALE VALUES (payload):', {
              scaleXCanvas: layoutData.payload?.scaleXCanvas,
              scaleYCanvas: layoutData.payload?.scaleYCanvas,
              offsetXCheck: layoutData.payload?.offsetXCheck,
              offsetYCheck: layoutData.payload?.offsetYCheck,
              scaleFactorX: layoutData.payload?.scaleFactorX,
              scaleFactorY: layoutData.payload?.scaleFactorY,
            });
            
            // 4. API-provided scale values (from globalScaling)
            console.log('[SCALE DEBUG] 4. API SCALE VALUES (globalScaling):', {
              scaleXCanvas: layoutData.globalScaling?.scaleXCanvas,
              scaleYCanvas: layoutData.globalScaling?.scaleYCanvas,
              offsetXCheck: layoutData.globalScaling?.offsetXCheck,
              offsetYCheck: layoutData.globalScaling?.offsetYCheck,
              scaleFactorX: layoutData.globalScaling?.scaleFactorX,
              scaleFactorY: layoutData.globalScaling?.scaleFactorY,
            });
            
            // 5. Floors data (used in scale calculation)
            console.log('[SCALE DEBUG] 5. FLOORS DATA:', {
              extraLeft: layoutData.payload?.floors?.extraLeft,
              extraRight: layoutData.payload?.floors?.extraRight,
              extraTop: layoutData.payload?.floors?.extraTop,
              extraBottom: layoutData.payload?.floors?.extraBottom,
            });
            
            // 6. Modal vertices (shape data)
            const vertices = layoutData.payload?.modalVertices;
            if (vertices && vertices.length > 0) {
              const allX = vertices.flatMap((v) => [v[0]?.x, v[1]?.x]).filter(Boolean);
              const allY = vertices.flatMap((v) => [v[0]?.y, v[1]?.y]).filter(Boolean);
              console.log('[SCALE DEBUG] 6. MODAL VERTICES:', {
                count: vertices.length,
                minX: Math.min(...allX),
                maxX: Math.max(...allX),
                minY: Math.min(...allY),
                maxY: Math.max(...allY),
                rawShapeWidth: Math.max(...allX) - Math.min(...allX),
                rawShapeHeight: Math.max(...allY) - Math.min(...allY),
                firstVertex: vertices[0],
                lastVertex: vertices[vertices.length - 1],
              });
            } else {
              console.log('[SCALE DEBUG] 6. MODAL VERTICES: NONE');
            }
            
            // 7. Rooms data (furniture info)
            const rooms = layoutData.payload?.roomsData;
            console.log('[SCALE DEBUG] 7. ROOMS DATA:', {
              roomCount: rooms?.length,
              rooms: rooms?.map((r, i) => ({
                index: i,
                roomId: r.roomId,
                scaleXCanvas: r.scaleXCanvas,
                scaleYCanvas: r.scaleYCanvas,
                offsetX: r.offsetX,
                offsetY: r.offsetY,
                furnitureCount: r.layouts?.[0]?.furniture?.length,
                firstFurniturePosition: r.layouts?.[0]?.furniture?.[0]?.position,
                firstFurnitureOrigPosition: r.layouts?.[0]?.furniture?.[0]?.origionalPosition,
              })),
            });
            
            console.log('[SCALE DEBUG] ========== CALLING initializeStatesFromJSON ==========');
            
            initializeStatesFromJSON({
              ...layoutData.payload,
              ...layoutData.globalScaling,
            });
            
            console.log('[SCALE DEBUG] ========== TRIGGERING handleUpdate ==========');
            
            // [MATCH-PROD] Do NOT trigger handleUpdate here.
            // Production never calls setUpdateScale after data load.
            // handleUpdate fires naturally via the resize/calibration useEffect
            // (which now toggles setUpdateScale matching production line 1397).
            console.log('[MATCH-PROD] NOT calling setUpdateScale(true) here. handleUpdate will fire from resize path.');
          }

          const existingImage = document
            .getElementById("image-container-1")
            ?.querySelector("img");
  
          if (!existingImage) {
            loadAndInsertImage(layoutData?.image, "image-container-1");
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutLoading, divWidth, divHeight]);
  
  const convertToBase64 = (url) => {
    return fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  };


  const handleSlider = (event, newValue) => {
    setValue(newValue);
  };


  const addBed = (item, idx) => {
    setBedIndexByRoom((prevState) => ({
      ...prevState,
      [roomId]: item, 
    }));
  };

  useEffect(() => {
    const bedIndex = bedIndexByRoom?.[roomId];

    if (bedIndex) {
      const selectedBed = itemsbyZones?.items?.find(
        (item) => item.name.split(" ")[0] === bedIndex
      );
      setItems([selectedBed]);
    } else {
      setItems([]);
    }
  }, [bedIndexByRoom, roomId, itemsbyZones?.items]);

  useEffect(() => {
    if (roomId) {
      // Read the zones inside the updater rather than from this effect's render.
      // A captured copy is a snapshot of the room's zones as they were when the
      // effect was created, so writing it back dropped anything added between
      // that render and this flush — the "TV?", "Work Station?" and "Include
      // Extra Storage?" toggles all append a zone and were being erased.
      setZonesRoom((prevZones) => {
        const roomZones = prevZones[roomId];
        if (!Array.isArray(roomZones)) return prevZones;

        return {
          ...prevZones,
          [roomId]: roomZones.map((zone) =>
            zone.value === "lounging" || zone.value === "dining"
              ? { ...zone, capacity: value }
              : zone
          ),
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, selectedOption, roomId]);

  const handleApplyFilters = () => {
    if (!openFilters) return;
    // Active-room path: flip "see it another way" so the next Shuffle reads
    // the new filter intent, then furnish.
    if (roomActive !== -1) {
      setSeeItAnotherWay((prev) => ({ ...prev, [roomActive]: true }));
      furnishRoom();
      return;
    }
    // Fresh-tap / shuffle post-pick path: roomActive is still -1 because the
    // room hasn't been committed to roomsData yet, but the user has selected
    // a room (lineBoundary OR shufflePickedRoom set) and configured filters.
    // Previously this fell through to a no-op — Apply did nothing. Mirror the
    // Shuffle button fix: drive furnishRoom directly off roomId, which is the
    // source of truth for the selected room in this state. Skip the
    // seeItAnotherWay write here since (a) keying it by -1 is meaningless and
    // (b) furnishRoom is being invoked directly, so no downstream read needs
    // that flag for this run.
    if (roomId && (shufflePickedRoom != null || lineBoundary)) {
      furnishRoom();
    }
  };

  const handleShuffle = () => {
    // eslint-disable-next-line no-unused-vars
    const timestamp = new Date().toISOString();

    eventLog(targetWindow, 'floor_plan_event', 'shuffle_room', {
      galleryId: layoutData?.uuid || layoutData?._id,
      galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
    });

    // TRIPWIRE: Mark as user-edited (intentional world change)
    markUserEdited();

    console.log('');
    console.log('🔀'.repeat(40));
    console.log('[SHUFFLE] ========== SHUFFLE BUTTON CLICKED ==========');
    // [VIEW-DIAG] Container state at shuffle time
    const _shufContainer = document.getElementById('lineContainer');
    const _shufRect = _shufContainer?.getBoundingClientRect();
    console.log('[VIEW-DIAG] At shuffle: container=' + _shufRect?.width?.toFixed(0) + 'x' + _shufRect?.height?.toFixed(0) + ' @ (' + _shufRect?.left?.toFixed(0) + ',' + _shufRect?.top?.toFixed(0) + ') | divW=' + divWidth + ' divH=' + divHeight + ' | sxC=' + scaleXCanvas?.toFixed(4));
    // [SHUFFLE-DIAG] Log the CURRENT furniture state BEFORE shuffle
    const _diagRoom = roomsData?.[roomActive];
    const _diagLayout = _diagRoom?.layouts?.[roomActiveLayout?.[roomActive]];
    const _diagFurn0 = _diagLayout?.furniture?.[0];
    if (_diagFurn0) {
      const _sfxDiag = scaleFactorX || 1;
      const _sxcDiag = scaleXCanvas || 1;
      const _effSX = _sfxDiag / _sxcDiag;
      console.log('[SHUFFLE-DIAG] ══════ BEFORE SHUFFLE ══════');
      console.log('[SHUFFLE-DIAG] Current item: ' + _diagFurn0.name);
      console.log('[SHUFFLE-DIAG]   CURRENT width: ' + _diagFurn0.width?.toFixed(2) + 'px');
      console.log('[SHUFFLE-DIAG]   origionalWidth: ' + _diagFurn0.origionalWidth + ' inches');
      console.log('[SHUFFLE-DIAG]   position.x: ' + _diagFurn0.position?.x?.toFixed(2));
      console.log('[SHUFFLE-DIAG]   Room centerX: ' + _diagRoom?.centerX?.toFixed(2));
      console.log('[SHUFFLE-DIAG]   Room scaleX: ' + _diagRoom?.scaleX?.toFixed(6));
      console.log('[SHUFFLE-DIAG]   Room scaleXCanvas: ' + _diagRoom?.scaleXCanvas?.toFixed(6));
      console.log('[SHUFFLE-DIAG]   STATE scaleFactorX: ' + scaleFactorX?.toFixed(6));
      console.log('[SHUFFLE-DIAG]   STATE scaleXCanvas: ' + scaleXCanvas?.toFixed(6));
      console.log('[SHUFFLE-DIAG]   handleUpdate effectiveSX: ' + _effSX?.toFixed(6));
      console.log('[SHUFFLE-DIAG]   Expected width from handleUpdate: ' + (_diagFurn0.origionalWidth / _effSX)?.toFixed(2) + 'px');
      console.log('[SHUFFLE-DIAG]   Expected width from modifyRoom: ' + (_diagFurn0.origionalWidth / _sfxDiag)?.toFixed(2) + 'px (RAW)');
      console.log('[SHUFFLE-DIAG]   Is current at VP scale? ' + (Math.abs(_diagFurn0.width - _diagFurn0.origionalWidth / _effSX) < 2 ? 'YES' : 'NO (' + (_diagFurn0.width / (_diagFurn0.origionalWidth / _effSX) * 100).toFixed(1) + '%)'));
      console.log('[SHUFFLE-DIAG] ══════════════════════════');
    }
    
    // TRIPWIRE: Log scale values before shuffle
    console.log('[TRIPWIRE] handleShuffle - Before shuffle:', {
      source: 'SHUFFLE_START',
      scaleXCanvas,
      scaleYCanvas,
      scaleFactorX,
      scaleFactorY,
      offsetXCheck,
      offsetYCheck,
    });
    
    const currentLayoutIndex = roomActiveLayout[roomActive]; 
    setViewLayouts(true);

    // Check 1: Keep items
    const hasKeepItems = keepItems?.[roomActive]?.[roomActiveLayout?.[roomActive]]?.length > 0;
    console.log('[SHUFFLE] Check 1 - Has keep items?', hasKeepItems);
    
    if (hasKeepItems) {
      console.log('[SHUFFLE] 🔄 Has keep items - calling furnishRoom(true, false, undefined, true) with keep items');
      console.log('[SHUFFLE] Keep items count:', keepItems?.[roomActive]?.[roomActiveLayout?.[roomActive]]?.length);
      // fromShuffle=true to stay on shuffle panel after layouts generated
      furnishRoom(true, false, undefined, true);
      return;
    }

    setSelectedFurniture(null);
    setCopySelectedFurniture(null);
    setSelectedItem(null);

    // First shuffle on each room: regenerate layouts via API (PATH A) with canonical vertices.
    // Existing layouts may have been generated with old double-scaled vertices, causing
    // beds to appear in the middle of rooms instead of against walls.
    // After regeneration, subsequent shuffles cycle the fresh layouts normally (PATH B).
    if (!hasRegeneratedLayoutsRef.current[roomActive]) {
      hasRegeneratedLayoutsRef.current[roomActive] = true;
      console.log('[SHUFFLE] First shuffle for room ' + roomActive + ' - regenerating layouts with canonical vertices');
      furnishRoom(false, false, undefined, true);
      trackEngagement({ shuffle: true });
      return;
    }

    const layouts = roomsData?.[roomActive]?.layouts || [];

    // Count layouts that have furniture
    const layoutsWithFurniture = layouts.filter(layout => 
      layout?.furniture?.length > 0
    ).length;

    // Comprehensive layout analysis
    console.log('');
    console.log('┌' + '─'.repeat(80) + '┐');
    console.log('│  🔀 [SHUFFLE] LAYOUT ANALYSIS                                                   │');
    console.log('├' + '─'.repeat(80) + '┤');
    console.log('│  roomActive:', roomActive);
    console.log('│  currentLayoutIndex:', currentLayoutIndex);
    console.log('│  layouts.length:', layouts.length);
    console.log('│  layoutsWithFurniture:', layoutsWithFurniture);
    console.log('│  ─────────────────────────────────────────────────────────────────────────────');
    if (layouts.length > 0) {
      layouts.forEach((layout, i) => {
        const furnCount = layout?.furniture?.length ?? 0;
        const newlyAddedCount = layout?.furniture?.filter(f => f?.newlyAdded)?.length ?? 0;
        const marker = i === currentLayoutIndex ? ' ◀ CURRENT' : '';
        console.log('│    Layout[' + i + ']: ' + furnCount + ' furniture items (' + newlyAddedCount + ' newly added)' + marker);
      });
    } else {
      console.log('│    (no layouts available)');
    }
    console.log('└' + '─'.repeat(80) + '┘');

    // Check 2: Only 1 or 0 layouts exist (external flow scenario)
    console.log('[SHUFFLE] Check 2 - layouts.length <= 1?', layouts.length <= 1, '(layouts.length=' + layouts.length + ')');
    
    if (layouts.length <= 1) {
      console.log('[SHUFFLE-DIAG] ══════ PATH A: CALLING FURNISHROOM (API) ══════');
      console.log('[SHUFFLE-DIAG] Reason: Only ' + layouts.length + ' layout(s) exist');
      console.log('[SHUFFLE-DIAG] furnishRoom will call modifyRoomProperties with scaleFactorX=' + scaleFactorX?.toFixed(6));
      console.log('[SHUFFLE-DIAG] modifyRoom outputs RAW pixels (÷ sfX). handleUpdate outputs VP pixels (÷ sfX/sxC).');
      console.log('[SHUFFLE-DIAG] If handleUpdate fires after this, furniture will SHRINK by ' + scaleXCanvas?.toFixed(4) + 'x');
      console.log('[SHUFFLE-DIAG] ════════════════════════════════════════════════');
      // fromShuffle=true to stay on shuffle panel after layouts generated
      furnishRoom(false, false, undefined, true);
      trackEngagement({ shuffle: true });
      return;
    }

    // Check 3: Cycle through layouts to find one with furniture
    console.log('[SHUFFLE] Check 3 - Cycling through ' + layouts.length + ' layouts to find next with furniture...');
    
    let nextIndex = currentLayoutIndex;
    let cycleCount = 0;

    do {
      nextIndex = (nextIndex + 1) % layouts.length;
      cycleCount++;
      const furniture =
        roomsData?.[roomActive]?.layouts?.[nextIndex]?.furniture || [];

      console.log('[SHUFFLE]   → Checking layout[' + nextIndex + ']: ' + furniture.length + ' furniture items');

      // Never cycle back to index 0 — it is reserved/hidden.
      if (furniture.length > 0 && nextIndex !== 0) {
        console.log('[SHUFFLE]   ✅ Found layout with furniture at index ' + nextIndex);
        break;
      }
    } while (nextIndex !== currentLayoutIndex); 

    console.log('[SHUFFLE] Cycle complete. Checked ' + cycleCount + ' layouts. nextIndex=' + nextIndex + ', currentLayoutIndex=' + currentLayoutIndex);

    // Check 4: If cycled back to current, no other layouts have furniture
    if (nextIndex === currentLayoutIndex) {
      console.log('');
      console.log('[SHUFFLE] 🚀 DECISION: Cycled through all layouts, none have furniture except current');
      console.log('[SHUFFLE] ACTION: Calling furnishRoom(false, false, undefined, true) to generate 4-8 new layout options');
      console.log('[SHUFFLE] This is the "make magic" API request');
      console.log('[SHUFFLE] fromShuffle=true - will stay on shuffle panel after completion');
      console.log('');
      // fromShuffle=true to stay on shuffle panel after layouts generated
      furnishRoom(false, false, undefined, true);
      trackEngagement({ shuffle: true });
      return;
    }

    // Success: Found another layout to switch to
    console.log('');
    console.log('[SHUFFLE] ✅ SUCCESS: Switching from layout[' + currentLayoutIndex + '] to layout[' + nextIndex + ']');
    console.log('');

    setGlobalUndoFurniture((prevGlobalUndoFurniture) => [
      ...prevGlobalUndoFurniture,
      {
        roomId: roomActive,
        type: "index",
        index: currentLayoutIndex, 
      },
    ]);

    const updateRoomActiveLayout = [...roomActiveLayout];
    updateRoomActiveLayout[roomActive] = nextIndex;
    
    // [SHUFFLE-DIAG] PATH B: Cycling to existing layout - compare source vs target
    const _shuffleRoom = roomsData?.[roomActive];
    const _srcLayout = _shuffleRoom?.layouts?.[currentLayoutIndex];
    const _tgtLayout = _shuffleRoom?.layouts?.[nextIndex];
    const _srcFurn0 = _srcLayout?.furniture?.[0];
    const _tgtFurn0 = _tgtLayout?.furniture?.[0];
    const _sfxS = _shuffleRoom?.scaleX || scaleFactorX || 1;
    const _sxcS = scaleXCanvas || 1;
    const _effSXS = _sfxS / _sxcS;
    console.log('[SHUFFLE-DIAG] ══════ PATH B: CYCLING LAYOUT ══════');
    console.log('[SHUFFLE-DIAG] From layout[' + currentLayoutIndex + '] → layout[' + nextIndex + ']');
    if (_srcFurn0) {
      const _srcRaw = _srcFurn0.origionalWidth / _sfxS;
      const _srcVp = _srcFurn0.origionalWidth / _effSXS;
      console.log('[SHUFFLE-DIAG] SOURCE: ' + _srcFurn0.name + ' | width=' + _srcFurn0.width?.toFixed(2) + 'px | origW=' + _srcFurn0.origionalWidth + ' | isVP=' + (Math.abs(_srcFurn0.width - _srcVp) < 2) + ' isRAW=' + (Math.abs(_srcFurn0.width - _srcRaw) < 2));
    }
    if (_tgtFurn0) {
      const _tgtRaw = _tgtFurn0.origionalWidth / _sfxS;
      const _tgtVp = _tgtFurn0.origionalWidth / _effSXS;
      console.log('[SHUFFLE-DIAG] TARGET: ' + _tgtFurn0.name + ' | width=' + _tgtFurn0.width?.toFixed(2) + 'px | origW=' + _tgtFurn0.origionalWidth + ' | isVP=' + (Math.abs(_tgtFurn0.width - _tgtVp) < 2) + ' isRAW=' + (Math.abs(_tgtFurn0.width - _tgtRaw) < 2));
      console.log('[SHUFFLE-DIAG]   Expected RAW: ' + _tgtRaw?.toFixed(2) + ' | Expected VP: ' + _tgtVp?.toFixed(2) + ' | Actual: ' + _tgtFurn0.width?.toFixed(2));
      if (Math.abs(_tgtFurn0.width - _tgtVp) < 2) {
        console.log('[SHUFFLE-DIAG]   ✅ Target is at VIEWPORT scale (same as handleUpdate output)');
      } else if (Math.abs(_tgtFurn0.width - _tgtRaw) < 2) {
        console.log('[SHUFFLE-DIAG]   ⚠️ Target is at RAW scale (modifyRoom output - handleUpdate will SHRINK this!)');
      } else {
        console.log('[SHUFFLE-DIAG]   ❓ Target at UNKNOWN scale: ' + (_tgtFurn0.width / _tgtVp * 100).toFixed(1) + '% of VP');
      }
      console.log('[SHUFFLE-DIAG]   pos.x=' + _tgtFurn0.position?.x?.toFixed(2) + ' | centerX=' + _shuffleRoom?.centerX?.toFixed(2));
    }
    console.log('[SHUFFLE-DIAG] Scale values: sfX=' + _sfxS?.toFixed(6) + ' sxC=' + _sxcS?.toFixed(6) + ' effSX=' + _effSXS?.toFixed(6));
    console.log('[SHUFFLE-DIAG] ════════════════════════════════════');
    
    setRoomActiveLayout(updateRoomActiveLayout);

    trackEngagement({ shuffle: true });
    console.log('🔀'.repeat(40));
    console.log('');
  };

  function loadAndInsertImage(imageSource, containerId) {
    const imageContainer = document.getElementById(containerId);

    imageContainer.innerHTML = "";
//    eventLog(targetWindow, 'floor_plan_event', 'load_image', {
//      galleryId: layoutData?.uuid || layoutData?._id,
//    });

    const imgElement = document.createElement("img");
    imgElement.alt = "Uploaded Image";
    imgElement.classList.add("image-shapes");
    imgElement.draggable = false;

    if (imageSource instanceof File) {
      const reader = new FileReader();

      reader.onload = (event) => {
        imgElement.src = event.target.result;
        imageContainer.appendChild(imgElement);
      };

      reader.onerror = (error) => console.error("Error reading file:", error);
      reader.readAsDataURL(imageSource);
    } else {
      const loadImage = async () => {
        imgElement.src = await getBase64Image(imageSource);
        imageContainer.appendChild(imgElement);
      };
      loadImage();
    }

    imgElement.onload = () => {
      imgElement.style.width = "100%";
      imgElement.style.height = "100%";
      imgElement.style.objectFit = "contain";

      const naturalWidth = imgElement.naturalWidth;
      const naturalHeight = imgElement.naturalHeight;
      const renderedHeight = imgElement.offsetHeight;

      const calculateZoomOut = () => {
        if (!renderedHeight || !naturalWidth || !transformRef.current) return;

        const imageWidth = +(
          (renderedHeight * naturalWidth) /
          naturalHeight
        ).toFixed(0); 
        const imageHeight = renderedHeight;

        if (!imageWidth || !imageHeight) return;

        const scaleFactor = Math.min(
          window.innerWidth / imageWidth,
          divHeight / imageHeight
        );

        const scaledImageWidth = divWidth * scaleFactor;
        const scaledImageHeight = divHeight * scaleFactor;

        const centerOffset = (divWidth - scaledImageWidth) / 2;
        const centerOffsetY = (divHeight - scaledImageHeight) / 2;

        setMinScale(scaleFactor);

        setTimeout(() => {
          if (transformRef.current && zoomChecker) {
            setZoomChecker(false);
            transformRef.current.setTransform(
              centerOffset,
              centerOffsetY,
              scaleFactor
            );
          }
        }, 0); 
      };

      calculateZoomOut();

      setTimeout(() => {
        setImageDimensions({
          orgWidth: naturalWidth,
          orgHeight: naturalHeight,
          width: +((renderedHeight * naturalWidth) / naturalHeight).toFixed(0),
          height: renderedHeight,
        });
      }, 0);

      imagesCount.current = imagesCount.current - 1;
      setImagesCountState((prev) => prev - 1);
    };

    imgElement.onerror = () => {
      console.error("Error Uploading Image");
      imagesCount.current = imagesCount.current - 1;
      setImagesCountState((prev) => prev - 1);
    };
  }

  const updateMarchingAntsAnimation = (newScale) => {
    const totalDashOffset = 8 / newScale + 4 / newScale; 

    const existingStyle = document.getElementById("marching-ants-style");
    if (existingStyle) {
      existingStyle.remove();
    }

    const style = document.createElement("style");
    style.id = "marching-ants-style";
    style.innerHTML = `
      @keyframes marching-ants {
        from {
          stroke-dashoffset: 0;
        }
        to {
          stroke-dashoffset: -${totalDashOffset};
        }
      }
      .marching-ants {
        animation: marching-ants 1s linear infinite;
      }
    `;

    document.head.appendChild(style);
  };

  const updateLineScale = (newScale) => {
    const polylines = document.querySelectorAll(".shape.Line polyline");

    polylines.forEach((polyline) => {
      polyline.setAttribute("stroke-width", `${1 / newScale}`);
      polyline.setAttribute(
        "stroke-dasharray",
        `${8 / newScale},${4 / newScale}`
      ); 
    });

    updateMarchingAntsAnimation(newScale);
  };

  // ─── Gallery "Shuffle it" handoff — claim the intent ─────────────────────
  // Waiting until an armed editor has finished loading means the throwaway
  // first mount from the gallery → editor route change cannot burn the intent,
  // while the editor the user actually lands in claims it exactly once — so a
  // later remount (guest fork-save, back navigation) can't silently drop them
  // into pick mode. The intent's TTL bounds the window if an armed editor never
  // finishes loading. One-shot, and only ever touches the auto-armed case.
  //
  // Claiming is only about the intent. Whether pick mode should survive is a
  // separate question with a different answer time, decided below.
  useEffect(() => {
    if (!autoArmedPickRef.current) return;
    if (layoutLoading || !imagesLoaded) return;
    autoArmedPickRef.current = false;
    consumePendingShuffleIntent(shuffleIntentLayoutKey);
  }, [layoutLoading, imagesLoaded, shuffleIntentLayoutKey]);

  // ─── Gallery "Shuffle it" handoff — stand down with nothing to pick ───────
  // Pick mode hides the primary FAB row, so arming it on a plan with no rooms
  // strands the user with a hint and a Done button. The default editor is the
  // right place for those plans.
  //
  // The decision cannot be made from modalData when the veil lifts, which is
  // what an earlier cut did. modalData is global context that is never reset
  // between layouts, and the payload setter keeps its previous value when a
  // payload has none, so an empty one can mean "not parsed yet" and a full one
  // can mean "the plan before this". Loading order does not settle it either:
  // initializeStatesFromJSON is gated on divWidth/divHeight, which nothing
  // sequences against imagesLoaded, so rooms routinely arrive after the veil is
  // already up — and disarming there was permanent, since the guard runs once.
  // Waiting for this plan's own payload replaces the guess with a fact.
  useEffect(() => {
    if (!armedPickNeedsRoomsRef.current) return;
    if (!payloadRoomsForLayout) return;
    if (payloadRoomsForLayout.layoutId !== (layoutData?._id ?? null)) return;
    armedPickNeedsRoomsRef.current = false;
    // modalData is checked too, so a plan whose rooms reached the canvas by
    // some other route is never disarmed out from under the user.
    if (!payloadRoomsForLayout.count && !modalData?.length) setIsPickingRoom(false);
  }, [payloadRoomsForLayout, layoutData?._id, modalData]);

  // Bound the wait, because the payload is not guaranteed to arrive at all — a
  // plan saved without one, or a fetch that fails, leaves the decision above
  // with nothing to answer, and pick mode would sit armed over an empty canvas
  // for the rest of the session.
  //
  // The clock starts when the editor becomes visible, not on mount. Counting the
  // layout fetch and image load against the same budget would mean a slow enough
  // connection disarms a handoff whose rooms were merely still on their way —
  // turning a network delay into the very bug this guard exists to prevent.
  useEffect(() => {
    if (!armedPickNeedsRoomsRef.current) return undefined;
    if (layoutLoading || !imagesLoaded) return undefined;
    const fallback = setTimeout(() => {
      if (!armedPickNeedsRoomsRef.current) return;
      armedPickNeedsRoomsRef.current = false;
      if (!modalDataRef.current?.length) setIsPickingRoom(false);
    }, ARMED_PICK_MODE_ROOMS_TIMEOUT_MS);
    return () => clearTimeout(fallback);
  }, [layoutLoading, imagesLoaded]);

  // ─── Room-pick canvas overlay ────────────────────────────────────────────
  // position:fixed canvas covers the full viewport; drawing is scoped to
  // divRef bounds (header stays clear). Imperative — zero React re-renders
  // during pan/zoom. Active in three modes:
  //   • isPickingRoom (pre-selection)  — ALL rooms slightly dimmed
  //   • shufflePickedRoom set          — only the picked room spotlighted
  //   • roomActive !== -1 (normal)     — replaces SVG marching ants;
  //                                      spotlights the active room, dims others
  //
  // useLayoutEffect, not useEffect, so the dim is on the canvas before the
  // browser paints the commit that produced it. Passive effects run after paint,
  // which is unnoticeable when the plan is already on screen (the manual Shuffle
  // tap) but lets a frame of undimmed plan through when the editor opens
  // straight into pick mode from the gallery — the commit that finishes loading
  // is also the commit that first makes the plan visible. Same work, scheduled
  // one frame earlier; the canvas still fades in over 200ms either way.
  useLayoutEffect(() => {
    // Resolve the single room to spotlight (null = all rooms equally treated).
    // Gate normal-mode selection on lineBoundary so the canvas never activates
    // for the default roomActive=0 state on initial editor load — only after
    // the user has actually outlined a room (lineBoundary=true).
    const normalSelectedRoom = (!isPickingRoom && shufflePickedRoom == null && roomActive !== -1 && lineBoundary && partnerPackage?.allowMakeMagic)
      ? modalData?.find(r => r.room_id === roomsData?.[roomActive]?.roomId) ?? null
      : null;

    const draw = () => {
      const canvas = overlayCanvasRef.current;
      if (!canvas) return;

      const W = window.innerWidth;
      const H = window.innerHeight;
      if (canvas.width !== W || canvas.height !== H) {
        canvas.width = W;
        canvas.height = H;
      }

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, W, H);

      const inPickMode = isPickingRoom;
      const inPostPickMode = !isPickingRoom && shufflePickedRoom != null;
      const inNormalMode = normalSelectedRoom != null;
      if (!inPickMode && !inPostPickMode && !inNormalMode) return;
      if (!modalData?.length || !scaleXCanvas || !divWidth || !divHeight) return;

      // 1. Dim the floor plan area only (header stays untouched).
      const floorPlanEl = divRef.current;
      if (!floorPlanEl) return;
      const fpBCR = floorPlanEl.getBoundingClientRect();
      ctx.fillStyle = "rgba(8,8,16,0.62)";
      ctx.fillRect(fpBCR.left, fpBCR.top, fpBCR.width, fpBCR.height);

      // 2. Image-container screen rect — includes zoom/pan from TransformWrapper
      const containerEl = document.querySelector(".image-container");
      if (!containerEl) return;
      const imgBCR = containerEl.getBoundingClientRect();
      const sfX = imgBCR.width / divWidth;
      const sfY = imgBCR.height / divHeight;
      const originX = imgBCR.left;
      const originY = imgBCR.top;

      // Convert a room-unit point → screen pixel (same formula as marching-ants SVG)
      const toScreen = (rx, ry) => ({
        x: originX + (rx * scaleXCanvas + offsetXCheck) * sfX,
        y: originY + (ry * scaleYCanvas + offsetYCheck) * sfY,
      });

      // 3. Punch out room polygons via destination-out.
      //
      //    Pre-pick: all rooms get a partial cut (≈16% residual dim).
      //    Post-pick / Normal selection: only the spotlight room is fully cut.
      //    output_alpha = dest_alpha × (1 − src_alpha)
      ctx.globalCompositeOperation = "destination-out";

      if (inPickMode) {
        // Slight overlay on all rooms — partial cut
        ctx.fillStyle = "rgba(0,0,0,0.74)";
        for (const room of modalData) {
          if (!room?.walls?.length) continue;
          const pts = buildRoomPolygon(room.walls);
          if (pts.length < 3) continue;
          ctx.beginPath();
          pts.forEach((pt, i) => {
            const sp = toScreen(pt.x, pt.y);
            if (i === 0) ctx.moveTo(sp.x, sp.y);
            else ctx.lineTo(sp.x, sp.y);
          });
          ctx.closePath();
          ctx.fill();
        }
      } else {
        // Spotlight: fully punch out the active/picked room; others stay dimmed
        ctx.fillStyle = "rgba(0,0,0,1)";
        const room = shufflePickedRoom ?? normalSelectedRoom;
        if (room?.walls?.length) {
          const pts = buildRoomPolygon(room.walls);
          if (pts.length >= 3) {
            ctx.beginPath();
            pts.forEach((pt, i) => {
              const sp = toScreen(pt.x, pt.y);
              if (i === 0) ctx.moveTo(sp.x, sp.y);
              else ctx.lineTo(sp.x, sp.y);
            });
            ctx.closePath();
            ctx.fill();
          }
        }
      }

      ctx.globalCompositeOperation = "source-over";

      // Step 4 (animated/static borders) lives on borderCanvasRef.
    };

    draw();
    drawOverlayRef.current = draw;
  // imagesLoaded is a dependency purely for the gallery "Shuffle it" handoff:
  // pick mode can be armed before the floor plan has its final layout, and
  // unlike the border canvas (rAF loop, self-healing) this dim is drawn once
  // per effect run. Re-running when the plan finishes loading guarantees the
  // dim is present the moment the editor becomes visible. No-op for the manual
  // flow, where imagesLoaded is already true and never changes again.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPickingRoom, shufflePickedRoom, roomActive, lineBoundary, roomsData, modalData, scaleXCanvas, scaleYCanvas, offsetXCheck, offsetYCheck, divWidth, divHeight, partnerPackage, imagesLoaded]);

  // Redraw on window resize while overlay is active (all three modes)
  useEffect(() => {
    if (!isPickingRoom && shufflePickedRoom == null && (roomActive === -1 || !lineBoundary || !partnerPackage?.allowMakeMagic)) return;
    const onResize = () => {
      if (drawOverlayRef.current) requestAnimationFrame(drawOverlayRef.current);
      // Also redraw static border canvas on resize (shuffle mode uses rAF loop already)
      if (drawBordersStaticRef.current) requestAnimationFrame(drawBordersStaticRef.current);
    };
    window.addEventListener("resize", onResize, { passive: true });
    return () => window.removeEventListener("resize", onResize);
  }, [isPickingRoom, shufflePickedRoom, roomActive, lineBoundary, partnerPackage]);

  // ─── Border canvas ────────────────────────────────────────────────────────
  // Two modes sharing one drawBorders helper:
  //
  //   ANIMATED (shuffle/pick) — rAF loop, dashOffset advances 12px/s.
  //   Active when isPickingRoom || shufflePickedRoom != null.
  //   Zero shadowBlur; safe on iPhone SE / mid-range Android.
  //
  //   STATIC (normal room selection) — single draw, no loop.
  //   Active when roomActive !== -1 only (no shuffle state).
  //   Zero continuous CPU/battery cost.
  useEffect(() => {
    const inShuffleMode = isPickingRoom || shufflePickedRoom != null;
    // Normal-mode selection requires lineBoundary=true so the marching-ants border
    // canvas never activates for the default roomActive=0 state on initial load.
    const normalSelectedRoom = (!isPickingRoom && shufflePickedRoom == null && roomActive !== -1 && lineBoundary && partnerPackage?.allowMakeMagic)
      ? modalData?.find(r => r.room_id === roomsData?.[roomActive]?.roomId) ?? null
      : null;
    const inNormalMode = normalSelectedRoom != null;
    const active = inShuffleMode || inNormalMode;

    const bc = borderCanvasRef.current;
    if (!active || !modalData?.length || !scaleXCanvas || !divWidth || !divHeight) {
      if (bc) { const bctx = bc.getContext("2d"); bctx.clearRect(0, 0, bc.width, bc.height); }
      return;
    }

    const DASH_LEN = 8;
    const GAP_LEN  = 4;
    const CYCLE    = DASH_LEN + GAP_LEN;
    const SPEED    = CYCLE / 60;  // 12px/s at 60fps — matches SVG animation

    const drawBorders = (animated) => {
      const canvas = borderCanvasRef.current;
      if (!canvas) return;

      const W = window.innerWidth;
      const H = window.innerHeight;
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }

      const bctx = canvas.getContext("2d");
      bctx.clearRect(0, 0, W, H);

      const containerEl = document.querySelector(".image-container");
      if (!containerEl) return;
      const imgBCR = containerEl.getBoundingClientRect();
      const sfX = imgBCR.width  / divWidth;
      const sfY = imgBCR.height / divHeight;
      const originX = imgBCR.left;
      const originY = imgBCR.top;

      const toScreen = (rx, ry) => ({
        x: originX + (rx * scaleXCanvas + offsetXCheck) * sfX,
        y: originY + (ry * scaleYCanvas + offsetYCheck) * sfY,
      });

      if (animated) {
        dashOffsetRef.current -= SPEED;
        if (dashOffsetRef.current <= -CYCLE) dashOffsetRef.current += CYCLE;
      }

      bctx.lineCap  = "round";
      bctx.lineJoin = "round";
      bctx.setLineDash([DASH_LEN, GAP_LEN]);
      bctx.lineDashOffset = dashOffsetRef.current;

      const drawWalls = () => {
        for (const room of modalData) {
          if (!room.walls?.length) continue;
          for (const w of room.walls) {
            const s = toScreen(parseFloat(w.start.x), parseFloat(w.start.y));
            const e = toScreen(parseFloat(w.end.x),   parseFloat(w.end.y));
            bctx.beginPath();
            bctx.moveTo(s.x, s.y);
            bctx.lineTo(e.x, e.y);
            bctx.stroke();
          }
        }
      };

      // Hover highlight — desktop only, pre-pick shuffle mode only.
      // White polygon fill "undoes" the dim for the hovered room.
      // Zero extra loop: runs inside the already-running rAF.
      const showHover = isPickingRoom && !shufflePickedRoom;
      const hovRoom = showHover ? hoveredRoomRef.current : null;
      if (hovRoom?.walls?.length) {
        const hovPts = buildRoomPolygon(hovRoom.walls);
        if (hovPts.length >= 3) {
          bctx.setLineDash([]);
          bctx.globalCompositeOperation = "source-over";
          bctx.fillStyle = "rgba(255,255,255,0.28)";
          bctx.beginPath();
          hovPts.forEach((pt, i) => {
            const sp = toScreen(pt.x, pt.y);
            if (i === 0) bctx.moveTo(sp.x, sp.y);
            else bctx.lineTo(sp.x, sp.y);
          });
          bctx.closePath();
          bctx.fill();
          bctx.setLineDash([DASH_LEN, GAP_LEN]);
        }
      }

      // Pass 1 — wide translucent halo
      bctx.lineWidth   = 5;
      bctx.strokeStyle = "rgba(255,255,255,0.10)";
      drawWalls();

      // Pass 2 — thin bright core
      bctx.lineWidth   = 1.5;
      bctx.strokeStyle = "rgba(255,255,255,0.92)";
      drawWalls();
    };

    let rafId;

    if (inShuffleMode) {
      // Animated loop — only for shuffle/pick, where motion is meaningful
      drawBordersStaticRef.current = null;
      const frame = () => {
        drawBorders(true);
        rafId = requestAnimationFrame(frame);
      };
      rafId = requestAnimationFrame(frame);
      borderAnimRef.current = rafId;
    } else {
      // Static single draw — normal room selection: zero battery cost.
      // Store fn in ref so handleTransformed can redraw on pan/zoom.
      drawBordersStaticRef.current = () => drawBorders(false);
      drawBorders(false);
      borderAnimRef.current = null;
    }

    const bcAtCleanup = borderCanvasRef.current;
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      borderAnimRef.current = null;
      drawBordersStaticRef.current = null;
      if (bcAtCleanup) { const bctx = bcAtCleanup.getContext("2d"); bctx.clearRect(0, 0, bcAtCleanup.width, bcAtCleanup.height); }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPickingRoom, shufflePickedRoom, roomActive, lineBoundary, roomsData, modalData, scaleXCanvas, scaleYCanvas, offsetXCheck, offsetYCheck, divWidth, divHeight, partnerPackage]);
  // ─── Desktop hover room tracking ─────────────────────────────────────────
  // Active only in pre-pick mode on hover-capable (non-touch) devices.
  // Converts mouse screen coords → image-container coords using the live
  // imgBCR so zoom/pan are always accounted for — no state reads needed.
  useEffect(() => {
    if (!isPickingRoom || !modalData?.length || !scaleXCanvas || !divWidth || !divHeight) {
      hoveredRoomRef.current = null;
      return;
    }
    // Skip on touch-primary devices — hover state is meaningless there.
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    const onMove = (e) => {
      const containerEl = document.querySelector(".image-container");
      if (!containerEl) { hoveredRoomRef.current = null; return; }
      const imgBCR = containerEl.getBoundingClientRect();
      // Convert screen → image-container pixel space (accounts for zoom/pan)
      const icX = (e.clientX - imgBCR.left) * divWidth  / imgBCR.width;
      const icY = (e.clientY - imgBCR.top)  * divHeight / imgBCR.height;
      let found = null;
      for (const room of modalData) {
        if (!room.walls?.length) continue;
        // adjustPointToRoom: (icX - offsetXCheck)/scaleXCanvas → room units
        const rx = (icX - offsetXCheck) / scaleXCanvas;
        const ry = (icY - offsetYCheck) / scaleYCanvas;
        // Ray-casting hit test directly on wall segments (same as isPointInRoomPolygon)
        let inside = false;
        const n = room.walls.length;
        for (let i = 0, j = n - 1; i < n; j = i++) {
          const x1 = parseFloat(room.walls[i].start.x), y1 = parseFloat(room.walls[i].start.y);
          const x2 = parseFloat(room.walls[j].start.x), y2 = parseFloat(room.walls[j].start.y);
          if ((y1 > ry) !== (y2 > ry) && rx < (x2 - x1) * (ry - y1) / (y2 - y1) + x1) {
            inside = !inside;
          }
        }
        if (inside) { found = room; break; }
      }
      hoveredRoomRef.current = found;
    };

    const onLeave = () => { hoveredRoomRef.current = null; };
    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseleave", onLeave, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
      hoveredRoomRef.current = null;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPickingRoom, modalData, divWidth, divHeight, scaleXCanvas, scaleYCanvas, offsetXCheck, offsetYCheck]);
  // ─────────────────────────────────────────────────────────────────────────

  const handleTransformed = (state) => {
    updateLineScale(state?.state?.scale);
    setScale(state?.state?.scale);
    // Redraw canvases on every pan/zoom tick (shuffle, pick, or normal selection).
    // Normal-selection branch additionally requires lineBoundary so a stale
    // roomActive=0 from initial state never triggers a phantom redraw.
    const overlayActive =
      isPickingRoomRef.current ||
      shufflePickedRoomRef.current != null ||
      (roomActiveRef.current != null && roomActiveRef.current !== -1 && lineBoundary && partnerPackage?.allowMakeMagic);
    if (overlayActive && drawOverlayRef.current) {
      requestAnimationFrame(drawOverlayRef.current);
    }
    // In normal-selection mode the border canvas uses a static draw (no rAF loop),
    // so we must explicitly redraw it on every pan/zoom tick too.
    if (drawBordersStaticRef.current) {
      requestAnimationFrame(drawBordersStaticRef.current);
    }
  };

  // Keep minScaleRef in sync so the global-pinch listener always has the current value
  // without needing to re-register event listeners.
  useEffect(() => {
    minScaleRef.current = minScale;
  }, [minScale]);

  // ─── Global pinch-to-floor-plan ──────────────────────────────────────────────
  // Any two-finger gesture anywhere on the screen (including toolbar/header) is
  // forwarded to the floor-plan's zoom/pan.  Single-finger taps are untouched so
  // toolbar buttons remain fully interactive.
  //
  // Strategy:
  //   • touchstart  — record initial pinch state; flag whether the gesture started
  //                   INSIDE the TransformWrapper (library handles that case natively)
  //                   or OUTSIDE (we must drive setTransform ourselves).
  //   • touchmove   — non-passive; always call e.preventDefault() for multi-touch to
  //                   block browser viewport zoom.  Only compute + forward transform
  //                   when we own the gesture (started outside the wrapper).
  //   • touchend / touchcancel — clean up.
  useEffect(() => {
    const pinch = {
      active: false,   // true when WE are driving this gesture
      prevDist: 0,     // finger-to-finger distance on previous frame
      prevMidX: 0,     // screen-coordinate midpoint X on previous frame
      prevMidY: 0,     // screen-coordinate midpoint Y on previous frame
    };

    const getWrapper = () =>
      transformRef.current?.instance?.wrapperComponent ?? null;

    const bothTouchesInsideWrapper = (touches) => {
      const wrapper = getWrapper();
      if (!wrapper) return false;
      return wrapper.contains(touches[0].target) && wrapper.contains(touches[1].target);
    };

    const onTouchStart = (e) => {
      if (e.touches.length < 2) {
        pinch.active = false;
        return;
      }
      // If both fingers land on the wrapper the library handles it natively.
      if (bothTouchesInsideWrapper(e.touches)) {
        pinch.active = false;
        return;
      }
      pinch.active = true;
      const t1 = e.touches[0];
      const t2 = e.touches[1];
      pinch.prevDist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      pinch.prevMidX = (t1.clientX + t2.clientX) / 2;
      pinch.prevMidY = (t1.clientY + t2.clientY) / 2;
    };

    const onTouchMove = (e) => {
      if (e.touches.length < 2) return;

      // Always block the browser's built-in viewport zoom for multi-touch events.
      e.preventDefault();

      // If the library owns this gesture, stop here — it handles the transform.
      if (!pinch.active) return;
      if (!transformRef.current) return;

      const instance = transformRef.current.instance;
      if (!instance?.transformState || !instance?.wrapperComponent) return;

      const t1 = e.touches[0];
      const t2 = e.touches[1];
      const midX = (t1.clientX + t2.clientX) / 2;
      const midY = (t1.clientY + t2.clientY) / 2;
      const dist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);

      const { scale, positionX, positionY } = instance.transformState;
      const wrapperRect = instance.wrapperComponent.getBoundingClientRect();

      // --- Compute new scale ---
      const scaleRatio = pinch.prevDist > 0 ? dist / pinch.prevDist : 1;
      const hardMin = Math.max(0.05, minScaleRef.current - 0.2);
      const hardMax = 5;
      const newScale = Math.min(hardMax, Math.max(hardMin, scale * scaleRatio));

      // --- Keep the floor-plan content point under the pinch midpoint stationary ---
      const localMidX = midX - wrapperRect.left;
      const localMidY = midY - wrapperRect.top;
      const contentX = (localMidX - positionX) / scale;
      const contentY = (localMidY - positionY) / scale;
      let newPosX = localMidX - contentX * newScale;
      let newPosY = localMidY - contentY * newScale;

      // --- Also apply two-finger pan delta ---
      newPosX += midX - pinch.prevMidX;
      newPosY += midY - pinch.prevMidY;

      // Drive the floor-plan transform (animationTime = 0 for instant response).
      transformRef.current.setTransform(newPosX, newPosY, newScale, 0);

      pinch.prevDist = dist;
      pinch.prevMidX = midX;
      pinch.prevMidY = midY;
    };

    const onTouchEnd = (e) => {
      if (e.touches.length < 2) pinch.active = false;
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
      document.removeEventListener('touchcancel', onTouchEnd);
    };
  }, []); // runs once; reads minScaleRef dynamically so no deps needed

  const resetScale = () => {
    if (transformRef.current) {
      transformRef.current.resetTransform();
    }
  };

  const handleMouseDivDown = (e) => {
    isDragDiv.current = false;
    startX.current = e.clientX; 
    startY.current = e.clientY; 
  };

  const handleMouseDivMove = (e) => {
    const deltaX = e.clientX - startX.current; 
    const deltaY = e.clientY - startY.current; 
    const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2); 

    if (distance > 10) {
      isDragDiv.current = true; 
    }
  };

  const handleMouseDivUp = (e) => {
    if (e.target.closest(".edit-icon-container")) {
      return;
    }

    if (shoppingListFlag) {
      return;
    }

    if (!isDragDiv.current) {
      handleDivClick(e); 
    }

    isDragDiv.current = false; 
  };

  const handleDivClick = (e) => {
    // Block the browser-synthesized mouseup/click that fires after a touch-based
    // room-pick.  onTouchStart sets this flag before returning early; we clear it
    // here so normal subsequent taps are unaffected.
    if (mobileRoomJustSwitchedRef.current) {
      mobileRoomJustSwitchedRef.current = false;
      return;
    }

    // While the Add Items modal is open, tapping the canvas (above the modal)
    // should close the modal — but must NOT select a room or deselect anything.
    if (isAdding) {
      setIsAdding(false);
      setAddingFromSomethingElse(false);
      setManualToastDismissed(false);
      setShowZonesMenu(false);
      setOpenFilters(false);
      userDismissedAddItemsRef.current = true;
      // When the modal was opened from the no-room-selected path, a synthetic
      // "custom-room" entry was pushed to roomsData and roomActive was set to
      // its index.  Leaving roomActive !== -1 after dismiss causes addItemsDisabled
      // to hit the findIndex check (vertices.roomId is "" in this flow → returns
      // -1 → Add Items grayed) and Shuffle to fire silently against a roomless
      // API payload.  Clear back to the base no-room state so both FABs work.
      if (roomId === "custom-room") {
        setRoomActive(-1);
        setRoomId(null);
        setLineBoundary(false);
        setVertices({ index: false, vertices: [], roomId: "" });
      }
      return;
    }

    // While a layout is generating (Shuffle / Make Magic), ignore canvas taps
    // so rooms/layouts cannot be selected until loading finishes.
    if (loadingLayout) {
      return;
    }

    // When a zone-picker or filter flyout is open, a tap on the canvas should
    // only collapse that panel — do NOT trigger drawFloors.
    if (roomActive !== -1 && (showZonesMenu || openFilters)) {
      setShowZonesMenu(false);
      setOpenFilters(false);
      return;
    }

    setOptionsMenu(null);

    // Clear furniture selection when clicking the background canvas (click-outside)
    setSelectedFurniture(null);
    setCopySelectedFurniture(null);
    setSelectedItem(null);

    const { offsetX, offsetY } = e.nativeEvent;

    setIsScaleDimensionsMarked(true);
    drawFloors(offsetX, offsetY);
  };

  const resetLayouts = () => {
    eventLog(targetWindow, 'floor_plan_event', 'reset_layout', {
      galleryId: layoutData?.uuid || layoutData?._id,
      galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
    });
    setLineBoundary(false);
    setRoomsData([]);
    setLayouts([]);
    setRoomItemsList([]);
    setKeepItems([]);
    setRoomActiveLayout([]);
    resetScale();

    setErrorLayout({});
    setErrorLayoutGlobal(false);

    setZonesRoom({});
    setRoomId();

    setSelectedFurniture(null);
    setCopySelectedFurniture(null);
    setSelectedItem(null);

    setVertices({ index: false, vertices: [], roomId: "" });
    const lineContainer = document?.getElementById("lineContainer");
    setGlobalUndoFurniture([]);
    setGlobalRedoFurniture([]);

    const shapeElements = lineContainer?.querySelectorAll(".shape");
    shapeElements?.forEach((element) => element?.remove());
  };

  useEffect(() => {
    const lineContainer = document?.getElementById("lineContainer");

    if (lineContainer) {
      const shapeElements = lineContainer.querySelectorAll(".shape");
      shapeElements?.forEach((element) => element?.remove());
    }
  }, [divWidth, divHeight]);

  const getRoomLabel = (zoneArray) => {
    if (!zoneArray || !Array.isArray(zoneArray)) return "Unknown Room";

    const values = zoneArray.map((zone) => zone.value);

    if (values.includes("lounging") && values.includes("dining")) {
      return "Living + Dining";
    }

    const matchedZone = zonesData.find((zone) => values.includes(zone.value));
    return matchedZone ? matchedZone.label : "Unknown Room";
  };

  useEffect(() => {
    if (!loadingLayout) {
      const states = {
        modalVertices,
        modalData,
        divWidth,
        divHeight,
        floors,
        roomActive,
        roomActiveLayout,
        roomsData,
        zonesRoom,
        scaleFactorX,
        scaleFactorY,
        offsetXCheck,
        offsetYCheck,
        scaleXCanvas,
        scaleYCanvas,
        roomItemsList,
        errorLayout,
        errorLayoutGlobal,
        layouts,
        // Never persist OCR into `boxes` — layout-image-generator and legacy
        // scale helpers read that field. Overlay geometry uses planLabelBoxes.
        boxes: [],
        planLabelBoxes,
        isScaleDimensionsMarked,
        selectedFeet,
        selectedInches,
        initialScaleFactorX,
        initialLength,
        calculateInitialLength,
        calculateInitialScaleFactorX,
        textShow,
        selectedResetFeet,
        selectedResetInches,
        calculateScaleFactorX,
        calculateScaleFactorY,
        origin: window.location.origin,
      };

      setAutoSaveDataState(states);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    divWidth,
    divHeight,
    roomActive,
    isScaleDimensionsMarked,
    selectedFeet,
    selectedInches,
    loadingLayout,
    // =====================================================
    // CRITICAL: Include scaleFactorX/Y in dependencies!
    // =====================================================
    // Without these, autoSaveDataState captures stale values
    // and sends wrong scaleFactorX/Y to backend on auto-save.
    // This was the root cause of Plan 2 "major scale inconsistency".
    // =====================================================
    scaleFactorX,
    scaleFactorY,
    roomsData,
    planLabelBoxes,
  ]);

  useEffect(() => {
    if (!loadingLayout) {
      autoSaveDataRef.current = autoSaveDataState;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSaveDataState, loadingLayout]);

  // Keep editor state refs in sync for fork-save (avoids stale closure in useCallback)
  roomsDataRef.current = roomsData;
  roomActiveRef.current = roomActive;
  roomActiveLayoutRef.current = roomActiveLayout;
  zonesRoomRef.current = zonesRoom;

  function saveStatesToJSON() {
    return autoSaveDataState;
  }



  function initializeStatesFromJSON(parsedData) {
    // =====================================================
    // 🔧 GATED COMPREHENSIVE LOGGING (enable with ?debugScale=1)
    // =====================================================
    const sfx = parsedData.scaleFactorX || 1;
    const sfy = parsedData.scaleFactorY || 1;
    const blowUpFactor = 1 / sfx;
    const isExternal = window.location.pathname.includes('floor-gallery') || 
      window.location.pathname.includes('external');
    const flowType = isExternal ? 'EXTERNAL (Gallery→Editor)' : 'INTERNAL';
    const roomCount = parsedData.roomsData?.length || 0;
    const furnCount = parsedData.roomsData?.reduce((sum, r) => 
      sum + (r.layouts?.[0]?.furniture?.length || 0), 0) || 0;
    
    // =====================================================
    // 🎯 EXTERNAL FLOW ENTRY POINT DIAGNOSTIC (CONDENSED)
    // =====================================================
    if (isExternal) {
      const firstFurn = parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0];
      const firstRoom = parsedData.roomsData?.[0];
      if (firstFurn) {
        const storedW = firstFurn.width;
        const origW = firstFurn.origionalWidth;
        const exactX = firstFurn.exactPosition?.x ?? firstFurn.origionalPosition?.x ?? 0;
        const roomSfx = firstRoom?.scaleX || sfx;
        const editorW = origW / roomSfx;
        const widthRatio = storedW && storedW !== 0 ? editorW / storedW : null;
        const mutationExpected = widthRatio !== null && Math.abs(widthRatio - 1) > 0.05;
        console.log(
          '[EXTERNAL FLOW] ' + (mutationExpected ? '⚠️ MUTATION EXPECTED' : '✅ OK') +
          ' | ' + firstFurn.name +
          ' | storedW:' + (storedW?.toFixed(1) || '?') + ' editorW:' + editorW?.toFixed(1) +
          ' | ratio:' + (widthRatio?.toFixed(3) || '?') +
          ' | exactX:' + exactX?.toFixed(2) + ' sfX:' + roomSfx?.toFixed(4) +
          ' | sxC:' + (parsedData.scaleXCanvas?.toFixed(4) || '?') +
          ' | divW:' + (parsedData.divWidth || '?')
        );
      }
    }
    
    // ALWAYS log if mutation likely (single warning line)
    if (blowUpFactor > 1.5) {
      scaleDebug.mutation('INIT: 1/scaleFactorX=' + blowUpFactor.toFixed(2) + 'x | Flow: ' + flowType + ' | Items: ' + furnCount);
    }
    
    // Detailed logging only when debug enabled
    if (scaleDebug.enabled()) {
      console.log('');
      console.log('╔' + '═'.repeat(100) + '╗');
      console.log('║  🚀 [INIT] initializeStatesFromJSON - SCALE DEBUG                                                    ║');
      console.log('╠' + '═'.repeat(100) + '╣');
      console.log('║');
      console.log('║  FLOW TYPE: ' + flowType);
      console.log('║  Rooms: ' + roomCount + ' | Furniture items: ' + furnCount);
      console.log('║');
      console.log('║  ┌─── SCALE FACTORS (API) ────────────────────────────────────────────────────────────────────────┐');
      console.log('║  │  scaleFactorX: ' + scaleDebug.fmt(sfx, 6) + '  →  1/sfx = ' + scaleDebug.fmt(blowUpFactor, 4) + 'x (blow-up factor)');
      console.log('║  │  scaleFactorY: ' + scaleDebug.fmt(sfy, 6));
      console.log('║  │  scaleXCanvas: ' + scaleDebug.fmt(parsedData.scaleXCanvas, 6));
      console.log('║  │  scaleYCanvas: ' + scaleDebug.fmt(parsedData.scaleYCanvas, 6));
      console.log('║  └────────────────────────────────────────────────────────────────────────────────────────────────┘');
      console.log('║');
      console.log('║  ┌─── VIEWPORT ───────────────────────────────────────────────────────────────────────────────────┐');
      console.log('║  │  API viewport: ' + (parsedData.divWidth || 'N/A') + ' x ' + (parsedData.divHeight || 'N/A'));
      console.log('║  │  Current viewport: ' + divWidth + ' x ' + divHeight);
      if (parsedData.divWidth && divWidth) {
        const vpRatio = divWidth / parsedData.divWidth;
        console.log('║  │  Viewport ratio: ' + scaleDebug.fmt(vpRatio, 4) + 'x' + (Math.abs(vpRatio - 1) > 0.1 ? ' ⚠️ SIGNIFICANT CHANGE' : ''));
      }
      console.log('║  └────────────────────────────────────────────────────────────────────────────────────────────────┘');
      console.log('║');
      
      // Log first furniture item for quick reference
      const firstFurn = parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0];
      if (firstFurn) {
        const posX = firstFurn.position?.x;
        const exactX = firstFurn.exactPosition?.x;
        const posExactRatio = exactX && Math.abs(exactX) > 0.001 ? posX / exactX : null;
        
        console.log('║  ┌─── FIRST FURNITURE ITEM ──────────────────────────────────────────────────────────────────────┐');
        console.log('║  │  Name: ' + (firstFurn.name || 'unnamed'));
        console.log('║  │  position.x: ' + scaleDebug.fmt(posX, 2) + ' | exactPosition.x: ' + scaleDebug.fmt(exactX, 2));
        console.log('║  │  width: ' + scaleDebug.fmt(firstFurn.width, 2) + ' | origionalWidth: ' + (firstFurn.origionalWidth || 'N/A'));
        if (posExactRatio !== null) {
          console.log('║  │  pos/exact ratio: ' + scaleDebug.fmt(posExactRatio, 4) + (Math.abs(posExactRatio - 1) < 0.1 ? ' → EXTERNAL FLOW (pos≈exact)' : ' → INTERNAL FLOW'));
        }
        console.log('║  └────────────────────────────────────────────────────────────────────────────────────────────────┘');
      }
      
      // Log per-room scale values
      if (parsedData.roomsData?.length > 0) {
        console.log('║');
        console.log('║  ┌─── PER-ROOM SCALE VALUES ─────────────────────────────────────────────────────────────────────┐');
        parsedData.roomsData.forEach((room, idx) => {
          const roomFurnCount = room.layouts?.[0]?.furniture?.length || 0;
          console.log('║  │  Room[' + idx + '] ' + (room.roomId || 'unnamed') + ': scaleX=' + scaleDebug.fmt(room.scaleX, 4) + 
            ' | scaleXCanvas=' + scaleDebug.fmt(room.scaleXCanvas, 4) + ' | furniture=' + roomFurnCount);
        });
        console.log('║  └────────────────────────────────────────────────────────────────────────────────────────────────┘');
      }
      
      console.log('║');
      console.log('║  ⚠️  PREDICTION: Furniture will be multiplied by ~' + scaleDebug.fmt(blowUpFactor, 2) + 'x in handleUpdate');
      if (blowUpFactor > 1.5) {
        console.log('║  🚨 WARNING: This will cause SCALE MUTATION (furniture appears blown up)');
      }
      console.log('╚' + '═'.repeat(100) + '╝');
      console.log('');
    }
    
    // =====================================================
    // EXISTING DIAGNOSTIC LOGGING (kept for backwards compatibility)
    // =====================================================
    console.log('');
    console.log('█'.repeat(100));
    console.log('█  [DIAGNOSTIC] initializeStatesFromJSON - COMPREHENSIVE DATA DUMP');
    console.log('█'.repeat(100));
    
    // =====================================================
    // SECTION 1: ALL API SCALE VALUES
    // =====================================================
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  📊 SECTION 1: ALL SCALE VALUES FROM API                                                        │');
    console.log('├' + '─'.repeat(98) + '┤');
    console.log('│  VIEWPORT SCALES (scaleXCanvas/scaleYCanvas):');
    console.log('│    scaleXCanvas:', parsedData.scaleXCanvas, typeof parsedData.scaleXCanvas);
    console.log('│    scaleYCanvas:', parsedData.scaleYCanvas, typeof parsedData.scaleYCanvas);
    console.log('│  ');
    console.log('│  FURNITURE SCALES (scaleFactorX/scaleFactorY):');
    console.log('│    scaleFactorX:', parsedData.scaleFactorX, typeof parsedData.scaleFactorX);
    console.log('│    scaleFactorY:', parsedData.scaleFactorY, typeof parsedData.scaleFactorY);
    console.log('│  ');
    console.log('│  OFFSET VALUES:');
    console.log('│    offsetXCheck:', parsedData.offsetXCheck, typeof parsedData.offsetXCheck);
    console.log('│    offsetYCheck:', parsedData.offsetYCheck, typeof parsedData.offsetYCheck);
    console.log('│  ');
    console.log('│  🔑 KEY RATIO: scaleXCanvas / scaleFactorX =', 
      parsedData.scaleXCanvas && parsedData.scaleFactorX 
        ? (parsedData.scaleXCanvas / parsedData.scaleFactorX).toFixed(4) 
        : 'N/A');
    console.log('│  🔑 KEY RATIO: 1 / scaleFactorX =', 
      parsedData.scaleFactorX ? (1 / parsedData.scaleFactorX).toFixed(4) : 'N/A',
      '← This is the "blow up" factor in handleUpdate');
    console.log('└' + '─'.repeat(98) + '┘');
    
    // =====================================================
    // SECTION 2: VIEWPORT INFO
    // =====================================================
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  🖥️  SECTION 2: VIEWPORT INFORMATION                                                             │');
    console.log('├' + '─'.repeat(98) + '┤');
    console.log('│  API SAVED VIEWPORT (if present):');
    console.log('│    divWidth (API):', parsedData.divWidth);
    console.log('│    divHeight (API):', parsedData.divHeight);
    console.log('│  ');
    console.log('│  CURRENT FRONTEND VIEWPORT:');
    console.log('│    divWidth (current):', divWidth);
    console.log('│    divHeight (current):', divHeight);
    console.log('│  ');
    if (parsedData.divWidth && divWidth) {
      const viewportRatioX = divWidth / parsedData.divWidth;
      const viewportRatioY = divHeight / parsedData.divHeight;
      console.log('│  VIEWPORT CHANGE RATIO:');
      console.log('│    X ratio (current/API):', viewportRatioX.toFixed(4), viewportRatioX > 1.1 ? '← SIGNIFICANT CHANGE!' : '');
      console.log('│    Y ratio (current/API):', viewportRatioY.toFixed(4), viewportRatioY > 1.1 ? '← SIGNIFICANT CHANGE!' : '');
    }
    console.log('└' + '─'.repeat(98) + '┘');
    
    // =====================================================
    // SECTION 3: ROOM VERTICES (RAW DATA)
    // =====================================================
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  🏠 SECTION 3: ROOM VERTICES FROM API (modalVertices)                                           │');
    console.log('├' + '─'.repeat(98) + '┤');
    if (parsedData.modalVertices && parsedData.modalVertices.length > 0) {
      const vertices = parsedData.modalVertices;
      const allX = vertices.flatMap((v) => [v[0]?.x, v[1]?.x]).filter(x => x !== undefined);
      const allY = vertices.flatMap((v) => [v[0]?.y, v[1]?.y]).filter(y => y !== undefined);
      const minX = Math.min(...allX);
      const maxX = Math.max(...allX);
      const minY = Math.min(...allY);
      const maxY = Math.max(...allY);
      console.log('│  Vertex count:', vertices.length);
      console.log('│  X range: [', minX.toFixed(2), 'to', maxX.toFixed(2), '] width:', (maxX - minX).toFixed(2));
      console.log('│  Y range: [', minY.toFixed(2), 'to', maxY.toFixed(2), '] height:', (maxY - minY).toFixed(2));
      console.log('│  ');
      console.log('│  First 3 vertices (raw):');
      vertices.slice(0, 3).forEach((v, i) => {
        console.log('│    [' + i + '] start: {x:', v[0]?.x?.toFixed(2), ', y:', v[0]?.y?.toFixed(2), 
          '} end: {x:', v[1]?.x?.toFixed(2), ', y:', v[1]?.y?.toFixed(2), '}');
      });
      console.log('│  ');
      console.log('│  🔑 COORDINATE SPACE ANALYSIS:');
      console.log('│    Vertices in ~' + (maxX > 1000 ? 'PIXEL' : maxX > 10 ? 'SCALED' : 'NORMALIZED') + ' space (maxX=' + maxX.toFixed(0) + ')');
    } else {
      console.log('│  ⚠️ No modalVertices in API data!');
    }
    console.log('└' + '─'.repeat(98) + '┘');
    
    // =====================================================
    // SECTION 4: ROOM DATA (per-room scale values)
    // =====================================================
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  📦 SECTION 4: ROOM DATA (roomsData) - PER-ROOM SCALE VALUES                                    │');
    console.log('├' + '─'.repeat(98) + '┤');
    if (parsedData.roomsData && parsedData.roomsData.length > 0) {
      parsedData.roomsData.forEach((room, idx) => {
        console.log('│  ');
        console.log('│  Room [' + idx + ']: ' + room.roomId);
        console.log('│    scaleXCanvas (room):', room.scaleXCanvas);
        console.log('│    scaleYCanvas (room):', room.scaleYCanvas);
        console.log('│    scaleX (room):', room.scaleX, '← This is used as effectiveScaleX');
        console.log('│    scaleY (room):', room.scaleY);
        console.log('│    offsetX (room):', room.offsetX);
        console.log('│    offsetY (room):', room.offsetY);
        console.log('│    centerX:', room.centerX);
        console.log('│    centerY:', room.centerY);
        console.log('│    payloadVertices exists:', !!room.payloadVertices, room.payloadVertices ? '(' + room.payloadVertices.length + ' vertices)' : '');
        console.log('│    orignalPayloadVertices exists:', !!room.orignalPayloadVertices);
        console.log('│    layouts count:', room.layouts?.length || 0);
        console.log('│    furniture count:', room.layouts?.[0]?.furniture?.length || 0);
      });
    } else {
      console.log('│  ⚠️ No roomsData!');
    }
    console.log('└' + '─'.repeat(98) + '┘');
    
    // =====================================================
    // SECTION 5: FIRST FURNITURE ITEM - DEEP DIVE
    // =====================================================
    const diagFirstRoom = parsedData.roomsData?.[0];
    const diagFirstFurniture = diagFirstRoom?.layouts?.[0]?.furniture?.[0];
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  🪑 SECTION 5: FIRST FURNITURE ITEM - COMPLETE DATA DUMP                                        │');
    console.log('├' + '─'.repeat(98) + '┤');
    if (diagFirstFurniture) {
      console.log('│  name:', diagFirstFurniture.name);
      console.log('│  ');
      console.log('│  POSITION FIELDS (all of them):');
      console.log('│    position:', JSON.stringify(diagFirstFurniture.position));
      console.log('│    exactPosition:', JSON.stringify(diagFirstFurniture.exactPosition));
      console.log('│    origionalPosition:', JSON.stringify(diagFirstFurniture.origionalPosition));
      console.log('│  ');
      console.log('│  SIZE FIELDS (all of them):');
      console.log('│    width:', diagFirstFurniture.width);
      console.log('│    height:', diagFirstFurniture.height);
      console.log('│    origionalWidth:', diagFirstFurniture.origionalWidth);
      console.log('│    origionalHeight:', diagFirstFurniture.origionalHeight);
      console.log('│  ');
      console.log('│  FLAGS:');
      console.log('│    calculateWidth:', diagFirstFurniture.calculateWidth);
      console.log('│    newlyAdded:', diagFirstFurniture.newlyAdded);
      console.log('│  ');
      console.log('│  🔍 COORDINATE SPACE ANALYSIS:');
      const diagEp = diagFirstFurniture.exactPosition;
      const diagPos = diagFirstFurniture.position;
      if (diagEp && diagPos) {
        console.log('│    position === exactPosition?', diagPos.x === diagEp.x && diagPos.y === diagEp.y);
        console.log('│    exactPosition.x:', diagEp.x?.toFixed?.(4) || diagEp.x);
        console.log('│    position.x:', diagPos.x?.toFixed?.(4) || diagPos.x);
      }
      console.log('│  ');
      console.log('│  🧮 PREDICTED TRANSFORM (using handleUpdate formula):');
      const diagRawX = diagFirstFurniture.exactPosition?.x || diagFirstFurniture.origionalPosition?.x || 0;
      const diagSfx = parsedData.scaleFactorX || 1;
      const diagRoomSfx = diagFirstRoom?.scaleX || diagSfx;
      console.log('│    rawX (exactPosition.x):', diagRawX.toFixed?.(4) || diagRawX);
      console.log('│    scaleFactorX (API):', diagSfx);
      console.log('│    room.scaleX:', diagRoomSfx);
      console.log('│    ');
      console.log('│    WITH ÷ scaleFactorX: rawX / scaleFactorX =', diagRawX, '/', diagSfx, '=', (diagRawX / diagSfx).toFixed(4));
      console.log('│    WITHOUT ÷ scaleFactorX: rawX =', diagRawX.toFixed?.(4) || diagRawX);
      console.log('│    RATIO (with/without):', (1/diagSfx).toFixed(4), '← This is the "blow up" factor');
    } else {
      console.log('│  ⚠️ No furniture in first room!');
    }
    console.log('└' + '─'.repeat(98) + '┘');
    
    // =====================================================
    // SECTION 6: ALL FURNITURE COORDINATES (for pattern analysis)
    // =====================================================
    console.log('');
    console.log('┌' + '─'.repeat(98) + '┐');
    console.log('│  📋 SECTION 6: ALL FURNITURE COORDINATES (pattern analysis)                                     │');
    console.log('├' + '─'.repeat(98) + '┤');
    if (diagFirstRoom?.layouts?.[0]?.furniture) {
      const diagFurnitureList = diagFirstRoom.layouts[0].furniture;
      diagFurnitureList.slice(0, 10).forEach((f, idx) => {
        const diagItemEp = f.exactPosition;
        const diagItemPos = f.position;
        console.log('│  [' + idx + '] ' + (f.name || 'unnamed').substring(0, 30));
        console.log('│      exactPosition: {x:', diagItemEp?.x?.toFixed?.(2) || 'N/A', ', y:', diagItemEp?.y?.toFixed?.(2) || 'N/A', '}');
        console.log('│      position:      {x:', diagItemPos?.x?.toFixed?.(2) || 'N/A', ', y:', diagItemPos?.y?.toFixed?.(2) || 'N/A', '}');
        console.log('│      same?', diagItemEp?.x === diagItemPos?.x && diagItemEp?.y === diagItemPos?.y);
      });
      if (diagFurnitureList.length > 10) {
        console.log('│  ... and', diagFurnitureList.length - 10, 'more items');
      }
    }
    console.log('└' + '─'.repeat(98) + '┘');
    
    console.log('');
    console.log('█'.repeat(100));
    console.log('');
    
    // Original logging continues below
    console.log('[INIT] RAW API DATA RECEIVED:');
    console.log('  scaleXCanvas:', parsedData.scaleXCanvas);
    console.log('  scaleYCanvas:', parsedData.scaleYCanvas);
    console.log('  scaleFactorX:', parsedData.scaleFactorX);
    console.log('  scaleFactorY:', parsedData.scaleFactorY);
    console.log('  offsetXCheck:', parsedData.offsetXCheck);
    console.log('  offsetYCheck:', parsedData.offsetYCheck);
    console.log('  divWidth (from API):', parsedData.divWidth);
    console.log('  divHeight (from API):', parsedData.divHeight);
    console.log('  roomsData length:', parsedData.roomsData?.length || 0);
    console.log('  modalVertices length:', parsedData.modalVertices?.length || 0);
    console.log('[INIT] CURRENT VIEWPORT:');
    console.log('  divWidth (current):', divWidth);
    console.log('  divHeight (current):', divHeight);
    
    // =====================================================
    // DIAGNOSTIC: Check if API values came from a different viewport
    // =====================================================
    // If parsedData.divWidth exists and differs from current divWidth,
    // the API values were saved from a DIFFERENT viewport session.
    // This is a sign of potential "scale drift" from old auto-saves.
    // After this fix, divWidth/divHeight should NOT be in the API payload.
    // =====================================================
    if (parsedData.divWidth !== undefined) {
      const viewportMismatch = parsedData.divWidth !== divWidth || parsedData.divHeight !== divHeight;
      console.log('[INIT] ⚠️ VIEWPORT HISTORY DETECTED (divWidth/Height in API):');
      console.log('  API saved from viewport:', parsedData.divWidth, 'x', parsedData.divHeight);
      console.log('  Current viewport:', divWidth, 'x', divHeight);
      console.log('  Viewport mismatch:', viewportMismatch ? '⚠️ YES - potential scale drift source' : '✅ NO');
      if (viewportMismatch) {
        console.log('[INIT] ⚠️ This layout was last saved from a DIFFERENT viewport!');
        console.log('       Scale values in API may be corrupted by previous auto-save.');
        console.log('       After this fix deploys, viewport fields will be stripped from saves.');
      }
    } else {
      console.log('[INIT] ✅ No viewport history in API (divWidth undefined)');
      console.log('       Scale values should be from backend, not corrupted by auto-save');
    }
    
    // Log first room's furniture data if available
    const firstRoom = parsedData.roomsData?.[0];
    if (firstRoom?.layouts?.[0]?.furniture?.[0]) {
      const f = firstRoom.layouts[0].furniture[0];
      console.log('');
      console.log('╔' + '═'.repeat(70) + '╗');
      console.log('║  🪑 [INIT] FIRST FURNITURE ITEM FROM API (RAW DATA)                  ║');
      console.log('╠' + '═'.repeat(70) + '╣');
      console.log('║  name:', f.name);
      console.log('║  COORDINATES (all sources):');
      console.log('║    position:', JSON.stringify(f.position));
      console.log('║    exactPosition:', JSON.stringify(f.exactPosition));
      console.log('║    origionalPosition:', JSON.stringify(f.origionalPosition));
      console.log('║  SIZE:');
      console.log('║    width:', f.width);
      console.log('║    height:', f.height);
      console.log('║    origionalWidth:', f.origionalWidth);
      console.log('║    origionalHeight:', f.origionalHeight);
      console.log('║  FLAGS:');
      console.log('║    calculateWidth:', f.calculateWidth);
      console.log('║    newlyAdded:', f.newlyAdded);
      console.log('║  ');
      console.log('║  🔍 COORDINATE ANALYSIS:');
      // Check if position and exactPosition are identical (screen coords)
      const posEqExact = f.position?.x === f.exactPosition?.x && f.position?.y === f.exactPosition?.y;
      console.log('║    position === exactPosition?', posEqExact, posEqExact ? '← Likely SCREEN coords!' : '');
      // Check if values are small (typical world coords are fractional)
      const hasLargeCoords = (f.position?.x > 100 || f.position?.y > 100) || (f.exactPosition?.x > 100 || f.exactPosition?.y > 100);
      console.log('║    Has large coordinate values (>100)?', hasLargeCoords, hasLargeCoords ? '← Likely SCREEN coords!' : '← Likely WORLD coords');
      console.log('╚' + '═'.repeat(70) + '╝');
    }
    // Log ALL furniture items to see the pattern
    if (firstRoom?.layouts?.[0]?.furniture?.length > 1) {
      console.log('[INIT] ALL FURNITURE COORDINATES FROM API:');
      firstRoom.layouts[0].furniture.slice(0, 5).forEach((f, idx) => {
        console.log(`  [${idx}] ${f.name}: position=${JSON.stringify(f.position)} exactPosition=${JSON.stringify(f.exactPosition)}`);
      });
      if (firstRoom.layouts[0].furniture.length > 5) {
        console.log(`  ... and ${firstRoom.layouts[0].furniture.length - 5} more items`);
      }
    }
    console.log('');
    
    // =====================================================
    // SCALE FIX: Calculate correct scale and adjust scaleFactorX/Y
    // This fixes the external flow bug where backend uses wrong viewport (694px)
    // 
    // Key insight: handleUpdate calculates screen_position = exactPosition / scaleFactorX
    // So instead of transforming positions, we adjust scaleFactorX to produce correct positions
    // =====================================================
    let correctScaleXCanvas = parsedData.scaleXCanvas;
    let correctScaleYCanvas = parsedData.scaleYCanvas;
    let correctOffsetX = parsedData.offsetXCheck;
    let correctOffsetY = parsedData.offsetYCheck;
    let correctScaleFactorX = parsedData.scaleFactorX;
    let correctScaleFactorY = parsedData.scaleFactorY;
    // Note: We no longer transform roomsData - positions are kept original
    // Scale correction is applied at render time via renderScaleCorrectionX/Y
    
    // =====================================================
    // PRODUCTION-MATCHING FIX: Skip scale recalculation for external flow
    // =====================================================
    // PROD behavior: Uses stored API values directly without recalculation
    // STAGING bug: Was recalculating scaleXCanvas based on current viewport,
    //              causing room boundaries to shift relative to furniture
    // 
    // The Gallery image was rendered with stored scaleXCanvas.
    // The Editor must use the SAME scaleXCanvas for consistency.
    // =====================================================
    const isExternalFlowRoute = window.location.pathname.includes('floor-gallery') || 
                                 window.location.pathname.includes('external');
    
    if (isExternalFlowRoute) {
      console.log('');
      console.log('╔' + '═'.repeat(98) + '╗');
      console.log('║  🎯 [EXTERNAL FLOW] VIEWPORT VALUES DEFERRED TO drawVerticesInDiv                                ║');
      console.log('╠' + '═'.repeat(98) + '╣');
      console.log('║  Detected external flow route: ' + window.location.pathname);
      console.log('║  ');
      console.log('║  BEHAVIOR: Nullifying viewport-dependent values from API payload.');
      console.log('║  drawVerticesInDiv will compute the correct scaleXCanvas/offsets');
      console.log('║  for the CURRENT container dimensions, preventing stale overrides.');
      console.log('║  ');
      console.log('║  API values (NOT used for viewport scales):');
      console.log('║    scaleXCanvas:', parsedData.scaleXCanvas?.toFixed(6) || 'N/A', '← IGNORED');
      console.log('║    scaleYCanvas:', parsedData.scaleYCanvas?.toFixed(6) || 'N/A', '← IGNORED');
      console.log('║    offsetXCheck:', parsedData.offsetXCheck?.toFixed(2) || 'N/A', '← IGNORED');
      console.log('║    offsetYCheck:', parsedData.offsetYCheck?.toFixed(2) || 'N/A', '← IGNORED');
      console.log('║  ');
      console.log('║  WORLD values (preserved):');
      console.log('║    scaleFactorX:', parsedData.scaleFactorX?.toFixed(6) || 'N/A');
      console.log('║    scaleFactorY:', parsedData.scaleFactorY?.toFixed(6) || 'N/A');
      console.log('╚' + '═'.repeat(98) + '╝');
      console.log('');
      
      setRenderScaleCorrectionX(1);
      setRenderScaleCorrectionY(1);
      
      // Nullify viewport-dependent values so the setScaleXCanvas/setOffsetXCheck
      // setters below fall back to current state (preserving whatever
      // drawVerticesInDiv has already computed, or letting it compute fresh).
      // Auto-save strips these from the payload, so API values are often
      // undefined or stale from a different viewport — using them caused the
      // "furniture blows up" mutation on re-entry.
      correctScaleXCanvas = null;
      correctScaleYCanvas = null;
      correctOffsetX = null;
      correctOffsetY = null;
    }
    
    // Calculate correct scale using frontend formula (same as drawVerticesInDiv)
    // ONLY for non-external flow (internal flow still needs this for proper viewport adaptation)
    if (!isExternalFlowRoute && parsedData.modalVertices && parsedData.modalVertices.length > 0 && divWidth > 0 && divHeight > 0) {
      const vertices = parsedData.modalVertices;
      const floorsData = parsedData.floors || {};
      const backendViewport = parsedData.backendViewport; // New metadata from backend
      
      // Get vertex bounds
      const allX = vertices.flatMap((v) => [v[0]?.x, v[1]?.x]).filter(x => x !== undefined && x !== null);
      const allY = vertices.flatMap((v) => [v[0]?.y, v[1]?.y]).filter(y => y !== undefined && y !== null);
      
      if (allX.length > 0 && allY.length > 0) {
        const rawMinX = Math.min(...allX);
        const rawMaxX = Math.max(...allX);
        const rawMinY = Math.min(...allY);
        const rawMaxY = Math.max(...allY);
        
        // Apply floors padding (same as drawVerticesInDiv)
        const minX = rawMinX - (floorsData.extraLeft || 0);
        const maxX = rawMaxX + (floorsData.extraRight || 0);
        const minY = rawMinY - (floorsData.extraTop || 0);
        const maxY = rawMaxY + (floorsData.extraBottom || 0);
        
        const shapeWidth = maxX - minX;
        const shapeHeight = maxY - minY;
        
        if (shapeWidth > 0 && shapeHeight > 0) {
          // Calculate scale using THE formula (same as drawVerticesInDiv)
          const scaleX = divWidth / shapeWidth;
          const scaleY = divHeight / shapeHeight;
          const calculatedScale = Math.min(scaleX, scaleY);
          const calculatedOffsetX = (divWidth - shapeWidth * calculatedScale) / 2 - minX * calculatedScale;
          const calculatedOffsetY = (divHeight - shapeHeight * calculatedScale) / 2 - minY * calculatedScale;
          
          const apiScale = parsedData.scaleXCanvas;
          const apiScaleFactorX = parsedData.scaleFactorX;
          const apiScaleFactorY = parsedData.scaleFactorY;
          
          // =====================================================
          // CHECK ROOM DATA FOR ORIGINAL SCALE VALUES
          // =====================================================
          // Auto-save may overwrite parsedData.scaleXCanvas with user's viewport values.
          // But room data preserves the ORIGINAL backend scale values.
          // If room.scaleXCanvas differs from apiScale, use room's value as the reference.
          // =====================================================
          const firstRoom = parsedData.roomsData?.[0];
          const roomScale = firstRoom?.scaleXCanvas;
          const roomScaleFactorX = firstRoom?.scaleX;
          const roomScaleFactorY = firstRoom?.scaleY;
          
          // Determine the TRUE reference scale (room data takes precedence if different)
          // Room data is more reliable because it's not affected by auto-save
          let referenceScale = apiScale;
          let referenceScaleFactorX = apiScaleFactorX;
          let referenceScaleFactorY = apiScaleFactorY;
          let usingRoomData = false;
          
          if (roomScale && Math.abs(roomScale - apiScale) > 0.01) {
            // Room has different scale than API - auto-save likely overwrote API values
            referenceScale = roomScale;
            referenceScaleFactorX = roomScaleFactorX;
            referenceScaleFactorY = roomScaleFactorY;
            usingRoomData = true;
            console.log('[SCALE FIX] *** DETECTED AUTO-SAVE OVERWRITE ***');
            console.log('  API scaleXCanvas:', apiScale?.toFixed(4), '(may be from auto-save)');
            console.log('  Room scaleXCanvas:', roomScale?.toFixed(4), '(original backend value)');
            console.log('  Using ROOM values as reference for correction');
          }
          
          // =====================================================
          // BACKEND VIEWPORT GATING
          // =====================================================
          // If backend provides viewport metadata showing standard dimensions (1920x1080),
          // this layout was authored under the NEW regime. The scales should recalculate
          // correctly without legacy correction.
          // 
          // Only apply legacy correction if:
          // - No backendViewport metadata exists (old 694px era layout), OR
          // - backendViewport shows legacy dimensions (height around 694)
          // =====================================================
          const isModernBackend = backendViewport && 
            backendViewport.width === 1920 && 
            backendViewport.height === 1080;
          const isLegacyLayout = !backendViewport || 
            (backendViewport.height && backendViewport.height < 800); // Legacy was ~694px
          
          // Log backend viewport metadata
          if (backendViewport) {
            console.log('[SCALE FIX] Backend viewport metadata found:', backendViewport);
            console.log('  Backend calculated scale for:', backendViewport.width, 'x', backendViewport.height);
            console.log('  User viewport:', divWidth, 'x', divHeight);
            console.log('  isModernBackend (1920x1080):', isModernBackend);
            console.log('  isLegacyLayout (no metadata or height<800):', isLegacyLayout);
          } else {
            console.log('[SCALE FIX] No backend viewport metadata - assuming LEGACY layout');
          }
          
          console.log('='.repeat(80));
          console.log('[SCALE FIX] ========== SCALE COMPARISON ==========');
          console.log('='.repeat(80));
          console.log('[SCALE FIX] API VALUES:');
          console.log('  scaleXCanvas (from backend):', apiScale);
          console.log('  scaleFactorX (from backend):', apiScaleFactorX);
          console.log('  scaleFactorY (from backend):', apiScaleFactorY);
          if (usingRoomData) {
            console.log('[SCALE FIX] ROOM VALUES (used as reference):');
            console.log('  scaleXCanvas (from room):', referenceScale);
            console.log('  scaleX (from room):', referenceScaleFactorX);
            console.log('  scaleY (from room):', referenceScaleFactorY);
          }
          console.log('[SCALE FIX] CALCULATED VALUES (using user viewport):');
          console.log('  calculatedScale:', calculatedScale);
          console.log('  divWidth:', divWidth, 'divHeight:', divHeight);
          console.log('  shapeWidth:', shapeWidth, 'shapeHeight:', shapeHeight);
          
          // =====================================================
          // 🔬 PETER'S CLAIM ANALYSIS: Scale A vs Scale B
          // =====================================================
          console.log('');
          console.log('📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊');
          console.log('[PETER ANALYSIS] 🔬 SCALE A vs SCALE B COMPARISON');
          console.log('📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊');
          console.log('');
          console.log('[PETER ANALYSIS] Peter claims: "Backend provides Scale A, Frontend calculates Scale B"');
          console.log('[PETER ANALYSIS] Peter\'s fix: "Use Scale A consistently (stop recalculating)"');
          console.log('');
          console.log('[PETER ANALYSIS] SCALE A (from backend):');
          console.log('[PETER ANALYSIS]    scaleXCanvas = ' + (apiScale?.toFixed(6) || 'N/A'));
          console.log('[PETER ANALYSIS]    scaleFactorX = ' + (apiScaleFactorX?.toFixed(6) || 'N/A'));
          console.log('');
          console.log('[PETER ANALYSIS] SCALE B (frontend calculated):');
          console.log('[PETER ANALYSIS]    calculatedScale = ' + calculatedScale.toFixed(6));
          console.log('');
          
          const scaleABDiff = apiScale ? Math.abs(calculatedScale - apiScale) : null;
          const scaleABPercent = apiScale ? ((scaleABDiff / apiScale) * 100) : null;
          
          console.log('[PETER ANALYSIS] DIFFERENCE (A vs B):');
          console.log('[PETER ANALYSIS]    |Scale B - Scale A| = ' + (scaleABDiff?.toFixed(6) || 'N/A'));
          console.log('[PETER ANALYSIS]    Percent difference = ' + (scaleABPercent?.toFixed(2) || 'N/A') + '%');
          console.log('');
          
          console.log('[PETER ANALYSIS] 🔍 FACT CHECK OF PETER\'S CLAIM:');
          if (scaleABPercent !== null && scaleABPercent < 1) {
            console.log('[PETER ANALYSIS]    ✅ Scale A ≈ Scale B (diff < 1%)');
            console.log('[PETER ANALYSIS]    → Peter\'s fix would have MINIMAL effect');
            console.log('[PETER ANALYSIS]    → The mutation is NOT caused by A≠B');
          } else if (scaleABPercent !== null && scaleABPercent < 10) {
            console.log('[PETER ANALYSIS]    ⚠️ Scale A ≠ Scale B (diff ' + scaleABPercent.toFixed(1) + '%)');
            console.log('[PETER ANALYSIS]    → Peter\'s fix would reduce mismatch');
            console.log('[PETER ANALYSIS]    → But this is for VIEWPORT scale, not furniture!');
          } else {
            console.log('[PETER ANALYSIS]    🔴 Scale A ≠ Scale B (diff > 10%)');
            console.log('[PETER ANALYSIS]    → Significant viewport scale mismatch');
          }
          console.log('');
          
          console.log('[PETER ANALYSIS] 🚨 KEY INSIGHT:');
          console.log('[PETER ANALYSIS]    scaleXCanvas is for ROOM VERTICES (viewport fitting)');
          console.log('[PETER ANALYSIS]    scaleFactorX is for FURNITURE (coordinate conversion)');
          console.log('[PETER ANALYSIS]    The "mutation" is caused by ÷ scaleFactorX in handleUpdate');
          console.log('[PETER ANALYSIS]    Using Scale A for scaleXCanvas would NOT fix furniture mutation!');
          console.log('');
          console.log('[PETER ANALYSIS] 💡 THE REAL ISSUE:');
          console.log('[PETER ANALYSIS]    Backend stores position === exactPosition');
          console.log('[PETER ANALYSIS]    Frontend does: position = exactPosition / scaleFactorX');
          console.log('[PETER ANALYSIS]    This creates the ' + (1/(apiScaleFactorX || 1)).toFixed(2) + 'x "blow up"');
          console.log('');
          console.log('📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊📊');
          console.log('');
          
          const scaleMismatchDetected = referenceScale && referenceScale > 0 && 
            Math.abs(calculatedScale - referenceScale) / referenceScale > 0.01;
          
          console.log('[SCALE FIX] COMPARISON (using ' + (usingRoomData ? 'ROOM' : 'API') + ' as reference):');
          console.log('  difference:', referenceScale ? Math.abs(calculatedScale - referenceScale).toFixed(6) : 'N/A');
          console.log('  percentDiff:', referenceScale ? ((Math.abs(calculatedScale - referenceScale) / referenceScale) * 100).toFixed(2) + '%' : 'N/A');
          console.log('  scaleMismatchDetected:', scaleMismatchDetected);
          console.log('  shouldApplyCorrection:', scaleMismatchDetected && isLegacyLayout);
          
          // =====================================================
          // TRANSFORM SOURCE SUMMARY (one line for easy grep)
          // =====================================================
          console.log('='.repeat(80));
          console.log('[TRANSFORM SOURCE] FINAL DECISION:');
          console.log('  scaleXCanvas source:', usingRoomData ? 'ROOM-STORED' : 'API-PROVIDED');
          console.log('  scaleFactorX source:', usingRoomData ? 'ROOM-STORED' : 'API-PROVIDED');
          console.log('  camera (offset/scale) source:', 'FRESHLY COMPUTED from viewport');
          console.log('  correction applied:', scaleMismatchDetected && isLegacyLayout ? 'YES (legacy)' : 'NO');
          console.log('='.repeat(80));
          
          // =====================================================
          // 🔬 KEY DIAGNOSTIC: scaleXCanvas vs scaleFactorX
          // =====================================================
          console.log('');
          console.log('╔' + '═'.repeat(98) + '╗');
          console.log('║  🔬 [DIAGNOSTIC] KEY SCALE COMPARISON: scaleXCanvas vs scaleFactorX                           ║');
          console.log('╠' + '═'.repeat(98) + '╣');
          console.log('║  ');
          console.log('║  These are TWO DIFFERENT scale values used for TWO DIFFERENT purposes:');
          console.log('║  ');
          console.log('║  scaleXCanvas (viewport scale):');
          console.log('║    Value:', referenceScale?.toFixed(6) || apiScale?.toFixed(6) || 'N/A');
          console.log('║    Purpose: Scales room VERTICES to fit viewport');
          console.log('║    Formula: containerWidth / shapeWidth');
          console.log('║    Used in: normalizeVertices → adjustVertices');
          console.log('║  ');
          console.log('║  scaleFactorX (furniture scale):');
          console.log('║    Value:', (referenceScaleFactorX || apiScaleFactorX)?.toFixed(6) || 'N/A');
          console.log('║    Purpose: Converts furniture between screen ↔ canonical coords');
          console.log('║    Used in: handleUpdate (÷ scaleFactorX)');
          console.log('║  ');
          console.log('║  🚨 THE MISMATCH (Peter\'s bug):');
          console.log('║    Room vertices: × cameraRatio only');
          console.log('║    Furniture: ÷ scaleFactorX × cameraRatio');
          console.log('║  ');
          console.log('║    1/scaleFactorX =', (1/(referenceScaleFactorX || apiScaleFactorX || 1)).toFixed(4));
          console.log('║    This means furniture is scaled by ~' + (1/(referenceScaleFactorX || apiScaleFactorX || 1)).toFixed(2) + 'x MORE than room!');
          console.log('║  ');
          if ((1/(referenceScaleFactorX || apiScaleFactorX || 1)) > 1.5) {
            console.log('║  ⚠️⚠️⚠️ MISMATCH DETECTED: Furniture will be ~' + (1/(referenceScaleFactorX || apiScaleFactorX || 1)).toFixed(1) + 'x larger than room! ⚠️⚠️⚠️');
          }
          console.log('╚' + '═'.repeat(98) + '╝');
          console.log('');
          
          // =====================================================
          // ONLY APPLY CORRECTION FOR LEGACY LAYOUTS
          // =====================================================
          // For modern layouts (1920x1080), the frontend should recalculate scale
          // based on user viewport WITHOUT applying a legacy correction factor.
          // The furniture positions in modern layouts are in the correct coordinate space.
          // =====================================================
          if (scaleMismatchDetected && isLegacyLayout) {
            // Use referenceScale (from room data if auto-save detected, otherwise from API)
            const scaleRatio = calculatedScale / referenceScale;
            
            console.log('='.repeat(80));
            console.log('[SCALE FIX] *** LEGACY LAYOUT - APPLYING CORRECTION ***');
            console.log('='.repeat(80));
            console.log('[SCALE FIX] CORRECTION DETAILS:');
            console.log('  Layout type: LEGACY (no 1920x1080 metadata)');
            console.log('  Reference scale source:', usingRoomData ? 'ROOM DATA (original)' : 'API');
            console.log('  Reference scale:', referenceScale?.toFixed(6));
            console.log('  User calculated scale:', calculatedScale?.toFixed(6));
            console.log('  Scale ratio (calculated/reference):', scaleRatio.toFixed(6));
            
            // =====================================================
            // RENDER-ONLY CORRECTION (NO MUTATION!)
            // =====================================================
            // Instead of transforming exactPosition/origionalPosition (which get saved back),
            // we store a correction factor and apply it ONLY when rendering.
            // 
            // This prevents the "compounding drift" problem where:
            // - User A loads, transforms, saves → positions change
            // - User B loads, transforms again, saves → positions drift further
            // - Over time, furniture positions become completely wrong
            //
            // The formula in handleUpdate is: screen_pos = exactPosition / scaleFactorX
            // We multiply the result by scaleRatio to get correct screen position:
            //   corrected_screen_pos = (exactPosition / scaleFactorX) * renderScaleCorrection
            // =====================================================
            console.log('[SCALE FIX - RENDER ONLY] Applying correction factor (NOT mutating positions):');
            console.log('  scaleRatio:', scaleRatio.toFixed(4));
            console.log('  This will be applied at RENDER time only');
            console.log('  Original positions will be PRESERVED for saving');
            
            // Set the render-only correction factor
            // This will be applied in handleUpdate when calculating screen positions
            setRenderScaleCorrectionX(scaleRatio);
            setRenderScaleCorrectionY(scaleRatio);
            
            console.log('[SCALE FIX - RENDER ONLY] Set renderScaleCorrectionX/Y to:', scaleRatio.toFixed(4));
            
            // Log example of how correction will work
            if (parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]) {
              const f = parsedData.roomsData[0].layouts[0].furniture[0];
              const oldExactX = f.exactPosition?.x || f.origionalPosition?.x || 0;
              console.log('[SCALE FIX - RENDER ONLY] EXAMPLE - First furniture:');
              console.log('  Furniture:', f.name);
              console.log('  exactPosition.x (PRESERVED):', oldExactX.toFixed(2));
              console.log('  Without correction: screen_x = ' + oldExactX.toFixed(2) + ' / ' + apiScaleFactorX?.toFixed(4) + ' = ' + (oldExactX / apiScaleFactorX).toFixed(2));
              console.log('  With correction: screen_x = ' + (oldExactX / apiScaleFactorX).toFixed(2) + ' * ' + scaleRatio.toFixed(4) + ' = ' + ((oldExactX / apiScaleFactorX) * scaleRatio).toFixed(2));
            }
            
            // DO NOT transform roomsData - keep original positions
            // Scale correction applied via renderScaleCorrectionX/Y at render time
            
            // Use the correct scale values
            correctScaleXCanvas = calculatedScale;
            correctScaleYCanvas = calculatedScale;
            correctOffsetX = calculatedOffsetX;
            correctOffsetY = calculatedOffsetY;
          } else if (scaleMismatchDetected && isModernBackend) {
            // =====================================================
            // MODERN LAYOUT (1920x1080) - DO NOT APPLY LEGACY CORRECTION
            // =====================================================
            // This layout was authored with the new backend (1920x1080).
            // The scale mismatch is expected because user viewport differs from backend.
            // The frontend should recalculate scale WITHOUT applying a correction factor.
            // Furniture positions are already in the correct coordinate space.
            // =====================================================
            console.log('='.repeat(80));
            console.log('[SCALE FIX] *** MODERN LAYOUT (1920x1080) - NO CORRECTION APPLIED ***');
            console.log('='.repeat(80));
            console.log('[SCALE FIX] Scale mismatch detected but this is a MODERN layout');
            console.log('  Backend viewport: 1920x1080 (standard)');
            console.log('  User viewport:', divWidth, 'x', divHeight);
            console.log('  API scale:', apiScale?.toFixed(6));
            console.log('  Calculated scale:', calculatedScale?.toFixed(6));
            console.log('  NOT applying renderScaleCorrection - furniture coords are in correct space');
            
            // Use calculated scale values for user's viewport
            correctScaleXCanvas = calculatedScale;
            correctScaleYCanvas = calculatedScale;
            correctOffsetX = calculatedOffsetX;
            correctOffsetY = calculatedOffsetY;
            
            // NO correction - let frontend recalculate naturally
            setRenderScaleCorrectionX(1);
            setRenderScaleCorrectionY(1);
          } else if (!apiScale || apiScale <= 0) {
            // No API scale provided, use calculated values
            console.log('[SCALE FIX] No API scale, using calculated values');
            correctScaleXCanvas = calculatedScale;
            correctScaleYCanvas = calculatedScale;
            correctOffsetX = calculatedOffsetX;
            correctOffsetY = calculatedOffsetY;
            // Reset render correction - no correction needed for fresh layouts
            setRenderScaleCorrectionX(1);
            setRenderScaleCorrectionY(1);
          } else {
            console.log('[SCALE FIX] Scales match - no adjustment needed');
            // Reset render correction - scales already match
            setRenderScaleCorrectionX(1);
            setRenderScaleCorrectionY(1);
          }
        }
      }
    }
    // =====================================================
    // END SCALE FIX
    // =====================================================
    
    setModalVertices((data) => parsedData.modalVertices || data);
    setModalData((data) => parsedData.modalData || data);
    // Read from the payload rather than from modalData afterwards: the setter
    // above falls back to the existing value, which is the previous plan's rooms
    // when this one has none. This is the only place the room count for a
    // specific plan is knowable, so it is where the armed-open guard gets its
    // answer from.
    setPayloadRoomsForLayout({
      layoutId: layoutData?._id ?? null,
      count: parsedData.modalData?.length ?? 0,
    });

    setPlanLabelBoxes(
      normalizeTextBoxes(
        parsedData.planLabelBoxes ||
          parsedData.text_boxes ||
          // Legacy mid-flight payloads that mistakenly stored OCR under boxes.
          parsedData.boxes ||
          []
      )
    );
    setRoomActiveLayout((data) => parsedData.roomActiveLayout || data);

    // Correct room.scaleX/Y BEFORE loading into state (applies to both branches below).
    // calculateScaleFactorX is never overwritten by auto-save, so it retains the backend's
    // original value. room.scaleX can be corrupted if auto-save persisted a different scaleFactorX.
    const origSFX = parsedData.calculateScaleFactorX;
    const origSFY = parsedData.calculateScaleFactorY;
    if (parsedData.roomsData && origSFX && Number.isFinite(origSFX) && origSFX > 0) {
      parsedData.roomsData = parsedData.roomsData.map((room, idx) => {
        if (room.scaleX && Math.abs(room.scaleX - origSFX) > 0.0001) {
          console.log('[SCALE FIX] Room ' + idx + ' scaleX corrected: ' + room.scaleX + ' → ' + origSFX + ' (auto-save had corrupted it)');
          return { ...room, scaleX: origSFX, scaleY: origSFY || room.scaleY };
        }
        return room;
      });
    }

    if(!partnerPackage?.allowMakeMagic){
      setRoomsData((prevRoomsData) => {
        // RENDER-ONLY FIX: Always use ORIGINAL data - positions are NOT transformed
        // Scale correction is applied at render time via renderScaleCorrectionX/Y
        const prevRooms = parsedData?.roomsData || prevRoomsData;
        const existingRoomIndex = prevRooms.findIndex(
          (room) => room.roomId === "custom-room"
        );

        if (existingRoomIndex !== -1) {
          return prevRooms;
        } else {
          setRoomItemsList((prevRoomItemsList) => {
            const initializedItemsArray = Array.from({ length: 1 }, () =>
              Array.from({ length: 1 }, () => [])
            );

            const combinedArray = [
              ...prevRoomItemsList,
              ...initializedItemsArray,
            ];
            return combinedArray;
          });

          const newCustomRoom = {
            layouts: [
              {
                room: {
                  width: 124,
                  height: 214,
                  shape: "box-shape",
                  zone: [
                    {
                      value: "workingvanity",
                      capacity: 1,
                    },
                  ],
                  position: {
                    x: 0,
                    y: 0,
                    z: 0,
                  },
                },
                doors: [],
                windows: [],
                furniture: [],
                vertices: [],
                prompt: "",
              },
            ],
            payloadVertices: [],
            doors: [],
            windows: [],
            scaleX: scaleFactorX,
            scaleY: scaleFactorY,
            centerX: 1500,
            centerY: divHeight / 2,
            roomId: "custom-room",
            orignalPayloadVertices: [],
            scaleXCanvas: scaleXCanvas,
            scaleYCanvas: scaleYCanvas,
            offsetX: offsetXCheck,
            offsetY: offsetYCheck,
            zones: [{ value: "custom", label: "Custom Room" }],
            resultRoomVerticesState: {},
          };

          const newIndex = prevRooms.length;

          setRoomActiveLayout((prevActiveLayout) => {
            const newLayout = [...prevActiveLayout];
            newLayout[newIndex] = 0;
            return newLayout;
          });

          return [...prevRooms, newCustomRoom];
        }
      });
    } else{
      // RENDER-ONLY FIX: Always use ORIGINAL data - positions are NOT transformed
      // room.scaleX correction already applied above (before if/else)
      setRoomsData((data) => parsedData.roomsData || data);
    }


    setRoomItemsList((data) => parsedData.roomItemsList || data);

  
    const blacklistValues = {
      gettingready: setVanityIndexByRoom,
      watchingtv: setTvIndexByRoom,
      storagemedia: setStorageIndexByRoom,
    };
    
    setZonesRoom((prevData) => {
      const zonesRoom = parsedData.zonesRoom || prevData;
    
      Object.entries(zonesRoom).forEach(([roomId, zones]) => {
        const foundTypes = new Set();
    
        zones.forEach((zone) => {
          if (blacklistValues[zone.value]) {
            foundTypes.add(zone.value);
          }
        });
    
        Object.entries(blacklistValues).forEach(([zoneType, setter]) => {
          setter((prev) => ({
            ...prev,
            [roomId]: foundTypes.has(zoneType) ? 0 : 1,  
          }));
        });
      });
    
      return zonesRoom;
    });    
    
    // =====================================================
    // SCALE DEBUG: COMPREHENSIVE API DATA LOGGING
    // =====================================================
    console.log('='.repeat(80));
    console.log('[SCALE DEBUG] ========== initializeStatesFromJSON CALLED ==========');
    console.log('='.repeat(80));
    
    // 1. Scale values being SET from API
    console.log('[SCALE DEBUG] API SCALE VALUES BEING SET:', {
      scaleXCanvas: parsedData.scaleXCanvas,
      scaleYCanvas: parsedData.scaleYCanvas,
      offsetXCheck: parsedData.offsetXCheck,
      offsetYCheck: parsedData.offsetYCheck,
      scaleFactorX: parsedData.scaleFactorX,
      scaleFactorY: parsedData.scaleFactorY,
      calculateScaleFactorX: parsedData.calculateScaleFactorX,
    });
    
    // 2. Floors data (critical for scale calculation)
    console.log('[SCALE DEBUG] FLOORS DATA FROM API:', parsedData.floors);
    
    // 3. Modal vertices (shape dimensions)
    if (parsedData.modalVertices && parsedData.modalVertices.length > 0) {
      const allX = parsedData.modalVertices.flatMap((v) => [v[0]?.x, v[1]?.x]).filter(x => x !== undefined);
      const allY = parsedData.modalVertices.flatMap((v) => [v[0]?.y, v[1]?.y]).filter(y => y !== undefined);
      const minX = Math.min(...allX);
      const maxX = Math.max(...allX);
      const minY = Math.min(...allY);
      const maxY = Math.max(...allY);
      
      // Calculate what scale SHOULD be using frontend formula
      const floorsData = parsedData.floors || {};
      const adjMinX = minX - (floorsData.extraLeft || 0);
      const adjMaxX = maxX + (floorsData.extraRight || 0);
      const adjMinY = minY - (floorsData.extraTop || 0);
      const adjMaxY = maxY + (floorsData.extraBottom || 0);
      const shapeW = adjMaxX - adjMinX;
      const shapeH = adjMaxY - adjMinY;
      
      console.log('[SCALE DEBUG] CALCULATED SHAPE FROM VERTICES:', {
        vertexCount: parsedData.modalVertices.length,
        rawMinX: minX,
        rawMaxX: maxX,
        rawMinY: minY,
        rawMaxY: maxY,
        rawShapeWidth: maxX - minX,
        rawShapeHeight: maxY - minY,
        adjustedShapeWidth: shapeW,
        adjustedShapeHeight: shapeH,
        // What frontend WOULD calculate (need divWidth/divHeight)
        note: 'Frontend scale = Math.min(divWidth/shapeW, divHeight/shapeH)',
      });
    }
    
    // 4. Rooms data with furniture positions
    console.log('[SCALE DEBUG] ROOMS DATA SUMMARY:');
    parsedData.roomsData?.forEach((room, idx) => {
      console.log(`[SCALE DEBUG] Room ${idx} (${room.roomId}):`, {
        scaleXCanvas: room.scaleXCanvas,
        scaleYCanvas: room.scaleYCanvas,
        offsetX: room.offsetX,
        offsetY: room.offsetY,
        scaleX: room.scaleX,
        scaleY: room.scaleY,
        layoutCount: room.layouts?.length,
        furnitureCount: room.layouts?.[0]?.furniture?.length,
      });
      
      // Log first few furniture items
      room.layouts?.[0]?.furniture?.slice(0, 3).forEach((item, fIdx) => {
        console.log(`[SCALE DEBUG]   Furniture ${fIdx}:`, {
          name: item.name,
          position: item.position,
          origionalPosition: item.origionalPosition,
          exactPosition: item.exactPosition,
          width: item.width,
          height: item.height,
          origionalWidth: item.origionalWidth,
          origionalHeight: item.origionalHeight,
        });
      });
    });
    
    // Log final state values
    console.log('='.repeat(80));
    console.log('[SCALE FIX] ========== FINAL STATE VALUES BEING SET ==========');
    console.log('='.repeat(80));
    console.log('[SCALE FIX] VALUES TO SET:');
    console.log('  scaleXCanvas:', correctScaleXCanvas);
    console.log('  scaleYCanvas:', correctScaleYCanvas);
    console.log('  offsetXCheck:', correctOffsetX);
    console.log('  offsetYCheck:', correctOffsetY);
    console.log('  scaleFactorX:', correctScaleFactorX, '(original:', parsedData.scaleFactorX, ')');
    console.log('  scaleFactorY:', correctScaleFactorY, '(original:', parsedData.scaleFactorY, ')');
    console.log('  renderScaleCorrectionX:', renderScaleCorrectionX, '(render-only, NOT saved to DB)');
    console.log('  renderScaleCorrectionY:', renderScaleCorrectionY, '(render-only, NOT saved to DB)');
    
    // [E2E-INIT] Log what the API payload contains for scale/viewport fields
    console.log('[E2E-INIT] ══════ initializeStatesFromJSON — API PAYLOAD ══════');
    console.log('[E2E-INIT] parsedData.scaleFactorX:', parsedData.scaleFactorX);
    console.log('[E2E-INIT] parsedData.scaleXCanvas:', parsedData.scaleXCanvas);
    console.log('[E2E-INIT] parsedData.calculateScaleFactorX:', parsedData.calculateScaleFactorX);
    console.log('[E2E-INIT] parsedData.offsetXCheck:', parsedData.offsetXCheck);
    console.log('[E2E-INIT] parsedData.divWidth:', parsedData.divWidth, 'parsedData.divHeight:', parsedData.divHeight);
    console.log('[E2E-INIT] First room scaleX:', parsedData.roomsData?.[0]?.scaleX);
    console.log('[E2E-INIT] First room scaleXCanvas:', parsedData.roomsData?.[0]?.scaleXCanvas);
    console.log('[E2E-INIT] First room centerX:', parsedData.roomsData?.[0]?.centerX);
    console.log('[E2E-INIT] First furniture stored width:', parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]?.width);
    console.log('[E2E-INIT] First furniture origionalWidth:', parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]?.origionalWidth);
    console.log('[E2E-INIT] First furniture exactPosition:', JSON.stringify(parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]?.exactPosition));
    console.log('[E2E-INIT] First furniture position:', JSON.stringify(parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]?.position));
    console.log('[E2E-INIT] ══════════════════════════════════════════════════════');
    
    // =====================================================
    // Keep scaleFactorX/Y from API - we transform positions instead
    // =====================================================
    // FALLBACK CHAIN: API payload -> room data -> current state
    // Room data (parsedData.roomsData[0].scaleX) is a reliable fallback
    // because it's stored with each room and not stripped from auto-save
    // =====================================================
    setScaleFactorX((data) => {
      // Priority: calculateScaleFactorX (original backend, never corrupted by auto-save)
      //         > scaleFactorX from API payload
      //         > room data > current state
      // calculateScaleFactorX is stripped from auto-save, so it always retains the
      // backend's original value. scaleFactorX can be corrupted if the calibration
      // useEffect or picker changed it and auto-save persisted the new value.
      const fromCalculate = parsedData.calculateScaleFactorX;
      const fromApi = parsedData.scaleFactorX;
      const fromRoom = parsedData.roomsData?.[0]?.scaleX;
      let valueToSet;
      
      if (fromCalculate !== undefined && Number.isFinite(fromCalculate) && fromCalculate > 0) {
        valueToSet = fromCalculate;
        scaleFactorFromApiRef.current = true;
        console.log('[SCALE FIX] setScaleFactorX: using calculateScaleFactorX (original backend):', valueToSet,
          '| scaleFactorX from API was:', fromApi, '| diff:', fromApi ? Math.abs(fromApi - valueToSet).toFixed(6) : 'N/A');
        console.log('[SCALE INVARIANT] ✅ scaleFactorFromApiRef set to TRUE - calibration overwrite blocked');
      } else if (fromApi !== undefined && Number.isFinite(fromApi) && fromApi > 0) {
        valueToSet = fromApi;
        scaleFactorFromApiRef.current = true;
        console.log('[SCALE FIX] setScaleFactorX: using API scaleFactorX (calculateScaleFactorX unavailable):', valueToSet);
        console.log('[SCALE INVARIANT] ✅ scaleFactorFromApiRef set to TRUE - calibration overwrite blocked');
      } else if (fromRoom !== undefined && Number.isFinite(fromRoom) && fromRoom > 0) {
        valueToSet = fromRoom;
        scaleFactorFromApiRef.current = true;
        console.log('[SCALE FIX] setScaleFactorX: API undefined, using room.scaleX fallback:', valueToSet);
        console.log('[SCALE INVARIANT] ✅ scaleFactorFromApiRef set to TRUE (from room data)');
      } else if (Number.isFinite(data) && data > 0) {
        valueToSet = data;
        console.log('[SCALE FIX] setScaleFactorX: no API/room data, keeping current:', valueToSet);
      } else {
        valueToSet = 1; // Safe fallback
        console.log('[SCALE FIX] setScaleFactorX: all sources invalid, using safe default:', valueToSet);
      }
      return valueToSet;
    });
    setScaleFactorY((data) => {
      const fromCalculate = parsedData.calculateScaleFactorY;
      const fromApi = parsedData.scaleFactorY;
      const fromRoom = parsedData.roomsData?.[0]?.scaleY;
      let valueToSet;
      
      if (fromCalculate !== undefined && Number.isFinite(fromCalculate) && fromCalculate > 0) {
        valueToSet = fromCalculate;
        console.log('[SCALE FIX] setScaleFactorY: using calculateScaleFactorY (original backend):', valueToSet,
          '| scaleFactorY from API was:', fromApi);
      } else if (fromApi !== undefined && Number.isFinite(fromApi) && fromApi > 0) {
        valueToSet = fromApi;
        console.log('[SCALE FIX] setScaleFactorY: using API value:', valueToSet);
      } else if (fromRoom !== undefined && Number.isFinite(fromRoom) && fromRoom > 0) {
        valueToSet = fromRoom;
        console.log('[SCALE FIX] setScaleFactorY: API undefined, using room.scaleY fallback:', valueToSet);
      } else if (Number.isFinite(data) && data > 0) {
        valueToSet = data;
        console.log('[SCALE FIX] setScaleFactorY: no API/room data, keeping current:', valueToSet);
      } else {
        valueToSet = 1; // Safe fallback
        console.log('[SCALE FIX] setScaleFactorY: all sources invalid, using safe default:', valueToSet);
      }
      return valueToSet;
    });

    setCalculateScaleFactorX(
      (data) => parsedData.calculateScaleFactorX || data
    );

    // PATCH 2A continued: Use CORRECTED scale values - properly handle 0 values
    setOffsetXCheck((data) => {
      const valueToSet = correctOffsetX !== undefined && correctOffsetX !== null ? correctOffsetX : data;
      console.log('[SCALE FIX] setOffsetXCheck:', data, '->', valueToSet);
      return valueToSet;
    });
    setOffsetYCheck((data) => {
      const valueToSet = correctOffsetY !== undefined && correctOffsetY !== null ? correctOffsetY : data;
      console.log('[SCALE FIX] setOffsetYCheck:', data, '->', valueToSet);
      return valueToSet;
    });
    setScaleXCanvas((data) => {
      const valueToSet = correctScaleXCanvas !== undefined && correctScaleXCanvas !== null ? correctScaleXCanvas : data;
      console.log('[SCALE FIX] setScaleXCanvas:', data, '->', valueToSet, '(calculated, not API!)');
      return valueToSet;
    });
    setFloors((data) => parsedData.floors || data);
    setScaleYCanvas((data) => {
      const valueToSet = correctScaleYCanvas !== undefined && correctScaleYCanvas !== null ? correctScaleYCanvas : data;
      console.log('[SCALE FIX] setScaleYCanvas:', data, '->', valueToSet);
      return valueToSet;
    });
    setErrorLayoutGlobal((data) => parsedData.errorLayoutGlobal || data);
    setErrorLayout((data) => parsedData.errorLayout || data);
    setLayouts((data) => parsedData.layouts || data);
    setVertices((data) => parsedData.vertices || data);

    setSelectedFeet(
      (data) =>
        parsedData?.globalSelectedFeet || parsedData.selectedFeet || data
    );

    setSelectedInches(
      (data) =>
        parsedData?.globalSelectedInches || parsedData.selectedInches || data
    );

    setSelectedResetFeet(
      (data) =>
        parsedData?.globalResetSelectedFeet ||
        parsedData.selectedResetFeet ||
        data
    );
    setIsScaleDimensionsMarked((data) =>
      parsedData?.globalSelectedFeet !== 0 &&
      parsedData?.globalSelectedFeet !== null
        ? true
        : parsedData.isScaleDimensionsMarked === "select"
        ? ""
        : parsedData.isScaleDimensionsMarked || data
    );

    setSelectedResetInches(
      (data) =>
        parsedData?.globalResetSelectedInches ||
        parsedData.selectedResetInches ||
        data
    );

    setInitialLength((data) => parsedData.initialLength || data);
    setCalculateInitialLength(
      (data) => parsedData.calculateInitialLength || data
    );

    setTextShow((data) => parsedData?.textShow ?? data);
    setInitialScaleFactorX((data) => parsedData.initialScaleFactorX || data);
    setCalculateInitialScaleFactorX(
      (data) => parsedData.calculateInitialScaleFactorX || data
    );

    setImageDimensions((data) => parsedData.imageDimensions || data);
    
    // =====================================================
    // TRIPWIRE: Initialize World Geometry Hash
    // =====================================================
    // Compute and store hash of world geometry after initialization.
    // This will be compared before auto-save to detect corruption.
    // IMPORTANT: Also reset hasUserEditedRef so each session starts clean.
    // Tripwire only blocks when hasUserEditedRef === false (no user edits yet).
    // =====================================================
    console.log('[TRIPWIRE INIT] Checking if world geometry hash needs initialization...');
    console.log('[TRIPWIRE INIT] parsedData.roomsData exists:', !!parsedData.roomsData);
    console.log('[TRIPWIRE INIT] parsedData.roomsData length:', parsedData.roomsData?.length);
    console.log('[TRIPWIRE INIT] parsedData.modalVertices exists:', !!parsedData.modalVertices);
    console.log('[TRIPWIRE INIT] parsedData.modalVertices length:', parsedData.modalVertices?.length);
    console.log('[TRIPWIRE INIT] worldGeometryInitializedRef.current:', worldGeometryInitializedRef.current);
    
    if ((parsedData.roomsData || parsedData.modalVertices) && !worldGeometryInitializedRef.current) {
      const initialHash = computeWorldGeometryHash(parsedData.roomsData, parsedData.modalVertices);
      console.log('[TRIPWIRE INIT] Computed initial hash:', initialHash);
      
      if (initialHash) {
        worldGeometryHashRef.current = initialHash;
        worldGeometryInitializedRef.current = true;
        // RESET hasUserEditedRef - new session means no user edits yet
        hasUserEditedRef.current = false;
        console.log('[TRIPWIRE INIT] ✅ World geometry hash initialized successfully');
        console.log('[TRIPWIRE INIT] ✅ hasUserEditedRef reset to false (new session)');
        console.log('[TRIPWIRE INIT] Hash includes: modalVertices + furniture exactPosition');
        console.log('[TRIPWIRE INIT] TRIPWIRE_BLOCK_SAVE:', TRIPWIRE_BLOCK_SAVE, '(will block saves if corruption detected AND no user edits)');
        console.log('[TRIPWIRE INIT] modalVertices count:', parsedData.modalVertices?.length);
        console.log('[TRIPWIRE INIT] First vertex sample:', JSON.stringify(parsedData.modalVertices?.[0]));
        console.log('[TRIPWIRE INIT] First furniture count:', parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.length);
        console.log('[TRIPWIRE INIT] First furniture exactPosition:', JSON.stringify(parsedData.roomsData?.[0]?.layouts?.[0]?.furniture?.[0]?.exactPosition));
      } else {
        console.log('[TRIPWIRE INIT] ⚠️ Could not compute hash - no valid vertex or furniture data');
      }
    } else if (worldGeometryInitializedRef.current) {
      console.log('[TRIPWIRE INIT] Already initialized - skipping');
    } else {
      console.log('[TRIPWIRE INIT] ⚠️ No roomsData or modalVertices to hash');
    }
  }


  useEffect(() => {
    // =====================================================
    // 🔑 CRITICAL: Set scaleReady BEFORE roomsData check
    // =====================================================
    // For fresh internal uploads, roomsData starts EMPTY.
    // If we return early, scaleReady never gets set.
    // The scaleReady logic only needs viewport + scale to be valid,
    // NOT roomsData. So check it FIRST.
    // =====================================================
    const divWidthOk = divWidth > 0;
    const divHeightOk = divHeight > 0;
    const scaleFactorXFinite = Number.isFinite(scaleFactorX);
    const scaleFactorXPositive = scaleFactorX > 0;
    const scaleFactorYFinite = Number.isFinite(scaleFactorY);
    const scaleFactorYPositive = scaleFactorY > 0;
    
    const guardsWillPass = divWidthOk && divHeightOk && scaleFactorXFinite && scaleFactorXPositive && scaleFactorYFinite && scaleFactorYPositive;

    console.log('');
    console.log('📍'.repeat(40));
    console.log('[HANDLEUPDATE USEEFFECT] ▶️ useEffect TRIGGERED');
    console.log('[HANDLEUPDATE USEEFFECT] Current state:', {
      scaleReady: scaleReady,
      roomsDataLength: roomsData?.length || 0,
      divWidth: divWidth,
      divHeight: divHeight,
      scaleFactorX: scaleFactorX,
      scaleFactorY: scaleFactorY,
    });
    console.log('[HANDLEUPDATE USEEFFECT] Guard breakdown:', {
      divWidthOk,
      divHeightOk,
      scaleFactorXFinite,
      scaleFactorXPositive,
      scaleFactorYFinite,
      scaleFactorYPositive,
      guardsWillPass,
    });
    
    // Set scaleReady BEFORE checking roomsData
    if (guardsWillPass && !scaleReady) {
      console.log('');
      console.log('🎯'.repeat(40));
      console.log('[SCALE READY] ✅✅✅ SETTING scaleReady = TRUE ✅✅✅');
      console.log('[SCALE READY] Guard values at moment of setting:', {
        divWidth,
        divHeight,
        scaleFactorX,
        scaleFactorY,
      });
      console.log('[SCALE READY] This runs BEFORE roomsData check (fixes internal flow)');
      console.log('🎯'.repeat(40));
      console.log('');
      setScaleReady(true);
    } else if (!guardsWillPass) {
      console.log('[HANDLEUPDATE USEEFFECT] ⏳ scaleReady NOT set - waiting for:');
      if (!divWidthOk) console.log('  - divWidth > 0 (current:', divWidth, ')');
      if (!divHeightOk) console.log('  - divHeight > 0 (current:', divHeight, ')');
      if (!scaleFactorXFinite) console.log('  - scaleFactorX finite (current:', scaleFactorX, ')');
      if (!scaleFactorXPositive) console.log('  - scaleFactorX > 0 (current:', scaleFactorX, ')');
      if (!scaleFactorYFinite) console.log('  - scaleFactorY finite (current:', scaleFactorY, ')');
      if (!scaleFactorYPositive) console.log('  - scaleFactorY > 0 (current:', scaleFactorY, ')');
    } else {
      console.log('[HANDLEUPDATE USEEFFECT] ✅ scaleReady already true - no action needed');
    }
    console.log('📍'.repeat(40));
    console.log('');
    
    // NOW check roomsData for the rest of handleUpdate logic
    if (!roomsData || roomsData.length === 0) {
      console.log('[HANDLEUPDATE USEEFFECT] 📭 Early return - roomsData is empty');
      console.log('[HANDLEUPDATE USEEFFECT] scaleReady was set above if guards passed');
      console.log('[HANDLEUPDATE USEEFFECT] handleUpdate will run when roomsData?.length changes');
      return;
    }
    
    console.log('[HANDLEUPDATE USEEFFECT] ✅ roomsData has', roomsData.length, 'rooms - proceeding to handleUpdate');

    const normalizeVertices = (
      vertices,
      offsetXCheck,
      offsetYCheck,
      scaleXCanvas,
      scaleYCanvas
    ) =>
      vertices.map(({ points: [startPoint, endPoint] }) => ({
        points: [
          {
            x: (startPoint.x - offsetXCheck) / scaleXCanvas,
            y: (startPoint.y - offsetYCheck) / scaleYCanvas,
          },
          {
            x: (endPoint.x - offsetXCheck) / scaleXCanvas,
            y: (endPoint.y - offsetYCheck) / scaleYCanvas,
          },
        ],
      }));

    // REVERTED TO DEV_NEW: Simple handleUpdate without scale recalculation
    // dev_new's approach works - just use state values from drawVerticesInDiv
    const handleUpdate = debounce(() => {
      // [DEDUP] Prevent handleUpdate from processing the same data multiple times
      // During init, the calibration useEffect can fire multiple times in rapid succession
      // (due to initialLength, initialScaleFactorX, resize all updating).
      // This guard ensures we only process when the inputs actually change.
      const _huKey = scaleFactorX + '|' + scaleXCanvas + '|' + divWidth + '|' + (roomsData?.length || 0);
      if (handleUpdateKeyRef.current === _huKey) {
        console.log('[HANDLEUPDATE] ⏩ SKIPPED (same inputs as last run) | key:' + _huKey);
        return;
      }
      handleUpdateKeyRef.current = _huKey;
      console.log('[HANDLEUPDATE] ⚡ FIRED | sfX:' + scaleFactorX?.toFixed(4) + ' sxC:' + scaleXCanvas?.toFixed(4) + ' divW:' + divWidth + ' updateScale:' + updateScale + ' t:' + Date.now());
      // =====================================================
      // GUARD: Don't run if container not ready
      // =====================================================
      if (divWidth === 0 || divHeight === 0) {
        console.log('[HANDLEUPDATE] ⏳ BLOCKED - container not ready');
        handleUpdateKeyRef.current = null;
        return;
      }
      
      if (!Number.isFinite(scaleXCanvas) || scaleXCanvas <= 0) {
        console.log('[HANDLEUPDATE] ⏳ BLOCKED - scaleXCanvas not ready:', scaleXCanvas);
        handleUpdateKeyRef.current = null;
        return;
      }
      
      // =====================================================
      // GUARD: Don't run if scaleFactorX is invalid
      // =====================================================
      // If scaleFactorX is not a valid positive number, division will fail:
      // - false/0 → Infinity (furniture renders HUGE)
      // - undefined → NaN (furniture disappears)
      // Wait for valid scale values before computing positions.
      // =====================================================
      if (!Number.isFinite(scaleFactorX) || scaleFactorX <= 0) {
        console.log('[HANDLEUPDATE] ⏳ BLOCKED - scaleFactorX invalid:', scaleFactorX);
        console.log('[HANDLEUPDATE] Note: scaleReady was already set in useEffect if guards passed');
        return;
      }
      if (!Number.isFinite(scaleFactorY) || scaleFactorY <= 0) {
        console.log('[HANDLEUPDATE] ⏳ BLOCKED - scaleFactorY invalid:', scaleFactorY);
        console.log('[HANDLEUPDATE] Note: scaleReady was already set in useEffect if guards passed');
        return;
      }
      
      console.log('[HANDLEUPDATE] ✅ All guards passed - proceeding');
      
      // =====================================================
      // 🎯 PRODUCTION-MATCHING FIX ACTIVE
      // =====================================================
      // This fix removes cameraRatio and renderScaleCorrection multiplications
      // from furniture transforms, matching production's simple formula:
      //   position = exactPosition / effectiveScaleX
      //   width = origionalWidth / effectiveScaleX
      // =====================================================
      console.log('[HANDLEUPDATE] 🎯 PRODUCTION-MATCHING FIX ACTIVE - No cameraRatio multiplication on furniture');
      
      // =====================================================
      // 🔧 COMPREHENSIVE HANDLEUPDATE LOGGING (gated)
      // =====================================================
      const blowUpFactor = 1 / scaleFactorX;
      const isExternalFlow = window.location.pathname.includes('floor-gallery') || 
        window.location.pathname.includes('external');
      const totalFurniture = roomsData?.reduce((sum, r) => 
        sum + (r.layouts?.reduce((s, l) => s + (l.furniture?.length || 0), 0) || 0), 0) || 0;
      
      // Track mutations for summary
      const mutationTracker = { count: 0, items: [] };
      
      // ALWAYS log if mutation likely (single warning line)
      if (blowUpFactor > 1.5) {
        scaleDebug.mutation('handleUpdate: 1/scaleFactorX=' + blowUpFactor.toFixed(2) + 'x | ' + (isExternalFlow ? 'EXTERNAL' : 'INTERNAL') + ' flow');
      }
      
      // Detailed logging when debug enabled
      if (scaleDebug.enabled()) {
        console.log('');
        console.log('╔' + '═'.repeat(100) + '╗');
        console.log('║  🔄 [HANDLEUPDATE] FURNITURE TRANSFORM - SCALE DEBUG                                                ║');
        console.log('╠' + '═'.repeat(100) + '╣');
        console.log('║');
        console.log('║  FLOW: ' + (isExternalFlow ? '🌐 EXTERNAL (Gallery→Editor)' : '🏠 INTERNAL'));
        console.log('║  Rooms: ' + (roomsData?.length || 0) + ' | Total furniture: ' + totalFurniture);
        console.log('║');
        console.log('║  ┌─── STATE VALUES ─────────────────────────────────────────────────────────────────────────────────┐');
        console.log('║  │  scaleFactorX (state): ' + scaleDebug.fmt(scaleFactorX, 6) + '  →  1/sfx = ' + scaleDebug.fmt(blowUpFactor, 4) + 'x');
        console.log('║  │  scaleXCanvas (state): ' + scaleDebug.fmt(scaleXCanvas, 6));
        console.log('║  │  renderScaleCorrectionX: ' + scaleDebug.fmt(renderScaleCorrectionX, 6));
        console.log('║  │  offsetXCheck: ' + scaleDebug.fmt(offsetXCheck, 2) + ' | offsetYCheck: ' + scaleDebug.fmt(offsetYCheck, 2));
        console.log('║  │  divWidth: ' + divWidth + ' | divHeight: ' + divHeight);
        console.log('║  └──────────────────────────────────────────────────────────────────────────────────────────────────┘');
        console.log('║');
        console.log('║  ┌─── TRANSFORM FORMULA (PRODUCTION-MATCHING FIX ACTIVE) ──────────────────────────────────────────┐');
        console.log('║  │  ✅ FIXED: position = exactPosition / effectiveScaleX');
        console.log('║  │  ✅ FIXED: width = origionalWidth / effectiveScaleX');
        console.log('║  │');
        console.log('║  │  ❌ OLD (buggy): position = (exactPosition / denomX) × renderCorrection × cameraRatio');
        console.log('║  │  ✅ NEW (matches prod): position = exactPosition / effectiveScaleX (NO extra multiplications)');
        console.log('║  │');
        console.log('║  │  This fix removes cameraRatio multiplication from furniture (keeps it for room vertices only)');
        console.log('║  └──────────────────────────────────────────────────────────────────────────────────────────────────┘');
        console.log('║');
        
        // Per-room preview - now showing production-style multiplier
        console.log('║  ┌─── PER-ROOM SCALE INFO (PRODUCTION FORMULA) ────────────────────────────────────────────────────┐');
        roomsData?.forEach((room, idx) => {
          const roomApiScale = room.scaleXCanvas || scaleXCanvas;
          const cameraRatio = roomApiScale > 0 ? scaleXCanvas / roomApiScale : 1;
          const effectiveScale = room.scaleX || scaleFactorX;
          // NEW: Production formula = just 1/effectiveScale (no cameraRatio)
          const prodMultiplier = 1 / effectiveScale;
          // OLD: Buggy formula that caused mutation
          const oldBuggyMultiplier = (1 / effectiveScale) * (renderScaleCorrectionX || 1) * cameraRatio;
          const roomFurnCount = room.layouts?.reduce((s, l) => s + (l.furniture?.length || 0), 0) || 0;
          
          console.log('║  │  Room[' + idx + '] ' + (room.roomId || 'unnamed').substring(0, 20) + 
            ': effectiveScale=' + scaleDebug.fmt(effectiveScale, 4) +
            ' | prodMultiplier=' + scaleDebug.fmt(prodMultiplier, 2) + 'x' +
            ' | (old buggy=' + scaleDebug.fmt(oldBuggyMultiplier, 2) + 'x)' +
            ' | items=' + roomFurnCount);
        });
        console.log('║  └──────────────────────────────────────────────────────────────────────────────────────────────────┘');
        console.log('╚' + '═'.repeat(100) + '╝');
        console.log('');
      }
      
      // =====================================================
      // ██████ COMPREHENSIVE DIAGNOSTIC: handleUpdate ██████
      // =====================================================
      console.log('');
      console.log('█'.repeat(100));
      console.log('█  [DIAGNOSTIC] handleUpdate - COMPREHENSIVE TRANSFORM ANALYSIS');
      console.log('█'.repeat(100));
      
      // =====================================================
      // SECTION A: ALL CURRENT STATE VALUES
      // =====================================================
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  📊 SECTION A: ALL CURRENT STATE VALUES AT handleUpdate TIME                                  │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  VIEWPORT SCALES (from state):');
      console.log('│    scaleXCanvas:', scaleXCanvas);
      console.log('│    scaleYCanvas:', scaleYCanvas);
      console.log('│  ');
      console.log('│  FURNITURE SCALES (from state):');
      console.log('│    scaleFactorX:', scaleFactorX, '← This is the DENOMINATOR in furniture transform');
      console.log('│    scaleFactorY:', scaleFactorY);
      console.log('│  ');
      console.log('│  OFFSET VALUES (from state):');
      console.log('│    offsetXCheck:', offsetXCheck);
      console.log('│    offsetYCheck:', offsetYCheck);
      console.log('│  ');
      console.log('│  VIEWPORT DIMENSIONS:');
      console.log('│    divWidth:', divWidth);
      console.log('│    divHeight:', divHeight);
      console.log('│  ');
      console.log('│  RENDER CORRECTIONS:');
      console.log('│    renderScaleCorrectionX:', renderScaleCorrectionX);
      console.log('│    renderScaleCorrectionY:', renderScaleCorrectionY);
      console.log('│  ');
      console.log('│  🔑 KEY RELATIONSHIPS:');
      console.log('│    1/scaleFactorX =', (1/scaleFactorX).toFixed(4), '← Furniture gets MULTIPLIED by this');
      console.log('│    scaleXCanvas/scaleFactorX =', (scaleXCanvas/scaleFactorX).toFixed(4));
      console.log('│    These are DIFFERENT? scaleXCanvas !== scaleFactorX:', scaleXCanvas !== scaleFactorX);
      console.log('└' + '─'.repeat(98) + '┘');
      
      // =====================================================
      // SECTION B: ROOM-BY-ROOM DATA
      // =====================================================
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  📦 SECTION B: ROOM-BY-ROOM STORED VALUES                                                     │');
      console.log('├' + '─'.repeat(98) + '┤');
      roomsData?.forEach((room, idx) => {
        console.log('│  ');
        console.log('│  Room [' + idx + ']: ' + room.roomId);
        console.log('│    room.scaleXCanvas:', room.scaleXCanvas);
        console.log('│    room.scaleX:', room.scaleX, '← Used as effectiveScaleX');
        console.log('│    room.offsetX:', room.offsetX);
        console.log('│    room.centerX:', room.centerX);
        console.log('│    payloadVertices:', room.payloadVertices ? room.payloadVertices.length + ' vertices' : 'NONE');
        console.log('│    orignalPayloadVertices:', room.orignalPayloadVertices ? 'EXISTS' : 'NONE');
        console.log('│    furniture count:', room.layouts?.[0]?.furniture?.length || 0);
        
        // Camera ratio for this room
        const roomApiScaleX = room.scaleXCanvas || scaleXCanvas;
        const cameraRatioX = (roomApiScaleX > 0) ? (scaleXCanvas / roomApiScaleX) : 1;
        console.log('│    cameraRatioX (current/room.scaleXCanvas):', cameraRatioX.toFixed(4));
      });
      console.log('└' + '─'.repeat(98) + '┘');
      
      // =====================================================
      // SECTION C: TRANSFORM FORMULA EXPLANATION
      // =====================================================
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  🧮 SECTION C: TRANSFORM FORMULAS (for comparison)                                            │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  ');
      console.log('│  ROOM VERTEX TRANSFORM (normalize → adjust):');
      console.log('│    Step 1 (normalize): canonical = (stored - storedOffset) / storedScaleXCanvas');
      console.log('│    Step 2 (adjust):    current = canonical * currentScaleXCanvas + currentOffset');
      console.log('│    NET EFFECT: current ≈ stored × (currentScaleXCanvas / storedScaleXCanvas)');
      console.log('│                       = stored × cameraRatio');
      console.log('│  ');
      console.log('│  FURNITURE TRANSFORM (in handleUpdate):');
      console.log('│    Step 1: baseX = exactPosition.x / denomX');
      console.log('│            where denomX = effectiveScaleX (≈ scaleFactorX ≈', scaleFactorX?.toFixed(4), ')');
      console.log('│    Step 2: correctedX = baseX × renderScaleCorrectionX × cameraRatioX');
      console.log('│    NET EFFECT: correctedX = exactPosition × (1/' + scaleFactorX?.toFixed(4) + ') × ' + renderScaleCorrectionX?.toFixed(4) + ' × cameraRatio');
      console.log('│                          = exactPosition × ' + ((1/scaleFactorX) * renderScaleCorrectionX).toFixed(4) + ' × cameraRatio');
      console.log('│  ');
      console.log('│  ⚠️  KEY DIFFERENCE:');
      console.log('│    Room:      × cameraRatio');
      console.log('│    Furniture: × (1/scaleFactorX) × renderScaleCorrection × cameraRatio');
      console.log('│    Extra factor: ×', ((1/scaleFactorX) * renderScaleCorrectionX).toFixed(4), '← PETER\'S "BLOW UP" FACTOR');
      console.log('└' + '─'.repeat(98) + '┘');
      
      // Original logging continues below
      console.log('');
      console.log('='.repeat(80));
      console.log('[SCALE DEBUG] ========== handleUpdate CALLED ==========');
      console.log('='.repeat(80));
      
      console.log('[SCALE DEBUG] CURRENT STATE VALUES:');
      console.log('  scaleXCanvas:', scaleXCanvas);
      console.log('  scaleYCanvas:', scaleYCanvas);
      console.log('  offsetXCheck:', offsetXCheck);
      console.log('  offsetYCheck:', offsetYCheck);
      console.log('  scaleFactorX:', scaleFactorX);
      console.log('  scaleFactorY:', scaleFactorY);
      console.log('  divWidth:', divWidth);
      console.log('  divHeight:', divHeight);
      console.log('  renderScaleCorrectionX:', renderScaleCorrectionX, '(render-only, NOT saved)');
      console.log('  renderScaleCorrectionY:', renderScaleCorrectionY, '(render-only, NOT saved)');
      
      console.log('[SCALE DEBUG] ROOMS TO PROCESS:', roomsData?.length);
      roomsData?.forEach((room, idx) => {
        console.log(`[SCALE DEBUG] Room ${idx} (${room.roomId}) STORED VALUES:`, {
          scaleXCanvas: room.scaleXCanvas,
          scaleYCanvas: room.scaleYCanvas,
          offsetX: room.offsetX,
          offsetY: room.offsetY,
          furnitureCount: room.layouts?.[0]?.furniture?.length,
        });
      });
      
      // A shuffle reaches here with the viewport untouched — it only wants the room
      // centers recomputed. Re-deriving furniture in that case rewrites the already
      // shuffled rooms at the wrong size, which is the flash they show.
      const { key: _furnitureKey, retransform: retransformFurniture } =
        resolveFurnitureRetransform(furnitureTransformKeyRef.current, {
          scaleFactorX,
          scaleFactorY,
          scaleXCanvas,
          scaleYCanvas,
          divWidth,
          divHeight,
          offsetXCheck,
          offsetYCheck,
        });
      furnitureTransformKeyRef.current = _furnitureKey;
      console.log('[HANDLEUPDATE] furniture re-derive:' + (retransformFurniture ? 'YES (viewport moved)' : 'NO (viewport unchanged)'));

      const updatedRoomsData = roomsData?.map((oldRoom, roomIdx) => {
        const room = JSON.parse(JSON.stringify(oldRoom));
        
        // CRITICAL LOGGING: Check if payloadVertices exists
        if (process.env.NODE_ENV !== 'production' && roomIdx === 0) {
          console.log('[HANDLEUPDATE] Room', room.roomId, 'payloadVertices exists:', !!room.payloadVertices);
          console.log('[HANDLEUPDATE] Room', room.roomId, 'payloadVertices length:', room.payloadVertices?.length);
        }
        
        // =====================================================
        // DIAGNOSTIC: Detailed logging for transform decision
        // =====================================================
        const hasPayloadVertices = !!room.payloadVertices;
        const hasOriginalVertices = !!room.orignalPayloadVertices;
        const hasFurniture = room.layouts?.some(l => l.furniture?.length > 0);
        const furnitureCount = room.layouts?.reduce((sum, l) => sum + (l.furniture?.length || 0), 0);
        
        if (process.env.NODE_ENV !== 'production') {
          console.log('');
          console.log('┌' + '─'.repeat(70) + '┐');
          console.log('│  🔍 [HANDLEUPDATE] ROOM ANALYSIS: ' + room.roomId);
          console.log('├' + '─'.repeat(70) + '┤');
          console.log('│  payloadVertices exists:', hasPayloadVertices, hasPayloadVertices ? '(' + room.payloadVertices.length + ' vertices)' : '');
          console.log('│  orignalPayloadVertices exists:', hasOriginalVertices, hasOriginalVertices ? '(' + room.orignalPayloadVertices.length + ' vertices)' : '');
          console.log('│  hasFurniture:', hasFurniture, '(' + furnitureCount + ' items)');
          console.log('│  room.scaleXCanvas:', room.scaleXCanvas);
          console.log('│  room.scaleX:', room.scaleX);
          console.log('│  room.offsetX:', room.offsetX);
          console.log('│  room.centerX:', room.centerX);
          console.log('│  room.centerY:', room.centerY);
          console.log('└' + '─'.repeat(70) + '┘');
        }
        
        if (!room.payloadVertices) {
          // =====================================================
          // CRITICAL: This early return SKIPS the furniture transform!
          // =====================================================
          // This is the ROOT CAUSE of the scale mutation bug for API-loaded rooms.
          // API-loaded rooms don't have payloadVertices, so transform is skipped,
          // but centerX/centerY ARE recalculated for the new viewport.
          // Result: furniture position offset is for old viewport, 
          //         room center is for new viewport = MISMATCH = "blow up"
          // =====================================================
          if (process.env.NODE_ENV !== 'production') {
            console.log('');
            console.log('╔' + '═'.repeat(70) + '╗');
            console.log('║  ⚠️⚠️⚠️ [HANDLEUPDATE] TRANSFORM SKIPPED! ⚠️⚠️⚠️                        ║');
            console.log('╠' + '═'.repeat(70) + '╣');
            console.log('║  Room:', room.roomId);
            console.log('║  Reason: room.payloadVertices is', room.payloadVertices);
            console.log('║  ');
            console.log('║  🚨 CONSEQUENCE: Furniture positions will NOT be transformed!');
            console.log('║  🚨 Furniture keeps raw API coordinates (exactPosition)');
            console.log('║  🚨 But centerX/centerY WERE recalculated for new viewport!');
            console.log('║  🚨 This causes the "blow up" / scale mutation bug!');
            console.log('║  ');
            if (hasFurniture) {
              const firstFurn = room.layouts?.[0]?.furniture?.[0];
              if (firstFurn) {
                console.log('║  FIRST FURNITURE (will keep these raw values):');
                console.log('║    name:', firstFurn.name);
                console.log('║    exactPosition:', JSON.stringify(firstFurn.exactPosition));
                console.log('║    position:', JSON.stringify(firstFurn.position));
                console.log('║    width:', firstFurn.width, 'height:', firstFurn.height);
              }
            }
            console.log('╚' + '═'.repeat(70) + '╝');
          }
          return room;
        }

        // =====================================================
        // 🔬 DIAGNOSTIC: ROOM VERTEX TRANSFORM (Step-by-Step)
        // =====================================================
        if (process.env.NODE_ENV !== 'production' && roomIdx === 0) {
          console.log('');
          console.log('╔' + '═'.repeat(98) + '╗');
          console.log('║  🏠 [DIAGNOSTIC] ROOM VERTEX TRANSFORM - STEP BY STEP                                        ║');
          console.log('╠' + '═'.repeat(98) + '╣');
          
          // Log first vertex BEFORE transform
          const firstOrigVertex = room.orignalPayloadVertices?.[0];
          if (firstOrigVertex) {
            const origX = firstOrigVertex.points?.[0]?.x || 0;
            const origY = firstOrigVertex.points?.[0]?.y || 0;
            console.log('║  ORIGINAL VERTEX (first point):');
            console.log('║    x:', origX.toFixed(2), 'y:', origY.toFixed(2));
            console.log('║  ');
            console.log('║  STEP 1: NORMALIZE (stored screen → canonical)');
            console.log('║    Formula: canonical = (stored - storedOffset) / storedScale');
            console.log('║    storedOffset (room.offsetX):', room.offsetX);
            console.log('║    storedScale (room.scaleXCanvas):', room.scaleXCanvas);
            const canonicalX = (origX - (room.offsetX || 0)) / (room.scaleXCanvas || 1);
            console.log('║    Result: (' + origX.toFixed(2) + ' - ' + (room.offsetX || 0) + ') / ' + (room.scaleXCanvas || 1) + ' = ' + canonicalX.toFixed(2));
            console.log('║  ');
            console.log('║  STEP 2: ADJUST (canonical → current screen)');
            console.log('║    Formula: current = canonical × currentScale + currentOffset');
            console.log('║    currentScale (scaleXCanvas state):', scaleXCanvas);
            console.log('║    currentOffset (offsetXCheck state):', offsetXCheck);
            const adjustedX = canonicalX * scaleXCanvas + offsetXCheck;
            console.log('║    Result: ' + canonicalX.toFixed(2) + ' × ' + scaleXCanvas + ' + ' + offsetXCheck + ' = ' + adjustedX.toFixed(2));
            console.log('║  ');
            console.log('║  NET TRANSFORM:');
            console.log('║    Original: ' + origX.toFixed(2) + ' → Adjusted: ' + adjustedX.toFixed(2));
            const vertexMultiplier = adjustedX / origX;
            console.log('║    Multiplier: ' + vertexMultiplier.toFixed(4) + 'x');
            console.log('║  ');
            console.log('║  SIMPLIFIED: adjusted ≈ original × (currentScale/storedScale)');
            const cameraRatioVertices = scaleXCanvas / (room.scaleXCanvas || 1);
            console.log('║    cameraRatio = ' + scaleXCanvas + ' / ' + (room.scaleXCanvas || 1) + ' = ' + cameraRatioVertices.toFixed(4));
          }
          console.log('╚' + '═'.repeat(98) + '╝');
        }
        
        const normalizedVertices = normalizeVertices(
          room.orignalPayloadVertices,
          room.offsetX,
          room.offsetY,
          room.scaleXCanvas,
          room.scaleYCanvas
        );

        const adjustedVertices = adjustVertices(
          normalizedVertices,
          offsetXCheck,
          offsetYCheck,
          scaleXCanvas,
          scaleYCanvas
        );
        
        // DETAILED LOGGING: Vertex transform trace (first room only)
        if (process.env.NODE_ENV !== 'production' && roomIdx === 0) {
          console.log('[VERTEX TRANSFORM] ========== ROOM', room.roomId, '==========');
          console.log('[VERTEX TRANSFORM] Original vertex (first point):', room.orignalPayloadVertices?.[0]?.points?.[0]);
          console.log('[VERTEX TRANSFORM] Room stored scales: scaleXCanvas=', room.scaleXCanvas, 'scaleYCanvas=', room.scaleYCanvas);
          console.log('[VERTEX TRANSFORM] Room stored offsets: offsetX=', room.offsetX, 'offsetY=', room.offsetY);
          console.log('[VERTEX TRANSFORM] Current scales: scaleXCanvas=', scaleXCanvas, 'scaleYCanvas=', scaleYCanvas);
          console.log('[VERTEX TRANSFORM] Current offsets: offsetXCheck=', offsetXCheck, 'offsetYCheck=', offsetYCheck);
          console.log('[VERTEX TRANSFORM] Normalized vertex (first point):', normalizedVertices?.[0]?.points?.[0]);
          console.log('[VERTEX TRANSFORM] Adjusted vertex (first point):', adjustedVertices?.[0]?.points?.[0]);
          
          // Calculate the effective scale ratio for vertices
          const vertexScaleRatioX = scaleXCanvas / (room.scaleXCanvas || scaleXCanvas);
          console.log('[VERTEX TRANSFORM] Effective vertex scale ratio X:', vertexScaleRatioX.toFixed(6));
        }

        const foundRoom = modalData.find(
          (item) => item?.room_id === room?.roomId
        );

        if (!foundRoom) {
          // =====================================================
          // [MATCH-PROD] Use scaleFactorX directly (production main line 5144).
          // Timing fixes (single dep, toggle, API guard) prevent the staging mutation.
          // =====================================================
          let effectiveScaleX = scaleFactorX;
          let effectiveScaleY = scaleFactorY;
          
          // DEFENSIVE: Ensure effectiveScale is a valid positive number
          // If not, skip this room to avoid Infinity/NaN positions
          if (!Number.isFinite(effectiveScaleX) || effectiveScaleX <= 0) {
            console.warn('[HANDLEUPDATE] Room', room.roomId, 'has invalid effectiveScaleX:', effectiveScaleX, '- using 1 as fallback');
            effectiveScaleX = 1;
          }
          if (!Number.isFinite(effectiveScaleY) || effectiveScaleY <= 0) {
            console.warn('[HANDLEUPDATE] Room', room.roomId, 'has invalid effectiveScaleY:', effectiveScaleY, '- using 1 as fallback');
            effectiveScaleY = 1;
          }
          
          // =====================================================
          // PR #101 FIX: CAMERA RATIO FOR FURNITURE (no foundRoom branch)
          // =====================================================
          const roomApiScaleX = room.scaleXCanvas || scaleXCanvas;
          const roomApiScaleY = room.scaleYCanvas || scaleYCanvas;
          const cameraRatioX = (roomApiScaleX > 0) ? (scaleXCanvas / roomApiScaleX) : 1;
          const cameraRatioY = (roomApiScaleY > 0) ? (scaleYCanvas / roomApiScaleY) : 1;
          
          // DETAILED LOGGING: Branch entry
          if (process.env.NODE_ENV !== 'production') {
            console.log('[FURNITURE TRANSFORM] ========== NO FOUNDROOM BRANCH ==========');
            console.log('[FURNITURE TRANSFORM] Room:', room.roomId);
            console.log('[FURNITURE TRANSFORM] Camera scales: scaleXCanvas=', scaleXCanvas, 'roomApiScaleX=', roomApiScaleX);
            console.log('[FURNITURE TRANSFORM] Camera ratios: X=', cameraRatioX.toFixed(6), 'Y=', cameraRatioY.toFixed(6), '(NOT used in transform - fix applied)');
            console.log('[FURNITURE TRANSFORM] effectiveScaleX=', effectiveScaleX, 'room.scaleX=', room.scaleX);
            console.log('[FURNITURE TRANSFORM] renderScaleCorrectionX=', renderScaleCorrectionX);
          }
          
          const updatedLayouts = !retransformFurniture ? room?.layouts : room?.layouts?.map((layout) => ({
            ...layout,
            furniture: layout.furniture?.map((item, itemIdx) => {
              // =====================================================
              // PR #101 FIX v2: UNIFIED DENOMINATOR (no foundRoom branch)
              // =====================================================
              // IMPORTANT: When calculateWidth is true AND effectiveScaleX === room.scaleX,
              // denomX would become 1, which may not be intended.
              // Adding safety check to prevent division by very small values.
              // =====================================================
              let denomX = item.calculateWidth 
                ? (effectiveScaleX / (room.scaleX || 1)) 
                : effectiveScaleX;
              let denomY = item.calculateWidth 
                ? (effectiveScaleY / (room.scaleY || 1)) 
                : effectiveScaleY;
              
              // SAFETY: Ensure denominator is not too small (would cause huge values)
              if (Math.abs(denomX) < 0.001) {
                console.warn('[FURNITURE TRANSFORM] ⚠️ denomX too small:', denomX, '- using 1 as fallback');
                denomX = 1;
              }
              if (Math.abs(denomY) < 0.001) {
                console.warn('[FURNITURE TRANSFORM] ⚠️ denomY too small:', denomY, '- using 1 as fallback');
                denomY = 1;
              }
              
              const rawX = item?.exactPosition?.x ?? item.origionalPosition?.x ?? 0;
              const rawY = item?.exactPosition?.y ?? item.origionalPosition?.y ?? 0;
              const rawW = item.origionalWidth ?? 0;
              const rawH = item.origionalHeight ?? 0;
              
              // =====================================================
              // PRODUCTION-MATCHING FIX: Remove cameraRatio & renderScaleCorrection
              // =====================================================
              // OLD BUGGY: correctedX = (rawX / denomX) * renderScaleCorrectionX * cameraRatioX
              // NEW FIXED: correctedX = rawX / denomX (matches production)
              //
              // The extra multiplications caused scale mutation (1.82x blow up)
              // Production only divides by scaleFactorX, no extra multiplications
              // =====================================================
              
              // Keep denomX logic intact (handles calculateWidth case correctly)
              // Just remove the cameraRatioX and renderScaleCorrectionX multiplications
              const correctedX = rawX / denomX;
              const correctedY = rawY / denomY;
              const correctedWidth = rawW / denomX;
              const correctedHeight = rawH / denomY;
              
              // Log the fix
              if (itemIdx === 0 && scaleDebug.enabled()) {
                console.log('[SCALE FIX] ✅ Using PRODUCTION formula (no cameraRatio multiplication)');
                console.log('[SCALE FIX] denomX=' + denomX.toFixed(4) + ' (calculateWidth=' + item.calculateWidth + ')');
                console.log('[SCALE FIX] Old formula would give: ' + ((rawW / denomX) * renderScaleCorrectionX * cameraRatioX).toFixed(2));
                console.log('[SCALE FIX] New formula gives: ' + correctedWidth.toFixed(2));
                console.log('[SCALE FIX] Avoided ' + (cameraRatioX).toFixed(2) + 'x scale mutation from cameraRatio');
              }
              
              // =====================================================
              // MUTATION DETECTION + INTERNAL vs EXTERNAL COMPARISON
              // =====================================================
              const storedW = item.width;
              const storedX = item.position?.x;
              const widthRatio = storedW && storedW > 0 ? correctedWidth / storedW : null;
              const isMutated = widthRatio !== null && (widthRatio > 1.5 || widthRatio < 0.67);
              
              // Calculate what EXTERNAL flow would produce (for comparison)
              const externalX = rawX * cameraRatioX;
              const externalW = rawW * cameraRatioX;
              
              // Check which formula is closer to stored values
              const internalDeltaX = storedX !== undefined ? Math.abs(correctedX - storedX) : Infinity;
              const externalDeltaX = storedX !== undefined ? Math.abs(externalX - storedX) : Infinity;
              const closerFormula = internalDeltaX < externalDeltaX ? 'INTERNAL' : 'EXTERNAL';
              
              // Track mutations for summary
              if (isMutated) {
                mutationTracker.count++;
                if (mutationTracker.items.length < 5) {
                  mutationTracker.items.push({
                    name: item.name,
                    ratio: widthRatio,
                    storedW: storedW,
                    computedW: correctedWidth,
                    closer: closerFormula
                  });
                }
                scaleDebug.mutation('Item "' + item.name + '" width ' + widthRatio.toFixed(2) + 'x | ' + closerFormula + ' formula closer to stored');
              }
              
              // Detailed per-item logging (gated)
              if (scaleDebug.enabled()) {
                scaleDebug.log(
                  'Item[' + itemIdx + '] ' + (item.name || 'unnamed').substring(0, 20) +
                  ' | rawW:' + rawW +
                  ' | INTERNAL:' + scaleDebug.fmt(correctedWidth, 1) +
                  ' | EXTERNAL:' + scaleDebug.fmt(externalW, 1) +
                  ' | stored:' + scaleDebug.fmt(storedW, 1) +
                  ' | ratio:' + scaleDebug.fmt(widthRatio, 2) +
                  ' | closer:' + closerFormula +
                  (isMutated ? ' ⚠️ MUTATED' : '')
                );
              }
              
              // =====================================================
              // PETER'S DIAGNOSTIC: Log EVERY newly added item's transform
              // =====================================================
              if (item.newlyAdded) {
                console.log('');
                console.log('┌' + '─'.repeat(85) + '┐');
                console.log('│  🆕 [HANDLEUPDATE] NEWLY ADDED ITEM TRANSFORM (no foundRoom branch)                    │');
                console.log('├' + '─'.repeat(85) + '┤');
                console.log('│  Item:', item.name);
                console.log('│  INPUT: rawX=' + rawX + ' rawY=' + rawY + ' rawW=' + rawW + ' rawH=' + rawH);
                console.log('│  DENOM: denomX=' + denomX + ' denomY=' + denomY);
                console.log('│  OUTPUT: correctedX=' + correctedX + ' correctedY=' + correctedY);
                console.log('│  OUTPUT: correctedW=' + correctedWidth + ' correctedH=' + correctedHeight);
                console.log('│  ');
                console.log('│  🔍 VALIDATION:');
                const outXValid = Number.isFinite(correctedX);
                const outYValid = Number.isFinite(correctedY);
                const outWValid = Number.isFinite(correctedWidth) && correctedWidth > 0;
                const outHValid = Number.isFinite(correctedHeight) && correctedHeight > 0;
                console.log('│    correctedX valid?', outXValid ? '✅' : '❌ NaN/Infinity!');
                console.log('│    correctedY valid?', outYValid ? '✅' : '❌ NaN/Infinity!');
                console.log('│    correctedWidth valid?', outWValid ? '✅' : '❌ ZERO/NaN! (invisible!)');
                console.log('│    correctedHeight valid?', outHValid ? '✅' : '❌ ZERO/NaN! (invisible!)');
                if (!outXValid || !outYValid || !outWValid || !outHValid) {
                  console.log('│  ❌❌❌ TRANSFORM PRODUCED INVALID OUTPUT - ITEM WILL NOT RENDER! ❌❌❌');
                }
                console.log('└' + '─'.repeat(85) + '┘');
              }
              
              // =====================================================
              // 🔬 CONDENSED DIAGNOSTIC: FURNITURE TRANSFORM (no foundRoom)
              // =====================================================
              if (process.env.NODE_ENV !== 'production' && itemIdx === 0) {
                const _wDelta_nf = ((correctedWidth || 0) - (item.width || 0)).toFixed(1);
                console.log(
                  '[TRANSFORM-NF] ' + item.name + 
                  ' | rawX:' + rawX?.toFixed(2) + ' rawW:' + rawW +
                  ' | denomX:' + denomX?.toFixed(4) + ' effSX:' + effectiveScaleX?.toFixed(4) +
                  ' | corrX:' + correctedX?.toFixed(2) + ' corrW:' + correctedWidth?.toFixed(2) +
                  ' | storedW:' + (item.width?.toFixed(1) || '?') + ' Δ:' + _wDelta_nf +
                  ' | sfX:' + scaleFactorX?.toFixed(4) + ' sxC:' + scaleXCanvas?.toFixed(4)
                );
              }
              
              return {
                ...item,
                width: correctedWidth,
                height: correctedHeight,
                position: { x: correctedX, y: correctedY },
              };
            }),
          }));
        
          return {
            ...room,
            layouts: updatedLayouts,
          };
        }
        
        const doors = getDoorsWithLineIndex(
          foundRoom?.doors,
          foundRoom?.walls,
          scaleXCanvas,
          scaleYCanvas,
          offsetXCheck,
          offsetYCheck
        );

        const validDoors = doors?.filter((door) => door.lineId !== null);

        const updatedDoors = adjustDoorPositionAndOrientation(
          validDoors,
          adjustedVertices
        );

        const { centerX: centerOriX, centerY: centerOriY } =
          calculateScaleFactor(adjustedVertices, 0, 0, 0);

        // [BEDROCK] Compute raw center from normalizedVertices (backend's approach)
        const rawCenterResult = calculateScaleFactor(normalizedVertices, 0, 0, 0);
        const rawCenterX = rawCenterResult.centerX;
        
        // [BEDROCK] Also compute center from modalData walls (exactly what backend does)
        const _modalWalls = modalData?.find(item => item?.room_id === room?.roomId)?.walls || [];
        const _wallPoints = [];
        _modalWalls.forEach(w => { if (w.start) _wallPoints.push(w.start); if (w.end) _wallPoints.push(w.end); });
        const _modalCenterX = _wallPoints.length > 0 ? (Math.min(..._wallPoints.map(p=>p.x)) + Math.max(..._wallPoints.map(p=>p.x))) / 2 : 'N/A';
        const _modalRoomWidth = _wallPoints.length > 0 ? (Math.max(..._wallPoints.map(p=>p.x)) - Math.min(..._wallPoints.map(p=>p.x))) : 'N/A';
        
        // [BEDROCK] Room outline bounding box (viewport space)
        const _adjX = adjustedVertices.flatMap(v => [v.points[0].x, v.points[1].x]);
        const _roomVpWidth = _adjX.length > 0 ? (Math.max(..._adjX) - Math.min(..._adjX)) : 'N/A';
        
        if (process.env.NODE_ENV !== 'production') {
          console.log('');
          console.log('████████████████████████████████████████████████████████████████████');
          console.log('████ [BEDROCK] COMPLETE COORDINATE ANALYSIS — Room:', room.roomId);
          console.log('████████████████████████████████████████████████████████████████████');
          console.log('████');
          console.log('████ A. ROOM CENTER — 3 METHODS COMPARED:');
          console.log('████    1. Frontend centerOriX (from adjustedVertices):', centerOriX?.toFixed(2), '← VIEWPORT space');
          console.log('████    2. Raw center (from normalizedVertices):', rawCenterX?.toFixed(2), '← RAW pixel space');
          console.log('████    3. modalData center (backend method):', typeof _modalCenterX === 'number' ? _modalCenterX?.toFixed(2) : _modalCenterX, '← RAW pixel space');
          console.log('████    Verify: rawCenter * scaleXCanvas + offset = viewportCenter?');
          console.log('████    ', (rawCenterX * scaleXCanvas + offsetXCheck)?.toFixed(2), '≈', centerOriX?.toFixed(2), '?', Math.abs((rawCenterX * scaleXCanvas + offsetXCheck) - centerOriX) < 2 ? 'YES ✓' : 'NO ✗');
          console.log('████');
          console.log('████ B. ROOM DIMENSIONS:');
          console.log('████    modalData raw room width:', typeof _modalRoomWidth === 'number' ? _modalRoomWidth?.toFixed(2) + ' px' : _modalRoomWidth);
          console.log('████    Viewport room width (from adjustedVertices):', typeof _roomVpWidth === 'number' ? _roomVpWidth?.toFixed(0) + ' px' : _roomVpWidth);
          console.log('████    Ratio (viewport/raw):', typeof _roomVpWidth === 'number' && typeof _modalRoomWidth === 'number' ? (_roomVpWidth / _modalRoomWidth)?.toFixed(4) : 'N/A');
          console.log('████    scaleXCanvas:', scaleXCanvas);
          console.log('████    These should be ≈ equal: viewport/raw ≈ scaleXCanvas');
          console.log('████');
          console.log('████ C. SCALE FACTORS:');
          console.log('████    scaleFactorX (state):', scaleFactorX, '← inches per raw pixel');
          console.log('████    scaleXCanvas:', scaleXCanvas, '← viewport pixels per raw pixel');
          console.log('████    room.scaleX:', room.scaleX, '← stored per-room');
          console.log('████    room.scaleXCanvas:', room.scaleXCanvas, '← stored per-room');
          console.log('████    offsetXCheck:', offsetXCheck);
          console.log('████');
          console.log('████ D. THE MISMATCH:');
          console.log('████    CenterSetX will be:', centerOriX?.toFixed(2), '(VIEWPORT space)');
          console.log('████    Furniture position will be: exactPosition / scaleFactorX (RAW space)');
          console.log('████    CSS: left = VIEWPORT + RAW = MIXING SPACES');
          console.log('████    The backend uses: left = (RAW_CENTER + RAW_POS) * SCALE_FACTOR = UNIFORM');
          console.log('████████████████████████████████████████████████████████████████████');
        }

        // =====================================================
        // [MATCH-PROD] Use scaleFactorX directly (production main line 5190).
        // Timing fixes (single dep, toggle, API guard) prevent the staging mutation.
        // =====================================================
        let effectiveScaleX = scaleFactorX;
        let effectiveScaleY = scaleFactorY;
        console.log('[VIEWPORT-DENOM]   vpDenom (new):', effectiveScaleX?.toFixed(6), '→ width would be:', (132 / effectiveScaleX)?.toFixed(2), 'viewport px');
        
        // DEFENSIVE: Ensure effectiveScale is a valid positive number
        // If not, use fallback to avoid Infinity/NaN positions
        if (!Number.isFinite(effectiveScaleX) || effectiveScaleX <= 0) {
          console.warn('[HANDLEUPDATE] Room', room.roomId, 'has invalid effectiveScaleX:', effectiveScaleX, '- using 1 as fallback');
          effectiveScaleX = 1;
        }
        if (!Number.isFinite(effectiveScaleY) || effectiveScaleY <= 0) {
          console.warn('[HANDLEUPDATE] Room', room.roomId, 'has invalid effectiveScaleY:', effectiveScaleY, '- using 1 as fallback');
          effectiveScaleY = 1;
        }
        
        // =====================================================
        // PR #101 FIX: CAMERA RATIO FOR FURNITURE
        // =====================================================
        // Room vertices go through normalize(apiScale) → adjust(currentScale)
        // This effectively scales them by: currentScaleXCanvas / apiScaleXCanvas
        // 
        // Furniture MUST use the same scale ratio, or it will be sized
        // differently than the room outline (the "K factor" bug).
        //
        // Previously: furniture used 1/scaleFactorX only (no camera ratio)
        // Now: furniture uses 1/scaleFactorX * cameraRatio
        // =====================================================
        const roomApiScaleX = room.scaleXCanvas || scaleXCanvas;
        const roomApiScaleY = room.scaleYCanvas || scaleYCanvas;
        
        // Camera ratio = how much the room is scaled from API to current viewport
        // For modern layouts: currentScale / apiScale ≈ 1.14 (14% larger)
        const cameraRatioX = (roomApiScaleX > 0) ? (scaleXCanvas / roomApiScaleX) : 1;
        const cameraRatioY = (roomApiScaleY > 0) ? (scaleYCanvas / roomApiScaleY) : 1;
        
        // DETAILED LOGGING: Branch entry
        if (process.env.NODE_ENV !== 'production') {
          console.log('[FURNITURE TRANSFORM] ========== FOUNDROOM BRANCH ==========');
          console.log('[FURNITURE TRANSFORM] Room:', room.roomId);
          console.log('[FURNITURE TRANSFORM] Camera scales: scaleXCanvas=', scaleXCanvas, 'roomApiScaleX=', roomApiScaleX);
          console.log('[FURNITURE TRANSFORM] Camera ratios: X=', cameraRatioX.toFixed(6), 'Y=', cameraRatioY.toFixed(6), '(NOT used in transform - fix applied)');
          console.log('[FURNITURE TRANSFORM] effectiveScaleX=', effectiveScaleX, 'room.scaleX=', room.scaleX);
          console.log('[FURNITURE TRANSFORM] renderScaleCorrectionX=', renderScaleCorrectionX);
        }

        const updatedLayouts = !retransformFurniture ? room?.layouts : room?.layouts?.map((layout) => ({
          ...layout,
          furniture: layout.furniture?.map((item, itemIdx) => {
            // =====================================================
            // PR #101 FIX v2: UNIFIED DENOMINATOR FOR POSITION AND SIZE
            // =====================================================
            // Peter's insight: position was using (effectiveScaleX / room.scaleX)
            // when calculateWidth === true, but size was using effectiveScaleX.
            // This caused K factor = room.scaleX (2x, 3x per plan).
            //
            // FIX: Use the SAME denominator for both position AND size.
            // ALSO: Apply renderScaleCorrectionX to SIZE (was missing!)
            // =====================================================
            let denomX = item.calculateWidth 
              ? (effectiveScaleX / (room.scaleX || 1)) 
              : effectiveScaleX;
            let denomY = item.calculateWidth 
              ? (effectiveScaleY / (room.scaleY || 1)) 
              : effectiveScaleY;
            
            // SAFETY: Ensure denominator is not too small (would cause huge values)
            if (Math.abs(denomX) < 0.001) {
              console.warn('[FURNITURE TRANSFORM] ⚠️ denomX too small:', denomX, '- using 1 as fallback');
              denomX = 1;
            }
            if (Math.abs(denomY) < 0.001) {
              console.warn('[FURNITURE TRANSFORM] ⚠️ denomY too small:', denomY, '- using 1 as fallback');
              denomY = 1;
            }
            
            const rawX = item?.exactPosition?.x ?? item.origionalPosition?.x ?? 0;
            const rawY = item?.exactPosition?.y ?? item.origionalPosition?.y ?? 0;
            const rawW = item.origionalWidth ?? 0;
            
            // =====================================================
            // 🔬 DEEP DIAGNOSTIC: COORDINATE SYSTEM ANALYSIS
            // =====================================================
            // This is THE key diagnostic for the scale mutation bug.
            // We compare: stored position vs computed position
            // If they differ significantly, furniture will "jump".
            // =====================================================
            if (process.env.NODE_ENV !== 'production' && itemIdx === 0) {
              console.log(
                '[INCOMING] ' + item.name + ' | pos:(' + (item.position?.x?.toFixed(1) || '?') + ',' + (item.position?.y?.toFixed(1) || '?') + ')' +
                ' | w:' + (item.width?.toFixed(1) || '?') + ' h:' + (item.height?.toFixed(1) || '?') +
                ' | origW:' + (item.origionalWidth || '?') + ' origH:' + (item.origionalHeight || '?') +
                ' | rawX:' + (rawX?.toFixed(2) || '?') + ' rawW:' + rawW +
                ' | effSX:' + effectiveScaleX?.toFixed(4) + ' denomX:' + denomX?.toFixed(4) +
                ' | sfX:' + scaleFactorX?.toFixed(4) + ' sxC:' + scaleXCanvas?.toFixed(4) +
                ' | blowUp:' + ((1/denomX) * renderScaleCorrectionX * cameraRatioX)?.toFixed(2) + 'x'
              );
            }
            const rawH = item.origionalHeight ?? 0;
            
            // =====================================================
            // PRODUCTION-MATCHING FIX: Remove cameraRatio & renderScaleCorrection
            // =====================================================
            // OLD BUGGY: correctedX = (rawX / denomX) * renderScaleCorrectionX * cameraRatioX
            // NEW FIXED: correctedX = rawX / denomX (matches production)
            //
            // The extra multiplications caused scale mutation (1.82x blow up)
            // Production only divides by scaleFactorX, no extra multiplications
            // =====================================================
            
            // Keep denomX logic intact (handles calculateWidth case correctly)
            // Just remove the cameraRatioX and renderScaleCorrectionX multiplications
            const correctedX = rawX / denomX;
            const correctedY = rawY / denomY;
            const correctedWidth = rawW / denomX;
            const correctedHeight = rawH / denomY;
            
            // [BEDROCK] Condensed furniture transform log
            if (itemIdx === 0) {
              const _roomVpW = typeof _roomVpWidth === 'number' ? _roomVpWidth : 320;
              const _wDelta = ((correctedWidth || 0) - (item.width || 0)).toFixed(1);
              const _cssLeft = (centerOriX + correctedX - correctedWidth/2)?.toFixed(0);
              console.log(
                '[BEDROCK] ' + item.name + 
                ' | origW:' + rawW + ' → corrW:' + correctedWidth?.toFixed(1) + ' (Δ' + _wDelta + ')' +
                ' | storedW:' + (item.width?.toFixed(1) || '?') +
                ' | roomVpW:' + _roomVpW?.toFixed(0) + ' ratio:' + (correctedWidth / _roomVpW * 100)?.toFixed(1) + '%' +
                ' | cssLeft:' + _cssLeft
              );
            }

            // Log the fix (foundRoom branch)
            if (itemIdx === 0 && scaleDebug.enabled()) {
              console.log('[SCALE FIX] ✅ Using PRODUCTION formula in foundRoom branch (no cameraRatio)');
              console.log('[SCALE FIX] denomX=' + denomX.toFixed(4) + ' (calculateWidth=' + item.calculateWidth + ')');
              console.log('[SCALE FIX] Old formula would give: ' + ((rawW / denomX) * renderScaleCorrectionX * cameraRatioX).toFixed(2));
              console.log('[SCALE FIX] New formula gives: ' + correctedWidth.toFixed(2));
              console.log('[SCALE FIX] Avoided ' + (cameraRatioX).toFixed(2) + 'x scale mutation from cameraRatio');
            }
            
            // =====================================================
            // MUTATION DETECTION + INTERNAL vs EXTERNAL COMPARISON (foundRoom)
            // =====================================================
            const storedW_fr = item.width;
            const storedX_fr = item.position?.x;
            const widthRatio_fr = storedW_fr && storedW_fr > 0 ? correctedWidth / storedW_fr : null;
            const isMutated_fr = widthRatio_fr !== null && (widthRatio_fr > 1.5 || widthRatio_fr < 0.67);
            
            // Calculate what EXTERNAL flow would produce (for comparison)
            const externalX_fr = rawX * cameraRatioX;
            const externalW_fr = rawW * cameraRatioX;
            
            // Check which formula is closer to stored values
            const internalDeltaX_fr = storedX_fr !== undefined ? Math.abs(correctedX - storedX_fr) : Infinity;
            const externalDeltaX_fr = storedX_fr !== undefined ? Math.abs(externalX_fr - storedX_fr) : Infinity;
            const closerFormula_fr = internalDeltaX_fr < externalDeltaX_fr ? 'INTERNAL' : 'EXTERNAL';
            
            // Track mutations for summary
            if (isMutated_fr) {
              mutationTracker.count++;
              if (mutationTracker.items.length < 5) {
                mutationTracker.items.push({
                  name: item.name,
                  ratio: widthRatio_fr,
                  storedW: storedW_fr,
                  computedW: correctedWidth,
                  closer: closerFormula_fr
                });
              }
              scaleDebug.mutation('Item "' + item.name + '" width ' + widthRatio_fr.toFixed(2) + 'x | ' + closerFormula_fr + ' formula closer to stored');
            }
            
            // Detailed per-item logging (gated)
            if (scaleDebug.enabled()) {
              scaleDebug.log(
                'Item[' + itemIdx + '] ' + (item.name || 'unnamed').substring(0, 20) +
                ' | rawW:' + rawW +
                ' | INTERNAL:' + scaleDebug.fmt(correctedWidth, 1) +
                ' | EXTERNAL:' + scaleDebug.fmt(externalW_fr, 1) +
                ' | stored:' + scaleDebug.fmt(storedW_fr, 1) +
                ' | ratio:' + scaleDebug.fmt(widthRatio_fr, 2) +
                ' | closer:' + closerFormula_fr +
                (isMutated_fr ? ' ⚠️ MUTATED' : '')
              );
            }
            
            // =====================================================
            // PETER'S DIAGNOSTIC: Log EVERY newly added item's transform
            // =====================================================
            if (item.newlyAdded) {
              console.log('');
              console.log('┌' + '─'.repeat(85) + '┐');
              console.log('│  🆕 [HANDLEUPDATE] NEWLY ADDED ITEM TRANSFORM (foundRoom branch)                       │');
              console.log('├' + '─'.repeat(85) + '┤');
              console.log('│  Item:', item.name);
              console.log('│  INPUT: rawX=' + rawX + ' rawY=' + rawY + ' rawW=' + rawW + ' rawH=' + rawH);
              console.log('│  DENOM: denomX=' + denomX + ' denomY=' + denomY);
              console.log('│  OUTPUT: correctedX=' + correctedX + ' correctedY=' + correctedY);
              console.log('│  OUTPUT: correctedW=' + correctedWidth + ' correctedH=' + correctedHeight);
              console.log('│  ');
              console.log('│  🔍 VALIDATION:');
              const outXValid = Number.isFinite(correctedX);
              const outYValid = Number.isFinite(correctedY);
              const outWValid = Number.isFinite(correctedWidth) && correctedWidth > 0;
              const outHValid = Number.isFinite(correctedHeight) && correctedHeight > 0;
              console.log('│    correctedX valid?', outXValid ? '✅' : '❌ NaN/Infinity!');
              console.log('│    correctedY valid?', outYValid ? '✅' : '❌ NaN/Infinity!');
              console.log('│    correctedWidth valid?', outWValid ? '✅' : '❌ ZERO/NaN! (invisible!)');
              console.log('│    correctedHeight valid?', outHValid ? '✅' : '❌ ZERO/NaN! (invisible!)');
              if (!outXValid || !outYValid || !outWValid || !outHValid) {
                console.log('│  ❌❌❌ TRANSFORM PRODUCED INVALID OUTPUT - ITEM WILL NOT RENDER! ❌❌❌');
              }
              console.log('└' + '─'.repeat(85) + '┘');
            }
            
            // =====================================================
            // 🔬 CONDENSED FURNITURE TRANSFORM DIAGNOSTIC
            // =====================================================
            if (process.env.NODE_ENV !== 'production' && itemIdx === 0) {
              const deltaW = item.width !== undefined ? (correctedWidth - item.width) : null;
              const ratioW = item.width !== undefined && item.width !== 0 ? (correctedWidth / item.width) : null;
              const mutated = ratioW !== null && (ratioW > 1.5 || ratioW < 0.67);
              console.log(
                '[TRANSFORM] ' + (mutated ? '🚨 MUTATED' : '✅ OK') +
                ' | ' + item.name + ' | Room:' + room.roomId +
                ' | origW:' + rawW + ' | denomX:' + denomX?.toFixed(4) +
                ' | storedW:' + (item.width?.toFixed(1) || 'N/A') + ' → computedW:' + correctedWidth?.toFixed(1) +
                ' | delta:' + (deltaW?.toFixed(1) || '0') + ' ratio:' + (ratioW?.toFixed(2) || 'N/A') +
                ' | effScaleX:' + effectiveScaleX?.toFixed(4) +
                ' | sfX:' + scaleFactorX?.toFixed(4) + ' sxC:' + scaleXCanvas?.toFixed(4) +
                ' | room.scaleX:' + room.scaleX?.toFixed(4) + ' room.sxC:' + room.scaleXCanvas?.toFixed(4)
              );
            }
            
            return {
              ...item,
              width: correctedWidth,
              height: correctedHeight,
              position: { x: correctedX, y: correctedY },
            };
          }),
        }));

        return {
          ...room,
          doors: updatedDoors,
          layouts: updatedLayouts,
          centerX: centerOriX,
          centerY: centerOriY,
          payloadVertices: adjustedVertices,
        };
      });

      const finalRoomsData = (updatedRoomsData || []).map((room) => {
        const updatedLayouts = room?.layouts?.map((layout) => {
          const updatedFurniture = layout?.furniture?.map((item) => {
            if (!item.newlyAdded && !item._id.endsWith("-1")) {
              return {
                ...item,
                _id: `${item._id}-1`,
              };
            }
            return item;
          });

          return {
            ...layout,
            furniture: updatedFurniture,
          };
        });

        return {
          ...room,
          layouts: updatedLayouts,
        };
      });

      const newCustomRoom = {
        layouts: [
          {
            room: {
              width: 124,
              height: 214,
              shape: "box-shape",
              zone: [
                {
                  value: "workingvanity",
                  capacity: 1,
                },
              ],
              position: {
                x: 0,
                y: 0,
                z: 0,
              },
            },
            doors: [],
            windows: [],
            furniture: [],
            vertices: [],
            prompt: "",
          },
        ],
        payloadVertices: [],
        doors: [],
        windows: [],
        scaleX: scaleFactorX,
        scaleY: scaleFactorY,
        centerX: 1500,
        centerY: divHeight / 2,
        roomId: "custom-room",
        orignalPayloadVertices: [],
        scaleXCanvas: scaleXCanvas,
        scaleYCanvas: scaleYCanvas,
        offsetX: offsetXCheck,
        offsetY: offsetYCheck,
        zones: [{ value: "custom", label: "Custom Room" }],
        resultRoomVerticesState: {},
      };

      const existingRoomIndex = finalRoomsData?.findIndex(
        (room) => room?.roomId === "custom-room"
      );

      let updatedRooms = [...finalRoomsData]; 

      if (existingRoomIndex === -1) {
      } else {
        updatedRooms[existingRoomIndex] = {
          ...updatedRooms[existingRoomIndex],
          ...newCustomRoom,
          layouts: newCustomRoom.layouts.map((newLayout, layoutIndex) => {
            const oldLayout =
              updatedRooms[existingRoomIndex].layouts?.[layoutIndex] || {};
            return {
              ...oldLayout,
              ...newLayout,
              furniture: oldLayout.furniture || [],
              zones: [{ value: "custom", label: "Custom Room" }],
            };
          }),
        };
      }

      setRoomsData(updatedRooms);

      const updatedRoomItemsList = (roomItemsList || [])?.map(
        (roomZones, roomIndex) => {
          return roomZones.map((zoneItems, zoneIndex) => {
            const room = updatedRooms[roomIndex];
            const layout = room?.layouts[zoneIndex];

            if (!layout) return zoneItems;

            const existingIds = new Set(zoneItems.map((item) => item._id));
            const newItems = layout.furniture.filter(
              (item) => !existingIds.has(item._id)
            );

            const updateItemProps = (baseItem, referenceItem) => {
              const updatedItem = { ...baseItem };

              if (referenceItem.flipHorizontal !== undefined) {
                updatedItem.flipHorizontal = referenceItem.flipHorizontal;
              }
              if (referenceItem.flipVertical !== undefined) {
                updatedItem.flipVertical = referenceItem.flipVertical;
              }
              if (referenceItem.rotation?.z !== undefined) {
                updatedItem.rotation = {
                  ...updatedItem.rotation,
                  z: referenceItem.rotation.z,
                };
              }

              if (referenceItem.width !== undefined) {
                updatedItem.width = referenceItem.width;
              }
              if (referenceItem.height !== undefined) {
                updatedItem.height = referenceItem.height;
              }
              if (referenceItem.originalWidth !== undefined) {
                updatedItem.originalWidth = referenceItem.originalWidth;
              }
              if (referenceItem.originalHeight !== undefined) {
                updatedItem.originalHeight = referenceItem.originalHeight;
              }

              return updatedItem;
            };

            const updatedZoneItems = zoneItems.map((item) => {
              const matchedRoomItem = updatedRooms[roomIndex]?.layouts[
                zoneIndex
              ]?.furniture.find((furn) => furn._id === item._id);
              return matchedRoomItem
                ? updateItemProps(item, matchedRoomItem)
                : item;
            });

            const updatedNewItems = newItems.map((item) => {
              const matchedItem = zoneItems.find(
                (existingItem) => existingItem._id === item._id
              );
              return matchedItem ? updateItemProps(item, matchedItem) : item;
            });

            return [...updatedZoneItems, ...updatedNewItems];
          });
        }
      );

      setRoomItemsList(updatedRoomItemsList);
      
      // =====================================================
      // PR #89: Mark scale as ready AFTER handleUpdate completes
      // =====================================================
      // This ensures auto-save and add-item won't run until
      // furniture positions have been properly converted from
      // canonical (exactPosition) to screen (position) coordinates.
      // Using state (not ref) so addItems useEffect can re-trigger.
      // =====================================================
      console.log('='.repeat(80));
      console.log('[SCALE READY] ✅ SCALE INITIALIZATION COMPLETE');
      console.log('='.repeat(80));
      console.log('[SCALE READY] handleUpdate has finished converting positions');
      console.log('[SCALE READY] State at completion:', {
        scaleXCanvas: scaleXCanvas,
        scaleYCanvas: scaleYCanvas,
        scaleFactorX: scaleFactorX,
        scaleFactorY: scaleFactorY,
        offsetXCheck: offsetXCheck,
        offsetYCheck: offsetYCheck,
        divWidth: divWidth,
        divHeight: divHeight,
        roomsDataCount: updatedRooms?.length,
        renderScaleCorrectionX: renderScaleCorrectionX,
        renderScaleCorrectionY: renderScaleCorrectionY,
      });
      
      // =====================================================
      // TRANSFORM VALIDATION: Compare vertex vs furniture scaling
      // =====================================================
      if (process.env.NODE_ENV !== 'production' && updatedRooms?.length > 0) {
        const room = updatedRooms[0];
        const roomApiScaleX = room.scaleXCanvas || scaleXCanvas;
        const cameraRatioX = (roomApiScaleX > 0) ? (scaleXCanvas / roomApiScaleX) : 1;
        
        console.log('');
        console.log('[TRANSFORM VALIDATION] ========== CONSISTENCY CHECK ==========');
        console.log('[TRANSFORM VALIDATION] Vertex transform chain:');
        console.log('  normalize: (x - offset) / apiScale');
        console.log('  adjust: normalized * currentScale + offset');
        console.log('  Effective scale ratio: currentScale / apiScale =', (scaleXCanvas / roomApiScaleX).toFixed(6));
        console.log('');
        console.log('[TRANSFORM VALIDATION] Furniture transform chain:');
        console.log('  base: exactPosition / denomX');
        console.log('  corrected: base * renderScaleCorrectionX * cameraRatioX');
        console.log('  renderScaleCorrectionX =', renderScaleCorrectionX?.toFixed(6) || renderScaleCorrectionX);
        console.log('  cameraRatioX =', cameraRatioX.toFixed(6));
        console.log('  Combined multiplier =', (renderScaleCorrectionX * cameraRatioX).toFixed(6));
        console.log('');
        console.log('[TRANSFORM VALIDATION] *** EXPECTED: Combined multiplier ≈ Vertex scale ratio ***');
        const vertexRatio = scaleXCanvas / roomApiScaleX;
        const furnitureMultiplier = renderScaleCorrectionX * cameraRatioX;
        const discrepancy = Math.abs(vertexRatio - furnitureMultiplier);
        if (discrepancy < 0.001) {
          console.log('[TRANSFORM VALIDATION] ✅ MATCH! Vertex and furniture use same effective scale');
        } else if (discrepancy < 0.05) {
          console.log('[TRANSFORM VALIDATION] ⚠️ SMALL MISMATCH:', discrepancy.toFixed(6), '- may be acceptable');
        } else {
          console.log('[TRANSFORM VALIDATION] ❌ LARGE MISMATCH:', discrepancy.toFixed(6), '- FURNITURE WILL BE WRONG SIZE!');
          console.log('[TRANSFORM VALIDATION] This explains why room outline is correct but furniture is wrong');
        }
        console.log('='.repeat(80));
      }
      
      console.log('[SCALE READY] Auto-save and add-item are now ALLOWED');
      console.log('[SCALE READY] Any pending adds will now trigger via useEffect');
      
      // =====================================================
      // COMPREHENSIVE DIAGNOSIS: Full state summary
      // =====================================================
      if (process.env.NODE_ENV !== 'production' && updatedRooms?.length > 0) {
        const room = updatedRooms[0];
        const firstFurn = room.layouts?.[0]?.furniture?.[0];
        
        console.log('');
        console.log('╔' + '═'.repeat(78) + '╗');
        console.log('║  📊 [DIAGNOSIS] FULL STATE SUMMARY AFTER INITIALIZATION                       ║');
        console.log('╠' + '═'.repeat(78) + '╣');
        console.log('║  VIEWPORT:');
        console.log('║    Current: ' + divWidth + ' x ' + divHeight);
        console.log('║    API saved from: ' + (room.scaleXCanvas ? Math.round(1920 * room.scaleXCanvas / scaleXCanvas) : 'unknown') + ' x ' + (room.scaleYCanvas ? Math.round(1080 * room.scaleYCanvas / scaleYCanvas) : 'unknown') + ' (estimated)');
        console.log('║  ');
        console.log('║  SCALE VALUES:');
        console.log('║    scaleXCanvas (current): ' + scaleXCanvas?.toFixed(6));
        console.log('║    room.scaleXCanvas (API): ' + room.scaleXCanvas?.toFixed?.(6));
        console.log('║    scaleFactorX (px/foot): ' + scaleFactorX?.toFixed(6));
        console.log('║    renderScaleCorrectionX: ' + renderScaleCorrectionX?.toFixed?.(6) || renderScaleCorrectionX);
        console.log('║  ');
        console.log('║  ROOM CENTER (for furniture positioning):');
        console.log('║    centerX: ' + room.centerX);
        console.log('║    centerY: ' + room.centerY);
        console.log('║  ');
        console.log('║  TRANSFORM STATUS:');
        console.log('║    payloadVertices exists: ' + !!room.payloadVertices);
        console.log('║    TRANSFORM WAS: ' + (room.payloadVertices ? '✅ RUN' : '⚠️ SKIPPED (no payloadVertices)'));
        console.log('║  ');
        
        if (firstFurn) {
          console.log('║  FIRST FURNITURE STATE:');
          console.log('║    name: ' + firstFurn.name);
          console.log('║    exactPosition: ' + JSON.stringify(firstFurn.exactPosition));
          console.log('║    position (after transform?): ' + JSON.stringify(firstFurn.position));
          console.log('║    width: ' + firstFurn.width + ' height: ' + firstFurn.height);
          console.log('║  ');
          
          // Check if transform actually ran
          const posMatchesExact = 
            firstFurn.position?.x === firstFurn.exactPosition?.x && 
            firstFurn.position?.y === firstFurn.exactPosition?.y;
          
          if (posMatchesExact) {
            console.log('║  🚨 CRITICAL: position === exactPosition (TRANSFORM DID NOT RUN!)');
            console.log('║  🚨 Furniture will render with raw API coordinates');
            console.log('║  🚨 Combined with recalculated centerX = BLOW UP!');
          } else {
            console.log('║  ✅ position !== exactPosition (transform ran successfully)');
          }
          console.log('║  ');
          
          // Calculate where furniture WILL render
          const renderLeft = room.centerX + (firstFurn.position?.x || 0) - (firstFurn.width || 0) / 2;
          console.log('║  RENDER POSITION (CSS left):');
          console.log('║    left = centerX + position.x - width/2');
          console.log('║    left = ' + room.centerX + ' + ' + (firstFurn.position?.x || 0).toFixed(2) + ' - ' + ((firstFurn.width || 0) / 2).toFixed(2));
          console.log('║    left = ' + renderLeft.toFixed(2) + 'px');
        }
        
        console.log('╚' + '═'.repeat(78) + '╝');
      }
      
      // =====================================================
      // 🔬 FINAL DIAGNOSTIC SUMMARY
      // =====================================================
      console.log('');
      console.log('█'.repeat(100));
      console.log('█  [DIAGNOSTIC] handleUpdate COMPLETE - FINAL SUMMARY                                         █');
      console.log('█'.repeat(100));
      console.log('');
      console.log('┌' + '─'.repeat(98) + '┐');
      console.log('│  📊 TRANSFORM COMPARISON SUMMARY                                                              │');
      console.log('├' + '─'.repeat(98) + '┤');
      console.log('│  ');
      console.log('│  ROOM VERTEX TRANSFORM:');
      console.log('│    Formula: currentScreen = (stored - storedOffset) / storedScale × currentScale + currentOffset');
      console.log('│    Simplified: currentScreen ≈ stored × (currentScale / storedScale)');
      console.log('│    Simplified: currentScreen ≈ stored × cameraRatio');
      console.log('│    Key factor: cameraRatio only');
      console.log('│  ');
      console.log('│  FURNITURE TRANSFORM:');
      console.log('│    Formula: correctedX = (exactPosition / scaleFactorX) × renderScaleCorrection × cameraRatio');
      console.log('│    Key factors: (1/scaleFactorX) × renderScaleCorrection × cameraRatio');
      console.log('│  ');
      console.log('│  VALUES USED:');
      console.log('│    scaleFactorX:', scaleFactorX?.toFixed?.(6) || scaleFactorX, '→ 1/scaleFactorX =', (1/scaleFactorX)?.toFixed?.(4) || 'N/A');
      console.log('│    renderScaleCorrectionX:', renderScaleCorrectionX?.toFixed?.(6) || renderScaleCorrectionX);
      console.log('│    cameraRatio: scaleXCanvas / room.scaleXCanvas');
      console.log('│  ');
      console.log('│  ⚠️  MISMATCH ANALYSIS:');
      console.log('│    Room uses: × cameraRatio only');
      console.log('│    Furniture uses: × (1/' + scaleFactorX?.toFixed?.(4) + ') × ' + renderScaleCorrectionX?.toFixed?.(4) + ' × cameraRatio');
      console.log('│    Extra furniture factor: × ' + ((1/scaleFactorX) * renderScaleCorrectionX)?.toFixed?.(4));
      if ((1/scaleFactorX) * renderScaleCorrectionX > 1.5) {
        console.log('│  ');
        console.log('│    🚨 FURNITURE IS ~' + ((1/scaleFactorX) * renderScaleCorrectionX).toFixed(2) + 'x LARGER THAN ROOM SCALING!');
        console.log('│    🚨 This is Peter\'s "blow up" bug - extra ÷ scaleFactorX');
      }
      console.log('└' + '─'.repeat(98) + '┘');
      console.log('');
      console.log('█'.repeat(100));
      
      // =====================================================
      // 🔧 MUTATION SUMMARY (gated logging)
      // =====================================================
      if (scaleDebug.enabled()) {
        console.log('');
        console.log('╔' + '═'.repeat(100) + '╗');
        console.log('║  📊 [HANDLEUPDATE] TRANSFORM COMPLETE - SUMMARY                                                      ║');
        console.log('╠' + '═'.repeat(100) + '╣');
        console.log('║');
        console.log('║  Total items processed: ' + totalFurniture);
        console.log('║  Mutations detected: ' + mutationTracker.count + (mutationTracker.count > 0 ? ' ⚠️' : ' ✅'));
        console.log('║');
        if (mutationTracker.items.length > 0) {
          console.log('║  ┌─── MUTATED ITEMS (first 5) ────────────────────────────────────────────────────────────────────┐');
          mutationTracker.items.forEach((m, i) => {
            console.log('║  │  [' + i + '] ' + m.name + ': ratio=' + scaleDebug.fmt(m.ratio, 2) + 'x | stored=' + scaleDebug.fmt(m.storedW, 0) + ' computed=' + scaleDebug.fmt(m.computedW, 0) + ' | ' + m.closer + ' closer');
          });
          if (mutationTracker.count > 5) {
            console.log('║  │  ... and ' + (mutationTracker.count - 5) + ' more');
          }
          console.log('║  └────────────────────────────────────────────────────────────────────────────────────────────────┘');
          console.log('║');
          console.log('║  💡 If EXTERNAL is consistently closer, the scale mutation bug is present');
          console.log('║     Fix: For external flow, use position = exactPosition × cameraRatio (no ÷ scaleFactorX)');
        }
        console.log('╚' + '═'.repeat(100) + '╝');
        console.log('');
      }
      
      // Log mutation count even when debug disabled (single line)
      if (mutationTracker.count > 0) {
        console.warn('[SCALE] handleUpdate complete: ' + mutationTracker.count + ' items with scale mutation detected');
      }
      
      // =====================================================
      // setScaleReady(true) - BACKUP (primary is at TOP of useEffect)
      // =====================================================
      // scaleReady is ALREADY set at the top of useEffect (line ~7157)
      // This is kept as a backup for when handleUpdate completes.
      // Setting it again is a no-op if already true.
      // =====================================================
      console.log('[HANDLEUPDATE] ✅ handleUpdate completed - confirming scaleReady=true');
      setScaleReady(true);
    }, DEBOUNCE_DELAY);

    // scaleReady is set at the TOP of useEffect (before roomsData check)
    // handleUpdate runs here to do furniture transformations
    console.log('[E2E-HANDLEUPDATE] ⚡ handleUpdate() CALLED from useEffect. updateScale=' + updateScale);
    console.log('[E2E-HANDLEUPDATE] Current state: scaleFactorX=' + scaleFactorX + ' scaleXCanvas=' + scaleXCanvas + ' divWidth=' + divWidth + ' divHeight=' + divHeight);
    handleUpdate();

    // NOTE: Production clears selectedFurniture here unconditionally, which causes
    // the toolbar to disappear whenever updateScale toggles (including after rotate/flip).
    // Peter's requirement: toolbar must persist until user clicks outside or X.
    // Selection is managed by click handlers (onMouseUp, handleDivClick, X button),
    // not by the scale update effect.

    return () => {
      handleUpdate.cancel();
    };
    // [MATCH-PROD] Match production: only trigger on updateScale.
    // Production uses [updateScale] only (line 5385 on main branch).
    // The extra deps caused handleUpdate to fire multiple times during init,
    // recomputing furniture at the wrong time. handleUpdate now fires from
    // the resize/calibration useEffect (which toggles updateScale), matching production timing.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateScale]);
  // scaleReady is now set at TOP of useEffect, BEFORE roomsData check

  useEffect(() => {
    if (roomActive !== -1 && selectedItem) {
      setSelectedTab(0);
      return;
    } else if (roomActive !== -1 && !selectedItem) {
      setSelectedTab(roomActive);
      return;
    }

    if (roomsData?.length >= 1) {
      roomsData?.forEach((room, index) => {
        const hasFurniture =
          room.layouts?.[roomActiveLayout?.[selectedTab]]?.furniture?.length >
          0;

        if (!hasFurniture) {
          const nextIndex = roomsData?.findIndex(
            (nextRoom, nextIdx) =>
              nextRoom.layouts?.[roomActiveLayout?.[nextIdx]]?.furniture
                ?.length > 0
          );

          if (nextIndex !== -1) {
            setSelectedTab(nextIndex);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoppingListFlag, roomsData, roomActive, roomActiveLayout]);

  useEffect(() => {
    // Skip rebuilding shareMenu while the options modal is open to prevent flickering
    if (optionsMenu != null) {
      console.log('');
      console.log('╔════════════════════════════════════════════════════════════════════╗');
      console.log('║  [SHARE MENU EFFECT] ⏭️ SKIPPED - MODAL IS OPEN                    ║');
      console.log('╠════════════════════════════════════════════════════════════════════╣');
      console.log('║  optionsMenu is non-null, skipping rebuild to prevent flicker');
      console.log('║  Current optionsMenu length: ' + optionsMenu?.length);
      console.log('╚════════════════════════════════════════════════════════════════════╝');
      console.log('');
      return;
    }

    console.log('');
    console.log('╔════════════════════════════════════════════════════════════════════╗');
    console.log('║  [SHARE MENU EFFECT] 🔄 BUILDING NEW SHARE MENU                    ║');
    console.log('╠════════════════════════════════════════════════════════════════════╣');
    console.log('║  Modal is closed (optionsMenu is null)');
    console.log('║  Dependencies that triggered this:');
    console.log('║    - moveMenu, layoutData, layoutDataCopy, resizeCalculateScaleFlag');
    console.log('║    - roomsData, calculateScaleFactorX, optionsMenu');
    console.log('╚════════════════════════════════════════════════════════════════════╝');
    console.log('');

    const newShareMenu = [
      {
        icon: <FileDownloadOutlinedIcon fontSize="small" />,
        label: "Download to browser",
        loadingLabel: "Downloading...",
        loadingDoneLabel: "Downloaded",
        value: async () => {
          const runDownload = () => duplicateDownloadLayoutRef.current?.();

          if (isGuest) {
            setShareModalOpen(false);
            requireAuth(() => {
              void runDownload();
            }, GO_EDITOR, { surface: "shareMenuDownloadLayout" });
            return;
          }
          await runDownload();
        },
      },
      {
        icon: <InsertLinkOutlinedIcon fontSize="small" />,
        label: "Copy link",
        loadingLabel: "Copying",
        loadingDoneLabel: "Copied",
        value: async () => {
          try {
            eventLog(targetWindow, 'floor_plan_event', 'link_copied', {
              galleryId: layoutData?.uuid || layoutData?._id,
              galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
            });
            if (timeoutRef.current) {
              clearInterval(timeoutRef.current);
              timeoutRef.current = null;
            }

            const waitForAutoSave = async () => {
              await updatedLayout(false, true);
              while (autoSaveloadingRef.current) {
                await new Promise((resolve) => setTimeout(resolve, 100));
              }
            };

            await waitForAutoSave();

            if (
              JSON.stringify(
                autoSaveDataRef?.current?.roomsData?.map(
                  (room) => room?.layouts
                )
              ) !==
                JSON.stringify(
                  layoutDataCopy?.payload?.roomsData?.map(
                    (room) => room?.layouts
                  )
                )
            )
              await updatedLayoutRef.current(false);

            const url = `${window.location.origin}/gallery/${layoutData?._id}`;

            try {
              await navigator.clipboard.writeText(url);
            } catch (error) {
              try {
                copy(url);
              } catch (error) {
              }
            }
          } catch (error) {
          }
          layoutDataCopyRefetch();
          trackEngagementRef.current?.({ share: true });
        },
      },
    ];

    console.log('[SHARE MENU] 📝 Setting shareMenu state with new array reference');
    console.log('[SHARE MENU] 📝 New menu has ' + newShareMenu.length + ' items');
    setShareMenu(newShareMenu);
    console.log('[SHARE MENU] ✅ shareMenu state updated');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    layoutData,
    layoutDataCopy,
    layoutDataCopyRefetch,
    resizeCalculateScaleFlag,
    roomsData,
    calculateScaleFactorX,
    optionsMenu,
    isGuest,
    requireAuth,
  ]);

  useEffect(() => {
    if (!directoryData || !layoutData) {
      console.log('[MOVE MENU] ⏭️ Skipping - missing directoryData or layoutData');
      return;
    }
    
    // Skip rebuilding moveMenu while the options modal is open to prevent flickering
    if (optionsMenu != null) {
      console.log('[MOVE MENU] ⏭️ Skipping rebuild - options modal is open');
      return;
    }

    console.log('[MOVE MENU] 🔄 Building moveMenu - modal is closed, dependencies changed');

    setMoveMenu((prev) => {
      const updatedMenu = [
        ...(directoryData
          ?.filter((dir) => !dir.payload)
          ?.map((dir) => ({
            icon: <FolderOutlinedIcon fontSize="small" />,
            label: dir?.name || "Untitled",
            loadingLabel: "Moving",
            loadingDoneLabel: "Moved",

            value: async () => {
              await axios.put(
                `${baseUrl}/savedLayout/edit/${layoutData?._id}`,
                {
                  parent: dir?._id,
                },
                {
                  Authorization: `Bearer ${currentUserSessionStorage}`,
                }
              );
              setOptionsMenu(shareMenu);
            },
          })) || []),
        {
          icon: <AddCircleOutlinedIcon fontSize="small" color="white" />,
          label: "Create folder",
          value: async () => {
            setIsNewFolderOpen(true);
          },
        },
      ];

      console.log('[MOVE MENU] ✅ moveMenu built with', updatedMenu.length, 'items (folders:', directoryData?.filter((dir) => !dir.payload)?.length || 0, ')');
      return updatedMenu;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [directoryData, layoutData, currentUserSessionStorage, optionsMenu]);

  useEffect(() => {

    const ref =
      shoppingListFlag && isMobile ? footerRefShoppingList : footerRefOther;

    if (ref.current) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            setFooterHeight(
              !shoppingListFlag ? ref.current?.offsetHeight || 0 : footerHeight
            );
          }
        });
      });

      observer.observe(ref.current, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      return () => observer.disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoppingListFlag]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (autoSaveloadingRef.current || timeoutRef.current) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Guest "Save" intent — snapshots the live layout so the post-auth fork saves
  // exactly what the guest sees, then raises the auth gate. Moved here from the
  // primary FAB row so the overflow ⋯ menu can convert from its own surface.
  const handleGuestSaveIntent = useCallback(() => {
    try {
      guestForkGallerySaveSnapshotRef.current = {
        roomsData: cloneDeep(roomsDataRef.current),
        roomActive: roomActiveRef.current,
        roomActiveLayout: cloneDeep(roomActiveLayoutRef.current),
        zonesRoom: cloneDeep(zonesRoomRef.current),
      };
      mfLogGuestGalleryAuth("save.preAuthSnapshot", {
        layoutId: layoutData?._id,
        versionKey: versionLayout || layoutData?.version,
        snapshotFingerprint: fingerprintGuestLayoutState(
          guestForkGallerySaveSnapshotRef.current.roomsData
        ),
        ...fingerprintEditorDomCapture(),
        ...fingerprintGuestForkDomDeep(),
        editorPack: guestForkEditorDiagRef.current,
        autoSaveInFlight: autoSaveloadingRef.current,
        hasUserEdited: hasUserEditedRef.current,
      });
    } catch (snapErr) {
      guestForkGallerySaveSnapshotRef.current = null;
      mfLogGuestGalleryAuth("save.preAuthSnapshotFailed", {
        layoutId: layoutData?._id,
        message: snapErr?.message ?? String(snapErr),
      });
    }
    forkOnEdit();
    requireAuth(() => {}, GO_EDITOR, { surface: GUEST_SAVE_AUTH_SURFACE });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forkOnEdit, requireAuth, layoutData?._id, layoutData?.version, versionLayout]);

  useEffect(() => {
    // Skip rebuilding settingsMenu while the options modal is open to prevent flickering
    if (optionsMenu != null) {
      console.log('[SETTINGS MENU] ⏭️ Skipping rebuild - options modal is open');
      return;
    }

    console.log('[SETTINGS MENU] 🔄 Building settingsMenu - modal is closed, dependencies changed');

    // Overflow ⋯ menu always offers "Duplicate Version" (full plan/layout).
    // Per-item duplication moved to the ContentCopy icon in the furniture
    // actions row, so this row no longer flips between Version/Layout
    // based on whether an item is selected.
    const duplicateMenuLabel = "Duplicate Version";

    setSettingsMenu(() => {
      const newSettingsMenu = [
        {
          label: "Furniture",
          loadingLabel: "Furniture",
          isToggle: true,
          suppressToggleHover: true,
          toggleChecked: viewLayouts,
          value: async () => {
            setViewLayouts((prev) => !prev);
          },
        },
        {
          label: "Plan labels",
          loadingLabel: "Plan labels",
          isToggle: true,
          suppressToggleHover: true,
          toggleChecked: textShow,
          value: async () => {
            setTextShow((prev) => !prev);
          },
        },
        {
          divider: true,
          label: "View Items",
          value: () => {
            setShowHelperMessage(false);
            setShoppingListFlag(true);
            setSelectedFurniture(null);
            setCopySelectedFurniture(null);
            setSelectedItem(null);
            isDraggingFurnitureItem.current = false;
            isDragDiv.current = false;
            setOptionsMenu(null);
          },
        },
        // Hide "Duplicate Version" from guests. Showing it would surface the
        // auth modal *plus* the menu's own loadingDoneLabel ("Editing
        // duplicated version") simultaneously while the user is still on the
        // sign-up screen — misleading and confusing UX. Authenticated users
        // see and use this normally; deferring the duplication to fire on
        // post-auth is tracked separately.
        !isGuest && {
          divider: true,
          label: duplicateMenuLabel,
          loadingLabel: "Duplicating",
          loadingDoneLabel: "Editing duplicated version",
          loadingDoneIcon: <CheckOutlinedIcon sx={{ fontSize: 18, color: "#34A853" }} />,
          value: handleDuplicateVersionOrLayout,
        },
        canConfigureInquiries &&
          layoutData?._id && {
            divider: true,
            label: BUYER_CONTACT_MENU_LABEL,
            value: () => {
              setOptionsMenu(null);
              setUploaderContactModalOpen(true);
            },
          },
        // Bottom row for guests: the same save/account flow the primary FAB row
        // used to offer, so this menu is also a conversion surface. The
        // top-right Done control keeps its own identical flow.
        isGuest && {
          divider: true,
          label: "Save",
          value: () => {
            setOptionsMenu(null);
            handleGuestSaveIntent();
          },
        },
      ].filter(Boolean);
      console.log('[SETTINGS MENU] ✅ settingsMenu built with', newSettingsMenu.length, 'items');
      return newSettingsMenu;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    viewLayouts,
    textShow,
    optionsMenu,
    handleDuplicateVersionOrLayout,
    handleGuestSaveIntent,
    isGuest,
    isOwner,
    layoutData?._id,
  ]);

  const handleToggle = (index) => {
    setSeeItAnotherWay((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  // Memoized callback for closing options menu to prevent unnecessary re-renders
  const handleCloseOptionsMenu = useCallback(() => {
    console.log('[OPTIONS MENU] ❌ Modal closed via memoized callback');
    setOptionsMenu(null);
  }, []);

  useEffect(() => {
    console.log('');
    console.log('╔════════════════════════════════════════════════════════════════════╗');
    console.log('║  [OPTIONS MENU STATE] 🔍 optionsMenu STATE CHANGED                 ║');
    console.log('╠════════════════════════════════════════════════════════════════════╣');
    console.log('║  Is modal open: ' + (optionsMenu != null));
    console.log('║  Menu length: ' + (optionsMenu?.length || 0));
    console.log('║  Menu labels: ' + (optionsMenu?.map(item => item?.label).join(', ') || 'N/A'));
    console.log('║  Timestamp: ' + new Date().toISOString());
    console.log('╚════════════════════════════════════════════════════════════════════╝');
    console.log('');
    
    if (optionsMenu) {
      console.log('[OPTIONS MENU] 🧹 Modal opened - clearing furniture selections');
      setSelectedFurniture(null);
      setCopySelectedFurniture(null);
      setSelectedItem(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsMenu]);

  // Track data changes that might cause re-renders while modal is open
  useEffect(() => {
    if (optionsMenu != null) {
      console.log('');
      console.log('⚠️ [DATA CHANGE] layoutData changed WHILE MODAL IS OPEN:');
      console.log('    id: ' + layoutData?._id);
      console.log('    name: ' + layoutData?.name);
      console.log('    timestamp: ' + new Date().toISOString());
      console.log('    This could cause LayoutOptionMenu to re-render!');
      console.log('');
    }
  }, [layoutData, optionsMenu]);

  useEffect(() => {
    if (optionsMenu != null) {
      console.log('');
      console.log('⚠️ [DATA CHANGE] directoryData changed WHILE MODAL IS OPEN:');
      console.log('    length: ' + directoryData?.length);
      console.log('    timestamp: ' + new Date().toISOString());
      console.log('');
    }
  }, [directoryData, optionsMenu]);

  useEffect(() => {
  }, [selectedFurniture]);

  const handleClose = () => {
    setErrorLayoutGlobal(false);

    handleToggle(roomActive);
  };

  useEffect(() => {
    const images = Array.from(document.querySelectorAll("img"));

    if (layoutLoading) return;

    if (images.length === 0) {
      // Use setTimeout to avoid infinite loop by deferring the state update
      const timeoutId = setTimeout(() => {
        setRerunImagesLoad((prev) => !prev);
      }, 100);
      return () => clearTimeout(timeoutId);
    }

    imagesCount.current = images.length;

    const handleImageLoad = () => {
      setImagesCountState((prev) => prev - 1);
      imagesCount.current = imagesCount.current - 1;
    };

    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener("load", handleImageLoad);
        img.addEventListener("error", handleImageLoad);
      }
    });

    return () => {
      images.forEach((img) => {
        img.removeEventListener("load", handleImageLoad);
        img.removeEventListener("error", handleImageLoad);
      });
    };
  }, [layoutLoading]);

  useEffect(() => {
    if (imagesCount.current < 0) setImagesLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesCount.current, imagesCountState]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (imagesCount.current >= 0) {
        setImagesLoaded(true);
        imagesCount.current = -1;
        setImagesCountState(-1);
      }
    }, 30000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const resetRoom = () => {
    setIsAdding(false);

    setSelectedFurniture(null);
    setCopySelectedFurniture(null);

    setSelectedItem(null);

    setVertices({ index: false, vertices: [], roomId: "" });
    const lineContainer = document.getElementById("lineContainer");

    const shapeElements = lineContainer.querySelectorAll(".shape");
    shapeElements.forEach((element) => element.remove());
    setLineBoundary(false);
    setRoomId(null);
  };

  const trackEngagement = (data) => {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    postTrackEngagement({
      layoutId: layoutData?._id,
      versionId: layoutData?.version,
      body: data,
    });
  };
  trackEngagementRef.current = trackEngagement;

  useEffect(() => {
    if(layoutData){
      setDoneEditing(false);
      trackEngagement({ editorView: true });
      startTracking({ layoutData: layoutData, versionId: layoutData?.version });
      if (layoutData._id !== layoutDataIdToEdit) {
        setLayoutDataIdToEdit(layoutData?._id);
        eventLog(targetWindow, 'floor_plan_event', 'editor_opened', {
          galleryId: layoutData?.uuid || layoutData?._id,
          galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutData?._id]);

  useEffect(() => {
    if (loading === "recording") {
      furnishRoom();
      setLoading(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  // Derived: true once at least one room has furniture (unlocks Save/Share CTA styling)
  const anyRoomHasFurniture = roomsData?.some((room, idx) =>
    room.layouts?.[roomActiveLayout?.[idx]]?.furniture?.length > 0
  ) ?? false;

  // Save/Share becomes the primary CTA only after the user has manually added
  // an item OR shuffled 2+ distinct rooms.  Until then Shuffle is the hero.
  const saveIsPrimary = manualItemAdded || shuffledRoomIds.size >= 2;

  // ── FAB row focus ───────────────────────────────────────────────────────
  // States where the primary FAB is the only worthwhile action, so the
  // companion FABs stand down and it takes the centre. Read the active room's
  // furniture with the same expression the room-select effect uses to seed
  // seeItAnotherWay, so the two can never disagree about which room is empty.
  const activeRoomHasFurniture =
    roomsData?.[roomActive]?.layouts?.[roomActiveLayout?.[roomActive]]?.furniture
      ?.length > 0;
  const primaryFabSolo = isPrimaryFabSolo({
    shufflePickedRoom,
    showZonesMenu,
    openFilters,
    roomActive,
    seeItAnotherWay,
    activeRoomHasFurniture,
  });
  // Every FAB mounted in the row, including the ones currently stood down:
  // they keep their slots so the primary can reach the centre on a transform
  // alone. These same flags gate the render conditions in the row below, so
  // the count cannot drift from what is actually mounted.
  const shuffleFabMounted =
    Boolean(partnerPackage?.allowMakeMagic) && roomsData?.length > 0;
  const shareFabMounted = !isGuest;
  const inquireFabMounted = Boolean(showEditorInquireFab);
  const primaryFabShift = primaryFabSoloShiftPercent(
    [
      shuffleFabMounted,
      true, // Add Items, mounted unconditionally
      shareFabMounted,
      inquireFabMounted,
    ].filter(Boolean).length
  );
  // The iOS sheet curve: most of the distance early, then a soft landing.
  const fabGlideTransition = prefersReducedMotion
    ? "none"
    : "transform 380ms cubic-bezier(0.32, 0.72, 0, 1)";
  // Companions clear out ahead of the primary arriving rather than everything
  // moving as one block. Transform and opacity only — animating the flex
  // widths instead would put the row through layout on every frame.
  const companionFabStandDownSx = {
    transform: primaryFabSolo ? "scale(0.86)" : "scale(1)",
    transition: prefersReducedMotion
      ? "none"
      : `opacity 180ms ease, ${fabGlideTransition}`,
  };

  const location = useLocation();
  const isAdminViewerRoute =
    location.pathname.startsWith("/admin/floor-plan/") ||
    location.pathname.startsWith("/admin/floor-gallery/") ||
    location.pathname.startsWith("/admin/layout/");

  return (
    <>
      {successAlert && <SuccessAlert title={successAlert} />}

      {errorAlert && <ErrorAlert title={errorAlert} />}

      {(params.id || layoutId) &&
        ((layoutLoading &&  !document
          ?.getElementById("image-container-1")
          ?.querySelector("img")) || !imagesLoaded) &&
        imageDimensions.height === "" && (
          <Box
            position={"absolute"}
            top={"50%"}
            left={"50%"}
            sx={{
              transform: "translate(-50% , -50%)",
              width: "100%",
              textAlign: "center",
              color: "#3C3C4399",
              letterSpacing: "-0.43px",
              fontSize: "17px",
            }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <IconButton color="inherit">
                <CircularProgress size={19} color="inherit" />
              </IconButton>
              <Typography ml={1} color={"inherit"}>
                Loading
              </Typography>
            </Box>
          </Box>
        )}

      <Container
        component="main"
        sx={{
          maxWidth: "100% !important",
          p: "0 !important",
          display: "flex",
          flexDirection: "column",
          ...(isAdminViewerRoute
            ? {
                flex: 1,
                minHeight: 0,
                height: "100%",
                maxHeight: "100%",
              }
            : {
                minHeight: "100dvh",
                height: "100dvh",
              }),
          overflow: "hidden",
          position: "relative",
          alignItems: "center",
          width: "100%",
          visibility:
            (params.id || layoutId) && ((layoutLoading && !document
              ?.getElementById("image-container-1")
              ?.querySelector("img")) || !imagesLoaded)
              ? "hidden"
              : "visible",
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          sx={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            maxHeight: "100%",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
              minHeight: 0,
              position: "relative",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <Box
              ref={divRef}
              display={
                params?.id && autoSave === false
                  ? "none"
                  : "flex"
              }
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                flex: 1,
                minHeight: 0,
                alignSelf: "stretch",
                position: "relative",
                width: "100%",
                flexDirection: "column",
              }}
            >
              {/* ── Floating header overlay ─────────────────────────────────────────
                  Sits above the floor plan canvas (zIndex 20 > canvas overlays 4/5).
                  pointerEvents auto so buttons remain tappable.
                  paddingTop respects iOS safe-area (notch / Dynamic Island).       */}
              <Stack
                direction="row"
                alignItems="center"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 20,
                  px: "8px",
                  pt: "max(6px, env(safe-area-inset-top, 6px))",
                  pb: "2px",
                  pointerEvents: "none",
                  gap: { xs: 0.25, sm: 0.5 },
                }}
              >
                {/* Left group: undo / redo — single segmented pill (glass surface + hairline divider) */}
                <Stack
                  direction="row"
                  alignItems="center"
                  flexShrink={0}
                  sx={{ gap: { xs: 0.25, sm: 0.5 }, pointerEvents: "auto" }}
                >
                  {!params?.id && minimizeLoading && (
                    <IconButton
                      disableRipple
                      aria-label="Saving layout"
                      sx={{ minWidth: 44, minHeight: 44 }}
                    >
                      <CircularProgress size="12px" />
                    </IconButton>
                  )}

                  <Box
                    sx={{
                      ...EDITOR_TOP_BAR_SURFACE_SX,
                      height: 36,
                      minWidth: 88,
                      borderRadius: "18px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "stretch",
                      flexShrink: 0,
                      overflow: "hidden",
                      boxSizing: "border-box",
                    }}
                  >
                    <IconButton
                      disableRipple
                      disabled={globalUndoFurniture?.length === 0}
                      onClick={() => handleUndoFurniture()}
                      aria-label="Undo"
                      sx={{
                        flex: 1,
                        minWidth: 0,
                        height: "100%",
                        borderRadius: 0,
                        p: 0,
                        color: EDITOR_TOP_BAR_ICON_ENABLED,
                        "&.Mui-disabled": {
                          opacity: 0.34,
                          color: EDITOR_TOP_BAR_ICON_DISABLED,
                        },
                      }}
                    >
                      <UndoIcon style={{ width: 18, height: 18, display: "block" }} />
                    </IconButton>
                    <Box
                      aria-hidden
                      sx={{
                        width: "1px",
                        flexShrink: 0,
                        alignSelf: "stretch",
                        my: "7px",
                        bgcolor: "rgba(0, 0, 0, 0.09)",
                      }}
                    />
                    <IconButton
                      disableRipple
                      disabled={globalRedoFurniture?.length === 0}
                      onClick={() => handleRedoFurniture()}
                      aria-label="Redo"
                      sx={{
                        flex: 1,
                        minWidth: 0,
                        height: "100%",
                        borderRadius: 0,
                        p: 0,
                        color: EDITOR_TOP_BAR_ICON_ENABLED,
                        "&.Mui-disabled": {
                          opacity: 0.34,
                          color: EDITOR_TOP_BAR_ICON_DISABLED,
                        },
                      }}
                    >
                      <RedoIcon style={{ width: 18, height: 18, display: "block" }} />
                    </IconButton>
                  </Box>
                </Stack>

                {/* Spacer */}
                <Box sx={{ flex: 1, minWidth: 0 }} />

                {/* Right group: Done + edit / settings */}
                <Stack
                  direction="row"
                  alignItems="center"
                  gap={{ xs: 0.5, sm: 1 }}
                  sx={{ flexShrink: 0, pointerEvents: "auto" }}
                >
                  {/* ── Done button — contextual: deselect furniture → deselect room → exit ── */}
                  {!(params?.id && autoSave === false) &&
                    !shoppingListFlag &&
                    !optionsMenu &&
                    isScaleDimensionsMarked !== "select" && (
                    <Box
                      sx={{
                        ...EDITOR_TOP_BAR_SURFACE_SX,
                        height: 36,
                        px: "14px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "18px",
                        cursor: "pointer",
                        WebkitTapHighlightColor: "transparent",
                        transition: "transform 0.12s ease",
                        "&:active": { transform: "scale(0.96)" },
                        pointerEvents: "auto",
                      }}
                      onClick={() => {
                        // 1. Cancel picking mode
                        if (isPickingRoom || shufflePickedRoom != null) {
                          setIsPickingRoom(false);
                          setShufflePickedRoom(null);
                          setShowHelperMessage(false);
                          return;
                        }
                        // 2. Deselect furniture
                        if (selectedFurniture) {
                          setSelectedFurniture(null);
                          setCopySelectedFurniture(null);
                          setSelectedItem(null);
                          if (roomId === "custom-room") {
                            setRoomId(null);
                            setVertices({ index: false, vertices: [], roomId: "" });
                            const lineContainer = document.getElementById("lineContainer");
                            if (lineContainer) {
                              lineContainer.querySelectorAll(".shape").forEach((el) => el.remove());
                            }
                            setLineBoundary(false);
                          }
                          return;
                        }
                        // 3. Deselect room
                        if (roomActive !== -1) {
                          setIsAdding(false);
                          setAddingFromSomethingElse(false);
                          setSelectedFurniture(null);
                          setCopySelectedFurniture(null);
                          setSelectedItem(null);
                          setOpenFilters(false);
                          setShowZonesMenu(false);
                          setVertices({ index: false, vertices: [], roomId: "" });
                          const lineContainer = document.getElementById("lineContainer");
                          if (lineContainer) {
                            lineContainer.querySelectorAll(".shape").forEach((el) => el.remove());
                          }
                          setLineBoundary(false);
                          setRoomId(null);
                          setRoomActive(-1);
                          return;
                        }
                        // 3b. Deselect a fresh-tapped room that isn't in
                        // roomsData yet (roomActive stays -1 because the
                        // room hasn't been committed). Previously this fell
                        // through to "exit to gallery" if roomsData was
                        // non-empty, and to a silent no-op on first upload
                        // when roomsData was empty — both confusing. Clear
                        // the visible selection state so the room outline /
                        // bottom strip / dropdown disappear.
                        if (lineBoundary || roomId || vertices?.roomId) {
                          setIsAdding(false);
                          setAddingFromSomethingElse(false);
                          setOpenFilters(false);
                          setShowZonesMenu(false);
                          setVertices({ index: false, vertices: [], roomId: "" });
                          const lineContainer = document.getElementById("lineContainer");
                          if (lineContainer) {
                            lineContainer.querySelectorAll(".shape").forEach((el) => el.remove());
                          }
                          setLineBoundary(false);
                          setRoomId(null);
                          return;
                        }
                        // 4. Exit to gallery
                        if (roomsData?.length > 0) {
                          if (isLoading || editorBackToGalleryInFlightRef.current) return;
                          if (isGuest) {
                            editorBackToGalleryInFlightRef.current = true;
                            guestForkGalleryCaptureBlobRef.current = null;
                            const guestDoneVersionKey =
                              versionLayout || layoutData?.version;
                            (async () => {
                              try {
                                guestForkGallerySaveSnapshotRef.current = {
                                  roomsData: cloneDeep(roomsDataRef.current),
                                  roomActive: roomActiveRef.current,
                                  roomActiveLayout: cloneDeep(
                                    roomActiveLayoutRef.current
                                  ),
                                  zonesRoom: cloneDeep(zonesRoomRef.current),
                                };
                                mfLogGuestGalleryAuth("done.preAuthSnapshot", {
                                  layoutId: layoutData?._id,
                                  versionKey: guestDoneVersionKey,
                                  snapshotFingerprint:
                                    fingerprintGuestLayoutState(
                                      guestForkGallerySaveSnapshotRef.current
                                        .roomsData
                                    ),
                                  ...fingerprintEditorDomCapture(),
                                  ...fingerprintGuestForkDomDeep(),
                                  editorPack: guestForkEditorDiagRef.current,
                                  autoSaveInFlight: autoSaveloadingRef.current,
                                  hasUserEdited: hasUserEditedRef.current,
                                });
                              } catch (snapErr) {
                                guestForkGallerySaveSnapshotRef.current = null;
                                mfLogGuestGalleryAuth(
                                  "done.preAuthSnapshotFailed",
                                  {
                                    layoutId: layoutData?._id,
                                    message:
                                      snapErr?.message ?? String(snapErr),
                                  }
                                );
                              }

                              const captureFn =
                                downloadLayoutForGalleryCaptureRef.current;
                              if (captureFn) {
                                galleryCaptureDiagSessionRef.current = {
                                  diagSession:
                                    ++forkDiagSessionCounterRef.current,
                                  source: "guestDonePreAuth",
                                  tRequest: performance.now(),
                                };
                                const preAuthGalleryBlob = await captureFn(
                                  2
                                ).catch((capErr) => {
                                  mfLogGuestGalleryAuth(
                                    "done.preAuthCaptureRejected",
                                    {
                                      layoutId: layoutData?._id,
                                      versionKey: guestDoneVersionKey,
                                      message:
                                        capErr?.message ?? String(capErr),
                                    }
                                  );
                                  return null;
                                });
                                if (
                                  preAuthGalleryBlob &&
                                  preAuthGalleryBlob.size > 5000
                                ) {
                                  guestForkGalleryCaptureBlobRef.current =
                                    preAuthGalleryBlob;
                                  mfLogGuestGalleryAuth("done.preAuthCapture", {
                                    layoutId: layoutData?._id,
                                    versionKey: guestDoneVersionKey,
                                    galleryBlobBytes: preAuthGalleryBlob.size,
                                    galleryBlobType: preAuthGalleryBlob.type,
                                    ...fingerprintEditorDomCapture(),
                                    ...fingerprintGuestForkDomDeep(),
                                    editorPack: guestForkEditorDiagRef.current,
                                  });
                                } else {
                                  mfLogGuestGalleryAuth(
                                    "done.preAuthCaptureSkipped",
                                    {
                                      layoutId: layoutData?._id,
                                      versionKey: guestDoneVersionKey,
                                      reason: !preAuthGalleryBlob
                                        ? "no_blob"
                                        : "blob_too_small",
                                      galleryBlobBytes:
                                        preAuthGalleryBlob?.size ?? null,
                                    }
                                  );
                                }
                              } else {
                                mfLogGuestGalleryAuth(
                                  "done.preAuthCaptureSkipped",
                                  {
                                    layoutId: layoutData?._id,
                                    versionKey: guestDoneVersionKey,
                                    reason: "capture_fn_unavailable",
                                  }
                                );
                              }

                              requireAuth(() => {}, GO_GALLERY, {
                                surface: "doneBackToGallery",
                              });
                              // requireAuth has opened the auth gate (or, for a
                              // logged-in user, already run the action). Release
                              // the in-flight latch so that if the guest dismisses
                              // the modal without authenticating, a later Done tap
                              // is not permanently swallowed by the guard above.
                              editorBackToGalleryInFlightRef.current = false;
                            })().catch((doneErr) => {
                              guestForkGallerySaveSnapshotRef.current = null;
                              guestForkGalleryCaptureBlobRef.current = null;
                              editorBackToGalleryInFlightRef.current = false;
                              mfLogGuestGalleryAuth("done.preAuthCaptureFailed", {
                                layoutId: layoutData?._id,
                                message: doneErr?.message ?? String(doneErr),
                              });
                            });
                            return;
                          }
                          const runBackToGallery = async () => {
                            if (editorBackToGalleryInFlightRef.current) return;
                            editorBackToGalleryInFlightRef.current = true;
                            try {
                              const layoutId = layoutData?._id;
                              const versionKey =
                                versionLayout || layoutData?.version;
                              mfStaleGalleryEditorLog("done.start", {
                                layoutId,
                                versionKey,
                                autoSaveInFlight: autoSaveloadingRef.current,
                                ...fingerprintGuestForkDomDeep(),
                              });

                              // === Done → gallery ===
                              //
                              // PR #663 surgical revert: this block has been
                              // restored to the simple flow that worked in
                              // commit 65ce7f26 (May 9). Between then and PR
                              // #661 we layered eight separate "fixes"
                              // (pendingEditorBlobs handoff, postEditFreshGate,
                              // ProgressiveImage display lock, CAPTURE_SKIPPED
                              // sentinel, waitForCaptureReady gate, RAF
                              // pre-capture wait, capture-then-save
                              // serialization, refusal-to-clear cachedImage)
                              // on top of each other. Each one fixed a real
                              // edge case but the cumulative interaction
                              // between them produced the user-visible
                              // "gallery shows the previous edit until I go
                              // back into the editor and click Done a second
                              // time" regression that PRs #658–#662 could not
                              // settle.
                              //
                              // The simple flow:
                              //   1. Wait for any in-flight autosave to drain.
                              //   2. Sync autoSaveDataRef from the live refs.
                              //   3. Save + capture in parallel.
                              //   4. Cache the blob URL under (layoutId, version).
                              //   5. Navigate to the gallery with the
                              //      edited-version pin so the slider opens
                              //      on the right chip.
                              //   6. Invalidate RTK Query 150 ms after the
                              //      navigation so the slider renders from
                              //      its existing cache first (avoids the
                              //      generic "Loading" flash).
                              //
                              // The gallery side reads the same layoutCache
                              // entry in its useEffect — that single source
                              // of truth is what worked at 65ce7f26.
                              //
                              // RETAINED from later commits (orthogonal to
                              // staleness, demonstrably good):
                              //   * Saving overlay debounce (PR #80b9fda6)
                              //   * Deferred invalidateTags (PR #80b9fda6)
                              //   * cachedAt timestamp (PR #de02ea98) — used
                              //     by the gallery's blob-validation skip
                              //   * editedVersion navigate state (PR #d60a4397)
                              //   * toJpeg warm-up in downloadLayout (PR #660)
                              //
                              // NOT RETAINED (the staleness band-aids):
                              //   * pendingEditorBlobs handoff for Done
                              //     (handleDuplicateVersionOrLayout still
                              //     uses pendingEditorBlobs — that flow is
                              //     untouched per PR #663 scope.)
                              //   * 5 KB blob-size guard
                              //   * CAPTURE_SKIPPED sentinel for Done
                              //   * Cache-slot deletion on capture failure
                              //   * RAF pre-capture wait
                              //   * Capture-then-save serialization
                              setIsLoading(true);
                              savingOverlayTimerRef.current = setTimeout(() => {
                                savingOverlayTimerRef.current = null;
                                setSavingOverlayVisible(true);
                              }, 350);
                              if (timeoutRef.current) {
                                clearInterval(timeoutRef.current);
                                timeoutRef.current = null;
                              }
                              const waitForAutoSave = async () => {
                                while (autoSaveloadingRef.current) {
                                  await new Promise((resolve) => setTimeout(resolve, 100));
                                }
                              };
                              await waitForAutoSave();
                              mfStaleGalleryEditorLog("done.afterAutosaveDrain", {
                                layoutId,
                                versionKey,
                                autoSaveInFlight: autoSaveloadingRef.current,
                              });
                              autoSaveDataRef.current = {
                                ...autoSaveDataRef.current,
                                roomsData: roomsDataRef.current,
                                roomActive: roomActiveRef.current,
                                roomActiveLayout: roomActiveLayoutRef.current,
                                zonesRoom: zonesRoomRef.current,
                              };
                              mfStaleGalleryEditorLog("done.diag.beforeParallel", {
                                layoutId,
                                versionKey,
                                autoSaveInFlight: autoSaveloadingRef.current,
                                ...fingerprintGuestForkDomDeep(),
                                editorPack: guestForkEditorDiagRef.current,
                                payloadFingerprint: fingerprintGuestLayoutState(
                                  autoSaveDataRef.current?.roomsData
                                ),
                                liveRefFingerprint: fingerprintGuestLayoutState(
                                  roomsDataRef.current
                                ),
                              });
                              galleryCaptureDiagSessionRef.current = {
                                diagSession: ++forkDiagSessionCounterRef.current,
                                source: "loggedInDoneParallel",
                                tRequest: performance.now(),
                              };
                              const [saveSucceeded, galleryBlob] = await Promise.all([
                                updatedLayout(false),
                                downloadLayout(2).catch(() => null),
                              ]);
                              mfStaleGalleryEditorLog("done.saveAndCapture", {
                                layoutId,
                                versionKey,
                                saveSucceeded: !!saveSucceeded,
                                galleryBlobBytes: galleryBlob?.size ?? null,
                                galleryBlobType: galleryBlob?.type ?? null,
                              });
                              if (!saveSucceeded && !galleryBlob) {
                                mfStaleGalleryEditorLog("done.abort", {
                                  layoutId,
                                  versionKey,
                                  saveSucceeded: !!saveSucceeded,
                                  hadBlob: !!galleryBlob,
                                });
                                return;
                              }
                              const cacheKey = String(layoutId);
                              const oldData = layoutCache.get(cacheKey) || {};
                              if (!oldData["versions"]) oldData["versions"] = {};
                              if (galleryBlob && galleryBlob.size > 5000) {
                                const blobUrl = URL.createObjectURL(galleryBlob);
                                const cacheEntry = {
                                  version: versionKey,
                                  url: blobUrl,
                                  cachedAt: Date.now(),
                                };
                                oldData["versions"][versionKey] = cacheEntry;
                                layoutCache.set(cacheKey, oldData);
                                mfStaleGalleryEditorLog("done.cacheWrite", {
                                  layoutId,
                                  versionKey,
                                  blobBytes: galleryBlob.size,
                                  layoutCacheKey: cacheKey,
                                });
                                // Module-level handoff: consumed by LayoutVersionSlider's
                                // useState lazy init. Keyed by layoutId only so the gallery
                                // can retrieve it without needing location.state (which may
                                // not be committed to the router context on the first
                                // concurrent render pass).
                                setLastDoneEntry(layoutId, cacheEntry);
                              } else {
                                mfStaleGalleryEditorLog("done.cacheSkip", {
                                  layoutId,
                                  versionKey,
                                  reason: !galleryBlob
                                    ? "no_blob"
                                    : "blob_too_small",
                                  galleryBlobBytes: galleryBlob?.size ?? null,
                                });
                                // Capture failed or returned a suspiciously small
                                // blob. Clear any previous entry for this version
                                // so the gallery's lazy init returns null, arms the
                                // postEditFreshGate, and shows a loader instead of
                                // a stale blob from an earlier Done click.
                                if (oldData["versions"][versionKey]) {
                                  delete oldData["versions"][versionKey];
                                  layoutCache.set(cacheKey, oldData);
                                }
                              }
                              setActiveLayout(null);
                              setDoneEditing(true);
                              setShowVersionLayout(layoutId);
                              mfStaleGalleryEditorLog("done.navigate", {
                                layoutId,
                                editedVersionState: versionKey,
                              });
                              navigate(`/floor-gallery/${layoutId}`, {
                                state: { editedVersion: versionKey },
                              });
                              mfStaleGalleryEditorLog("done.invalidateTagsScheduled", {
                                delayMs: 150,
                                tags: ["savedLayouts"],
                              });
                              setTimeout(() => {
                                dispatch(apiRoomNate.util.invalidateTags(["savedLayouts"]));
                              }, 150);
                            } catch (error) {
                              mfStaleGalleryEditorLog("done.catch", {
                                message: error?.message ?? String(error),
                              });
                            } finally {
                              // Cancel the delayed overlay if the save finished quickly.
                              if (savingOverlayTimerRef.current) {
                                clearTimeout(savingOverlayTimerRef.current);
                                savingOverlayTimerRef.current = null;
                              }
                              setSavingOverlayVisible(false);
                              setIsLoading(false);
                              editorBackToGalleryInFlightRef.current = false;
                            }
                          };
                          void runBackToGallery();
                        }
                        eventLog(targetWindow, 'floor_plan_event', 'editor_closed', {
                          galleryId: layoutData?.uuid || layoutData?._id,
                          galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
                        });
                        setLayoutDataIdToEdit('');
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: EDITOR_TOP_BAR_ICON_ENABLED,
                          lineHeight: 1,
                          userSelect: "none",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {isLoading && roomActive === -1 && roomsData?.length > 0 ? "Saving…" : "Done"}
                      </Typography>
                    </Box>
                  )}

                  {params?.id && !autoSave && (
                    <IconButton
                      color="primary"
                      aria-label="Enable auto-save"
                      sx={{
                        width: 36,
                        height: 36,
                        minWidth: 36,
                        minHeight: 36,
                        p: 0.5,
                      }}
                      onClick={() => setAutoSave(true)}
                    >
                      <EditIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}

                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={editorTopBarMenuIconSx}>
                      <IconButton
                        disableRipple
                        aria-label="Layout options"
                        sx={{
                          p: 0,
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          color: EDITOR_TOP_BAR_ICON_ENABLED,
                        }}
                        onClick={() => {
                          console.log('[OPTIONS MENU] 📋 Settings button clicked - opening settings menu with', settingsMenu?.length, 'items');
                          setShoppingListFlag(false);
                          setOptionsMenu(settingsMenu);
                        }}
                      >
                        <ActionIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Stack>
              </Stack>

              {/* Room-pick overlay canvas — position:fixed covers full viewport.
                  Active during shuffle/pick AND normal room selection (replaces
                  SVG marching ants). z-index 4 stays below toolbars (z-999). */}
              {(isPickingRoom || shufflePickedRoom != null || (roomActive !== -1 && lineBoundary && partnerPackage?.allowMakeMagic)) && (
                <Box
                  component="canvas"
                  ref={overlayCanvasRef}
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 4,
                    pointerEvents: "none",
                    "@keyframes overlayFadeIn": {
                      from: { opacity: 0 },
                      to:   { opacity: 1 },
                    },
                    animation: "overlayFadeIn 200ms ease-out both",
                  }}
                />
              )}

              {/* Border canvas — animated (shuffle/pick) or static (normal selection).
                  Replaces SVG marching ants. pointerEvents:none — clicks pass through. */}
              {(isPickingRoom || shufflePickedRoom != null || (roomActive !== -1 && lineBoundary && partnerPackage?.allowMakeMagic)) && (
                <Box
                  component="canvas"
                  ref={borderCanvasRef}
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 5,
                    pointerEvents: "none",
                    "@keyframes overlayFadeIn": {
                      from: { opacity: 0 },
                      to:   { opacity: 1 },
                    },
                    animation: "overlayFadeIn 200ms ease-out both",
                  }}
                />
              )}

              {isPickingRoom &&
                partnerPackage?.allowMakeMagic &&
                !shoppingListFlag &&
                !isAdding &&
                !lineBoundary &&
                !openFilters &&
                !optionsMenu &&
                !selectedFurniture &&
                roomActive === -1 && (
                <Box
                  key={tooltipAnimKey}
                  sx={{
                    position: "fixed",
                    // Toolbar is hidden in picking mode — drop the message to sit
                    // just above the device safe-area, aligning with the toolbar's
                    // bottom edge that was removed (+ gap above Powered by strip).
                    bottom: {
                      xs: `${24 + EDITOR_ABOVE_BRANDING_PX}px`,
                      sm: `${28 + EDITOR_ABOVE_BRANDING_PX}px`,
                    },
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000,
                    width: "auto",
                    // Spring-pop entrance: scale from 0.86 → brief overshoot → settle.
                    // cubic-bezier(0.34, 1.56, 0.64, 1) is the iOS spring curve —
                    // creates the "notification pops into place" feel Apple uses
                    // throughout iOS. GPU-composited (transform + opacity only).
                    "@keyframes tooltipFadeSlide": {
                      "0%":   { opacity: 0, transform: "translateX(-50%) scale(0.82)" },
                      "60%":  { opacity: 1, transform: "translateX(-50%) scale(1.04)" },
                      "100%": { opacity: 1, transform: "translateX(-50%) scale(1.00)" },
                    },
                    animation: "tooltipFadeSlide 360ms cubic-bezier(0.34, 1.56, 0.64, 1) both",
                  }}
                >
                  <Stack
                    sx={{
                      boxShadow:
                        "0 8px 28px rgba(0, 0, 0, 0.14), 0 1px 0 rgba(255, 255, 255, 0.9) inset",
                      borderRadius: "14px",
                      background: "rgba(248, 248, 250, 0.96)",
                      border: "1px solid rgba(0, 0, 0, 0.07)",
                      px: 1.75,
                      py: 1,
                      flexDirection: "row",
                      gap: 1.25,
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                        color: "rgba(60, 60, 67, 0.78)",
                      }}
                    >
                      Tap a room to shuffle
                    </Typography>

                    <IconButton
                      sx={{ p: 0, ml: 0.5 }}
                      disableRipple
                      onClick={dismissTapRoomHint}
                    >
                      <ExitIcon style={{ width: 16, height: 16 }} />
                    </IconButton>
                  </Stack>
                </Box>
              )}

              {/* Deselect Room moved to fixed left-slot pill — see below */}

              {/* Done Editing / Cancel / Deselect Room moved to fixed left-slot pill — see below */}

              <TransformWrapper
                ref={transformRef} 
                initialScale={1}
                minScale={minScale - 0.2}
                doubleClick={{ disabled: true }}
                pinch={{
                  disabled: false, 
                }}
                panning={{
                  velocityDisabled: true,
                  disabled: false, 
                  lockAxisX: false, 
                  lockAxisY: false, 
                }}
                wheel={{
                  smoothStep: 0.005,
                }}
                maxScale={5}
                limitToBounds={false}
                onTransformed={handleTransformed}
              >
                <TransformComponent>
                  <div
                    className="image-container"
                    style={{
                      width: divWidth,
                      height: divHeight,
                    }}
                  >
                    <div id="image-container-1" className="image-content"></div>

                    {imageDimensions?.width &&
                      imageDimensions?.height &&
                      !textShow && (
                        <svg
                          width="100%"
                          height="100%"
                          className="rect-box"
                          style={{
                            position: "absolute",
                          }}
                        >
                          {roomsData?.map((roomData, roomIndex) => {
                            const selectedRoom = modalData?.find(
                              (room) => room.room_id === roomData.roomId
                            );
                            if (!selectedRoom) return null;

                            const activeLayoutIndex =
                              roomActiveLayout?.[roomIndex];
                            if (
                              !shouldCoverPlanLabelsForRoom({
                                room: selectedRoom,
                                roomsDataEntry: roomData,
                                activeLayoutIndex,
                                planLabelsVisible: textShow,
                              })
                            ) {
                              return null;
                            }

                            const filteredBoxes = filterBoxesInRoom(
                              normalizeTextBoxes(planLabelBoxes),
                              selectedRoom
                            );

                            return filteredBoxes?.map((box, index) => {
                              const adjustedX =
                                box.left * scaleXCanvas + offsetXCheck - 1;
                              const adjustedY =
                                box.top * scaleYCanvas + offsetYCheck - 1;
                              const adjustedWidth =
                                box.width * scaleXCanvas + 2;
                              const adjustedHeight =
                                box.height * scaleYCanvas + 2;

                              return (
                                <rect
                                  key={`${roomData.roomId || roomData.room_id}-${index}`}
                                  x={adjustedX}
                                  y={adjustedY}
                                  width={adjustedWidth}
                                  height={adjustedHeight}
                                  fill={getCoverFill(box)}
                                />
                              );
                            });
                          })}
                        </svg>
                      )}

                    <div
                      id="lineContainer"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: 1,
                      }}
                      onMouseDown={handleMouseDivDown}
                      onMouseMove={handleMouseDivMove}
                      onMouseUp={handleMouseDivUp}
                    ></div>

                    <>
                      {viewLayouts &&
                        Object.entries(roomsData ?? {}).map(
                          ([roomKey, roomValue]) => {
                            const activeLayoutKey = roomActiveLayout?.[roomKey];
                            const activeLayout =
                              roomValue?.layouts?.[activeLayoutKey];

                            const newlyAddedCenterX = divWidth / 2;
                            const newlyAddedCenterY = divHeight / 2;

                            if (!activeLayout) return null;

                            // PETER'S DIAGNOSTIC: Log furniture array before render
                            if (process.env.NODE_ENV !== 'production' && parseInt(roomKey) === roomActive) {
                              const furnitureCount = activeLayout?.furniture?.length ?? 0;
                              const newlyAddedCount = activeLayout?.furniture?.filter(f => f?.newlyAdded)?.length ?? 0;
                              if (furnitureCount > 0 || newlyAddedCount > 0) {
                                console.log('[RENDER] Room ' + roomKey + ' rendering ' + furnitureCount + ' items (' + newlyAddedCount + ' newly added)');
                              }
                            }
                            
                            return (activeLayout?.furniture ?? []).map(
                              (item, idx) => {
                                if (!item) return null;

                                // Newly added item render logging (disabled to prevent console crash)
                                // Enable by setting window.__MF_DEBUG_RENDER = true in console

                                const {
                                  rotation = { z: 0 },
                                  topViewImage,
                                  width,
                                  height,
                                  _id,
                                  origionalWidth,
                                  origionalHeight,
                                  origionalPosition,
                                  flipHorizontal,
                                  flipVertical,
                                  exactPosition,
                                  calculateWidth,
                                  newlyAdded,
                                } = item;

                                // [BEDROCK-RENDER] Quick scale check (limited to prevent console crash)
                                if (idx === 0 && parseInt(roomKey) === roomActive && !window.__mf_bedrock_render_logged) {
                                  window.__mf_bedrock_render_logged = true;
                                  const _rawW = origionalWidth / (roomValue.scaleX || scaleFactorX || 1);
                                  const _vpW = origionalWidth / ((roomValue.scaleX || scaleFactorX || 1) / (scaleXCanvas || 1));
                                  const _isViewportScaled = Math.abs(width - _vpW) < 2;
                                  const _isRawScaled = Math.abs(width - _rawW) < 2;
                                  console.log('████ [BEDROCK-RENDER] Room ' + roomKey + ' item[0]: ' + item.name);
                                  console.log('████ [BEDROCK-RENDER]   width=' + width?.toFixed(2) + ' | rawWouldBe=' + _rawW?.toFixed(2) + ' | vpWouldBe=' + _vpW?.toFixed(2));
                                  console.log('████ [BEDROCK-RENDER]   Scale type:', _isViewportScaled ? 'VIEWPORT ✓' : _isRawScaled ? 'RAW (will look too big!)' : 'UNKNOWN (' + width?.toFixed(2) + ')');
                                  console.log('████ [BEDROCK-RENDER]   newlyAdded:', newlyAdded, '| CenterSetX source:', newlyAdded ? 'divWidth/2' : 'roomValue.centerX');
                                }

                                const CenterSetX = newlyAdded
                                  ? newlyAddedCenterX
                                  : roomValue.centerX;
                                const CenterSetY = newlyAdded
                                  ? newlyAddedCenterY
                                  : roomValue.centerY;

                                const position =
                                  furniturePositions[roomKey]?.[item._id] ||
                                  item.position;

                                const adjustedWidth = width;
                                const adjustedHeight = height;

                                const centerLeft = CenterSetX + position.x * scaleXCanvas;
                                const centerTop = CenterSetY - position.y * scaleYCanvas;
                                
                                // [MATCH-PROD] CSS now renders directly in screen pixels (no * scaleXCanvas)

                                // RENDER LOGGING: Track furniture positioning
                                // =====================================================
                                // Log first item of first room (first render only to prevent console crash)
                                if (process.env.NODE_ENV !== 'production' && parseInt(roomKey) === 0 && idx === 0 && !window.__mf_furniture_render_logged) {
                                  window.__mf_furniture_render_logged = true;
                                  console.log('');
                                  console.log('╔' + '═'.repeat(78) + '╗');
                                  console.log('║  🎨 [FURNITURE RENDER] FIRST ITEM ACTUAL RENDER                              ║');
                                  console.log('╠' + '═'.repeat(78) + '╣');
                                  console.log('║  Item: ' + item.name);
                                  console.log('║  ');
                                  console.log('║  COORDINATES (from state):');
                                  console.log('║    exactPosition (original): ' + JSON.stringify(item.exactPosition));
                                  console.log('║    position (after transform): ' + JSON.stringify(position));
                                  console.log('║  ');
                                  console.log('║  SIZE (from state):');
                                  console.log('║    width: ' + width?.toFixed(2) + ' (original: ' + origionalWidth?.toFixed(2) + ')');
                                  console.log('║    height: ' + height?.toFixed(2) + ' (original: ' + origionalHeight?.toFixed(2) + ')');
                                  console.log('║  ');
                                  console.log('║  ROOM CENTER (for positioning):');
                                  console.log('║    CenterSetX: ' + CenterSetX?.toFixed(2));
                                  console.log('║    CenterSetY: ' + CenterSetY?.toFixed(2));
                                  console.log('║  ');
                                  
                                  const finalLeft = CenterSetX + position.x - width/2;
                                  const finalTop = CenterSetY - position.y - height/2;
                                  
                                  console.log('║  FINAL CSS (what browser will render):');
                                  console.log('║    left = centerX + position.x - width/2');
                                  console.log('║         = ' + CenterSetX?.toFixed(2) + ' + ' + position.x?.toFixed(2) + ' - ' + (width/2)?.toFixed(2));
                                  console.log('║         = ' + finalLeft?.toFixed(2) + 'px');
                                  console.log('║    top  = centerY - position.y - height/2');
                                  console.log('║         = ' + CenterSetY?.toFixed(2) + ' - ' + position.y?.toFixed(2) + ' - ' + (height/2)?.toFixed(2));
                                  console.log('║         = ' + finalTop?.toFixed(2) + 'px');
                                  console.log('║    width: ' + width?.toFixed(2) + 'px');
                                  console.log('║    height: ' + height?.toFixed(2) + 'px');
                                  console.log('║  ');
                                  
                                  // Check if transform ran
                                  const transformRan = position.x !== item.exactPosition?.x || position.y !== item.exactPosition?.y;
                                  console.log('║  TRANSFORM STATUS: ' + (transformRan ? '✅ TRANSFORM RAN' : '⚠️ NO TRANSFORM (position === exactPosition)'));
                                  
                                  if (!transformRan) {
                                    console.log('║  ');
                                    console.log('║  🚨 BUG EXPLANATION:');
                                    console.log('║  The furniture transform was SKIPPED (no payloadVertices on room).');
                                    console.log('║  Furniture position.x = exactPosition.x = ' + position.x?.toFixed(2));
                                    console.log('║  But centerX was RECALCULATED for new viewport = ' + CenterSetX?.toFixed(2));
                                    console.log('║  ');
                                    console.log('║  API viewport had centerX ≈ ' + (CenterSetX * 0.64)?.toFixed(2) + ' (estimated for 1920px)');
                                    console.log('║  So furniture that was at left=' + ((CenterSetX * 0.64) + position.x - width/2)?.toFixed(2));
                                    console.log('║  Is now at left=' + finalLeft?.toFixed(2));
                                    console.log('║  SHIFT: ' + (finalLeft - ((CenterSetX * 0.64) + position.x - width/2))?.toFixed(2) + 'px to the RIGHT');
                                  }
                                  
                                  console.log('╚' + '═'.repeat(78) + '╝');
                                }

                                const rotationAngle =
                                  (rotation.z * 180) / Math.PI;

                                const compositeKey = `${roomKey}-${_id}`;

                                let initialMouseX = 0;
                                let initialMouseY = 0;
                                let offsetX = 0;
                                let offsetY = 0;

                                const canvasWidth = divWidth;
                                const canvasHeight = divHeight;

                                const handleMouseDown = (e) => {
                                  // Don't start a furniture drag if this is part of a
                                  // multi-touch pinch gesture (two fingers on screen).
                                  if (e.touches && e.touches.length > 1) return;

                                  setSelectedItem(compositeKey); 

                                  const isTouchEvent = e.type === "touchstart";

                                  if (transformRef.current) {
                                    transformRef.current.instance.clearPanning();
                                  }

                                  if (!isTouchEvent) {
                                    e.preventDefault(); 
                                  } else {
                                  }

                                  const clientX = isTouchEvent
                                    ? e.touches[0].clientX
                                    : e.clientX;
                                  const clientY = isTouchEvent
                                    ? e.touches[0].clientY
                                    : e.clientY;

                                  initialMouseX = clientX / scale;
                                  initialMouseY = clientY / scale;

                                  offsetX = initialMouseX - centerLeft;
                                  offsetY = initialMouseY - centerTop;

                                  if (!isTouchEvent) {
                                    document.addEventListener(
                                      "mousemove",
                                      handleDrag,
                                      { passive: false }
                                    );
                                    document.addEventListener(
                                      "mouseup",
                                      handleMouseUp
                                    );
                                  } else {
                                    document.addEventListener(
                                      "touchmove",
                                      handleDrag,
                                      { passive: false }
                                    );
                                    document.addEventListener(
                                      "touchend",
                                      handleMouseUp
                                    );
                                  }
                                };

                                const handleDrag = (e) => {
                                  if (timeoutRef.current) {
                                    clearTimeout(timeoutRef.current);
                                    timeoutRef.current = null;
                                  }

                                  if (e.type === "touchmove") {
                                    e.preventDefault();
                                  }

                                  // TRIPWIRE: Mark as user-edited (intentional world change)
                                  // Only log once per drag to avoid console spam
                                  if (!hasUserEditedRef.current) {
                                    markUserEdited();
                                    console.log('[TRIPWIRE] User edit detected: DRAG furniture');
                                  }
                                  
                                  isDraggingFurnitureItem.current = true;

                                  const clientX =
                                    e.type === "touchmove"
                                      ? e.touches[0].clientX
                                      : e.clientX;
                                  const clientY =
                                    e.type === "touchmove"
                                      ? e.touches[0].clientY
                                      : e.clientY;

                                  const canvasWidth = divWidth;
                                  const canvasHeight = divHeight;

                                  const newCenterLeft =
                                    clientX / scale - offsetX;
                                  const newCenterTop =
                                    clientY / scale - offsetY;

                                  const rotationRadians = rotation.z;

                                  // Use viewport-scaled dimensions for bounds (matches visual size)
                                  const vpWidth = adjustedWidth * scaleXCanvas;
                                  const vpHeight = adjustedHeight * scaleYCanvas;
                                  const rotatedWidth =
                                    Math.abs(vpWidth * Math.cos(rotationRadians)) +
                                    Math.abs(vpHeight * Math.sin(rotationRadians));
                                  const rotatedHeight =
                                    Math.abs(vpWidth * Math.sin(rotationRadians)) +
                                    Math.abs(vpHeight * Math.cos(rotationRadians));

                                  const minLeft = rotatedWidth / 2;
                                  const maxLeft =
                                    canvasWidth - rotatedWidth / 2;

                                  const minTop = rotatedHeight / 2;
                                  const maxTop =
                                    canvasHeight - rotatedHeight / 2;

                                  const boundedCenterLeft = Math.min(
                                    Math.max(newCenterLeft, minLeft),
                                    maxLeft
                                  );
                                  const boundedCenterTop = Math.min(
                                    Math.max(newCenterTop, minTop),
                                    maxTop
                                  );

                                  // Store in RAW space (÷ sxc) so CSS (* sxc) renders correctly
                                  const updatedPosition = {
                                    x: (boundedCenterLeft - CenterSetX) / scaleXCanvas,
                                    y: (CenterSetY - boundedCenterTop) / scaleYCanvas,
                                  };

                                  setFurniturePositions((prevPositions) => ({
                                    ...prevPositions,
                                    [roomKey]: {
                                      ...(prevPositions[roomKey] || {}),
                                      [_id]: updatedPosition,
                                    },
                                  }));
                                };

                                const handleMouseUp = (e) => {
                                  const isTouchEvent = e.type === "touchend";

                                  if (!isTouchEvent) {
                                    document.removeEventListener(
                                      "mousemove",
                                      handleDrag
                                    );
                                    document.removeEventListener(
                                      "mouseup",
                                      handleMouseUp
                                    );
                                  } else {
                                    document.removeEventListener(
                                      "touchmove",
                                      handleDrag
                                    );
                                    document.removeEventListener(
                                      "touchend",
                                      handleMouseUp
                                    );
                                  }

                                  if (isDraggingFurnitureItem.current) {
                                    const clientX = isTouchEvent
                                      ? e.changedTouches[0].clientX
                                      : e.clientX;
                                    const clientY = isTouchEvent
                                      ? e.changedTouches[0].clientY
                                      : e.clientY;

                                    const finalMouseX = clientX / scale;
                                    const finalMouseY = clientY / scale;

                                    const finalCenterLeft =
                                      finalMouseX - offsetX;
                                    const finalCenterTop =
                                      finalMouseY - offsetY;

                                    const rotationRadians = rotation.z;

                                    // Use viewport-scaled dimensions for bounds (matches visual size)
                                    const vpWidth = adjustedWidth * scaleXCanvas;
                                    const vpHeight = adjustedHeight * scaleYCanvas;
                                    const rotatedWidth =
                                      Math.abs(vpWidth * Math.cos(rotationRadians)) +
                                      Math.abs(vpHeight * Math.sin(rotationRadians));
                                    const rotatedHeight =
                                      Math.abs(vpWidth * Math.sin(rotationRadians)) +
                                      Math.abs(vpHeight * Math.cos(rotationRadians));

                                    const minLeft = rotatedWidth / 2;
                                    const maxLeft =
                                      canvasWidth - rotatedWidth / 2;

                                    const minTop = rotatedHeight / 2;
                                    const maxTop =
                                      canvasHeight - rotatedHeight / 2;

                                    const boundedCenterLeft = Math.min(
                                      Math.max(finalCenterLeft, minLeft),
                                      maxLeft
                                    );

                                    const boundedCenterTop = Math.min(
                                      Math.max(finalCenterTop, minTop),
                                      maxTop
                                    );

                                    const updatedPosition = {
                                      x: boundedCenterLeft - CenterSetX,
                                      y: CenterSetY - boundedCenterTop,
                                    };

                                    updateFurniturePosition(
                                      item,
                                      updatedPosition,
                                      roomKey,
                                      _id
                                    );

                                    // Clear live drag position so CSS uses saved item.position
                                    setFurniturePositions((prevPositions) => {
                                      const newPositions = { ...prevPositions };
                                      if (newPositions[roomKey]) {
                                        delete newPositions[roomKey][_id];
                                      }
                                      return newPositions;
                                    });

                                    setCopySelectedFurniture({
                                      left: boundedCenterLeft,
                                      top: boundedCenterTop - rotatedHeight / 2,
                                      angle: rotationAngle,
                                      roomId: roomKey,
                                      _id,
                                      centerTop: boundedCenterTop,
                                    });

                                    setSelectedFurniture({
                                      left: boundedCenterLeft,
                                      top: boundedCenterTop - rotatedHeight / 2,
                                      angle: rotationAngle,
                                      roomId: roomKey,
                                      _id,
                                      centerTop: boundedCenterTop,
                                    });

                                    isDraggingFurnitureItem.current = false;
                                  }
                                };

                                const rotationRadians = rotation.z;

                                const rotatedHeight =
                                  Math.abs(
                                    adjustedWidth * Math.sin(rotationRadians)
                                  ) +
                                  Math.abs(
                                    adjustedHeight * Math.cos(rotationRadians)
                                  );


                                return (
                                  <Box key={`${_id}`} sx={{ animation: "furnitureFadeIn 0.22s ease-out" }}>
                                    <div
                                      className="image-boundary"
                                      id={`${CenterSetX}/${CenterSetY}/${
                                        roomValue?.roomId
                                      }/${origionalPosition?.x}/${
                                        origionalPosition?.y
                                      }/${origionalWidth}/${origionalHeight}/${
                                        roomValue.scaleX
                                      }/${roomValue.scaleY}/${
                                        exactPosition?.x
                                      }/${exactPosition?.y}/${
                                        newlyAdded ? newlyAdded : false
                                      }/${calculateWidth}`}
                                      style={{
                                        position: "absolute",
                                        left: `${
                                          CenterSetX + position.x * scaleXCanvas - (width * scaleXCanvas) / 2
                                        }px`,
                                        top: `${
                                          CenterSetY - position.y * scaleYCanvas - (height * scaleYCanvas) / 2
                                        }px`,
                                        width: `${width * scaleXCanvas}px`,
                                        height: `${height * scaleYCanvas}px`,
                                        zIndex: isRugItem(item)
                                        ? 1
                                        : (allSupplementaryItemsIds.some(id => item?._id?.includes(id)) ? 3 : 2),
                                        transformOrigin: "50% 50%",
                                        transform: `rotate(${rotationAngle}deg)`,
                                      }}
                                    >
                                      {selectedItem === compositeKey && (
                                        <>
                                          <>
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: `0`,
                                                top: `0`,
                                                width: "100%",
                                                height: `2px`,
                                                backgroundColor: EDITOR_FURNITURE_SELECTION_STROKE,
                                                transform: `scaleY(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              style={{
                                                position: "absolute",
                                                bottom: 0,
                                                left: 0,
                                                width: "100%",
                                                height: `2px`,
                                                backgroundColor: EDITOR_FURNITURE_SELECTION_STROKE,
                                                transform: `scaleY(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: `2px`,
                                                height: "100%",
                                                backgroundColor: EDITOR_FURNITURE_SELECTION_STROKE,
                                                transform: `scaleX(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                                width: `2px`,
                                                height: "100%",
                                                backgroundColor: EDITOR_FURNITURE_SELECTION_STROKE,
                                                transform: `scaleX(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              className="boundary"
                                              style={{
                                                position: "absolute",
                                                left: `-5px`,
                                                top: `-5px`,
                                                width: "10px",
                                                height: "10px",
                                                backgroundColor: "#FFFFFF",
                                                outline: `2px solid ${EDITOR_FURNITURE_SELECTION_STROKE}`,
                                                transform: `scale(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              className="boundary"
                                              style={{
                                                position: "absolute",
                                                right: `-5px`,
                                                top: `-5px`,
                                                width: "10px",
                                                height: "10px",
                                                backgroundColor: "#FFFFFF",
                                                outline: `2px solid ${EDITOR_FURNITURE_SELECTION_STROKE}`,

                                                transform: `scale(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              className="boundary"
                                              style={{
                                                position: "absolute",
                                                left: `-5px`,
                                                bottom: `-5px`,
                                                width: "10px",
                                                height: "10px",
                                                backgroundColor: "#FFFFFF",
                                                outline: `2px solid ${EDITOR_FURNITURE_SELECTION_STROKE}`,

                                                transform: `scale(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>

                                            <div
                                              className="boundary"
                                              style={{
                                                position: "absolute",
                                                right: `-5px`,
                                                bottom: `-5px`,
                                                width: "10px",
                                                height: "10px",
                                                backgroundColor: "#FFFFFF",
                                                outline: `2px solid ${EDITOR_FURNITURE_SELECTION_STROKE}`,
                                                transform: `scale(${
                                                  1 / scale
                                                })`,
                                                transformOrigin: "center",
                                              }}
                                            ></div>
                                          </>
                                        </>
                                      )}

                                      <img
                                        id={`${origionalWidth}/${origionalHeight}`}
                                        className="svg-image"
                                        src={`${baseUrl}/g${topViewImage}`}
                                        alt={`Furniture-${roomKey}-${activeLayoutKey}-${idx}`}
                                        width={width * scaleXCanvas}
                                        height={height * scaleYCanvas}
                                        style={{
                                          zIndex: isRugItem(item)
                                          ? 2
                                          : (allSupplementaryItemsIds.some(id => item?._id?.includes(id)) ? 4 : 3),
                                          position: "absolute",
                                          border:
                                            roomKey === roomActive
                                              ? "2px solid red"
                                              : "none",
                                          cursor: "move",
                                          pointerEvents: "auto",
                                          transform: `
                                            ${
                                              rotationAngle % 180 === 0
                                                ? flipHorizontal
                                                  ? "scaleX(-1)"
                                                  : ""
                                                : flipVertical
                                                ? "scaleX(-1)"
                                                : ""
                                            }
                                            ${
                                              rotationAngle % 180 === 0
                                                ? flipVertical
                                                  ? "scaleY(-1)"
                                                  : ""
                                                : flipHorizontal
                                                ? "scaleY(-1)"
                                                : ""
                                            }
                                          `.trim(),
                                        }}
                                        onMouseDown={(e) => {
                                          if (shoppingListFlag) {
                                            return;
                                          }

                                          if (loadingLayout) {
                                            return;
                                          }

                                          // Consume the synthesized-mousedown-after-room-switch guard.
                                          // The touch that switched rooms set this ref; by the time
                                          // the synthesized mousedown fires, roomActive has committed
                                          // to the new room so the stale-closure check below would
                                          // pass — this ref is the only reliable blocker.
                                          if (mobileRoomJustSwitchedRef.current) {
                                            mobileRoomJustSwitchedRef.current = false;
                                            return;
                                          }

                                          // In pre-pick spotlight mode, furniture taps select the room.
                                          //
                                          // This has to load the room's geometry, not just its id. An
                                          // earlier cut set roomId and an empty vertices array, which was
                                          // enough for the zone pill and the toolbar guard to light up but
                                          // left furnishRoom describing a room with no walls: it reads the
                                          // wall list straight off vertices.vertices, so Make Magic asked
                                          // the API to furnish nothing and got nothing back — the empty
                                          // room and Add Items the room-type change appeared to cause.
                                          if (isPickingRoom) {
                                            const pickRoom = modalData?.find(r => r.room_id === roomValue?.roomId);
                                            if (pickRoom && applySpotlightRoomSelection(pickRoom)) {
                                              setIsPickingRoom(false);
                                              setShowHelperMessage(false);
                                            }
                                            return;
                                          }

                                          // Post-pick: tapping furniture in a non-spotlighted room
                                          // switches the spotlight to that room.
                                          if (shufflePickedRoom != null && roomValue?.roomId !== shufflePickedRoom?.room_id) {
                                            const switchRoom = modalData?.find(r => r.room_id === roomValue?.roomId);
                                            if (switchRoom) {
                                              // Walls alone are not enough: doors and the room centre are
                                              // read from separate state that this used to leave pointing at
                                              // the room being switched away from, so furnishRoom described
                                              // one room's walls with another's doorways. Furniture is only
                                              // rendered for rooms in roomsData, so a room reached by tapping
                                              // its furniture always has geometry stored to read.
                                              const lcEl = document.getElementById("lineContainer");
                                              lcEl?.querySelectorAll(".shape").forEach(el => el.remove());
                                              applySpotlightRoomSelection(switchRoom);
                                            }
                                            return;
                                          }

                                          setOptionsMenu(null);

                                          // Reset scale selection mode so the toolbar can show.
                                          // "Adjust the Scale" sets this to "select", which hides the toolbar.
                                          // Clicking furniture should exit that mode.
                                          if (isScaleDimensionsMarked === "select") {
                                            setIsScaleDimensionsMarked(true);
                                          }

                                          setVertices({
                                            index: true,
                                            vertices:
                                              roomValue?.payloadVertices,
                                            roomId: roomValue?.roomId,
                                          });

                                          setRoomId(roomValue?.roomId);

                                          drawFloors(
                                            null,
                                            null,
                                            true,
                                            roomValue?.payloadVertices,
                                            roomValue?.doors,
                                            roomValue?.windows,
                                            roomValue?.scaleX,
                                            roomValue?.scaleY,
                                            CenterSetX,
                                            CenterSetY,
                                            roomValue?.roomId,
                                            roomValue.scaleXCanvas,
                                            roomValue.scaleYCanvas,
                                            roomValue.offsetX,
                                            roomValue.offsetY
                                          );

                                          // Room-first: drawFloors above updated room context.
                                          // If this furniture belongs to a different room than
                                          // the one now active, stop here — the room has been
                                          // selected; the next tap enters the furniture.
                                          if (roomsData[roomActive]?.roomId !== roomValue?.roomId) {
                                            return;
                                          }

                                          setStartPoint({
                                            x: e.clientX,
                                            y: e.clientY,
                                          });

                                          if (!selectedItem) {
                                            return;
                                          }

                                          e.stopPropagation();
                                          handleMouseDown(e);
                                        }}
                                        onTouchStart={(e) => {
                                          // Reset both guard flags at the start of every touch.
                                          touchRoomGuardFiredRef.current = false;
                                          mobileRoomJustSwitchedRef.current = false;

                                          if (shoppingListFlag) {
                                            return;
                                          }

                                          if (loadingLayout) {
                                            return;
                                          }

                                          // Pre-pick spotlight mode: touch on furniture spotlights the room.
                                          //
                                          // This is the tap the gallery's "Shuffle it" hands the user: the
                                          // plan it shows is furnished, so the room they aim at is covered
                                          // in furniture and the touch lands here rather than on the floor.
                                          // It must load the same geometry the floor tap does — setting only
                                          // roomId left furnishRoom sending a room with no walls, and the
                                          // API cannot furnish that.
                                          //
                                          // mobileRoomJustSwitchedRef blocks the browser-synthesized
                                          // mousedown that fires after touchend so furniture is NOT
                                          // selected in the same tap that picks the room. That block is
                                          // also why this cannot lean on handleDivClick to fill in the
                                          // rest: it never runs for this tap.
                                          if (isPickingRoom) {
                                            const pickRoom = modalData?.find(r => r.room_id === roomValue?.roomId);
                                            if (pickRoom && applySpotlightRoomSelection(pickRoom)) {
                                              setIsPickingRoom(false);
                                              setShowHelperMessage(false);
                                            }
                                            mobileRoomJustSwitchedRef.current = true;
                                            return;
                                          }

                                          // (mobile two-tap: handled via touchRoomGuardFiredRef below)

                                          // Post-pick: touch on non-spotlighted room furniture switches spotlight.
                                          if (shufflePickedRoom != null && roomValue?.roomId !== shufflePickedRoom?.room_id) {
                                            const switchRoom = modalData?.find(r => r.room_id === roomValue?.roomId);
                                            if (switchRoom) {
                                              // Walls alone are not enough — doors and the room centre live
                                              // in separate state that this used to leave describing the
                                              // room being switched away from. Read from the room's stored
                                              // geometry, which furniture rendering guarantees exists.
                                              const lcEl = document.getElementById("lineContainer");
                                              lcEl?.querySelectorAll(".shape").forEach(el => el.remove());
                                              applySpotlightRoomSelection(switchRoom);
                                            }
                                            // Block the synthesized mouseup/click from triggering handleDivClick.
                                            mobileRoomJustSwitchedRef.current = true;
                                            return;
                                          }

                                          setVertices({
                                            index: true,
                                            vertices:
                                              roomValue?.payloadVertices,
                                            roomId: roomValue?.roomId,
                                          });

                                          setOptionsMenu(null);

                                          // Reset scale selection mode so the toolbar can show (touch)
                                          if (isScaleDimensionsMarked === "select") {
                                            setIsScaleDimensionsMarked(true);
                                          }

                                          setRoomId(roomValue?.roomId);

                                          drawFloors(
                                            null,
                                            null,
                                            true,
                                            roomValue?.payloadVertices,
                                            roomValue?.doors,
                                            roomValue?.windows,
                                            roomValue?.scaleX,
                                            roomValue?.scaleY,
                                            CenterSetX,
                                            CenterSetY,
                                            roomValue?.roomId,
                                            roomValue.scaleXCanvas,
                                            roomValue.scaleYCanvas,
                                            roomValue.offsetX,
                                            roomValue.offsetY
                                          );

                                          // Room-first guard: if this furniture belongs to a different
                                          // room than the one currently active, the touch selects the
                                          // room but must NOT select the furniture on this same tap.
                                          // Set the ref synchronously so onTouchEnd (same render cycle,
                                          // same closure) can detect the block — state updates would
                                          // not be visible until after re-render.
                                          if (roomsData[roomActive]?.roomId !== roomValue?.roomId) {
                                            touchRoomGuardFiredRef.current = true;
                                            // Also block the browser-synthesized mousedown that
                                            // fires after touchend once React state has committed.
                                            mobileRoomJustSwitchedRef.current = true;
                                            return;
                                          }

                                          const touch = e.touches[0];
                                          setStartPoint({
                                            x: touch.clientX,
                                            y: touch.clientY,
                                          });

                                          if (!selectedItem) {
                                            return;
                                          }

                                          e.stopPropagation();
                                          handleMouseDown(e);
                                        }}
                                        onTouchEnd={(e) => {
                                          // If onTouchStart fired the room-first guard (different room),
                                          // this touch selected the room but must not select furniture.
                                          if (touchRoomGuardFiredRef.current) {
                                            touchRoomGuardFiredRef.current = false;
                                            setStartPoint(null);
                                            return;
                                          }

                                          // Mirror the desktop guard: if no touchstart set a startPoint
                                          // (e.g. guard or spotlight path returned early), bail out.
                                          if (!startPoint) return;

                                          const touch = e.changedTouches[0];
                                          const endPoint = {
                                            x: touch.clientX,
                                            y: touch.clientY,
                                          };
                                          const distance = Math.sqrt(
                                            Math.pow(
                                              endPoint.x - startPoint.x,
                                              2
                                            ) +
                                              Math.pow(
                                                endPoint.y - startPoint.y,
                                                2
                                              )
                                          );

                                          const dragThreshold = 5;

                                          if (distance < dragThreshold) {
                                            setCopySelectedFurniture({
                                              left: centerLeft,
                                              top:
                                                centerTop - rotatedHeight / 2,
                                              angle: rotationAngle,
                                              centerTop: centerTop,
                                              roomId: roomKey,
                                              _id,
                                            });
                                            setSelectedFurniture({
                                              left: centerLeft,
                                              top:
                                                centerTop - rotatedHeight / 2,
                                              angle: rotationAngle,
                                              centerTop: centerTop,
                                              roomId: roomKey,
                                              _id,
                                            });
                                            setSelectedItem(compositeKey);
                                          }
                                          setStartPoint(null);
                                        }}
                                        onMouseUp={(e) => {
                                          if (!startPoint) return; // Guard: no mousedown preceded this mouseup
                                          const endPoint = {
                                            x: e.clientX,
                                            y: e.clientY,
                                          };
                                          const distance = Math.sqrt(
                                            Math.pow(
                                              endPoint.x - startPoint.x,
                                              2
                                            ) +
                                              Math.pow(
                                                endPoint.y - startPoint.y,
                                                2
                                              )
                                          );

                                          const dragThreshold = 5;

                                          if (distance < dragThreshold) {
                                            setCopySelectedFurniture({
                                              left: centerLeft,
                                              top:
                                                centerTop - rotatedHeight / 2,
                                              angle: rotationAngle,
                                              centerTop: centerTop,
                                              roomId: roomKey,
                                              _id,
                                            });
                                            setSelectedFurniture({
                                              left: centerLeft,
                                              top:
                                                centerTop - rotatedHeight / 2,
                                              angle: rotationAngle,
                                              centerTop: centerTop,
                                              roomId: roomKey,
                                              _id,
                                            });
                                            setSelectedItem(compositeKey);
                                          }

                                          setStartPoint(null);
                                        }}
                                      />
                                    </div>
                                  </Box>
                                );
                              }
                            );
                          }
                        )}
                    </>
                  </div>
                </TransformComponent>
              </TransformWrapper>

              {/* Loading state: no overlay or shimmer — screen stays static.
                  Toolbar pointerEvents are disabled inline to block double-tap. */}

              {!shoppingListFlag && (
                <>
                  {isAdding && (
                    <ExitFooterIcon
                      style={{
                        position: "fixed",
                        bottom:
                          footerHeight > 0
                            ? `${footerHeight + 10 + EDITOR_ABOVE_BRANDING_PX}px`
                            : `${240 + EDITOR_ABOVE_BRANDING_PX}px`,
                        right: 0,
                        cursor: "pointer",
                        marginRight: "10px",
                        zIndex: 1210,
                        pointerEvents: "none",
                        display: "none",
                        visibility: "hidden",
                      }}
                      onClick={() => {
                        setIsAdding(!isAdding);
                        setAddingFromSomethingElse(false);
                        if (roomId === "custom-room") {
                          setRoomId(null);
                          setVertices({
                            index: false,
                            vertices: [],
                            roomId: "",
                          });
                          const lineContainer =
                            document.getElementById("lineContainer");

                          const shapeElements =
                            lineContainer.querySelectorAll(".shape");
                          shapeElements.forEach((element) => element.remove());
                          setLineBoundary(false);
                        }
                      }}
                    />
                  )}

                  <Box
                    ref={footerRefOther}
                    className={`page-footer ${
                      isAdding ||
                      (errorLayout?.[roomId] &&
                        !selectedFurniture &&
                        !optionsMenu &&
                        roomActive === -1)
                        ? "adding"
                        : ""
                    } ${
                      isAdding && !lineBoundary && roomsData?.length > 0 && !optionsMenu
                        ? "bg main"
                        : ""
                    } ${
                      !isAdding
                        ? "noBg"
                        : ""
                    } ${
                      ((openFilters && roomActive === -1) ||
                      isScaleDimensionsMarked === "select")
                        ? "menu"
                        : ""
                    } ${openFilters && roomActive === -1 ? "menu-openFilters" : ""}  `}
                    sx={{
                      // When a room is active and filter panel is open, float the
                      // footerRefOther as a fixed glass card above the room-type strip.
                      // Otherwise keep the standard absolute-bottom behaviour.
                      ...(roomActive !== -1 && openFilters
                        ? {
                            position: "fixed",
                            bottom: EDITOR_RESET_ZONE_DROPDOWN_BOTTOM,
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: EDITOR_RESET_STRIP_WIDTH,
                            maxWidth: "unset",
                            zIndex: 1005,
                            mx: "0px",
                            p: 1.5,
                            pb: 1.5,
                            textAlign: "left",
                            pointerEvents: "auto",
                            ...getEditorPanelSurfaceSx(theme),
                          }
                        : {
                            p: 2,
                            px:
                              isAdding ||
                              (errorLayout?.[roomId] &&
                                !selectedFurniture &&
                                roomActive === -1)
                                ? 0
                                : 2,
                            pb: "max(20px, env(safe-area-inset-bottom, 20px))",
                            maxWidth:
                              openFilters
                                ? "600px"
                                : errorLayout?.[roomId] &&
                                  !selectedFurniture &&
                                  roomActive === -1
                                ? "100%"
                                : !isAdding || selectedFurniture
                                ? "600px"
                                : "100%",
                            position: "absolute",
                            width: !isDesktop ? "100%" : divDynamicWidth,
                            zIndex: 999,
                            mx: isDesktop ? "16px" : "0px",
                            bottom: 0,
                            textAlign: "center",
                            pointerEvents: "none",
                          }),
                      display:
                        isPickingRoom ? "none" :
                        (params.id && autoSave === false) ? "none" :
                        optionsMenu ? "none" : "block",
                    }}
                  >
                    {isScaleDimensionsMarked === "select" && (
                      <Box sx={{ pointerEvents: "auto" }}>
                        <Picker
                          value={{
                            feet: selectedFeet,
                            inches: selectedInches,
                          }}
                          onChange={handleChangeScale}
                          wheelMode
                        >
                          <Picker.Column
                            name="feet"
                            className="custom-picker-column"
                          >
                            {feetOptions.map((option, idx) => (
                              <Picker.Item
                                key={idx}
                                value={option}
                                className={`${
                                  selectedFeet === option
                                    ? "custom-picker-item"
                                    : "picker"
                                } ft`}
                              >
                                {option} feet
                              </Picker.Item>
                            ))}
                          </Picker.Column>
                          <Picker.Column
                            name="inches"
                            className="custom-picker-column"
                          >
                            {inchOptions.map((option, idx) => (
                              <Picker.Item
                                key={idx}
                                value={option}
                                className={`${
                                  selectedInches === option
                                    ? "custom-picker-item"
                                    : "picker"
                                } in`}
                              >
                                {option} in
                              </Picker.Item>
                            ))}
                          </Picker.Column>
                        </Picker>

                        <Button
                          variant="contained"
                          className="button-style"
                          sx={{ p: "8px !important", width: "95%", mb: 2 }}
                          fullWidth
                          onClick={async () => {
                            if (!layoutData?._id) {
                              console.warn("Layout ID not available, skipping scale dimension update");
                              return;
                            }

                            let updationUrl = `${baseUrl}/savedLayout/edit/${layoutData._id}`;

                            // RELATIVE scale computation: multiply the opening scaleFactorX by the
                            // ratio of (what user selected) / (what was displayed). This preserves
                            // the backend's original scale relationships so round-trips work perfectly.
                            const selectedTotalInches = +selectedFeet * 12 + +selectedInches;
                            const openingSF = pickerOpenScaleRef.current || scaleFactorX;

                            // What was displayed when the picker opened
                            const displayedInches = userAdjustedInchesRef.current !== null
                              ? userAdjustedInchesRef.current
                              : (initialLength && initialScaleFactorX ? initialLength * initialScaleFactorX : selectedTotalInches);

                            console.log('[SCALE-DONE] ▶️ Done clicked.',
                              '| displayed=' + displayedInches + '"',
                              '| selected=' + selectedTotalInches + '" (' + selectedFeet + "'" + selectedInches + '")',
                              '| openingSF=' + openingSF,
                              '| scaleFactorX=' + scaleFactorX,
                              '| apiRef was=' + scaleFactorFromApiRef.current);

                            scaleFactorFromApiRef.current = false;

                            if (displayedInches > 0 && openingSF) {
                              const ratio = selectedTotalInches / displayedInches;
                              const newScaleFactor = openingSF * ratio;

                              console.log('[SCALE-DONE] RELATIVE: ratio=' + ratio.toFixed(6),
                                '(' + selectedTotalInches + '/' + displayedInches + ')',
                                '| newSF = ' + openingSF + ' × ' + ratio.toFixed(4) + ' = ' + newScaleFactor,
                                '| was ' + scaleFactorX,
                                '| changed=' + (newScaleFactor !== scaleFactorX));

                              setScaleFactorX(newScaleFactor);
                              setScaleFactorY(newScaleFactor);
                            }

                            // Store user's selection so picker shows this value on re-open
                            userAdjustedInchesRef.current = selectedTotalInches;

                            console.log('[SCALE-DONE] Post-scale state updates:',
                              '| setIsScaleDimensionsMarked(true)',
                              '| setSelectedResetFeet(' + selectedFeet + ')',
                              '| setSelectedResetInches(' + selectedInches + ')',
                              '| apiRef now=' + scaleFactorFromApiRef.current);
                            setIsScaleDimensionsMarked(true);
                            setSelectedResetInches(selectedInches);
                            setSelectedResetFeet(selectedFeet);

                            let url = `${baseUrl}/savedLayout/scaleAdjustment/${layoutData._id}/${versionLayout}`;
                            console.log('[SCALE-DONE] Calling scaleAdjustment API: DELETE', url);

                            try {
                              await axios.delete(url, {
                                headers: {
                                  Authorization: currentUserSessionStorage
                                    ? `Bearer ${currentUserSessionStorage}`
                                    : undefined,
                                },
                              });

                              layoutDataCopyRefetch();
                            } catch (error) {
                              console.error("Failed to update layout:", error);
                            }

                            try {
                              await handleLayoutSave(
                                "PUT",
                                updationUrl,
                                null,
                                {
                                  globalScaling: {
                                    globalSelectedFeet: +selectedFeet,
                                    globalSelectedInches: +selectedInches,
                                    globalResetSelectedFeet: +selectedFeet,
                                    globalResetSelectedInches: +selectedInches,
                                  },
                                }
                              );
                            } catch (error) {
                              console.error("Failed to update layout:", error);
                            }
                          }}
                        >
                          Done
                        </Button>
                      </Box>
                    )}

                    {/* No-room, furniture, and room button groups moved to fixed-position elements above */}

                    {errorLayout?.[roomId] &&
                      !selectedFurniture &&
                      !optionsMenu &&
                      roomActive === -1 && (
                        <Box
                          sx={{
                            mb: "12px",
                            pointerEvents: "auto",
                          }}
                        >
                          <ManuallyItems
                            errorLayoutGlobal={true}
                            setSupZones={setSupZonesWithLogging}
                            currentZone={supZones}
                            sliderRef={sliderRef}
                            roomActive={roomActive}
                            roomItemsList={roomItemsList}
                            roomActiveLayout={roomActiveLayout}
                            itemsWithSup={
                              error?.status ? [] : itemsWithSup?.items
                            }
                            allSupplementaryItems={
                              errorAllSupplementaryItems?.status
                                ? []
                                : allSupplementaryItems?.items
                            }
                            loadingAll={isFetchingAllSupplementaryItems}
                            loading={isFetching}
                            handleItems={handleItems}
                          />
                        </Box>
                      )}

                    {/* Furniture toolbar moved to fixed secondary row above */}

                    {/* Room-selected toolbar moved to fixed secondary row above */}

                    {(lineBoundary || isAdding) && !optionsMenu ? (
                      <Box
                        sx={{
                          pointerEvents:
                            isAdding ||
                            openFilters ||
                            (errorLayout?.[roomId] &&
                              !selectedFurniture &&
                              roomActive === -1)
                              ? "auto"
                              : "none",
                        }}
                      >
                          <>
                            {!isAdding && !selectedFurniture ? (
                              <Grid container spacing={1.5}>
                                {!shoppingListFlag &&
                                  !loadingLayout &&
                                  roomActive !== -1 &&
                                  openFilters &&
                                  isScaleDimensionsMarked !== "select" && (
                                    <Grid item xs={12}>
                                      {!openFilters ? (
                                        <>
                                          <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            gap={1}
                                            sx={{
                                              height: "100%",
                                              minHeight: selectedOption?.value
                                                ? "40px"
                                                : "48px",
                                            }}
                                          >
                                            <Box
                                              ref={containerRefZones}
                                              sx={{ width: "100%" }}
                                            >
                                              <Paper
                                                elevation={3}
                                                sx={{
                                                  borderRadius: "8px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent:
                                                    "space-between",
                                                  padding: "8px 16px",
                                                  boxShadow:
                                                    "0px 0px 10px 0px rgba(32, 33, 36, 0.4)",
                                                  height: "100%",
                                                  border:
                                                    "1px solid rgba(32, 33, 36, 0.3)",
                                                  minHeight:
                                                    selectedOption?.value
                                                      ? "40px"
                                                      : "48px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  setShowZonesMenu(
                                                    !showZonesMenu
                                                  )
                                                }
                                              >
                                                <Typography
                                                  variant="body1"
                                                  sx={{
                                                    fontWeight: 500,
                                                    color: "#333",
                                                  }}
                                                >
                                                  {selectedOption?.label ||
                                                    "See it as a..."}
                                                </Typography>

                                                <IconButton
                                                  sx={{ padding: 0 }}
                                                  disableRipple
                                                >
                                                  {showZonesMenu ? (
                                                    <HideZonesIcon />
                                                  ) : (
                                                    <ShowZonesIcon />
                                                  )}
                                                </IconButton>
                                              </Paper>

                                              {showZonesMenu && (
                                                <Paper
                                                  elevation={0}
                                                  sx={{
                                                    position: "absolute",
                                                    zIndex: 99999,
                                                    bottom:
                                                      (layouts?.length >= 1 ||
                                                        roomsData?.length >=
                                                          1) &&
                                                      roomsData?.findIndex(
                                                        (room) =>
                                                          vertices.roomId ===
                                                          room.roomId
                                                      ) !== -1 &&
                                                      (!errorLayout?.[roomId] ||
                                                        isAdding) &&
                                                      !selectedFurniture
                                                        ? "145px"
                                                        : selectedOption &&
                                                          !errorLayout?.[roomId]
                                                        ? "145px"
                                                        : "98px",
                                                    p: 1.5,
                                                    width: "calc(100% - 32px)",
                                                    left: "50%",
                                                    transform:
                                                      "translateX(-50%)",
                                                    ...getEditorPanelSurfaceSx(theme),
                                                  }}
                                                >
                                                  <MenuList sx={{ p: 0 }}>
                                                    {zonesData.map((zone) => (
                                                      <MenuItem
                                                        key={zone.label}
                                                        onClick={(event) => {
                                                          setShowZonesMenu(
                                                            false
                                                          );
                                                          handleChange(
                                                            roomId,
                                                            event,
                                                            zone
                                                          );
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 600,
                                                            fontSize: "14px",
                                                            textAlign: "center",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          {zone.label}
                                                        </Typography>
                                                      </MenuItem>
                                                    ))}
                                                  </MenuList>
                                                </Paper>
                                              )}
                                            </Box>

                                            {selectedOption &&
                                              ![
                                                "outdoors",
                                                "conferenceroom",
                                                "privateOffice",
                                                "custom",
                                              ].includes(
                                                selectedOption.value
                                              ) && (
                                                <Box
                                                  sx={{
                                                    border:
                                                      "1px solid rgba(32, 33, 36, 0.3)",
                                                    boxShadow:
                                                      "0px 0px 6px 0px rgba(32, 33, 36, 0.3)",
                                                    display: "flex",
                                                    backgroundColor: "white",
                                                    flexDirection: "row",
                                                    gap: 2,
                                                    minHeight:
                                                      selectedOption?.value
                                                        ? "40px"
                                                        : "48px",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    borderRadius: "8px",
                                                    px: 2,
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    setOpenFilters(true)
                                                  }
                                                >
                                                  <Typography
                                                    fontSize={"11px"}
                                                    fontWeight={"700"}
                                                  >
                                                    Customize
                                                  </Typography>

                                                  <FilterIcon />
                                                </Box>
                                              )}
                                          </Box>
                                        </>
                                      ) : (
                                        <Box>
                                          <Box
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: "15px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {selectedOption?.label}
                                            </Typography>

                                            <IconButton
                                              aria-label="Close filters"
                                              onClick={() =>
                                                setOpenFilters(false)
                                              }
                                              size="small"
                                              disableRipple
                                              sx={{
                                                flexShrink: 0,
                                                alignSelf: "center",
                                                color: "text.secondary",
                                                border: "none",
                                                boxShadow: "none",
                                                "&:hover": {
                                                  bgcolor: alpha(
                                                    theme.palette.action.hover,
                                                    0.08
                                                  ),
                                                },
                                              }}
                                            >
                                              <CloseIcon sx={{ fontSize: 22 }} />
                                            </IconButton>
                                          </Box>

                                          <Box py={1.5}>
                                            {(selectedOption?.value ===
                                              "lounging" ||
                                              selectedOption?.value ===
                                                "dining" ||
                                              selectedOption?.value ===
                                                "lounging,dining") && (
                                              <Box
                                                className="size-container"
                                                pb={2}
                                              >
                                                <Box
                                                  display={"flex"}
                                                  justifyContent={"center"}
                                                  sx={{
                                                    alignItems: {
                                                      xs: "flex-start",
                                                    },
                                                    flexDirection: {
                                                      xs: "column",
                                                    },
                                                  }}
                                                >
                                                  <Stack
                                                    flexDirection={"row"}
                                                    width={"100%"}
                                                    justifyContent={
                                                      "space-between"
                                                    }
                                                  >
                                                    <Typography
                                                      component="h6"
                                                      sx={{
                                                        fontWeight: 600,
                                                        fontSize: "15px",
                                                      }}
                                                    >
                                                      Ideal Seating Capacity
                                                    </Typography>

                                                    <Typography
                                                      component="h6"
                                                      sx={{
                                                        fontWeight: 600,
                                                        fontSize: "15px",
                                                      }}
                                                    >
                                                      {value === 9
                                                        ? "9+"
                                                        : value}
                                                    </Typography>
                                                  </Stack>

                                                  <Box
                                                    display={"flex"}
                                                    flexWrap="wrap"
                                                    flexGrow={1}
                                                    sx={{
                                                      justifyContent: {
                                                        xs: "flex-start",
                                                      },
                                                      width: { xs: "80%" },
                                                      mx: "auto",
                                                    }}
                                                  >
                                                    <Slider
                                                      value={value}
                                                      min={1}
                                                      max={9}
                                                      step={1}
                                                      onChange={handleSlider}
                                                      sx={{
                                                        ".MuiSlider-thumb": {
                                                          color: primaryColor,
                                                        },
                                                        ".MuiSlider-track": {
                                                          backgroundColor:
                                                            primaryColor,
                                                          borderColor:
                                                            primaryColor,
                                                        },
                                                      }}
                                                    />
                                                  </Box>

                                                  <Stack
                                                    flexDirection={"row"}
                                                    width={"100%"}
                                                    justifyContent={
                                                      "space-between"
                                                    }
                                                  >
                                                    <Typography
                                                      fontWeight={"500"}
                                                      fontSize={"14px"}
                                                      color={"#a7a7b9"}
                                                    >
                                                      1 Seat
                                                    </Typography>

                                                    <Typography
                                                      fontWeight={"500"}
                                                      fontSize={"14px"}
                                                      color={"#a7a7b9"}
                                                    >
                                                      9+ Seats
                                                    </Typography>
                                                  </Stack>
                                                </Box>
                                              </Box>
                                            )}

                                            {(selectedOption?.value ===
                                              "sleeping" ||
                                              selectedOption?.value ===
                                                "comingandgoing") && (
                                              <Box
                                                className="size-container"
                                                pb={2}
                                              >
                                                <Box
                                                  display={"flex"}
                                                  justifyContent={"center"}
                                                  sx={{
                                                    alignItems: {
                                                      xs: "flex-start",
                                                    },
                                                    flexDirection: {
                                                      xs: "column",
                                                    },
                                                  }}
                                                >
                                                  <Typography
                                                    component="h6"
                                                    sx={{
                                                      fontWeight: 600,
                                                      fontSize: "15px",
                                                    }}
                                                  >
                                                    Bed Size?
                                                  </Typography>

                                                  <Box
                                                    display={"flex"}
                                                    justifyContent={"center"}
                                                    flexWrap="wrap"
                                                    flexGrow={1}
                                                    sx={{
                                                      mt: { xs: 1 },
                                                      justifyContent: {
                                                        xs: "space-between",
                                                      },
                                                      width: { xs: "100%" },
                                                      gap: 1,
                                                    }}
                                                  >
                                                    {bedSize?.map(
                                                      (item, idx) => {
                                                        const bedSel =
                                                          bedIndexByRoom?.[
                                                            roomId
                                                          ] === item;
                                                        return (
                                                          <Box
                                                            key={item}
                                                            sx={getEditorFilterChipSx(
                                                              theme,
                                                              bedSel
                                                            )}
                                                            onClick={() =>
                                                              addBed(item, idx)
                                                            }
                                                          >
                                                            <span
                                                              style={{
                                                                textAlign:
                                                                  "center",
                                                                fontWeight: 600,
                                                                fontSize: 14,
                                                                color: bedSel
                                                                  ? primaryColor
                                                                  : "#a7a7b9",
                                                              }}
                                                            >
                                                              {item}
                                                            </span>
                                                          </Box>
                                                        );
                                                      }
                                                    )}
                                                  </Box>
                                                </Box>
                                              </Box>
                                            )}

                                            {(selectedOption?.value ===
                                              "lounging" ||
                                              selectedOption?.value ===
                                                "lounging,dining" ||
                                              selectedOption?.value ===
                                                "sleeping" ||
                                              selectedOption?.value ===
                                                "comingandgoing") && (
                                              <Box
                                                className="size-container"
                                                pb={2}
                                              >
                                                <Box
                                                  display={"flex"}
                                                  justifyContent={"center"}
                                                  sx={{
                                                    alignItems: {
                                                      xs: "flex-start",
                                                    },
                                                    flexDirection: {
                                                      xs: "column",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem
                                                    disableRipple
                                                    sx={{
                                                      ...getActionMenuToggleRowSx(
                                                        theme,
                                                        {
                                                          isFloorPlanDialog: true,
                                                          suppressHover: true,
                                                        }
                                                      ),
                                                      mx: 0,
                                                      width: "100%",
                                                      mt: { xs: 1 },
                                                      px: 0,
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      addTv(
                                                        roomId,
                                                        tvIndexByRoom?.[
                                                          roomId
                                                        ] === 0
                                                          ? 1
                                                          : 0
                                                      );
                                                    }}
                                                  >
                                                    TV?
                                                    <CustomSwitch
                                                      checked={
                                                        tvIndexByRoom?.[
                                                          roomId
                                                        ] === 0
                                                      }
                                                      onClick={() => {}}
                                                    />
                                                  </MenuItem>
                                                </Box>
                                              </Box>
                                            )}

                                            {(selectedOption?.value ===
                                              "lounging" ||
                                              selectedOption?.value ===
                                                "sleeping") &&
                                              !zonesRoom[roomId]?.find(
                                                (item) =>
                                                  item.value === "workingvanity"
                                              ) && (
                                                <Box
                                                  className="size-container"
                                                  pb={2.5}
                                                >
                                                  <Box
                                                    display={"flex"}
                                                    justifyContent={"center"}
                                                    sx={{
                                                      alignItems: {
                                                        xs: "flex-start",
                                                      },
                                                      flexDirection: {
                                                        xs: "column",
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem
                                                      disableRipple
                                                      sx={{
                                                        ...getActionMenuToggleRowSx(
                                                          theme,
                                                          {
                                                            isFloorPlanDialog: true,
                                                            suppressHover: true,
                                                          }
                                                        ),
                                                        mx: 0,
                                                        width: "100%",
                                                        mt: { xs: 1 },
                                                        px: 0,
                                                      }}
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        const next =
                                                          vanityIndexByRoom?.[
                                                            roomId
                                                          ] === 0
                                                            ? 1
                                                            : 0;
                                                        addVanity(
                                                          roomId,
                                                          tv[next],
                                                          next
                                                        );
                                                      }}
                                                    >
                                                      Work Station?
                                                      <CustomSwitch
                                                        checked={
                                                          vanityIndexByRoom?.[
                                                            roomId
                                                          ] === 0
                                                        }
                                                        onClick={() => {}}
                                                      />
                                                    </MenuItem>
                                                  </Box>
                                                </Box>
                                              )}

                                            {(selectedOption?.value ===
                                              "dining" ||
                                              selectedOption?.value ===
                                                "workingvanity" ||
                                              (selectedOption?.value ===
                                                "lounging,dining" &&
                                                tvIndexByRoom?.[roomId] ===
                                                  1) ||
                                              (selectedOption?.value ===
                                                "lounging" &&
                                                tvIndexByRoom?.[roomId] ===
                                                  1) ||
                                              (selectedOption?.value ===
                                                "sleeping" &&
                                                tvIndexByRoom?.[roomId] ===
                                                  1) ||
                                              (selectedOption?.value ===
                                                "comingandgoing" &&
                                                tvIndexByRoom?.[roomId] ===
                                                  1)) && (
                                              <Box className="size-container">
                                                <Box
                                                  display={"flex"}
                                                  justifyContent={"center"}
                                                  sx={{
                                                    alignItems: {
                                                      xs: "flex-start",
                                                    },
                                                    flexDirection: {
                                                      xs: "column",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem
                                                    disableRipple
                                                    sx={{
                                                      ...getActionMenuToggleRowSx(
                                                        theme,
                                                        {
                                                          isFloorPlanDialog: true,
                                                          suppressHover: true,
                                                        }
                                                      ),
                                                      mx: 0,
                                                      width: "100%",
                                                      mt: { xs: 1 },
                                                      px: 0,
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      addStorage(
                                                        roomId,
                                                        storageIndexByRoom?.[
                                                          roomId
                                                        ] === 0
                                                          ? 1
                                                          : 0
                                                      );
                                                    }}
                                                  >
                                                    Include Extra Storage?
                                                    <CustomSwitch
                                                      checked={
                                                        storageIndexByRoom?.[
                                                          roomId
                                                        ] === 0
                                                      }
                                                      onClick={() => {}}
                                                    />
                                                  </MenuItem>
                                                </Box>
                                              </Box>
                                            )}
                                            <Button
                                              variant="contained"
                                              fullWidth
                                              sx={{
                                                ...getMFPrimaryButtonSx(theme),
                                                mt: 2,
                                              }}
                                              onClick={handleApplyFilters}
                                            >
                                              Apply
                                            </Button>
                                          </Box>
                                        </Box>
                                      )}
                                    </Grid>
                                  )}


                                {(selectedOption ||
                                  layouts?.length >= 1) &&
                                  !loadingLayout &&
                                  !seeItAnotherWay[roomActive] &&
                                  isScaleDimensionsMarked !== "select" && (
                                    <Grid item xs={12}>
                                      {(
                                        <>
                                          {
                                            selectedOption &&
                                              ((roomActive !== -1 &&
                                                seeItAnotherWay[roomActive]) ||
                                                (roomActive === -1 &&
                                                  !seeItAnotherWay[
                                                    roomActive
                                                  ])) && (
                                                <>
                                                  {selectedOption.value !==
                                                  "custom" ? (
                                                    <Button
                                                      variant="contained"
                                                      fullWidth
                                                      sx={{
                                                        ...getMFPrimaryButtonSx(theme),
                                                        "&.Mui-disabled": {
                                                          color: "white",
                                                          opacity: 0.55,
                                                          boxShadow: "none",
                                                        },
                                                      }}
                                                      disabled={
                                                        vertices?.vertices
                                                          ?.length === 0 ||
                                                        !selectedOption ||
                                                        (itemsSupLoading &&
                                                          errorLayout?.[roomId])
                                                      }
                                                      startIcon={
                                                        openFilters ? (
                                                          <MagicIcon />
                                                        ) : shoppingListFlag ? null : roomsData?.[
                                                            roomActive
                                                          ]?.layouts?.length >=
                                                          1 ? (
                                                          <MagicIcon />
                                                        ) : (
                                                          <MagicIcon />
                                                        )
                                                      }
                                                      onClick={() => {
                                                        if (
                                                          openFilters ||
                                                          roomsData?.[
                                                            roomActive
                                                          ]?.layouts?.length >=
                                                            1
                                                        ) {
                                                          furnishRoom();
                                                          eventLog(targetWindow, 'floor_plan_event', 'furnish_room', {
                                                            galleryId: layoutData?.uuid || layoutData?._id,
                                                            galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
                                                            isRefurnish: true,
                                                          });
                                                        } else if (
                                                          roomsData?.[
                                                            roomActive
                                                          ]?.layouts?.length >=
                                                          1
                                                        ) {
                                                          setShoppingListFlag(
                                                            true
                                                          );
                                                          setSelectedFurniture(
                                                            null
                                                          );
                                                          setCopySelectedFurniture(
                                                            null
                                                          );
                                                          setSelectedItem(null);

                                                          isDraggingFurnitureItem.current = false;
                                                          isDragDiv.current = false;
                                                        } else if (
                                                          shoppingListFlag
                                                        ) {
                                                        } else {
                                                          furnishRoom();
                                                          eventLog(targetWindow, 'floor_plan_event', 'furnish_room', {
                                                            galleryId: layoutData?.uuid || layoutData?._id,
                                                            galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
                                                            isRefurnish: false,
                                                          });
                                                        }
                                                      }}
                                                    >
                                                      {openFilters
                                                        ? "Make Magic"
                                                        : shoppingListFlag
                                                        ? "Personalize my suggestions"
                                                        : roomsData?.[
                                                            roomActive
                                                          ]?.layouts?.length >=
                                                          1
                                                        ? "Make Magic"
                                                        : "Make Magic"}
                                                    </Button>
                                                  ) : (
                                                    <Button
                                                      sx={{
                                                        color: `${ink.primary} !important`,
                                                      }}
                                                      className={`button-style cancel-button`}
                                                      variant="contained"
                                                      fullWidth
                                                      disabled={!roomId}
                                                      onClick={() => {
                                                        furnishRoom(
                                                          undefined,
                                                          true,
                                                          true
                                                        );
                                                        eventLog(targetWindow, 'floor_plan_event', 'add_items_manually', {
                                                          galleryId: layoutData?.uuid || layoutData?._id,
                                                          galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
                                                        });
                                                      }}
                                                    >
                                                      Add Items Manually
                                                    </Button>
                                                  )}
                                                </>
                                              )
                                          }
                                        </>
                                      )}
                                    </Grid>
                                  )}
                              </Grid>
                            ) : !selectedFurniture ? (
                              <Grid container spacing={1.5}>
                                <ManuallyItems
                                  setSupZones={setSupZonesWithLogging}
                                  currentZone={supZones}
                                  sliderRef={sliderRef}
                                  roomActive={roomActive}
                                  roomItemsList={roomItemsList}
                                  roomActiveLayout={roomActiveLayout}
                                  itemsWithSup={
                                    error?.status ? [] : itemsWithSup?.items
                                  }
                                  loading={isFetching}
                                  handleItems={handleItems}
                                  allSupplementaryItems={
                                    errorAllSupplementaryItems?.status
                                      ? []
                                      : allSupplementaryItems?.items
                                  }
                                  loadingAll={isFetchingAllSupplementaryItems}
                                />
                              </Grid>
                            ) : null}
                          </>
                      </Box>
                    ) : null}
                  </Box>
                </>
              )}

              {/* ══════════════════════════════════════════════════════════════
                  FIXED BOTTOM CHROME — all position:fixed, viewport-relative.
                  PRIMARY ROW: Shuffle | Add Items | Share | Inquire
                  FURNITURE ROW replaces the room strip when furniture selected.
                  ══════════════════════════════════════════════════════════════ */}

              {/* ══ PRIMARY FAB ROW — iOS FAB style ══════════════════════
                  Each button: circle icon (52px) + text label below.
                  Primary CTA = white solid (#FFF) with drop shadow.
                  Secondary = semi-opaque glass.
                  Row is centered with maxWidth for desktop balance.

                  The icon sizes below differ per glyph on purpose. Each icon's
                  artwork fills a different share of its own box — the shuffle
                  strokes span 98% of theirs, the plus only 58% — so equal
                  fontSize values render visibly unequal icons. The heart's
                  extent at fontSize 22 anchors the row and the others are
                  picked against it: the shuffle runs slightly above it as the
                  primary CTA, and the plus is a stroked path so its weight
                  comes from stroke-width instead of from scaling filled bars. */}
              {!(params?.id && autoSave === false) &&
                !isPickingRoom &&
                !shoppingListFlag &&
                !isAdding &&
                !optionsMenu &&
                isScaleDimensionsMarked !== "select" && (
                <Box
                  sx={{
                    position: "fixed",
                    bottom: EDITOR_FAB_BOTTOM,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "calc(100% - 40px)",
                    maxWidth: showEditorInquireFab ? "520px" : "380px",
                    zIndex: 1001,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    gap: "0px",
                    pointerEvents: "none",
                  }}
                >
                  {/* ── Shuffle button (left — primary CTA) ──────────────────── */}
                  {shuffleFabMounted && (
                    <Box
                      aria-busy={loadingLayout}
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                        pointerEvents: loadingLayout ? "none" : "auto",
                        WebkitTapHighlightColor: "transparent",
                        // Glides to the row's centre while the companions stand
                        // down. The press feedback lives on .fab-circle, so this
                        // transform is the wrapper's alone.
                        transform: primaryFabSolo
                          ? `translateX(${primaryFabShift}%)`
                          : "translateX(0)",
                        transition: fabGlideTransition,
                        "&:active .fab-circle": { transform: "scale(0.93)" },
                      }}
                      onClick={() => {
                        const markShuffled = () =>
                          setShuffledRoomIds((prev) => new Set([...prev, roomId]));
                        switch (
                          resolveShuffleFabAction({
                            roomActive,
                            roomId,
                            shufflePickedRoom,
                            lineBoundary,
                            seeItAnotherWay,
                            openFilters,
                            zonesRoom,
                          })
                        ) {
                          case SHUFFLE_FAB_ACTION.FURNISH_ACTIVE_ROOM:
                            markShuffled();
                            furnishRoom();
                            break;
                          case SHUFFLE_FAB_ACTION.SHUFFLE_ACTIVE_ROOM:
                            markShuffled();
                            handleShuffle();
                            break;
                          // Fresh-room first-shuffle path: the user has selected a
                          // room (via shuffle pre-pick OR a normal canvas tap) but
                          // it isn't in roomsData yet, so roomActive stays -1.
                          case SHUFFLE_FAB_ACTION.FURNISH_PICKED_ROOM:
                            markShuffled();
                            furnishRoom(false, false, undefined, true);
                            break;
                          // Picking a non-custom zone sets zonesRoom[roomId], after
                          // which the next tap resolves to FURNISH_PICKED_ROOM.
                          case SHUFFLE_FAB_ACTION.CHOOSE_ROOM_TYPE:
                            setShowZonesMenu(true);
                            break;
                          default:
                            setShufflePickedRoom(null);
                            setIsPickingRoom(true);
                            setShowHelperMessage(true);
                            setTapRoomHintDismissed(false);
                            setTooltipAnimKey((k) => k + 1);
                        }
                      }}
                    >
                      <Box
                        className="fab-circle"
                        sx={{
                          ...getFabCircleGlassSx({
                            size: 52,
                            elevated: !saveIsPrimary,
                          }),
                          transition:
                            "transform 0.12s ease, background 0.3s ease, box-shadow 0.3s ease",
                        }}
                      >
                        {loadingLayout && shuffleLoadingAffordanceVisible ? (
                          prefersReducedMotion ? (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "22px",
                                fontWeight: 700,
                                lineHeight: 1,
                                color: ink.fabLabel,
                                letterSpacing: "0.12em",
                              }}
                              aria-hidden
                            >
                              ···
                            </Typography>
                          ) : (
                            <CircularProgress
                              size={26}
                              thickness={4}
                              sx={{ color: ink.fabLabel }}
                              aria-hidden
                            />
                          )
                        ) : (
                          <ShuffleIcon
                            style={{
                              color: ink.fabLabel,
                              width: 20.5,
                              height: 20.5,
                            }}
                          />
                        )}
                      </Box>
                      <Typography
                        role={
                          loadingLayout && shuffleLoadingAffordanceVisible
                            ? "status"
                            : undefined
                        }
                        aria-live={
                          loadingLayout && shuffleLoadingAffordanceVisible
                            ? "polite"
                            : undefined
                        }
                        sx={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "rgba(255,255,255,0.92)",
                          lineHeight: 1.2,
                          userSelect: "none",
                          letterSpacing: "-0.01em",
                          textAlign: "center",
                          textShadow: "0 1px 3px rgba(0,0,0,0.5)",
                          transition: "color 0.3s ease",
                        }}
                      >
                        {loadingLayout && shuffleLoadingAffordanceVisible
                          ? "Working…"
                          : roomActive !== -1 &&
                              (seeItAnotherWay[roomActive] || openFilters)
                            ? "Make Magic"
                            : "Shuffle"}
                      </Typography>
                    </Box>
                  )}

                  {/* ── Add Items button (right of Shuffle) ─────────────────── */}
                  {(() => {
                    // Unified disabled rule so the silent-fail guards in the
                    // click handler are reflected visually (dim + default
                    // cursor). Previously the FAB looked fully tappable even
                    // when the click was a no-op, leaving the user confused.
                    const addItemsDisabled =
                      (roomsData?.length === 0 && !lineBoundary) ||
                      (roomActive !== -1 &&
                        (roomsData.findIndex((room) => vertices.roomId === room.roomId) === -1 ||
                          objectsCheck ||
                          (itemsSupLoading && isAdding)));
                    return (
                    <Box
                      aria-hidden={primaryFabSolo || undefined}
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "5px",
                        cursor: addItemsDisabled ? "default" : "pointer",
                        pointerEvents: primaryFabSolo ? "none" : "auto",
                        opacity: primaryFabSolo ? 0 : addItemsDisabled ? 0.38 : 1,
                        WebkitTapHighlightColor: "transparent",
                        ...companionFabStandDownSx,
                        "&:active .fab-circle": { transform: addItemsDisabled ? "none" : "scale(0.93)" },
                      }}
                      onClick={() => {
                        if (addItemsDisabled || primaryFabSolo) return;
                        eventLog(targetWindow, 'floor_plan_event', 'add_items_manually', {
                          galleryId: layoutData?.uuid || layoutData?._id,
                          galleryUrl: layoutData?._id ? `${window.location.origin}/floor-gallery/${layoutData._id}` : undefined,
                        });
                        setSelectedFurniture(null);
                        setCopySelectedFurniture(null);
                        setSelectedItem(null);
                        setShowFlipMenu(false);
                        if (roomActive !== -1) {
                          if (!lineBoundary) setLineBoundary(true);
                          userDismissedAddItemsRef.current = false;
                          setIsAdding(true);
                          setAddingFromSomethingElse(false);
                        } else {
                          setShowHelperMessage(false);
                          let customIdx = roomsData?.findIndex((room) => room.roomId === "custom-room");
                          if (customIdx === -1) {
                            customIdx = roomsData?.length || 0;
                            setRoomsData((prev) => [
                              ...prev,
                              {
                                layouts: [{ room: { width: 124, height: 214, shape: "box-shape", zone: [{ value: "workingvanity", capacity: 1 }], position: { x: 0, y: 0, z: 0 } }, doors: [], windows: [], furniture: [], vertices: [], prompt: "" }],
                                payloadVertices: [], doors: [], windows: [],
                                scaleX: scaleFactorX, scaleY: scaleFactorY,
                                centerX: 1500, centerY: divHeight / 2,
                                roomId: "custom-room", orignalPayloadVertices: [],
                                scaleXCanvas, scaleYCanvas, offsetX: offsetXCheck, offsetY: offsetYCheck,
                                zones: [{ value: "custom", label: "Custom Room" }],
                                resultRoomVerticesState: {},
                              },
                            ]);
                          }
                          setRoomActive(customIdx);
                          setRoomItemsList((prev) => { const l = [...prev]; if (!l[customIdx]) l[customIdx] = [[]]; return l; });
                          setRoomActiveLayout((prev) => { const l = [...prev]; if (!l[customIdx]) l[customIdx] = 0; return l; });
                          setRoomId("custom-room");
                          userDismissedAddItemsRef.current = false;
                          setIsAdding(true);
                          setAddingFromSomethingElse(false);
                          setLineBoundary(true);
                        }
                      }}
                    >
                      <Box
                        className="fab-circle"
                        sx={{
                          ...getFabCircleGlassSx({ size: 52 }),
                          transition: "transform 0.12s ease",
                        }}
                      >
                        {/* Stroked plus rather than MUI's filled Add glyph: the
                            filled bars read heavier than the neighbouring
                            outline icons at this size. Endpoints match Add's
                            5→19 span so the extent is unchanged. */}
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden
                          style={{ color: ink.fabLabel }}
                        >
                          <path
                            d="M12 5v14M5 12h14"
                            stroke="currentColor"
                            strokeWidth="1.6"
                          />
                        </svg>
                      </Box>
                      <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,0.92)", lineHeight: 1.2, userSelect: "none", letterSpacing: "-0.01em", textAlign: "center", textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}>
                        Add Items
                      </Typography>
                    </Box>
                    );
                  })()}

                  {/* ── Share button ─────────────────────────────────────────────
                      Authenticated only. The guest "Save" that used to share
                      this slot duplicated the top-right Done control, so it now
                      lives as a row in the overflow ⋯ menu instead.          */}
                  {shareFabMounted && (
                    <Box
                      aria-hidden={primaryFabSolo || undefined}
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                        pointerEvents: primaryFabSolo ? "none" : "auto",
                        opacity: primaryFabSolo ? 0 : 1,
                        WebkitTapHighlightColor: "transparent",
                        ...companionFabStandDownSx,
                        "&:active .fab-circle": { transform: "scale(0.93)" },
                      }}
                      onClick={() => {
                        if (primaryFabSolo) return;
                        // Open the branded share/download modal — the single
                        // share surface. It persists pending edits (via prepare)
                        // before capturing, and hosts Copy link + branded
                        // download together, so no separate auto-copy here.
                        setBrandedExportOpen(true);
                      }}
                    >
                      <Box
                        className="fab-circle"
                        sx={{
                          ...getFabCircleGlassSx({ size: 52 }),
                          transition:
                            "transform 0.12s ease, background 0.3s ease, box-shadow 0.3s ease",
                        }}
                      >
                        {shareLinkCopied
                          ? <CheckOutlinedIcon sx={{ color: ink.fabLabel, fontSize: 24 }} />
                          : <IosShareIcon sx={{ color: ink.fabLabel, fontSize: 20 }} />
                        }
                      </Box>
                      <Typography sx={{ fontSize: "11px", fontWeight: saveIsPrimary ? 700 : 600, color: "rgba(255,255,255,0.92)", lineHeight: 1.2, userSelect: "none", letterSpacing: "-0.01em", textAlign: "center", textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}>
                        {shareLinkCopied ? "Link copied" : "Share"}
                      </Typography>
                    </Box>
                  )}

                  {/* ── I'm Interested (viewers — right of Share) ─────────────── */}
                  {inquireFabMounted && (
                    <Box
                      aria-disabled={
                        inquiryAlreadySent || inquireSubmitting || undefined
                      }
                      aria-hidden={primaryFabSolo || undefined}
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "5px",
                        cursor: inquireCtaInert ? "default" : "pointer",
                        pointerEvents:
                          primaryFabSolo || inquireCtaInert ? "none" : "auto",
                        opacity: primaryFabSolo ? 0 : 1,
                        WebkitTapHighlightColor: "transparent",
                        ...companionFabStandDownSx,
                        "&:active .fab-circle": {
                          transform: inquireCtaInert ? "none" : "scale(0.93)",
                        },
                      }}
                      onClick={
                        inquireCtaInert || primaryFabSolo
                          ? undefined
                          : handleInterestTap
                      }
                    >
                      <Box
                        className="fab-circle"
                        sx={{
                          ...getFabCircleGlassSx({ size: 52 }),
                          transition: "transform 0.12s ease",
                        }}
                      >
                        {inquiryAlreadySent ? (
                          <CheckOutlinedIcon sx={{ color: ink.fabLabel, fontSize: 24 }} />
                        ) : (
                          <FavoriteBorderIcon sx={{ color: ink.fabLabel, fontSize: 22 }} />
                        )}
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "rgba(255,255,255,0.92)",
                          lineHeight: 1.2,
                          userSelect: "none",
                          letterSpacing: "-0.01em",
                          textAlign: "center",
                          textShadow: "0 1px 3px rgba(0,0,0,0.5)",
                        }}
                      >
                        {inquiryAlreadySent
                          ? "Interest sent"
                          : inquireSubmitting
                          ? "Sending…"
                          : "I'm Interested"}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}

              {/* ── FURNITURE ACTIONS ROW ─────────────────────────────────
                  Shown in the room-type strip slot when furniture is selected,
                  leaving Add Items / Shuffle / Share reachable below.       */}
              {!(params?.id && autoSave === false) &&
                !isPickingRoom &&
                !shoppingListFlag &&
                !isAdding &&
                !optionsMenu &&
                selectedFurniture &&
                !isDraggingFurnitureItem.current &&
                isScaleDimensionsMarked !== "select" && (
                  <Box
                    sx={{
                      ...EDITOR_PILLS_ROW_SX,
                      position: "fixed",
                      bottom: EDITOR_FURNITURE_ACTIONS_BOTTOM,
                      left: "50%",
                      transform: "translateX(-50%)",
                      gap: { xs: "16px", sm: "20px" },
                      zIndex: 1004,
                    }}
                  >
                    {/* Duplicate selected item — sits to the left of Rotate.
                        Replaces the old "Duplicate Layout" row that used to
                        live inside the overflow ⋯ menu and flip labels based
                        on whether an item was selected. */}
                    <Box sx={EDITOR_CIRCLE_BTN_SX} onClick={handleDuplicateItem}>
                      <Box
                        sx={{
                          color: EDITOR_FOOTER_ICON_TONE,
                          lineHeight: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32,
                        }}
                      >
                        <ContentCopyOutlinedIcon
                          sx={{
                            fontSize: 18,
                            "& path": {
                              transform: "scale(calc((18 - 0.5) / 18))",
                              transformOrigin: "12px 12px",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                    <Box sx={EDITOR_CIRCLE_BTN_SX} onClick={() => handleRotateAntiClockwise(selectedFurniture)}>
                      <Box sx={{ color: EDITOR_FOOTER_ICON_TONE, lineHeight: 0, display: "flex", "& svg": { width: 32, height: 32 } }}>
                        <RotateIcon />
                      </Box>
                    </Box>
                    <Box
                      sx={showFlipMenu ? EDITOR_CIRCLE_BTN_ACTIVE_SX : EDITOR_CIRCLE_BTN_SX}
                      onClick={() => setShowFlipMenu((v) => !v)}
                    >
                      <MoreHorizIcon sx={{ color: EDITOR_FOOTER_ICON_TONE, fontSize: 22 }} />
                    </Box>
                    <Box sx={EDITOR_CIRCLE_BTN_DESTRUCTIVE_SX} onClick={() => handleDelete(selectedFurniture)}>
                      <Box sx={{ color: "rgba(255,59,48,0.90)", lineHeight: 0, display: "flex", "& svg": { width: 22, height: 22 } }}>
                        <DeleteIcon />
                      </Box>
                    </Box>
                  </Box>
                )}

              {/* ── FLIP SUB-MENU: shown above the circular button row ──────
                  Appears when the 3-dot flip button is tapped while furniture
                  is selected.  position:fixed so it never shifts the layout.  */}
              {showFlipMenu && selectedFurniture && (
                <Box
                  sx={{
                    ...EDITOR_PILLS_ROW_SX,
                    position: "fixed",
                    bottom: EDITOR_FLIP_MENU_BOTTOM,
                    left: "50%",
                    transform: "translateX(-50%)",
                    gap: "8px",
                    zIndex: 1005,
                  }}
                >
                  <Box
                    sx={{ ...EDITOR_BOTTOM_PILL, px: "14px", pointerEvents: "auto" }}
                    onClick={() => {
                      const updatedLayouts = [...roomsData];
                      const updatedFurniture = updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture.map((f) =>
                        f._id === selectedFurniture._id ? { ...f, flipHorizontal: !f.flipHorizontal } : f
                      );
                      updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture = updatedFurniture;
                      setRoomsData(updatedLayouts);
                      const updatedList = [...roomItemsList];
                      updatedList[roomActive][roomActiveLayout[roomActive]] = updatedFurniture;
                      setRoomItemsList(updatedList);
                      setShowFlipMenu(false);
                    }}
                  >
                    <Box sx={{ color: EDITOR_FOOTER_ICON_TONE, lineHeight: 0, display: "flex", "& svg": { width: 18, height: 18 } }}>
                      <FlipHorizonolIcon />
                    </Box>
                    <Typography sx={{ ...EDITOR_FOOTER_LABEL_SX, fontSize: "11px" }}>Flip H</Typography>
                  </Box>

                  <Box
                    sx={{ ...EDITOR_BOTTOM_PILL, px: "14px", pointerEvents: "auto" }}
                    onClick={() => {
                      const updatedLayouts = [...roomsData];
                      const updatedFurniture = updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture.map((f) =>
                        f._id === selectedFurniture._id ? { ...f, flipVertical: !f.flipVertical } : f
                      );
                      updatedLayouts[roomActive].layouts[roomActiveLayout[roomActive]].furniture = updatedFurniture;
                      setRoomsData(updatedLayouts);
                      const updatedList = [...roomItemsList];
                      updatedList[roomActive][roomActiveLayout[roomActive]] = updatedFurniture;
                      setRoomItemsList(updatedList);
                      setShowFlipMenu(false);
                    }}
                  >
                    <Box sx={{ color: EDITOR_FOOTER_ICON_TONE, lineHeight: 0, display: "flex", "& svg": { width: 18, height: 18 } }}>
                      <FlipVericalIcon />
                    </Box>
                    <Typography sx={{ ...EDITOR_FOOTER_LABEL_SX, fontSize: "11px" }}>Flip V</Typography>
                  </Box>
                </Box>
              )}

              {/* ── ROOM TYPE OPTIONS DROPDOWN ─────────────────────────────────
                  Opens upward from the strip when the zone picker is tapped.
                  position:fixed keeps it above all canvas layers.             */}
              {partnerPackage?.allowMakeMagic &&
                ((roomActive !== -1 && lineBoundary) ||
                  shufflePickedRoom != null ||
                  (lineBoundary && roomId)) &&
                !selectedFurniture &&
                showZonesMenu &&
                !openFilters && (
                  <Box
                    sx={{
                      position: "fixed",
                      bottom: EDITOR_RESET_ZONE_DROPDOWN_BOTTOM,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: EDITOR_RESET_STRIP_WIDTH,
                      zIndex: 1005,
                      p: 1.5,
                      overflow: "hidden",
                      ...getEditorPanelSurfaceSx(theme),
                    }}
                  >
                    <MenuList sx={{ p: 0 }}>
                      {zonesData.map((zone) => (
                        <MenuItem
                          key={zone.label}
                          onClick={(event) => {
                            setShowZonesMenu(false);
                            handleChange(roomId, event, zone);
                            if (zone.value === "custom") {
                              // "Something Else": open manual add-items modal
                              setOpenFilters(false);
                              userDismissedAddItemsRef.current = false;
                              setIsAdding(true);
                              setAddingFromSomethingElse(true);
                              setManualToastDismissed(false);
                              setErrorLayoutGlobal(false);
                              setErrorLayout((prev) => ({ ...prev, [roomId]: undefined }));
                            } else if (roomActive !== -1) {
                              // Changing zone type → enable "Make Magic" mode so
                              // Shuffle generates fresh layouts for the new type.
                              // Guard against roomActive === -1 (fresh-tap /
                              // shuffle post-pick) where keying by -1 would
                              // pollute state with a meaningless entry; in that
                              // case the Shuffle button drives furnishRoom
                              // directly off zonesRoom[roomId] so no seeItAnotherWay
                              // flag is needed for this run.
                              setSeeItAnotherWay((prev) => ({ ...prev, [roomActive]: true }));
                            }
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              textAlign: "left",
                            }}
                          >
                            {zone.label}
                          </Typography>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Box>
                )}

              {/* ── DROPDOWN BACKDROP ────────────────────────────────────────
                  Full-screen transparent layer rendered behind the zone/filter
                  flyout panels.  Tapping it closes the open panel without
                  exiting room-selection state.                                 */}
              {(showZonesMenu || openFilters) &&
                ((roomActive !== -1 && lineBoundary) ||
                  shufflePickedRoom != null ||
                  (lineBoundary && roomId)) && (
                <Box
                  sx={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 1004,
                    background: "transparent",
                  }}
                  onClick={() => {
                    setShowZonesMenu(false);
                    setOpenFilters(false);
                  }}
                />
              )}

              {/* ── OPTIONS / SETTINGS DROPDOWN ───────────────────────────────
                  Fixed overlay that appears below the top-right ⋯ ActionIcon.
                  Replaces the old bottom-sheet approach for the settings/share
                  menus so they feel native rather than a heavy modal.          */}
              {optionsMenu && isScaleDimensionsMarked !== "select" && (
                <>
                  {/* Invisible full-screen backdrop — closes menu on outside tap */}
                  <Box
                    sx={{
                      position: "fixed",
                      inset: 0,
                      zIndex: 1099,
                      background: "transparent",
                    }}
                    onClick={() => setOptionsMenu(null)}
                  />
                  <Box
                    sx={{
                      position: "fixed",
                      top: { xs: 52, sm: 58 },
                      right: { xs: 8, sm: 12 },
                      width: { xs: "min(260px, calc(100vw - 16px))", sm: 296 },
                      zIndex: 1100,
                      overflow: "visible",
                      "@keyframes dropdownFadeSlide": {
                        "0%":   { opacity: 0, transform: "translateY(-6px) scale(0.97)" },
                        "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
                      },
                      animation: "dropdownFadeSlide 160ms ease-out both",
                      transformOrigin: "top right",
                    }}
                  >
                    <LayoutOptionMenu
                      key="layout-option-menu-stable"
                      refetch={layoutDataRefetch}
                      optionsMenu={optionsMenu}
                      layoutData={layoutData}
                      onClose={handleCloseOptionsMenu}
                      menuUniformSpacing
                      footerNote={
                        isGuest && hasUserEditedRef.current
                          ? "You\u2019ve made changes worth saving."
                          : null
                      }
                    />
                  </Box>
                </>
              )}

              {/* ── ROOM TYPE STRIP ────────────────────────────────────────────
                  Always shows whenever a room is active (roomActive !== -1)
                  and allowMakeMagic is enabled.  One row: compact zone picker
                  pill + icon-only filter button.  Centred and compact so it
                  sits above the 3-FAB row.  Stays visible even when the filter
                  panel is open so context is preserved.
                  Hidden when the active room is the implicit "custom-room"
                  created by the Add Items FAB (manual-add flow) — the user
                  hasn't picked a zone, the pill would silently show
                  "See it as a..." with no obvious selected room on canvas,
                  and tapping the pill or running Make Magic over a free-form
                  custom room is a no-op. Keeping it hidden avoids that
                  confusion.                                                    */}
              {partnerPackage?.allowMakeMagic &&
                ((roomActive !== -1 && lineBoundary) ||
                  shufflePickedRoom != null ||
                  (lineBoundary && roomId)) &&
                roomId !== "custom-room" &&
                !selectedFurniture &&
                !isPickingRoom &&
                !shoppingListFlag &&
                !isAdding &&
                !optionsMenu &&
                !loadingLayout &&
                !(params?.id && autoSave === false) &&
                isScaleDimensionsMarked !== "select" && (
                  <Box
                    sx={{
                      position: "fixed",
                      bottom: EDITOR_RESET_STRIP_BOTTOM,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: EDITOR_RESET_STRIP_WIDTH,
                      zIndex: 1003,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "6px",
                      pointerEvents: "auto",
                    }}
                  >
                    {/* Zone type pill — grows to fill the row, leaving space for filter btn */}
                    <Box
                      sx={{
                        ...EDITOR_BOTTOM_PILL,
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        py: 0,
                        // Asymmetric by 2px each way: nudges the label off the
                        // left edge and the chevron closer to the right one.
                        // Sums to the old 24px so the text keeps its width.
                        pl: "14px",
                        pr: "10px",
                        minHeight: { xs: 42, sm: 44 },
                        minWidth: 0,
                        // Slightly transparent to blend with the glass aesthetic
                        background: "rgba(252,252,255,0.88)",
                        borderRadius: "22px",
                      }}
                      onClick={() => {
                        setShowZonesMenu((v) => !v);
                        if (openFilters) setOpenFilters(false);
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "13px", sm: "14px" },
                          fontWeight: 500,
                          color: "#333",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {selectedOption?.label || "See it as a..."}
                      </Typography>
                      <Box sx={{ lineHeight: 0, display: "flex", flexShrink: 0, ml: "6px" }}>
                        {showZonesMenu ? <HideZonesIcon /> : <ShowZonesIcon />}
                      </Box>
                    </Box>

                    {/* Filter icon button — toggles the filter/customize panel */}
                    {selectedOption?.value &&
                      !["outdoors", "conferenceroom", "privateOffice", "custom"].includes(
                        selectedOption.value
                      ) && (
                        <Box
                          sx={{
                            ...(openFilters ? EDITOR_CIRCLE_BTN_ACTIVE_SX : EDITOR_CIRCLE_BTN_SX),
                            color: EDITOR_FOOTER_ICON_TONE,
                            width: 42,
                            height: 42,
                            background: openFilters
                              ? "rgba(0,122,255,0.12)"
                              : "rgba(252,252,255,0.88)",
                          }}
                          onClick={() => {
                            setOpenFilters((v) => !v);
                            setShowZonesMenu(false);
                          }}
                        >
                          <Box sx={{ lineHeight: 0, display: "flex", "& svg": { width: 20, height: 20 } }}>
                            <FilterIcon />
                          </Box>
                        </Box>
                      )}
                  </Box>
                )}

              {/* Secondary row removed — furniture actions moved to FURNITURE ACTIONS ROW
                  above; Add Items merged into the 3-FAB PRIMARY ROW.              */}

              {errorLayoutGlobal &&
                errorLayout?.[roomId] &&
                isScaleDimensionsMarked !== "select" && (
                  <Container
                    maxWidth="sm"
                    sx={{
                      position: "absolute",
                      width: "100%",
                      left: 0,
                      right: 0,
                      top: "16px",
                    }}
                  >
                    <Stack
                      justifyContent={"space-between"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      sx={{
                        background: "white",
                        boxShadow: "0px 0px 6px 2px rgba(32, 33, 36, 0.15)",
                        borderRadius: "16px",
                        p: "16px",
                      }}
                    >
                      <Box display={"flex"} flexDirection={"column"}>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            marginBottom: "4px",
                          }}
                        >
                          {errorLayout?.[roomId] === "manually"
                            ? "Manual Layout"
                            : "No Magic Found"}
                        </div>
                        <div style={{ fontSize: "13px" }}>
                          {errorLayout?.[roomId] === "manually"
                            ? "You can add layouts manually or edit your request to get better suggestions."
                            : "Add suggested layouts or edit your request"}
                        </div>
                      </Box>

                      <Box
                        sx={{
                          background: "#EBEDF0 !important",
                          borderRadius: "12px",
                          width: "60px",
                          height: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClose()}
                      >
                        <Typography fontSize={"13px"} fontWeight={500}>
                          Edit
                        </Typography>
                      </Box>
                    </Stack>
                  </Container>
                )}
            </Box>

            {params.id &&
              autoSave === false &&
              isScaleDimensionsMarked !== "select" && (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    alignSelf: "stretch",
                    borderRadius: "12px",
                    position: "relative",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <Avatar
                    src={layoutData?.furnishedImageId || layoutData?.image}
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 0,
                    }}
                  />
                </Box>
              )}
          </Box>
        </Box>

        <NewFolderDialog
          isOpen={IsNewFolderOpen}
          onClose={() => setIsNewFolderOpen(false)}
          setReloadFiles={async () => {
            refetchDirectoryData();
          }}
        />

        <DeleteDialog
          isOpen={isShareLayout}
          onCancel={() => setIsSharelayout(false)}
          onAccept={async () => {
            setIsSharelayout(false);
            await shareLayout();
          }}
          acceptedText="Continue Anyway"
          instruction={"You are not logged in. Do you still want to conitnue?"}
        />

        <DeleteDialog
          isOpen={isResetScale}
          onCancel={() => setIsResetScale(false)}
          onAccept={async () => {
            setRoomsData([]);
            resetRoom();
            setRoomActiveLayout([]);
            setIsResetScale(false);
            setIsScaleDimensionsMarked("");
          }}
          acceptedText="Continue"
          instruction={
            "Are you sure you want to reset dimension?\n This will remove any changes made so far."
          }
        />
      </Container>

      {/* ── Items List Drawer ── */}
      <Drawer
        anchor={isMobile ? "bottom" : "right"}
        open={shoppingListFlag}
        onClose={() => setShoppingListFlag(false)}
        keepMounted
        variant="temporary"
        ModalProps={{
          keepMounted: true,
          BackdropProps: {
            sx: { backgroundColor: "transparent", pointerEvents: "none" },
          },
        }}
        PaperProps={{
          ref: containerShoppingRef,
          sx: {
            ...(isMobile
              ? {
                  maxHeight: "33vh",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                }
              : {
                  width: "380px",
                  maxWidth: "90vw",
                  top: "56px",
                  height: "calc(100% - 56px)",
                }),
            overflow: "auto",
            backgroundColor: "rgba(248, 248, 250, 0.97)",
            boxShadow: "-2px 0 12px rgba(0, 0, 0, 0.06)",
            border: "1px solid rgba(0, 0, 0, 0.06)",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          },
        }}
        sx={{
          zIndex: 1200,
          pointerEvents: "none",
          "& .MuiDrawer-paper": { pointerEvents: "auto" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            pt: 1.5,
            pb: 1,
            position: "sticky",
            top: 0,
            backgroundColor: "rgba(248, 248, 250, 0.97)",
            zIndex: 1,
            borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography
            sx={{ fontSize: "15px", fontWeight: 600, color: "rgba(60, 60, 67, 0.85)" }}
          >
            View Items
          </Typography>
          <IconButton
            onClick={() => setShoppingListFlag(false)}
            size="small"
            sx={{ color: "rgba(60, 60, 67, 0.45)" }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
        <Box sx={{ px: 2, pb: 2 }}>
          <ShoppingContent
            furniture={selectedItem}
            roomActive={roomActive}
            roomsData={roomsData}
            containerRef={containerShoppingRef}
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
            roomActiveLayout={roomActiveLayout}
            getRoomLabel={getRoomLabel}
          />
        </Box>
      </Drawer>

      {/* ── Persistent "Powered by MagicFurnish" footer + fade gradient ── */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 998,
          pointerEvents: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            // Single tall gradient merges the former separate gradient box and flat
            // strip. Now rendered in all editor states (including spotlight/overlay
            // pick + room-selected modes) so the dimmed plan is gently concealed at
            // the bottom for legibility of the FAB row, "tap a room" hint, and the
            // room-strip controls. The outer wrapper keeps pointerEvents:"none" so
            // all user interactions (including touch gestures on mobile) pass
            // through to the floor plan unchanged. Gradient string lives in
            // src/theme/spatial/tokens/gradients.js (extracted verbatim).
            background: editorBottomFadeGradient,
            pt: { xs: "min(360px, 56vh)", sm: "min(280px, 46vh)" },
            pb: "max(6px, env(safe-area-inset-bottom, 0px))",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 400,
              color: "rgba(200,200,200,0.85)",
              lineHeight: 1.3,
            }}
          >
            {isGuest
              ? "Powered by MagicFurnish"
              : "Powered by MagicFurnish. All changes saved."}
          </Typography>
        </Box>
      </Box>

      {isLoading && savingOverlayVisible && (
        <Box
          position={"absolute"}
          top={"50%"}
          left={"50%"}
          sx={{
            height: isAdminViewerRoute ? "100%" : "100dvh",
            backgroundColor: "white",
            zIndex: "9999",
            transform: "translate(-50% , -50%)",
            width: "100%",
            maxWidth: "100vw",
            textAlign: "center",
            color: "#3C3C4399",
            letterSpacing: "-0.43px",
            fontSize: "17px",
            boxSizing: "border-box",
            "@keyframes savingOverlayFadeIn": {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
            animation: "savingOverlayFadeIn 180ms ease-out both",
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            spacing={{ xs: 1.5, sm: 2 }}
            sx={{
              height: "100%",
              width: "100%",
              maxWidth: "100%",
              px: { xs: 2, sm: 3 },
              py: { xs: 2, sm: 0 },
              boxSizing: "border-box",
            }}
            role="status"
            aria-live="polite"
          >
            <CircularProgress
              size={isMobile ? 36 : 40}
              sx={{ color: "rgba(60, 60, 67, 0.45)" }}
            />
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "16px", sm: "17px" },
                fontWeight: 600,
                letterSpacing: { xs: "-0.32px", sm: "-0.43px" },
                lineHeight: 1.25,
                color: "rgba(60, 60, 67, 0.75)",
                textAlign: "center",
                maxWidth: "min(100%, 20rem)",
                mx: "auto",
              }}
            >
              Saving your layout
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "15px" },
                letterSpacing: { xs: "-0.15px", sm: "-0.25px" },
                lineHeight: 1.45,
                color: "rgba(60, 60, 67, 0.55)",
                textAlign: "center",
                maxWidth: { xs: "min(100%, 18.5rem)", sm: 360 },
                mx: "auto",
                px: { xs: 0.5, sm: 0 },
              }}
            >
              Updating your gallery preview…
            </Typography>
          </Stack>
        </Box>
      )}

      {/* Fork-on-first-edit toast — hidden per product decision; state/logic preserved */}
      {false && forkToastOpen && (
        <Box
          sx={{
            position: "fixed",
            bottom: EDITOR_TOAST_BOTTOM,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1001,
            width: "auto",
            "@keyframes forkToastFadeSlide": {
              "0%": { opacity: 0, transform: "translateX(-50%) translateY(4px)" },
              "100%": { opacity: 1, transform: "translateX(-50%) translateY(0)" },
            },
            animation: "forkToastFadeSlide 200ms ease-out both",
          }}
        >
          <Stack
            sx={{
              boxShadow:
                "0 8px 28px rgba(0, 0, 0, 0.14), 0 1px 0 rgba(255, 255, 255, 0.9) inset",
              borderRadius: "14px",
              background: "rgba(248, 248, 250, 0.96)",
              border: "1px solid rgba(0, 0, 0, 0.07)",
              px: 1.75,
              py: 1,
              flexDirection: "row",
              gap: 1.25,
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                color: "rgba(60, 60, 67, 0.78)",
              }}
            >
              Editing a copy
            </Typography>
            <IconButton
              sx={{ p: 0, ml: 0.5 }}
              disableRipple
              onClick={() => setForkToastOpen(false)}
            >
              <ExitIcon style={{ width: 16, height: 16 }} />
            </IconButton>
          </Stack>
        </Box>
      )}

      {/* ── "Add items manually" toast ─────────────────────────────────────
          Appears whenever the ManuallyItems modal is open (isAdding = true).
          Anchored 10 px above the modal top, same glass chip style as the
          "Editing a copy" fork toast.  Centred horizontally.              */}
      {isAdding && addingFromSomethingElse && !manualToastDismissed && (
        <Box
          sx={{
            position: "fixed",
            bottom:
              footerHeight > 0
                ? `${footerHeight + 10 + EDITOR_ABOVE_BRANDING_PX}px`
                : `${240 + EDITOR_ABOVE_BRANDING_PX}px`,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1205,
            width: "auto",
            "@keyframes addManuallyFadeSlide": {
              "0%": { opacity: 0, transform: "translateX(-50%) translateY(4px)" },
              "100%": { opacity: 1, transform: "translateX(-50%) translateY(0)" },
            },
            animation: "addManuallyFadeSlide 200ms ease-out both",
          }}
        >
          <Stack
            sx={{
              boxShadow:
                "0 8px 28px rgba(0, 0, 0, 0.14), 0 1px 0 rgba(255, 255, 255, 0.9) inset",
              borderRadius: "14px",
              background: "rgba(248, 248, 250, 0.96)",
              border: "1px solid rgba(0, 0, 0, 0.07)",
              px: 1.75,
              py: 1,
              flexDirection: "row",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                color: "rgba(60, 60, 67, 0.78)",
              }}
            >
              Add items manually
            </Typography>
            <IconButton
              size="small"
              disableRipple
              sx={{ p: 0 }}
              onClick={() => setManualToastDismissed(true)}
            >
              <CloseIcon sx={{ fontSize: 15, color: "rgba(60,60,67,0.45)" }} />
            </IconButton>
          </Stack>
        </Box>
      )}

      {/* Auth modal — shown when guest tries to save/share/download */}
      <AuthModal
        open={authModalOpen || forkTransitioning}
        onClose={() => {
          setAuthModalOpen(false);
          guestAuthPrefillEmailRef.current = "";
          setAuthPrefillEmail("");
          pendingActionRef.current = null;
          pendingGuestAuthIntentRef.current = null;
          guestForkGallerySaveSnapshotRef.current = null;
          guestForkGalleryCaptureBlobRef.current = null;
          editorBackToGalleryInFlightRef.current = false;
          mfLogGuestGalleryAuth("authModal.dismissed", {
            layoutId: layoutData?._id,
          });
        }}
        onSuccess={handleAuthSuccess}
        saving={forkTransitioning}
        initialEmail={authPrefillEmail}
        forkSaveError={forkSaveError}
        onRetryForkSave={handleForkSaveRetry}
        onDismissForkSave={handleForkSaveDismiss}
      />

      {BRANDED_EXPORT_ENABLED && brandedExportOpen && (
        <BrandedExportModal
          open={brandedExportOpen}
          onClose={() => setBrandedExportOpen(false)}
          getSnapshot={() => duplicateDownloadLayoutRef.current?.(2)}
          layoutId={layoutData?._id}
          version={versionLayout || layoutData?.version}
          isSaved={!!layoutData?._id}
          fileName={layoutData?.name || "floor-plan"}
          onLegacyFallback={() => duplicateDownloadLayoutRef.current?.()}
          onDownloaded={() => {
            // Match the legacy download analytics exactly: the downloads count
            // (trackEngagement) plus the secondary download_layout event.
            eventLog(targetWindow, "floor_plan_event", "download_layout", {
              galleryId: layoutData?.uuid || layoutData?._id,
              galleryUrl: layoutData?._id
                ? `${window.location.origin}/floor-gallery/${layoutData._id}`
                : undefined,
            });
            trackEngagement({ downloads: true });
          }}
          onShared={() => {
            // Mirror the legacy "Copy link" analytics: share count + event.
            eventLog(targetWindow, "floor_plan_event", "link_copied", {
              galleryId: layoutData?.uuid || layoutData?._id,
              galleryUrl: layoutData?._id
                ? `${window.location.origin}/floor-gallery/${layoutData._id}`
                : undefined,
            });
            trackEngagement({ share: true });
          }}
          prepare={async () => {
            // Persist pending edits before capture so the QR's gallery target
            // matches the freshly captured flyer. Bounded (8s) and non-throwing
            // so a stalled/failed autosave can never block the modal.
            if (isGuest) return;
            try {
              await updatedLayout(false, true);
              const deadline = Date.now() + 8000;
              while (autoSaveloadingRef.current && Date.now() < deadline) {
                await new Promise((resolve) => setTimeout(resolve, 100));
              }
            } catch (error) {
              console.warn("[brandedExport] pre-open autosave failed:", error);
            }
          }}
        />
      )}

      <GalleryUploaderContactModal
        open={shouldDisplayUploaderContactModal({
          scheduledOpen: uploaderContactModalOpen,
          authModalOpen,
          forkTransitioning,
        })}
        onClose={handleCloseUploaderContactModal}
        accountEmail={userData?.email}
        savedContactEmail={layoutData?.inquiryContactEmail}
        savedInquiryDisplayName={layoutData?.inquiryDisplayName}
        onSubmit={handleSaveUploaderContact}
        submitting={uploaderContactSubmitting}
        saved={uploaderContactSaved}
        error={uploaderContactError}
      />

      <GalleryInterestToast
        open={interestToastOpen && !inquireModalOpen}
        email={inquireConfirmState?.email}
        error={inquireError}
        onClose={handleCloseInterestToast}
        onRetry={handleRetryInterest}
        bottom={EDITOR_TOAST_BOTTOM}
      />

      <GalleryInquireModal
        open={inquireModalOpen}
        onClose={handleCloseInquireModal}
        isGuest={isGuest}
        accountEmail={userData?.email}
        onSubmit={submitGalleryInquiry}
        submitting={inquireSubmitting}
        confirmState={inquireConfirmState}
        error={inquireError}
        inquiriesAvailable={layoutInquiriesAvailable}
        guestEmailPrefill={inquireGuestEmailPrefill}
        knownEmail={inquireKnownEmail}
      />
    </>
  );
};

export default UploadFloor;
